/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProcessLoginRouteImport } from './routes/process-login'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AuthUnverifiedRouteRouteImport } from './routes/_auth/unverified/route'
import { Route as AuthModulesRouteRouteImport } from './routes/_auth/_modules/route'
import { Route as AuthUnverifiedIndexRouteImport } from './routes/_auth/unverified/index'
import { Route as AuthModulesIndexRouteImport } from './routes/_auth/_modules/index'
import { Route as AuthTrackErpRouteImport } from './routes/_auth/track.$erp'
import { Route as AuthModulesCrtRouteRouteImport } from './routes/_auth/_modules/crt/route'
import { Route as AuthModulesCreditRouteRouteImport } from './routes/_auth/_modules/credit/route'
import { Route as AuthModulesAppRouteRouteImport } from './routes/_auth/_modules/_app/route'
import { Route as AuthModulesSharedKitchenSinkRouteImport } from './routes/_auth/_modules/_shared/kitchen-sink'
import { Route as AuthModulesCrtWelcomeRouteRouteImport } from './routes/_auth/_modules/crt/welcome/route'
import { Route as AuthModulesCrtVolumesRouteRouteImport } from './routes/_auth/_modules/crt/volumes/route'
import { Route as AuthModulesCrtVolumeScenariosRouteRouteImport } from './routes/_auth/_modules/crt/volume-scenarios/route'
import { Route as AuthModulesCrtVolumeForecastsRouteRouteImport } from './routes/_auth/_modules/crt/volume-forecasts/route'
import { Route as AuthModulesCrtVarianceAnalysisRouteRouteImport } from './routes/_auth/_modules/crt/variance-analysis/route'
import { Route as AuthModulesCrtSettingsRouteRouteImport } from './routes/_auth/_modules/crt/settings/route'
import { Route as AuthModulesCrtPricingExciseRouteRouteImport } from './routes/_auth/_modules/crt/pricing-excise/route'
import { Route as AuthModulesCrtMyUploadsRouteRouteImport } from './routes/_auth/_modules/crt/my-uploads/route'
import { Route as AuthModulesCrtMyExportsRouteRouteImport } from './routes/_auth/_modules/crt/my-exports/route'
import { Route as AuthModulesCrtMaterialsRouteRouteImport } from './routes/_auth/_modules/crt/materials/route'
import { Route as AuthModulesCrtKpiReportsRouteRouteImport } from './routes/_auth/_modules/crt/kpi-reports/route'
import { Route as AuthModulesCrtCustomersRouteRouteImport } from './routes/_auth/_modules/crt/customers/route'
import { Route as AuthModulesCrtCustomerInvestmentsRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/route'
import { Route as AuthModulesCrtCostOfGoodsRouteRouteImport } from './routes/_auth/_modules/crt/cost-of-goods/route'
import { Route as AuthModulesCrtBpcActualsRouteRouteImport } from './routes/_auth/_modules/crt/bpc-actuals/route'
import { Route as AuthModulesCrtAzureImportsRouteRouteImport } from './routes/_auth/_modules/crt/azure-imports/route'
import { Route as AuthModulesCrtAdminRouteRouteImport } from './routes/_auth/_modules/crt/admin/route'
import { Route as AuthModulesCreditWelcomeRouteRouteImport } from './routes/_auth/_modules/credit/welcome/route'
import { Route as AuthModulesCreditOperationsRouteRouteImport } from './routes/_auth/_modules/credit/operations/route'
import { Route as AuthModulesCreditMyUploadsRouteRouteImport } from './routes/_auth/_modules/credit/my-uploads/route'
import { Route as AuthModulesCreditMyExportsRouteRouteImport } from './routes/_auth/_modules/credit/my-exports/route'
import { Route as AuthModulesCreditInitiativesRouteRouteImport } from './routes/_auth/_modules/credit/initiatives/route'
import { Route as AuthModulesCreditInboxRouteRouteImport } from './routes/_auth/_modules/credit/inbox/route'
import { Route as AuthModulesCreditGoogleFinancialStatementsRouteRouteImport } from './routes/_auth/_modules/credit/google-financial-statements/route'
import { Route as AuthModulesCreditCustomersRouteRouteImport } from './routes/_auth/_modules/credit/customers/route'
import { Route as AuthModulesCreditCreditLimitReviewsRouteRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/route'
import { Route as AuthModulesCreditCreditIndexScoresRouteRouteImport } from './routes/_auth/_modules/credit/credit-index-scores/route'
import { Route as AuthModulesCreditBlockedOrdersRouteRouteImport } from './routes/_auth/_modules/credit/blocked-orders/route'
import { Route as AuthModulesCreditAdminRouteRouteImport } from './routes/_auth/_modules/credit/admin/route'
import { Route as AuthModulesAppWelcomeRouteRouteImport } from './routes/_auth/_modules/_app/welcome/route'
import { Route as AuthModulesAppSoxComplianceRouteRouteImport } from './routes/_auth/_modules/_app/sox-compliance/route'
import { Route as AuthModulesAppReportsRouteRouteImport } from './routes/_auth/_modules/_app/reports/route'
import { Route as AuthModulesAppProcessesRouteRouteImport } from './routes/_auth/_modules/_app/processes/route'
import { Route as AuthModulesAppOrdersRouteRouteImport } from './routes/_auth/_modules/_app/orders/route'
import { Route as AuthModulesAppOperationsRouteRouteImport } from './routes/_auth/_modules/_app/operations/route'
import { Route as AuthModulesAppMyUploadsRouteRouteImport } from './routes/_auth/_modules/_app/my-uploads/route'
import { Route as AuthModulesAppMaterialsRouteRouteImport } from './routes/_auth/_modules/_app/materials/route'
import { Route as AuthModulesAppCustomersRouteRouteImport } from './routes/_auth/_modules/_app/customers/route'
import { Route as AuthModulesAppCoreUploadDataRouteRouteImport } from './routes/_auth/_modules/_app/core-upload-data/route'
import { Route as AuthModulesAppAssortmentRouteRouteImport } from './routes/_auth/_modules/_app/assortment/route'
import { Route as AuthModulesAppAdminRouteRouteImport } from './routes/_auth/_modules/_app/admin/route'
import { Route as AuthModulesCrtWelcomeIndexRouteImport } from './routes/_auth/_modules/crt/welcome/index'
import { Route as AuthModulesCrtVolumeScenariosIndexRouteImport } from './routes/_auth/_modules/crt/volume-scenarios/index'
import { Route as AuthModulesCrtVolumeForecastsIndexRouteImport } from './routes/_auth/_modules/crt/volume-forecasts/index'
import { Route as AuthModulesCrtVarianceAnalysisIndexRouteImport } from './routes/_auth/_modules/crt/variance-analysis/index'
import { Route as AuthModulesCrtSettingsIndexRouteImport } from './routes/_auth/_modules/crt/settings/index'
import { Route as AuthModulesCrtPricingExciseIndexRouteImport } from './routes/_auth/_modules/crt/pricing-excise/index'
import { Route as AuthModulesCrtMyUploadsIndexRouteImport } from './routes/_auth/_modules/crt/my-uploads/index'
import { Route as AuthModulesCrtMyExportsIndexRouteImport } from './routes/_auth/_modules/crt/my-exports/index'
import { Route as AuthModulesCrtMaterialsIndexRouteImport } from './routes/_auth/_modules/crt/materials/index'
import { Route as AuthModulesCrtKpiReportsIndexRouteImport } from './routes/_auth/_modules/crt/kpi-reports/index'
import { Route as AuthModulesCrtCustomerInvestmentsIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/index'
import { Route as AuthModulesCrtCostOfGoodsIndexRouteImport } from './routes/_auth/_modules/crt/cost-of-goods/index'
import { Route as AuthModulesCrtBpcActualsIndexRouteImport } from './routes/_auth/_modules/crt/bpc-actuals/index'
import { Route as AuthModulesCrtAzureImportsIndexRouteImport } from './routes/_auth/_modules/crt/azure-imports/index'
import { Route as AuthModulesCrtAdminIndexRouteImport } from './routes/_auth/_modules/crt/admin/index'
import { Route as AuthModulesCreditWelcomeIndexRouteImport } from './routes/_auth/_modules/credit/welcome/index'
import { Route as AuthModulesCreditOperationsIndexRouteImport } from './routes/_auth/_modules/credit/operations/index'
import { Route as AuthModulesCreditMyUploadsIndexRouteImport } from './routes/_auth/_modules/credit/my-uploads/index'
import { Route as AuthModulesCreditMyExportsIndexRouteImport } from './routes/_auth/_modules/credit/my-exports/index'
import { Route as AuthModulesCreditInitiativesIndexRouteImport } from './routes/_auth/_modules/credit/initiatives/index'
import { Route as AuthModulesCreditInboxIndexRouteImport } from './routes/_auth/_modules/credit/inbox/index'
import { Route as AuthModulesCreditGoogleFinancialStatementsIndexRouteImport } from './routes/_auth/_modules/credit/google-financial-statements/index'
import { Route as AuthModulesCreditCustomersIndexRouteImport } from './routes/_auth/_modules/credit/customers/index'
import { Route as AuthModulesCreditCreditLimitReviewsIndexRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/index'
import { Route as AuthModulesCreditCreditIndexScoresIndexRouteImport } from './routes/_auth/_modules/credit/credit-index-scores/index'
import { Route as AuthModulesCreditBlockedOrdersIndexRouteImport } from './routes/_auth/_modules/credit/blocked-orders/index'
import { Route as AuthModulesCreditAdminIndexRouteImport } from './routes/_auth/_modules/credit/admin/index'
import { Route as AuthModulesAppWelcomeIndexRouteImport } from './routes/_auth/_modules/_app/welcome/index'
import { Route as AuthModulesAppSoxComplianceIndexRouteImport } from './routes/_auth/_modules/_app/sox-compliance/index'
import { Route as AuthModulesAppReportsIndexRouteImport } from './routes/_auth/_modules/_app/reports/index'
import { Route as AuthModulesAppProcessesIndexRouteImport } from './routes/_auth/_modules/_app/processes/index'
import { Route as AuthModulesAppOrdersIndexRouteImport } from './routes/_auth/_modules/_app/orders/index'
import { Route as AuthModulesAppOperationsIndexRouteImport } from './routes/_auth/_modules/_app/operations/index'
import { Route as AuthModulesAppMyUploadsIndexRouteImport } from './routes/_auth/_modules/_app/my-uploads/index'
import { Route as AuthModulesAppMaterialsIndexRouteImport } from './routes/_auth/_modules/_app/materials/index'
import { Route as AuthModulesAppCustomersIndexRouteImport } from './routes/_auth/_modules/_app/customers/index'
import { Route as AuthModulesAppCoreUploadDataIndexRouteImport } from './routes/_auth/_modules/_app/core-upload-data/index'
import { Route as AuthModulesAppAssortmentIndexRouteImport } from './routes/_auth/_modules/_app/assortment/index'
import { Route as AuthModulesAppAdminIndexRouteImport } from './routes/_auth/_modules/_app/admin/index'
import { Route as AuthModulesCrtVolumeScenariosVolumeScenarioIdRouteImport } from './routes/_auth/_modules/crt/volume-scenarios/$volumeScenarioId'
import { Route as AuthModulesCrtVarianceAnalysisByCostTypeRouteImport } from './routes/_auth/_modules/crt/variance-analysis/by-cost-type'
import { Route as AuthModulesCrtVarianceAnalysisByBudgetRouteImport } from './routes/_auth/_modules/crt/variance-analysis/by-budget'
import { Route as AuthModulesCrtVarianceAnalysisByBannerRouteImport } from './routes/_auth/_modules/crt/variance-analysis/by-banner'
import { Route as AuthModulesCrtVarianceAnalysisByAgreementRouteImport } from './routes/_auth/_modules/crt/variance-analysis/by-agreement'
import { Route as AuthModulesCrtKpiReportsGraphsRouteImport } from './routes/_auth/_modules/crt/kpi-reports/graphs'
import { Route as AuthModulesCrtBpcActualsYearRouteImport } from './routes/_auth/_modules/crt/bpc-actuals/$year'
import { Route as AuthModulesCreditInitiativesIdRouteImport } from './routes/_auth/_modules/credit/initiatives/$id'
import { Route as AuthModulesCreditGoogleFinancialStatementsSapErpRouteImport } from './routes/_auth/_modules/credit/google-financial-statements/$sapErp'
import { Route as AuthModulesCreditCreditLimitReviewsReviewIdRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/$reviewId'
import { Route as AuthModulesSharedErrorsUnauthorizedRouteImport } from './routes/_auth/_modules/_shared/_errors/unauthorized'
import { Route as AuthModulesSharedErrorsNotFoundRouteImport } from './routes/_auth/_modules/_shared/_errors/not-found'
import { Route as AuthModulesSharedErrorsErrorRouteImport } from './routes/_auth/_modules/_shared/_errors/error'
import { Route as AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRouteImport } from './routes/_auth/_modules/crt/volume-forecasts/sub-channel-allocations/route'
import { Route as AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRouteImport } from './routes/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions/route'
import { Route as AuthModulesCrtVolumeForecastsChannelContributionsRouteRouteImport } from './routes/_auth/_modules/crt/volume-forecasts/channel-contributions/route'
import { Route as AuthModulesCrtPricingExciseTaxAssumptionsRouteRouteImport } from './routes/_auth/_modules/crt/pricing-excise/tax-assumptions/route'
import { Route as AuthModulesCrtPricingExcisePricingRateTableRouteRouteImport } from './routes/_auth/_modules/crt/pricing-excise/pricing-rate-table/route'
import { Route as AuthModulesCrtPricingExcisePricingAssumptionsRouteRouteImport } from './routes/_auth/_modules/crt/pricing-excise/pricing-assumptions/route'
import { Route as AuthModulesCrtPricingExciseInsightsRouteRouteImport } from './routes/_auth/_modules/crt/pricing-excise/insights/route'
import { Route as AuthModulesCrtMaterialsPriceListRouteRouteImport } from './routes/_auth/_modules/crt/materials/price-list/route'
import { Route as AuthModulesCrtMaterialsMaterialsListRouteRouteImport } from './routes/_auth/_modules/crt/materials/materials-list/route'
import { Route as AuthModulesCrtMaterialsInsightsRouteRouteImport } from './routes/_auth/_modules/crt/materials/insights/route'
import { Route as AuthModulesCrtMaterialsBrandVariantsRouteRouteImport } from './routes/_auth/_modules/crt/materials/brand-variants/route'
import { Route as AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRouteImport } from './routes/_auth/_modules/crt/kpi-reports/profits-and-loss-summary/route'
import { Route as AuthModulesCrtKpiReportsCashDashboardRouteRouteImport } from './routes/_auth/_modules/crt/kpi-reports/cash-dashboard/route'
import { Route as AuthModulesCrtCustomersCommercialPartnersRouteRouteImport } from './routes/_auth/_modules/crt/customers/commercial-partners/route'
import { Route as AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/key-accounts/route'
import { Route as AuthModulesCrtCustomerInvestmentsInvestmentsRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/investments/route'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/route'
import { Route as AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/budget-tracker/route'
import { Route as AuthModulesCrtAdminUsersRouteRouteImport } from './routes/_auth/_modules/crt/admin/users/route'
import { Route as AuthModulesCrtAdminRolesRouteRouteImport } from './routes/_auth/_modules/crt/admin/roles/route'
import { Route as AuthModulesCrtAdminNotificationsRouteRouteImport } from './routes/_auth/_modules/crt/admin/notifications/route'
import { Route as AuthModulesCrtAdminInvitationsRouteRouteImport } from './routes/_auth/_modules/crt/admin/invitations/route'
import { Route as AuthModulesCrtAdminAuditTrailsRouteRouteImport } from './routes/_auth/_modules/crt/admin/audit-trails/route'
import { Route as AuthModulesCreditOperationsVeryLowRiskCustomersRouteRouteImport } from './routes/_auth/_modules/credit/operations/very-low-risk-customers/route'
import { Route as AuthModulesCreditOperationsProvinceAovPerCartonRouteRouteImport } from './routes/_auth/_modules/credit/operations/province-aov-per-carton/route'
import { Route as AuthModulesCreditOperationsOrderCutoffsRouteRouteImport } from './routes/_auth/_modules/credit/operations/order-cutoffs/route'
import { Route as AuthModulesCreditOperationsMultiplierRouteRouteImport } from './routes/_auth/_modules/credit/operations/multiplier/route'
import { Route as AuthModulesCreditCustomersErpRouteRouteImport } from './routes/_auth/_modules/credit/customers/$erp/route'
import { Route as AuthModulesCreditCreditLimitReviewsReviewEventsRouteRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/review-events/route'
import { Route as AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/pending-confirmations/route'
import { Route as AuthModulesCreditCreditLimitReviewsMassRouteRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/mass/route'
import { Route as AuthModulesCreditAdminUsersRouteRouteImport } from './routes/_auth/_modules/credit/admin/users/route'
import { Route as AuthModulesCreditAdminRolesRouteRouteImport } from './routes/_auth/_modules/credit/admin/roles/route'
import { Route as AuthModulesCreditAdminInvitationsRouteRouteImport } from './routes/_auth/_modules/credit/admin/invitations/route'
import { Route as AuthModulesCreditAdminAuditTrailsRouteRouteImport } from './routes/_auth/_modules/credit/admin/audit-trails/route'
import { Route as AuthModulesAppReportsSalesforceRouteRouteImport } from './routes/_auth/_modules/_app/reports/salesforce/route'
import { Route as AuthModulesAppReportsOrderServiceRouteRouteImport } from './routes/_auth/_modules/_app/reports/order-service/route'
import { Route as AuthModulesAppReportsOperationsRouteRouteImport } from './routes/_auth/_modules/_app/reports/operations/route'
import { Route as AuthModulesAppReportsMiscRouteRouteImport } from './routes/_auth/_modules/_app/reports/misc/route'
import { Route as AuthModulesAppReportsMaterialRouteRouteImport } from './routes/_auth/_modules/_app/reports/material/route'
import { Route as AuthModulesAppReportsEccRouteRouteImport } from './routes/_auth/_modules/_app/reports/ecc/route'
import { Route as AuthModulesAppProcessesPipelinesRouteRouteImport } from './routes/_auth/_modules/_app/processes/pipelines/route'
import { Route as AuthModulesAppOrdersReturnsRouteRouteImport } from './routes/_auth/_modules/_app/orders/returns/route'
import { Route as AuthModulesAppOrdersPaymentReviewRouteRouteImport } from './routes/_auth/_modules/_app/orders/payment-review/route'
import { Route as AuthModulesAppOrdersMissingRouteRouteImport } from './routes/_auth/_modules/_app/orders/missing/route'
import { Route as AuthModulesAppOrdersFlaggedRouteRouteImport } from './routes/_auth/_modules/_app/orders/flagged/route'
import { Route as AuthModulesAppOrdersAllRouteRouteImport } from './routes/_auth/_modules/_app/orders/all/route'
import { Route as AuthModulesAppMaterialsBcpPricedRouteRouteImport } from './routes/_auth/_modules/_app/materials/bcp-priced/route'
import { Route as AuthModulesAppCustomersStoresRouteRouteImport } from './routes/_auth/_modules/_app/customers/stores/route'
import { Route as AuthModulesAppCustomersBannersRouteRouteImport } from './routes/_auth/_modules/_app/customers/banners/route'
import { Route as AuthModulesAppCoreUploadDataOrderServiceRouteRouteImport } from './routes/_auth/_modules/_app/core-upload-data/order-service/route'
import { Route as AuthModulesAppCoreUploadDataOperationsRouteRouteImport } from './routes/_auth/_modules/_app/core-upload-data/operations/route'
import { Route as AuthModulesAppCoreUploadDataOnHandInventoryRouteRouteImport } from './routes/_auth/_modules/_app/core-upload-data/on-hand-inventory/route'
import { Route as AuthModulesAppCoreUploadDataMaterialsRouteRouteImport } from './routes/_auth/_modules/_app/core-upload-data/materials/route'
import { Route as AuthModulesAppCoreUploadDataBusinessRouteRouteImport } from './routes/_auth/_modules/_app/core-upload-data/business/route'
import { Route as AuthModulesAppCoreUploadDataAutoInjectRouteRouteImport } from './routes/_auth/_modules/_app/core-upload-data/auto-inject/route'
import { Route as AuthModulesAppAssortmentLaunchesRouteRouteImport } from './routes/_auth/_modules/_app/assortment/launches/route'
import { Route as AuthModulesAppAssortmentBannersRouteRouteImport } from './routes/_auth/_modules/_app/assortment/banners/route'
import { Route as AuthModulesAppAssortmentActiveRouteRouteImport } from './routes/_auth/_modules/_app/assortment/active/route'
import { Route as AuthModulesAppAdminUsersRouteRouteImport } from './routes/_auth/_modules/_app/admin/users/route'
import { Route as AuthModulesAppAdminRolesRouteRouteImport } from './routes/_auth/_modules/_app/admin/roles/route'
import { Route as AuthModulesAppAdminInvitationsRouteRouteImport } from './routes/_auth/_modules/_app/admin/invitations/route'
import { Route as AuthModulesAppAdminAuditTrailsRouteRouteImport } from './routes/_auth/_modules/_app/admin/audit-trails/route'
import { Route as AuthModulesCrtVolumeForecastsSubChannelAllocationsIndexRouteImport } from './routes/_auth/_modules/crt/volume-forecasts/sub-channel-allocations/index'
import { Route as AuthModulesCrtVolumeForecastsNcProvincialContributionsIndexRouteImport } from './routes/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions/index'
import { Route as AuthModulesCrtVolumeForecastsChannelContributionsIndexRouteImport } from './routes/_auth/_modules/crt/volume-forecasts/channel-contributions/index'
import { Route as AuthModulesCrtPricingExciseTaxAssumptionsIndexRouteImport } from './routes/_auth/_modules/crt/pricing-excise/tax-assumptions/index'
import { Route as AuthModulesCrtPricingExcisePricingRateTableIndexRouteImport } from './routes/_auth/_modules/crt/pricing-excise/pricing-rate-table/index'
import { Route as AuthModulesCrtPricingExcisePricingAssumptionsIndexRouteImport } from './routes/_auth/_modules/crt/pricing-excise/pricing-assumptions/index'
import { Route as AuthModulesCrtPricingExciseInsightsIndexRouteImport } from './routes/_auth/_modules/crt/pricing-excise/insights/index'
import { Route as AuthModulesCrtMaterialsPriceListIndexRouteImport } from './routes/_auth/_modules/crt/materials/price-list/index'
import { Route as AuthModulesCrtMaterialsMaterialsListIndexRouteImport } from './routes/_auth/_modules/crt/materials/materials-list/index'
import { Route as AuthModulesCrtMaterialsInsightsIndexRouteImport } from './routes/_auth/_modules/crt/materials/insights/index'
import { Route as AuthModulesCrtMaterialsBrandVariantsIndexRouteImport } from './routes/_auth/_modules/crt/materials/brand-variants/index'
import { Route as AuthModulesCrtKpiReportsProfitsAndLossSummaryIndexRouteImport } from './routes/_auth/_modules/crt/kpi-reports/profits-and-loss-summary/index'
import { Route as AuthModulesCrtKpiReportsCashDashboardIndexRouteImport } from './routes/_auth/_modules/crt/kpi-reports/cash-dashboard/index'
import { Route as AuthModulesCrtCustomersCommercialPartnersIndexRouteImport } from './routes/_auth/_modules/crt/customers/commercial-partners/index'
import { Route as AuthModulesCrtCustomerInvestmentsKeyAccountsIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/key-accounts/index'
import { Route as AuthModulesCrtCustomerInvestmentsInvestmentsIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/investments/index'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/index'
import { Route as AuthModulesCrtCustomerInvestmentsBudgetTrackerIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/budget-tracker/index'
import { Route as AuthModulesCrtAdminUsersIndexRouteImport } from './routes/_auth/_modules/crt/admin/users/index'
import { Route as AuthModulesCrtAdminRolesIndexRouteImport } from './routes/_auth/_modules/crt/admin/roles/index'
import { Route as AuthModulesCrtAdminNotificationsIndexRouteImport } from './routes/_auth/_modules/crt/admin/notifications/index'
import { Route as AuthModulesCrtAdminInvitationsIndexRouteImport } from './routes/_auth/_modules/crt/admin/invitations/index'
import { Route as AuthModulesCrtAdminAuditTrailsIndexRouteImport } from './routes/_auth/_modules/crt/admin/audit-trails/index'
import { Route as AuthModulesCreditOperationsVeryLowRiskCustomersIndexRouteImport } from './routes/_auth/_modules/credit/operations/very-low-risk-customers/index'
import { Route as AuthModulesCreditOperationsProvinceAovPerCartonIndexRouteImport } from './routes/_auth/_modules/credit/operations/province-aov-per-carton/index'
import { Route as AuthModulesCreditOperationsOrderCutoffsIndexRouteImport } from './routes/_auth/_modules/credit/operations/order-cutoffs/index'
import { Route as AuthModulesCreditOperationsMultiplierIndexRouteImport } from './routes/_auth/_modules/credit/operations/multiplier/index'
import { Route as AuthModulesCreditCustomersErpIndexRouteImport } from './routes/_auth/_modules/credit/customers/$erp/index'
import { Route as AuthModulesCreditCreditLimitReviewsReviewEventsIndexRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/review-events/index'
import { Route as AuthModulesCreditCreditLimitReviewsPendingConfirmationsIndexRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/pending-confirmations/index'
import { Route as AuthModulesCreditCreditLimitReviewsMassIndexRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/mass/index'
import { Route as AuthModulesCreditAdminUsersIndexRouteImport } from './routes/_auth/_modules/credit/admin/users/index'
import { Route as AuthModulesCreditAdminRolesIndexRouteImport } from './routes/_auth/_modules/credit/admin/roles/index'
import { Route as AuthModulesCreditAdminInvitationsIndexRouteImport } from './routes/_auth/_modules/credit/admin/invitations/index'
import { Route as AuthModulesCreditAdminAuditTrailsIndexRouteImport } from './routes/_auth/_modules/credit/admin/audit-trails/index'
import { Route as AuthModulesAppReportsSalesforceIndexRouteImport } from './routes/_auth/_modules/_app/reports/salesforce/index'
import { Route as AuthModulesAppReportsOrderServiceIndexRouteImport } from './routes/_auth/_modules/_app/reports/order-service/index'
import { Route as AuthModulesAppReportsOperationsIndexRouteImport } from './routes/_auth/_modules/_app/reports/operations/index'
import { Route as AuthModulesAppReportsMiscIndexRouteImport } from './routes/_auth/_modules/_app/reports/misc/index'
import { Route as AuthModulesAppReportsMaterialIndexRouteImport } from './routes/_auth/_modules/_app/reports/material/index'
import { Route as AuthModulesAppReportsEccIndexRouteImport } from './routes/_auth/_modules/_app/reports/ecc/index'
import { Route as AuthModulesAppProcessesPipelinesIndexRouteImport } from './routes/_auth/_modules/_app/processes/pipelines/index'
import { Route as AuthModulesAppOrdersReturnsIndexRouteImport } from './routes/_auth/_modules/_app/orders/returns/index'
import { Route as AuthModulesAppOrdersPaymentReviewIndexRouteImport } from './routes/_auth/_modules/_app/orders/payment-review/index'
import { Route as AuthModulesAppOrdersMissingIndexRouteImport } from './routes/_auth/_modules/_app/orders/missing/index'
import { Route as AuthModulesAppOrdersFlaggedIndexRouteImport } from './routes/_auth/_modules/_app/orders/flagged/index'
import { Route as AuthModulesAppOrdersAllIndexRouteImport } from './routes/_auth/_modules/_app/orders/all/index'
import { Route as AuthModulesAppMaterialsBcpPricedIndexRouteImport } from './routes/_auth/_modules/_app/materials/bcp-priced/index'
import { Route as AuthModulesAppCustomersStoresIndexRouteImport } from './routes/_auth/_modules/_app/customers/stores/index'
import { Route as AuthModulesAppCustomersBannersIndexRouteImport } from './routes/_auth/_modules/_app/customers/banners/index'
import { Route as AuthModulesAppCoreUploadDataOrderServiceIndexRouteImport } from './routes/_auth/_modules/_app/core-upload-data/order-service/index'
import { Route as AuthModulesAppCoreUploadDataOperationsIndexRouteImport } from './routes/_auth/_modules/_app/core-upload-data/operations/index'
import { Route as AuthModulesAppCoreUploadDataOnHandInventoryIndexRouteImport } from './routes/_auth/_modules/_app/core-upload-data/on-hand-inventory/index'
import { Route as AuthModulesAppCoreUploadDataMaterialsIndexRouteImport } from './routes/_auth/_modules/_app/core-upload-data/materials/index'
import { Route as AuthModulesAppCoreUploadDataBusinessIndexRouteImport } from './routes/_auth/_modules/_app/core-upload-data/business/index'
import { Route as AuthModulesAppCoreUploadDataAutoInjectIndexRouteImport } from './routes/_auth/_modules/_app/core-upload-data/auto-inject/index'
import { Route as AuthModulesAppAssortmentLaunchesIndexRouteImport } from './routes/_auth/_modules/_app/assortment/launches/index'
import { Route as AuthModulesAppAssortmentBannersIndexRouteImport } from './routes/_auth/_modules/_app/assortment/banners/index'
import { Route as AuthModulesAppAssortmentActiveIndexRouteImport } from './routes/_auth/_modules/_app/assortment/active/index'
import { Route as AuthModulesAppAdminUsersIndexRouteImport } from './routes/_auth/_modules/_app/admin/users/index'
import { Route as AuthModulesAppAdminRolesIndexRouteImport } from './routes/_auth/_modules/_app/admin/roles/index'
import { Route as AuthModulesAppAdminInvitationsIndexRouteImport } from './routes/_auth/_modules/_app/admin/invitations/index'
import { Route as AuthModulesAppAdminAuditTrailsIndexRouteImport } from './routes/_auth/_modules/_app/admin/audit-trails/index'
import { Route as AuthModulesCrtPricingExciseTaxAssumptionsTaxAssumptionIdRouteImport } from './routes/_auth/_modules/crt/pricing-excise/tax-assumptions/$taxAssumptionId'
import { Route as AuthModulesCrtPricingExcisePricingAssumptionsPricingAssumptionIdRouteImport } from './routes/_auth/_modules/crt/pricing-excise/pricing-assumptions/$pricingAssumptionId'
import { Route as AuthModulesCrtMyUploadsScopeFileNameRouteImport } from './routes/_auth/_modules/crt/my-uploads/$scope.$fileName'
import { Route as AuthModulesCrtCostOfGoodsYearMonthRouteImport } from './routes/_auth/_modules/crt/cost-of-goods/$year.$month'
import { Route as AuthModulesCreditMyUploadsScopeFileNameRouteImport } from './routes/_auth/_modules/credit/my-uploads/$scope.$fileName'
import { Route as AuthModulesCreditCustomersErpPrepareClrRouteImport } from './routes/_auth/_modules/credit/customers/$erp/prepare-clr'
import { Route as AuthModulesCreditCreditLimitReviewsMassNewRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/mass/new'
import { Route as AuthModulesCreditBlockedOrdersGroupsGroupKeyRouteImport } from './routes/_auth/_modules/credit/blocked-orders/groups/$groupKey'
import { Route as AuthModulesAppReportsSalesforceReportIdRouteImport } from './routes/_auth/_modules/_app/reports/salesforce/$reportId'
import { Route as AuthModulesAppReportsOrderServiceReportIdRouteImport } from './routes/_auth/_modules/_app/reports/order-service/$reportId'
import { Route as AuthModulesAppReportsOperationsReportIdRouteImport } from './routes/_auth/_modules/_app/reports/operations/$reportId'
import { Route as AuthModulesAppReportsMiscReportIdRouteImport } from './routes/_auth/_modules/_app/reports/misc/$reportId'
import { Route as AuthModulesAppReportsMaterialReportIdRouteImport } from './routes/_auth/_modules/_app/reports/material/$reportId'
import { Route as AuthModulesAppReportsEccReportIdRouteImport } from './routes/_auth/_modules/_app/reports/ecc/$reportId'
import { Route as AuthModulesAppMyUploadsScopeFileNameRouteImport } from './routes/_auth/_modules/_app/my-uploads/$scope.$fileName'
import { Route as AuthModulesAppCustomersStoresStoreIdRouteImport } from './routes/_auth/_modules/_app/customers/stores/$storeId'
import { Route as AuthModulesAppCustomersBannersBannerIdRouteImport } from './routes/_auth/_modules/_app/customers/banners/$bannerId'
import { Route as AuthModulesAppAssortmentLaunchesLaunchIdRouteImport } from './routes/_auth/_modules/_app/assortment/launches/$launchId'
import { Route as AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRouteImport } from './routes/_auth/_modules/crt/pricing-excise/insights/retailer-rates/route'
import { Route as AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRouteImport } from './routes/_auth/_modules/crt/pricing-excise/insights/consumer-rates/route'
import { Route as AuthModulesCrtPricingExciseInsightsChannelMixRouteRouteImport } from './routes/_auth/_modules/crt/pricing-excise/insights/channel-mix/route'
import { Route as AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRouteImport } from './routes/_auth/_modules/crt/materials/insights/unreleased-materials/route'
import { Route as AuthModulesCrtMaterialsInsightsProductTypesRouteRouteImport } from './routes/_auth/_modules/crt/materials/insights/product-types/route'
import { Route as AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRouteImport } from './routes/_auth/_modules/crt/materials/insights/product-type-variants/route'
import { Route as AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRouteImport } from './routes/_auth/_modules/crt/materials/insights/material-groups-overrides/route'
import { Route as AuthModulesCrtMaterialsInsightsFederalExciseRouteRouteImport } from './routes/_auth/_modules/crt/materials/insights/federal-excise/route'
import { Route as AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/key-accounts/estimates/route'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals/route'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/rap-forecasts/route'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/master-agreements/route'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/manual-investments/route'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/ip-accruals/route'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/route'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals/route'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/budget-allocations/route'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/agreements/route'
import { Route as AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/mass/pending-confirmations/route'
import { Route as AuthModulesCreditCreditLimitReviewsMassRunIdRouteRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/mass/$runId/route'
import { Route as AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRouteImport } from './routes/_auth/_modules/credit/admin/users/delegation-of-authority/route'
import { Route as AuthModulesCrtPricingExciseInsightsRetailerRatesIndexRouteImport } from './routes/_auth/_modules/crt/pricing-excise/insights/retailer-rates/index'
import { Route as AuthModulesCrtPricingExciseInsightsConsumerRatesIndexRouteImport } from './routes/_auth/_modules/crt/pricing-excise/insights/consumer-rates/index'
import { Route as AuthModulesCrtPricingExciseInsightsChannelMixIndexRouteImport } from './routes/_auth/_modules/crt/pricing-excise/insights/channel-mix/index'
import { Route as AuthModulesCrtMaterialsInsightsUnreleasedMaterialsIndexRouteImport } from './routes/_auth/_modules/crt/materials/insights/unreleased-materials/index'
import { Route as AuthModulesCrtMaterialsInsightsProductTypesIndexRouteImport } from './routes/_auth/_modules/crt/materials/insights/product-types/index'
import { Route as AuthModulesCrtMaterialsInsightsProductTypeVariantsIndexRouteImport } from './routes/_auth/_modules/crt/materials/insights/product-type-variants/index'
import { Route as AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesIndexRouteImport } from './routes/_auth/_modules/crt/materials/insights/material-groups-overrides/index'
import { Route as AuthModulesCrtMaterialsInsightsFederalExciseIndexRouteImport } from './routes/_auth/_modules/crt/materials/insights/federal-excise/index'
import { Route as AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/key-accounts/estimates/index'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals/index'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsRapForecastsIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/rap-forecasts/index'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/master-agreements/index'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/manual-investments/index'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/ip-accruals/index'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/index'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals/index'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/budget-allocations/index'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsAgreementsIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/agreements/index'
import { Route as AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsIndexRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/mass/pending-confirmations/index'
import { Route as AuthModulesCreditCreditLimitReviewsMassRunIdIndexRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/mass/$runId/index'
import { Route as AuthModulesCreditAdminUsersDelegationOfAuthorityIndexRouteImport } from './routes/_auth/_modules/credit/admin/users/delegation-of-authority/index'
import { Route as AuthModulesCrtVolumeForecastsNcProvincialContributionsYearMonthRouteImport } from './routes/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions/$year.$month'
import { Route as AuthModulesCrtVolumeForecastsChannelContributionsYearMonthRouteImport } from './routes/_auth/_modules/crt/volume-forecasts/channel-contributions/$year.$month'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsManualInvestmentIdRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/manual-investments/$manualInvestmentId'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixBannerMixRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/banner-mix'
import { Route as AuthModulesCreditCreditLimitReviewsMassRunIdSubmitRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/mass/$runId/submit'
import { Route as AuthModulesCreditCreditLimitReviewsMassRunIdPendingConfirmationsRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/mass/$runId/pending-confirmations'
import { Route as AuthModulesCreditCreditLimitReviewsMassRunIdLinesRouteImport } from './routes/_auth/_modules/credit/credit-limit-reviews/mass/$runId/lines'
import { Route as AuthModulesAppOrdersAllDynamoIdPoNumberRouteImport } from './routes/_auth/_modules/_app/orders/all/$dynamoId.$poNumber'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/nc/route'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/fmc/route'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/retailer-margins/nc/route'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/retailer-margins/fmc/route'
import { Route as AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRouteImport } from './routes/_auth/_modules/credit/admin/users/delegation-of-authority/single-with-deviation/route'
import { Route as AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRouteImport } from './routes/_auth/_modules/credit/admin/users/delegation-of-authority/single-no-deviation/route'
import { Route as AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRouteImport } from './routes/_auth/_modules/credit/admin/users/delegation-of-authority/mass/route'
import { Route as AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRouteImport } from './routes/_auth/_modules/credit/admin/users/delegation-of-authority/initiative/route'
import { Route as AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRouteImport } from './routes/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/route'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/nc/index'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/fmc/index'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/retailer-margins/nc/index'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcIndexRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/retailer-margins/fmc/index'
import { Route as AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationIndexRouteImport } from './routes/_auth/_modules/credit/admin/users/delegation-of-authority/single-with-deviation/index'
import { Route as AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationIndexRouteImport } from './routes/_auth/_modules/credit/admin/users/delegation-of-authority/single-no-deviation/index'
import { Route as AuthModulesCreditAdminUsersDelegationOfAuthorityMassIndexRouteImport } from './routes/_auth/_modules/credit/admin/users/delegation-of-authority/mass/index'
import { Route as AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeIndexRouteImport } from './routes/_auth/_modules/credit/admin/users/delegation-of-authority/initiative/index'
import { Route as AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersIndexRouteImport } from './routes/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/index'
import { Route as AuthModulesCrtPricingExciseInsightsChannelMixYearMonthRouteImport } from './routes/_auth/_modules/crt/pricing-excise/insights/channel-mix/$year.$month'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsYearMonthRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals/$year.$month'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsRapForecastsYearMonthRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/rap-forecasts/$year.$month'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsYearMonthRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/ip-accruals/$year.$month'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixYearMonthRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/$year.$month'
import { Route as AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsYearMonthRouteImport } from './routes/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals/$year.$month'
import { Route as AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRouteImport } from './routes/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers/route'
import { Route as AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersIndexRouteImport } from './routes/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers/index'

const ProcessLoginRoute = ProcessLoginRouteImport.update({
  id: '/process-login',
  path: '/process-login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthUnverifiedRouteRoute = AuthUnverifiedRouteRouteImport.update({
  id: '/unverified',
  path: '/unverified',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthModulesRouteRoute = AuthModulesRouteRouteImport.update({
  id: '/_modules',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthUnverifiedIndexRoute = AuthUnverifiedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthUnverifiedRouteRoute,
} as any)
const AuthModulesIndexRoute = AuthModulesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthModulesRouteRoute,
} as any)
const AuthTrackErpRoute = AuthTrackErpRouteImport.update({
  id: '/track/$erp',
  path: '/track/$erp',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthModulesCrtRouteRoute = AuthModulesCrtRouteRouteImport.update({
  id: '/crt',
  path: '/crt',
  getParentRoute: () => AuthModulesRouteRoute,
} as any)
const AuthModulesCreditRouteRoute = AuthModulesCreditRouteRouteImport.update({
  id: '/credit',
  path: '/credit',
  getParentRoute: () => AuthModulesRouteRoute,
} as any)
const AuthModulesAppRouteRoute = AuthModulesAppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => AuthModulesRouteRoute,
} as any)
const AuthModulesSharedKitchenSinkRoute =
  AuthModulesSharedKitchenSinkRouteImport.update({
    id: '/_shared/kitchen-sink',
    path: '/kitchen-sink',
    getParentRoute: () => AuthModulesRouteRoute,
  } as any)
const AuthModulesCrtWelcomeRouteRoute =
  AuthModulesCrtWelcomeRouteRouteImport.update({
    id: '/welcome',
    path: '/welcome',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtVolumesRouteRoute =
  AuthModulesCrtVolumesRouteRouteImport.update({
    id: '/volumes',
    path: '/volumes',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtVolumeScenariosRouteRoute =
  AuthModulesCrtVolumeScenariosRouteRouteImport.update({
    id: '/volume-scenarios',
    path: '/volume-scenarios',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtVolumeForecastsRouteRoute =
  AuthModulesCrtVolumeForecastsRouteRouteImport.update({
    id: '/volume-forecasts',
    path: '/volume-forecasts',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtVarianceAnalysisRouteRoute =
  AuthModulesCrtVarianceAnalysisRouteRouteImport.update({
    id: '/variance-analysis',
    path: '/variance-analysis',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtSettingsRouteRoute =
  AuthModulesCrtSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtPricingExciseRouteRoute =
  AuthModulesCrtPricingExciseRouteRouteImport.update({
    id: '/pricing-excise',
    path: '/pricing-excise',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtMyUploadsRouteRoute =
  AuthModulesCrtMyUploadsRouteRouteImport.update({
    id: '/my-uploads',
    path: '/my-uploads',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtMyExportsRouteRoute =
  AuthModulesCrtMyExportsRouteRouteImport.update({
    id: '/my-exports',
    path: '/my-exports',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtMaterialsRouteRoute =
  AuthModulesCrtMaterialsRouteRouteImport.update({
    id: '/materials',
    path: '/materials',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtKpiReportsRouteRoute =
  AuthModulesCrtKpiReportsRouteRouteImport.update({
    id: '/kpi-reports',
    path: '/kpi-reports',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtCustomersRouteRoute =
  AuthModulesCrtCustomersRouteRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsRouteRoute =
  AuthModulesCrtCustomerInvestmentsRouteRouteImport.update({
    id: '/customer-investments',
    path: '/customer-investments',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtCostOfGoodsRouteRoute =
  AuthModulesCrtCostOfGoodsRouteRouteImport.update({
    id: '/cost-of-goods',
    path: '/cost-of-goods',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtBpcActualsRouteRoute =
  AuthModulesCrtBpcActualsRouteRouteImport.update({
    id: '/bpc-actuals',
    path: '/bpc-actuals',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtAzureImportsRouteRoute =
  AuthModulesCrtAzureImportsRouteRouteImport.update({
    id: '/azure-imports',
    path: '/azure-imports',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCrtAdminRouteRoute =
  AuthModulesCrtAdminRouteRouteImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => AuthModulesCrtRouteRoute,
  } as any)
const AuthModulesCreditWelcomeRouteRoute =
  AuthModulesCreditWelcomeRouteRouteImport.update({
    id: '/welcome',
    path: '/welcome',
    getParentRoute: () => AuthModulesCreditRouteRoute,
  } as any)
const AuthModulesCreditOperationsRouteRoute =
  AuthModulesCreditOperationsRouteRouteImport.update({
    id: '/operations',
    path: '/operations',
    getParentRoute: () => AuthModulesCreditRouteRoute,
  } as any)
const AuthModulesCreditMyUploadsRouteRoute =
  AuthModulesCreditMyUploadsRouteRouteImport.update({
    id: '/my-uploads',
    path: '/my-uploads',
    getParentRoute: () => AuthModulesCreditRouteRoute,
  } as any)
const AuthModulesCreditMyExportsRouteRoute =
  AuthModulesCreditMyExportsRouteRouteImport.update({
    id: '/my-exports',
    path: '/my-exports',
    getParentRoute: () => AuthModulesCreditRouteRoute,
  } as any)
const AuthModulesCreditInitiativesRouteRoute =
  AuthModulesCreditInitiativesRouteRouteImport.update({
    id: '/initiatives',
    path: '/initiatives',
    getParentRoute: () => AuthModulesCreditRouteRoute,
  } as any)
const AuthModulesCreditInboxRouteRoute =
  AuthModulesCreditInboxRouteRouteImport.update({
    id: '/inbox',
    path: '/inbox',
    getParentRoute: () => AuthModulesCreditRouteRoute,
  } as any)
const AuthModulesCreditGoogleFinancialStatementsRouteRoute =
  AuthModulesCreditGoogleFinancialStatementsRouteRouteImport.update({
    id: '/google-financial-statements',
    path: '/google-financial-statements',
    getParentRoute: () => AuthModulesCreditRouteRoute,
  } as any)
const AuthModulesCreditCustomersRouteRoute =
  AuthModulesCreditCustomersRouteRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthModulesCreditRouteRoute,
  } as any)
const AuthModulesCreditCreditLimitReviewsRouteRoute =
  AuthModulesCreditCreditLimitReviewsRouteRouteImport.update({
    id: '/credit-limit-reviews',
    path: '/credit-limit-reviews',
    getParentRoute: () => AuthModulesCreditRouteRoute,
  } as any)
const AuthModulesCreditCreditIndexScoresRouteRoute =
  AuthModulesCreditCreditIndexScoresRouteRouteImport.update({
    id: '/credit-index-scores',
    path: '/credit-index-scores',
    getParentRoute: () => AuthModulesCreditRouteRoute,
  } as any)
const AuthModulesCreditBlockedOrdersRouteRoute =
  AuthModulesCreditBlockedOrdersRouteRouteImport.update({
    id: '/blocked-orders',
    path: '/blocked-orders',
    getParentRoute: () => AuthModulesCreditRouteRoute,
  } as any)
const AuthModulesCreditAdminRouteRoute =
  AuthModulesCreditAdminRouteRouteImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => AuthModulesCreditRouteRoute,
  } as any)
const AuthModulesAppWelcomeRouteRoute =
  AuthModulesAppWelcomeRouteRouteImport.update({
    id: '/welcome',
    path: '/welcome',
    getParentRoute: () => AuthModulesAppRouteRoute,
  } as any)
const AuthModulesAppSoxComplianceRouteRoute =
  AuthModulesAppSoxComplianceRouteRouteImport.update({
    id: '/sox-compliance',
    path: '/sox-compliance',
    getParentRoute: () => AuthModulesAppRouteRoute,
  } as any)
const AuthModulesAppReportsRouteRoute =
  AuthModulesAppReportsRouteRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthModulesAppRouteRoute,
  } as any)
const AuthModulesAppProcessesRouteRoute =
  AuthModulesAppProcessesRouteRouteImport.update({
    id: '/processes',
    path: '/processes',
    getParentRoute: () => AuthModulesAppRouteRoute,
  } as any)
const AuthModulesAppOrdersRouteRoute =
  AuthModulesAppOrdersRouteRouteImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => AuthModulesAppRouteRoute,
  } as any)
const AuthModulesAppOperationsRouteRoute =
  AuthModulesAppOperationsRouteRouteImport.update({
    id: '/operations',
    path: '/operations',
    getParentRoute: () => AuthModulesAppRouteRoute,
  } as any)
const AuthModulesAppMyUploadsRouteRoute =
  AuthModulesAppMyUploadsRouteRouteImport.update({
    id: '/my-uploads',
    path: '/my-uploads',
    getParentRoute: () => AuthModulesAppRouteRoute,
  } as any)
const AuthModulesAppMaterialsRouteRoute =
  AuthModulesAppMaterialsRouteRouteImport.update({
    id: '/materials',
    path: '/materials',
    getParentRoute: () => AuthModulesAppRouteRoute,
  } as any)
const AuthModulesAppCustomersRouteRoute =
  AuthModulesAppCustomersRouteRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthModulesAppRouteRoute,
  } as any)
const AuthModulesAppCoreUploadDataRouteRoute =
  AuthModulesAppCoreUploadDataRouteRouteImport.update({
    id: '/core-upload-data',
    path: '/core-upload-data',
    getParentRoute: () => AuthModulesAppRouteRoute,
  } as any)
const AuthModulesAppAssortmentRouteRoute =
  AuthModulesAppAssortmentRouteRouteImport.update({
    id: '/assortment',
    path: '/assortment',
    getParentRoute: () => AuthModulesAppRouteRoute,
  } as any)
const AuthModulesAppAdminRouteRoute =
  AuthModulesAppAdminRouteRouteImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => AuthModulesAppRouteRoute,
  } as any)
const AuthModulesCrtWelcomeIndexRoute =
  AuthModulesCrtWelcomeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtWelcomeRouteRoute,
  } as any)
const AuthModulesCrtVolumeScenariosIndexRoute =
  AuthModulesCrtVolumeScenariosIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtVolumeScenariosRouteRoute,
  } as any)
const AuthModulesCrtVolumeForecastsIndexRoute =
  AuthModulesCrtVolumeForecastsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtVolumeForecastsRouteRoute,
  } as any)
const AuthModulesCrtVarianceAnalysisIndexRoute =
  AuthModulesCrtVarianceAnalysisIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtVarianceAnalysisRouteRoute,
  } as any)
const AuthModulesCrtSettingsIndexRoute =
  AuthModulesCrtSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtSettingsRouteRoute,
  } as any)
const AuthModulesCrtPricingExciseIndexRoute =
  AuthModulesCrtPricingExciseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtPricingExciseRouteRoute,
  } as any)
const AuthModulesCrtMyUploadsIndexRoute =
  AuthModulesCrtMyUploadsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtMyUploadsRouteRoute,
  } as any)
const AuthModulesCrtMyExportsIndexRoute =
  AuthModulesCrtMyExportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtMyExportsRouteRoute,
  } as any)
const AuthModulesCrtMaterialsIndexRoute =
  AuthModulesCrtMaterialsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtMaterialsRouteRoute,
  } as any)
const AuthModulesCrtKpiReportsIndexRoute =
  AuthModulesCrtKpiReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtKpiReportsRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsIndexRoute =
  AuthModulesCrtCustomerInvestmentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtCustomerInvestmentsRouteRoute,
  } as any)
const AuthModulesCrtCostOfGoodsIndexRoute =
  AuthModulesCrtCostOfGoodsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtCostOfGoodsRouteRoute,
  } as any)
const AuthModulesCrtBpcActualsIndexRoute =
  AuthModulesCrtBpcActualsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtBpcActualsRouteRoute,
  } as any)
const AuthModulesCrtAzureImportsIndexRoute =
  AuthModulesCrtAzureImportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtAzureImportsRouteRoute,
  } as any)
const AuthModulesCrtAdminIndexRoute =
  AuthModulesCrtAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtAdminRouteRoute,
  } as any)
const AuthModulesCreditWelcomeIndexRoute =
  AuthModulesCreditWelcomeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditWelcomeRouteRoute,
  } as any)
const AuthModulesCreditOperationsIndexRoute =
  AuthModulesCreditOperationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditOperationsRouteRoute,
  } as any)
const AuthModulesCreditMyUploadsIndexRoute =
  AuthModulesCreditMyUploadsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditMyUploadsRouteRoute,
  } as any)
const AuthModulesCreditMyExportsIndexRoute =
  AuthModulesCreditMyExportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditMyExportsRouteRoute,
  } as any)
const AuthModulesCreditInitiativesIndexRoute =
  AuthModulesCreditInitiativesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditInitiativesRouteRoute,
  } as any)
const AuthModulesCreditInboxIndexRoute =
  AuthModulesCreditInboxIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditInboxRouteRoute,
  } as any)
const AuthModulesCreditGoogleFinancialStatementsIndexRoute =
  AuthModulesCreditGoogleFinancialStatementsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditGoogleFinancialStatementsRouteRoute,
  } as any)
const AuthModulesCreditCustomersIndexRoute =
  AuthModulesCreditCustomersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditCustomersRouteRoute,
  } as any)
const AuthModulesCreditCreditLimitReviewsIndexRoute =
  AuthModulesCreditCreditLimitReviewsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditCreditLimitReviewsRouteRoute,
  } as any)
const AuthModulesCreditCreditIndexScoresIndexRoute =
  AuthModulesCreditCreditIndexScoresIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditCreditIndexScoresRouteRoute,
  } as any)
const AuthModulesCreditBlockedOrdersIndexRoute =
  AuthModulesCreditBlockedOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditBlockedOrdersRouteRoute,
  } as any)
const AuthModulesCreditAdminIndexRoute =
  AuthModulesCreditAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditAdminRouteRoute,
  } as any)
const AuthModulesAppWelcomeIndexRoute =
  AuthModulesAppWelcomeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppWelcomeRouteRoute,
  } as any)
const AuthModulesAppSoxComplianceIndexRoute =
  AuthModulesAppSoxComplianceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppSoxComplianceRouteRoute,
  } as any)
const AuthModulesAppReportsIndexRoute =
  AuthModulesAppReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppReportsRouteRoute,
  } as any)
const AuthModulesAppProcessesIndexRoute =
  AuthModulesAppProcessesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppProcessesRouteRoute,
  } as any)
const AuthModulesAppOrdersIndexRoute =
  AuthModulesAppOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppOrdersRouteRoute,
  } as any)
const AuthModulesAppOperationsIndexRoute =
  AuthModulesAppOperationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppOperationsRouteRoute,
  } as any)
const AuthModulesAppMyUploadsIndexRoute =
  AuthModulesAppMyUploadsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppMyUploadsRouteRoute,
  } as any)
const AuthModulesAppMaterialsIndexRoute =
  AuthModulesAppMaterialsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppMaterialsRouteRoute,
  } as any)
const AuthModulesAppCustomersIndexRoute =
  AuthModulesAppCustomersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppCustomersRouteRoute,
  } as any)
const AuthModulesAppCoreUploadDataIndexRoute =
  AuthModulesAppCoreUploadDataIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppCoreUploadDataRouteRoute,
  } as any)
const AuthModulesAppAssortmentIndexRoute =
  AuthModulesAppAssortmentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppAssortmentRouteRoute,
  } as any)
const AuthModulesAppAdminIndexRoute =
  AuthModulesAppAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppAdminRouteRoute,
  } as any)
const AuthModulesCrtVolumeScenariosVolumeScenarioIdRoute =
  AuthModulesCrtVolumeScenariosVolumeScenarioIdRouteImport.update({
    id: '/$volumeScenarioId',
    path: '/$volumeScenarioId',
    getParentRoute: () => AuthModulesCrtVolumeScenariosRouteRoute,
  } as any)
const AuthModulesCrtVarianceAnalysisByCostTypeRoute =
  AuthModulesCrtVarianceAnalysisByCostTypeRouteImport.update({
    id: '/by-cost-type',
    path: '/by-cost-type',
    getParentRoute: () => AuthModulesCrtVarianceAnalysisRouteRoute,
  } as any)
const AuthModulesCrtVarianceAnalysisByBudgetRoute =
  AuthModulesCrtVarianceAnalysisByBudgetRouteImport.update({
    id: '/by-budget',
    path: '/by-budget',
    getParentRoute: () => AuthModulesCrtVarianceAnalysisRouteRoute,
  } as any)
const AuthModulesCrtVarianceAnalysisByBannerRoute =
  AuthModulesCrtVarianceAnalysisByBannerRouteImport.update({
    id: '/by-banner',
    path: '/by-banner',
    getParentRoute: () => AuthModulesCrtVarianceAnalysisRouteRoute,
  } as any)
const AuthModulesCrtVarianceAnalysisByAgreementRoute =
  AuthModulesCrtVarianceAnalysisByAgreementRouteImport.update({
    id: '/by-agreement',
    path: '/by-agreement',
    getParentRoute: () => AuthModulesCrtVarianceAnalysisRouteRoute,
  } as any)
const AuthModulesCrtKpiReportsGraphsRoute =
  AuthModulesCrtKpiReportsGraphsRouteImport.update({
    id: '/graphs',
    path: '/graphs',
    getParentRoute: () => AuthModulesCrtKpiReportsRouteRoute,
  } as any)
const AuthModulesCrtBpcActualsYearRoute =
  AuthModulesCrtBpcActualsYearRouteImport.update({
    id: '/$year',
    path: '/$year',
    getParentRoute: () => AuthModulesCrtBpcActualsRouteRoute,
  } as any)
const AuthModulesCreditInitiativesIdRoute =
  AuthModulesCreditInitiativesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthModulesCreditInitiativesRouteRoute,
  } as any)
const AuthModulesCreditGoogleFinancialStatementsSapErpRoute =
  AuthModulesCreditGoogleFinancialStatementsSapErpRouteImport.update({
    id: '/$sapErp',
    path: '/$sapErp',
    getParentRoute: () => AuthModulesCreditGoogleFinancialStatementsRouteRoute,
  } as any)
const AuthModulesCreditCreditLimitReviewsReviewIdRoute =
  AuthModulesCreditCreditLimitReviewsReviewIdRouteImport.update({
    id: '/$reviewId',
    path: '/$reviewId',
    getParentRoute: () => AuthModulesCreditCreditLimitReviewsRouteRoute,
  } as any)
const AuthModulesSharedErrorsUnauthorizedRoute =
  AuthModulesSharedErrorsUnauthorizedRouteImport.update({
    id: '/_shared/_errors/unauthorized',
    path: '/unauthorized',
    getParentRoute: () => AuthModulesRouteRoute,
  } as any)
const AuthModulesSharedErrorsNotFoundRoute =
  AuthModulesSharedErrorsNotFoundRouteImport.update({
    id: '/_shared/_errors/not-found',
    path: '/not-found',
    getParentRoute: () => AuthModulesRouteRoute,
  } as any)
const AuthModulesSharedErrorsErrorRoute =
  AuthModulesSharedErrorsErrorRouteImport.update({
    id: '/_shared/_errors/error',
    path: '/error',
    getParentRoute: () => AuthModulesRouteRoute,
  } as any)
const AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRoute =
  AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRouteImport.update({
    id: '/sub-channel-allocations',
    path: '/sub-channel-allocations',
    getParentRoute: () => AuthModulesCrtVolumeForecastsRouteRoute,
  } as any)
const AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRoute =
  AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRouteImport.update(
    {
      id: '/nc-provincial-contributions',
      path: '/nc-provincial-contributions',
      getParentRoute: () => AuthModulesCrtVolumeForecastsRouteRoute,
    } as any,
  )
const AuthModulesCrtVolumeForecastsChannelContributionsRouteRoute =
  AuthModulesCrtVolumeForecastsChannelContributionsRouteRouteImport.update({
    id: '/channel-contributions',
    path: '/channel-contributions',
    getParentRoute: () => AuthModulesCrtVolumeForecastsRouteRoute,
  } as any)
const AuthModulesCrtPricingExciseTaxAssumptionsRouteRoute =
  AuthModulesCrtPricingExciseTaxAssumptionsRouteRouteImport.update({
    id: '/tax-assumptions',
    path: '/tax-assumptions',
    getParentRoute: () => AuthModulesCrtPricingExciseRouteRoute,
  } as any)
const AuthModulesCrtPricingExcisePricingRateTableRouteRoute =
  AuthModulesCrtPricingExcisePricingRateTableRouteRouteImport.update({
    id: '/pricing-rate-table',
    path: '/pricing-rate-table',
    getParentRoute: () => AuthModulesCrtPricingExciseRouteRoute,
  } as any)
const AuthModulesCrtPricingExcisePricingAssumptionsRouteRoute =
  AuthModulesCrtPricingExcisePricingAssumptionsRouteRouteImport.update({
    id: '/pricing-assumptions',
    path: '/pricing-assumptions',
    getParentRoute: () => AuthModulesCrtPricingExciseRouteRoute,
  } as any)
const AuthModulesCrtPricingExciseInsightsRouteRoute =
  AuthModulesCrtPricingExciseInsightsRouteRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => AuthModulesCrtPricingExciseRouteRoute,
  } as any)
const AuthModulesCrtMaterialsPriceListRouteRoute =
  AuthModulesCrtMaterialsPriceListRouteRouteImport.update({
    id: '/price-list',
    path: '/price-list',
    getParentRoute: () => AuthModulesCrtMaterialsRouteRoute,
  } as any)
const AuthModulesCrtMaterialsMaterialsListRouteRoute =
  AuthModulesCrtMaterialsMaterialsListRouteRouteImport.update({
    id: '/materials-list',
    path: '/materials-list',
    getParentRoute: () => AuthModulesCrtMaterialsRouteRoute,
  } as any)
const AuthModulesCrtMaterialsInsightsRouteRoute =
  AuthModulesCrtMaterialsInsightsRouteRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => AuthModulesCrtMaterialsRouteRoute,
  } as any)
const AuthModulesCrtMaterialsBrandVariantsRouteRoute =
  AuthModulesCrtMaterialsBrandVariantsRouteRouteImport.update({
    id: '/brand-variants',
    path: '/brand-variants',
    getParentRoute: () => AuthModulesCrtMaterialsRouteRoute,
  } as any)
const AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRoute =
  AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRouteImport.update({
    id: '/profits-and-loss-summary',
    path: '/profits-and-loss-summary',
    getParentRoute: () => AuthModulesCrtKpiReportsRouteRoute,
  } as any)
const AuthModulesCrtKpiReportsCashDashboardRouteRoute =
  AuthModulesCrtKpiReportsCashDashboardRouteRouteImport.update({
    id: '/cash-dashboard',
    path: '/cash-dashboard',
    getParentRoute: () => AuthModulesCrtKpiReportsRouteRoute,
  } as any)
const AuthModulesCrtCustomersCommercialPartnersRouteRoute =
  AuthModulesCrtCustomersCommercialPartnersRouteRouteImport.update({
    id: '/commercial-partners',
    path: '/commercial-partners',
    getParentRoute: () => AuthModulesCrtCustomersRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRoute =
  AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRouteImport.update({
    id: '/key-accounts',
    path: '/key-accounts',
    getParentRoute: () => AuthModulesCrtCustomerInvestmentsRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsInvestmentsRouteRoute =
  AuthModulesCrtCustomerInvestmentsInvestmentsRouteRouteImport.update({
    id: '/investments',
    path: '/investments',
    getParentRoute: () => AuthModulesCrtCustomerInvestmentsRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsInsightsRouteRoute =
  AuthModulesCrtCustomerInvestmentsInsightsRouteRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => AuthModulesCrtCustomerInvestmentsRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRoute =
  AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRouteImport.update({
    id: '/budget-tracker',
    path: '/budget-tracker',
    getParentRoute: () => AuthModulesCrtCustomerInvestmentsRouteRoute,
  } as any)
const AuthModulesCrtAdminUsersRouteRoute =
  AuthModulesCrtAdminUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthModulesCrtAdminRouteRoute,
  } as any)
const AuthModulesCrtAdminRolesRouteRoute =
  AuthModulesCrtAdminRolesRouteRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthModulesCrtAdminRouteRoute,
  } as any)
const AuthModulesCrtAdminNotificationsRouteRoute =
  AuthModulesCrtAdminNotificationsRouteRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthModulesCrtAdminRouteRoute,
  } as any)
const AuthModulesCrtAdminInvitationsRouteRoute =
  AuthModulesCrtAdminInvitationsRouteRouteImport.update({
    id: '/invitations',
    path: '/invitations',
    getParentRoute: () => AuthModulesCrtAdminRouteRoute,
  } as any)
const AuthModulesCrtAdminAuditTrailsRouteRoute =
  AuthModulesCrtAdminAuditTrailsRouteRouteImport.update({
    id: '/audit-trails',
    path: '/audit-trails',
    getParentRoute: () => AuthModulesCrtAdminRouteRoute,
  } as any)
const AuthModulesCreditOperationsVeryLowRiskCustomersRouteRoute =
  AuthModulesCreditOperationsVeryLowRiskCustomersRouteRouteImport.update({
    id: '/very-low-risk-customers',
    path: '/very-low-risk-customers',
    getParentRoute: () => AuthModulesCreditOperationsRouteRoute,
  } as any)
const AuthModulesCreditOperationsProvinceAovPerCartonRouteRoute =
  AuthModulesCreditOperationsProvinceAovPerCartonRouteRouteImport.update({
    id: '/province-aov-per-carton',
    path: '/province-aov-per-carton',
    getParentRoute: () => AuthModulesCreditOperationsRouteRoute,
  } as any)
const AuthModulesCreditOperationsOrderCutoffsRouteRoute =
  AuthModulesCreditOperationsOrderCutoffsRouteRouteImport.update({
    id: '/order-cutoffs',
    path: '/order-cutoffs',
    getParentRoute: () => AuthModulesCreditOperationsRouteRoute,
  } as any)
const AuthModulesCreditOperationsMultiplierRouteRoute =
  AuthModulesCreditOperationsMultiplierRouteRouteImport.update({
    id: '/multiplier',
    path: '/multiplier',
    getParentRoute: () => AuthModulesCreditOperationsRouteRoute,
  } as any)
const AuthModulesCreditCustomersErpRouteRoute =
  AuthModulesCreditCustomersErpRouteRouteImport.update({
    id: '/$erp',
    path: '/$erp',
    getParentRoute: () => AuthModulesCreditCustomersRouteRoute,
  } as any)
const AuthModulesCreditCreditLimitReviewsReviewEventsRouteRoute =
  AuthModulesCreditCreditLimitReviewsReviewEventsRouteRouteImport.update({
    id: '/review-events',
    path: '/review-events',
    getParentRoute: () => AuthModulesCreditCreditLimitReviewsRouteRoute,
  } as any)
const AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRoute =
  AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRouteImport.update(
    {
      id: '/pending-confirmations',
      path: '/pending-confirmations',
      getParentRoute: () => AuthModulesCreditCreditLimitReviewsRouteRoute,
    } as any,
  )
const AuthModulesCreditCreditLimitReviewsMassRouteRoute =
  AuthModulesCreditCreditLimitReviewsMassRouteRouteImport.update({
    id: '/mass',
    path: '/mass',
    getParentRoute: () => AuthModulesCreditCreditLimitReviewsRouteRoute,
  } as any)
const AuthModulesCreditAdminUsersRouteRoute =
  AuthModulesCreditAdminUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthModulesCreditAdminRouteRoute,
  } as any)
const AuthModulesCreditAdminRolesRouteRoute =
  AuthModulesCreditAdminRolesRouteRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthModulesCreditAdminRouteRoute,
  } as any)
const AuthModulesCreditAdminInvitationsRouteRoute =
  AuthModulesCreditAdminInvitationsRouteRouteImport.update({
    id: '/invitations',
    path: '/invitations',
    getParentRoute: () => AuthModulesCreditAdminRouteRoute,
  } as any)
const AuthModulesCreditAdminAuditTrailsRouteRoute =
  AuthModulesCreditAdminAuditTrailsRouteRouteImport.update({
    id: '/audit-trails',
    path: '/audit-trails',
    getParentRoute: () => AuthModulesCreditAdminRouteRoute,
  } as any)
const AuthModulesAppReportsSalesforceRouteRoute =
  AuthModulesAppReportsSalesforceRouteRouteImport.update({
    id: '/salesforce',
    path: '/salesforce',
    getParentRoute: () => AuthModulesAppReportsRouteRoute,
  } as any)
const AuthModulesAppReportsOrderServiceRouteRoute =
  AuthModulesAppReportsOrderServiceRouteRouteImport.update({
    id: '/order-service',
    path: '/order-service',
    getParentRoute: () => AuthModulesAppReportsRouteRoute,
  } as any)
const AuthModulesAppReportsOperationsRouteRoute =
  AuthModulesAppReportsOperationsRouteRouteImport.update({
    id: '/operations',
    path: '/operations',
    getParentRoute: () => AuthModulesAppReportsRouteRoute,
  } as any)
const AuthModulesAppReportsMiscRouteRoute =
  AuthModulesAppReportsMiscRouteRouteImport.update({
    id: '/misc',
    path: '/misc',
    getParentRoute: () => AuthModulesAppReportsRouteRoute,
  } as any)
const AuthModulesAppReportsMaterialRouteRoute =
  AuthModulesAppReportsMaterialRouteRouteImport.update({
    id: '/material',
    path: '/material',
    getParentRoute: () => AuthModulesAppReportsRouteRoute,
  } as any)
const AuthModulesAppReportsEccRouteRoute =
  AuthModulesAppReportsEccRouteRouteImport.update({
    id: '/ecc',
    path: '/ecc',
    getParentRoute: () => AuthModulesAppReportsRouteRoute,
  } as any)
const AuthModulesAppProcessesPipelinesRouteRoute =
  AuthModulesAppProcessesPipelinesRouteRouteImport.update({
    id: '/pipelines',
    path: '/pipelines',
    getParentRoute: () => AuthModulesAppProcessesRouteRoute,
  } as any)
const AuthModulesAppOrdersReturnsRouteRoute =
  AuthModulesAppOrdersReturnsRouteRouteImport.update({
    id: '/returns',
    path: '/returns',
    getParentRoute: () => AuthModulesAppOrdersRouteRoute,
  } as any)
const AuthModulesAppOrdersPaymentReviewRouteRoute =
  AuthModulesAppOrdersPaymentReviewRouteRouteImport.update({
    id: '/payment-review',
    path: '/payment-review',
    getParentRoute: () => AuthModulesAppOrdersRouteRoute,
  } as any)
const AuthModulesAppOrdersMissingRouteRoute =
  AuthModulesAppOrdersMissingRouteRouteImport.update({
    id: '/missing',
    path: '/missing',
    getParentRoute: () => AuthModulesAppOrdersRouteRoute,
  } as any)
const AuthModulesAppOrdersFlaggedRouteRoute =
  AuthModulesAppOrdersFlaggedRouteRouteImport.update({
    id: '/flagged',
    path: '/flagged',
    getParentRoute: () => AuthModulesAppOrdersRouteRoute,
  } as any)
const AuthModulesAppOrdersAllRouteRoute =
  AuthModulesAppOrdersAllRouteRouteImport.update({
    id: '/all',
    path: '/all',
    getParentRoute: () => AuthModulesAppOrdersRouteRoute,
  } as any)
const AuthModulesAppMaterialsBcpPricedRouteRoute =
  AuthModulesAppMaterialsBcpPricedRouteRouteImport.update({
    id: '/bcp-priced',
    path: '/bcp-priced',
    getParentRoute: () => AuthModulesAppMaterialsRouteRoute,
  } as any)
const AuthModulesAppCustomersStoresRouteRoute =
  AuthModulesAppCustomersStoresRouteRouteImport.update({
    id: '/stores',
    path: '/stores',
    getParentRoute: () => AuthModulesAppCustomersRouteRoute,
  } as any)
const AuthModulesAppCustomersBannersRouteRoute =
  AuthModulesAppCustomersBannersRouteRouteImport.update({
    id: '/banners',
    path: '/banners',
    getParentRoute: () => AuthModulesAppCustomersRouteRoute,
  } as any)
const AuthModulesAppCoreUploadDataOrderServiceRouteRoute =
  AuthModulesAppCoreUploadDataOrderServiceRouteRouteImport.update({
    id: '/order-service',
    path: '/order-service',
    getParentRoute: () => AuthModulesAppCoreUploadDataRouteRoute,
  } as any)
const AuthModulesAppCoreUploadDataOperationsRouteRoute =
  AuthModulesAppCoreUploadDataOperationsRouteRouteImport.update({
    id: '/operations',
    path: '/operations',
    getParentRoute: () => AuthModulesAppCoreUploadDataRouteRoute,
  } as any)
const AuthModulesAppCoreUploadDataOnHandInventoryRouteRoute =
  AuthModulesAppCoreUploadDataOnHandInventoryRouteRouteImport.update({
    id: '/on-hand-inventory',
    path: '/on-hand-inventory',
    getParentRoute: () => AuthModulesAppCoreUploadDataRouteRoute,
  } as any)
const AuthModulesAppCoreUploadDataMaterialsRouteRoute =
  AuthModulesAppCoreUploadDataMaterialsRouteRouteImport.update({
    id: '/materials',
    path: '/materials',
    getParentRoute: () => AuthModulesAppCoreUploadDataRouteRoute,
  } as any)
const AuthModulesAppCoreUploadDataBusinessRouteRoute =
  AuthModulesAppCoreUploadDataBusinessRouteRouteImport.update({
    id: '/business',
    path: '/business',
    getParentRoute: () => AuthModulesAppCoreUploadDataRouteRoute,
  } as any)
const AuthModulesAppCoreUploadDataAutoInjectRouteRoute =
  AuthModulesAppCoreUploadDataAutoInjectRouteRouteImport.update({
    id: '/auto-inject',
    path: '/auto-inject',
    getParentRoute: () => AuthModulesAppCoreUploadDataRouteRoute,
  } as any)
const AuthModulesAppAssortmentLaunchesRouteRoute =
  AuthModulesAppAssortmentLaunchesRouteRouteImport.update({
    id: '/launches',
    path: '/launches',
    getParentRoute: () => AuthModulesAppAssortmentRouteRoute,
  } as any)
const AuthModulesAppAssortmentBannersRouteRoute =
  AuthModulesAppAssortmentBannersRouteRouteImport.update({
    id: '/banners',
    path: '/banners',
    getParentRoute: () => AuthModulesAppAssortmentRouteRoute,
  } as any)
const AuthModulesAppAssortmentActiveRouteRoute =
  AuthModulesAppAssortmentActiveRouteRouteImport.update({
    id: '/active',
    path: '/active',
    getParentRoute: () => AuthModulesAppAssortmentRouteRoute,
  } as any)
const AuthModulesAppAdminUsersRouteRoute =
  AuthModulesAppAdminUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthModulesAppAdminRouteRoute,
  } as any)
const AuthModulesAppAdminRolesRouteRoute =
  AuthModulesAppAdminRolesRouteRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthModulesAppAdminRouteRoute,
  } as any)
const AuthModulesAppAdminInvitationsRouteRoute =
  AuthModulesAppAdminInvitationsRouteRouteImport.update({
    id: '/invitations',
    path: '/invitations',
    getParentRoute: () => AuthModulesAppAdminRouteRoute,
  } as any)
const AuthModulesAppAdminAuditTrailsRouteRoute =
  AuthModulesAppAdminAuditTrailsRouteRouteImport.update({
    id: '/audit-trails',
    path: '/audit-trails',
    getParentRoute: () => AuthModulesAppAdminRouteRoute,
  } as any)
const AuthModulesCrtVolumeForecastsSubChannelAllocationsIndexRoute =
  AuthModulesCrtVolumeForecastsSubChannelAllocationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRoute,
  } as any)
const AuthModulesCrtVolumeForecastsNcProvincialContributionsIndexRoute =
  AuthModulesCrtVolumeForecastsNcProvincialContributionsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRoute,
    } as any,
  )
const AuthModulesCrtVolumeForecastsChannelContributionsIndexRoute =
  AuthModulesCrtVolumeForecastsChannelContributionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtVolumeForecastsChannelContributionsRouteRoute,
  } as any)
const AuthModulesCrtPricingExciseTaxAssumptionsIndexRoute =
  AuthModulesCrtPricingExciseTaxAssumptionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtPricingExciseTaxAssumptionsRouteRoute,
  } as any)
const AuthModulesCrtPricingExcisePricingRateTableIndexRoute =
  AuthModulesCrtPricingExcisePricingRateTableIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtPricingExcisePricingRateTableRouteRoute,
  } as any)
const AuthModulesCrtPricingExcisePricingAssumptionsIndexRoute =
  AuthModulesCrtPricingExcisePricingAssumptionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtPricingExcisePricingAssumptionsRouteRoute,
  } as any)
const AuthModulesCrtPricingExciseInsightsIndexRoute =
  AuthModulesCrtPricingExciseInsightsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtPricingExciseInsightsRouteRoute,
  } as any)
const AuthModulesCrtMaterialsPriceListIndexRoute =
  AuthModulesCrtMaterialsPriceListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtMaterialsPriceListRouteRoute,
  } as any)
const AuthModulesCrtMaterialsMaterialsListIndexRoute =
  AuthModulesCrtMaterialsMaterialsListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtMaterialsMaterialsListRouteRoute,
  } as any)
const AuthModulesCrtMaterialsInsightsIndexRoute =
  AuthModulesCrtMaterialsInsightsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtMaterialsInsightsRouteRoute,
  } as any)
const AuthModulesCrtMaterialsBrandVariantsIndexRoute =
  AuthModulesCrtMaterialsBrandVariantsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtMaterialsBrandVariantsRouteRoute,
  } as any)
const AuthModulesCrtKpiReportsProfitsAndLossSummaryIndexRoute =
  AuthModulesCrtKpiReportsProfitsAndLossSummaryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRoute,
  } as any)
const AuthModulesCrtKpiReportsCashDashboardIndexRoute =
  AuthModulesCrtKpiReportsCashDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtKpiReportsCashDashboardRouteRoute,
  } as any)
const AuthModulesCrtCustomersCommercialPartnersIndexRoute =
  AuthModulesCrtCustomersCommercialPartnersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtCustomersCommercialPartnersRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsKeyAccountsIndexRoute =
  AuthModulesCrtCustomerInvestmentsKeyAccountsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsInvestmentsIndexRoute =
  AuthModulesCrtCustomerInvestmentsInvestmentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtCustomerInvestmentsInvestmentsRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsInsightsIndexRoute =
  AuthModulesCrtCustomerInvestmentsInsightsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtCustomerInvestmentsInsightsRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsBudgetTrackerIndexRoute =
  AuthModulesCrtCustomerInvestmentsBudgetTrackerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRoute,
  } as any)
const AuthModulesCrtAdminUsersIndexRoute =
  AuthModulesCrtAdminUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtAdminUsersRouteRoute,
  } as any)
const AuthModulesCrtAdminRolesIndexRoute =
  AuthModulesCrtAdminRolesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtAdminRolesRouteRoute,
  } as any)
const AuthModulesCrtAdminNotificationsIndexRoute =
  AuthModulesCrtAdminNotificationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtAdminNotificationsRouteRoute,
  } as any)
const AuthModulesCrtAdminInvitationsIndexRoute =
  AuthModulesCrtAdminInvitationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtAdminInvitationsRouteRoute,
  } as any)
const AuthModulesCrtAdminAuditTrailsIndexRoute =
  AuthModulesCrtAdminAuditTrailsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtAdminAuditTrailsRouteRoute,
  } as any)
const AuthModulesCreditOperationsVeryLowRiskCustomersIndexRoute =
  AuthModulesCreditOperationsVeryLowRiskCustomersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCreditOperationsVeryLowRiskCustomersRouteRoute,
  } as any)
const AuthModulesCreditOperationsProvinceAovPerCartonIndexRoute =
  AuthModulesCreditOperationsProvinceAovPerCartonIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCreditOperationsProvinceAovPerCartonRouteRoute,
  } as any)
const AuthModulesCreditOperationsOrderCutoffsIndexRoute =
  AuthModulesCreditOperationsOrderCutoffsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditOperationsOrderCutoffsRouteRoute,
  } as any)
const AuthModulesCreditOperationsMultiplierIndexRoute =
  AuthModulesCreditOperationsMultiplierIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditOperationsMultiplierRouteRoute,
  } as any)
const AuthModulesCreditCustomersErpIndexRoute =
  AuthModulesCreditCustomersErpIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditCustomersErpRouteRoute,
  } as any)
const AuthModulesCreditCreditLimitReviewsReviewEventsIndexRoute =
  AuthModulesCreditCreditLimitReviewsReviewEventsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCreditCreditLimitReviewsReviewEventsRouteRoute,
  } as any)
const AuthModulesCreditCreditLimitReviewsPendingConfirmationsIndexRoute =
  AuthModulesCreditCreditLimitReviewsPendingConfirmationsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRoute,
    } as any,
  )
const AuthModulesCreditCreditLimitReviewsMassIndexRoute =
  AuthModulesCreditCreditLimitReviewsMassIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditCreditLimitReviewsMassRouteRoute,
  } as any)
const AuthModulesCreditAdminUsersIndexRoute =
  AuthModulesCreditAdminUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditAdminUsersRouteRoute,
  } as any)
const AuthModulesCreditAdminRolesIndexRoute =
  AuthModulesCreditAdminRolesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditAdminRolesRouteRoute,
  } as any)
const AuthModulesCreditAdminInvitationsIndexRoute =
  AuthModulesCreditAdminInvitationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditAdminInvitationsRouteRoute,
  } as any)
const AuthModulesCreditAdminAuditTrailsIndexRoute =
  AuthModulesCreditAdminAuditTrailsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCreditAdminAuditTrailsRouteRoute,
  } as any)
const AuthModulesAppReportsSalesforceIndexRoute =
  AuthModulesAppReportsSalesforceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppReportsSalesforceRouteRoute,
  } as any)
const AuthModulesAppReportsOrderServiceIndexRoute =
  AuthModulesAppReportsOrderServiceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppReportsOrderServiceRouteRoute,
  } as any)
const AuthModulesAppReportsOperationsIndexRoute =
  AuthModulesAppReportsOperationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppReportsOperationsRouteRoute,
  } as any)
const AuthModulesAppReportsMiscIndexRoute =
  AuthModulesAppReportsMiscIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppReportsMiscRouteRoute,
  } as any)
const AuthModulesAppReportsMaterialIndexRoute =
  AuthModulesAppReportsMaterialIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppReportsMaterialRouteRoute,
  } as any)
const AuthModulesAppReportsEccIndexRoute =
  AuthModulesAppReportsEccIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppReportsEccRouteRoute,
  } as any)
const AuthModulesAppProcessesPipelinesIndexRoute =
  AuthModulesAppProcessesPipelinesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppProcessesPipelinesRouteRoute,
  } as any)
const AuthModulesAppOrdersReturnsIndexRoute =
  AuthModulesAppOrdersReturnsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppOrdersReturnsRouteRoute,
  } as any)
const AuthModulesAppOrdersPaymentReviewIndexRoute =
  AuthModulesAppOrdersPaymentReviewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppOrdersPaymentReviewRouteRoute,
  } as any)
const AuthModulesAppOrdersMissingIndexRoute =
  AuthModulesAppOrdersMissingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppOrdersMissingRouteRoute,
  } as any)
const AuthModulesAppOrdersFlaggedIndexRoute =
  AuthModulesAppOrdersFlaggedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppOrdersFlaggedRouteRoute,
  } as any)
const AuthModulesAppOrdersAllIndexRoute =
  AuthModulesAppOrdersAllIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppOrdersAllRouteRoute,
  } as any)
const AuthModulesAppMaterialsBcpPricedIndexRoute =
  AuthModulesAppMaterialsBcpPricedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppMaterialsBcpPricedRouteRoute,
  } as any)
const AuthModulesAppCustomersStoresIndexRoute =
  AuthModulesAppCustomersStoresIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppCustomersStoresRouteRoute,
  } as any)
const AuthModulesAppCustomersBannersIndexRoute =
  AuthModulesAppCustomersBannersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppCustomersBannersRouteRoute,
  } as any)
const AuthModulesAppCoreUploadDataOrderServiceIndexRoute =
  AuthModulesAppCoreUploadDataOrderServiceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppCoreUploadDataOrderServiceRouteRoute,
  } as any)
const AuthModulesAppCoreUploadDataOperationsIndexRoute =
  AuthModulesAppCoreUploadDataOperationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppCoreUploadDataOperationsRouteRoute,
  } as any)
const AuthModulesAppCoreUploadDataOnHandInventoryIndexRoute =
  AuthModulesAppCoreUploadDataOnHandInventoryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppCoreUploadDataOnHandInventoryRouteRoute,
  } as any)
const AuthModulesAppCoreUploadDataMaterialsIndexRoute =
  AuthModulesAppCoreUploadDataMaterialsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppCoreUploadDataMaterialsRouteRoute,
  } as any)
const AuthModulesAppCoreUploadDataBusinessIndexRoute =
  AuthModulesAppCoreUploadDataBusinessIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppCoreUploadDataBusinessRouteRoute,
  } as any)
const AuthModulesAppCoreUploadDataAutoInjectIndexRoute =
  AuthModulesAppCoreUploadDataAutoInjectIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppCoreUploadDataAutoInjectRouteRoute,
  } as any)
const AuthModulesAppAssortmentLaunchesIndexRoute =
  AuthModulesAppAssortmentLaunchesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppAssortmentLaunchesRouteRoute,
  } as any)
const AuthModulesAppAssortmentBannersIndexRoute =
  AuthModulesAppAssortmentBannersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppAssortmentBannersRouteRoute,
  } as any)
const AuthModulesAppAssortmentActiveIndexRoute =
  AuthModulesAppAssortmentActiveIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppAssortmentActiveRouteRoute,
  } as any)
const AuthModulesAppAdminUsersIndexRoute =
  AuthModulesAppAdminUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppAdminUsersRouteRoute,
  } as any)
const AuthModulesAppAdminRolesIndexRoute =
  AuthModulesAppAdminRolesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppAdminRolesRouteRoute,
  } as any)
const AuthModulesAppAdminInvitationsIndexRoute =
  AuthModulesAppAdminInvitationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppAdminInvitationsRouteRoute,
  } as any)
const AuthModulesAppAdminAuditTrailsIndexRoute =
  AuthModulesAppAdminAuditTrailsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesAppAdminAuditTrailsRouteRoute,
  } as any)
const AuthModulesCrtPricingExciseTaxAssumptionsTaxAssumptionIdRoute =
  AuthModulesCrtPricingExciseTaxAssumptionsTaxAssumptionIdRouteImport.update({
    id: '/$taxAssumptionId',
    path: '/$taxAssumptionId',
    getParentRoute: () => AuthModulesCrtPricingExciseTaxAssumptionsRouteRoute,
  } as any)
const AuthModulesCrtPricingExcisePricingAssumptionsPricingAssumptionIdRoute =
  AuthModulesCrtPricingExcisePricingAssumptionsPricingAssumptionIdRouteImport.update(
    {
      id: '/$pricingAssumptionId',
      path: '/$pricingAssumptionId',
      getParentRoute: () =>
        AuthModulesCrtPricingExcisePricingAssumptionsRouteRoute,
    } as any,
  )
const AuthModulesCrtMyUploadsScopeFileNameRoute =
  AuthModulesCrtMyUploadsScopeFileNameRouteImport.update({
    id: '/$scope/$fileName',
    path: '/$scope/$fileName',
    getParentRoute: () => AuthModulesCrtMyUploadsRouteRoute,
  } as any)
const AuthModulesCrtCostOfGoodsYearMonthRoute =
  AuthModulesCrtCostOfGoodsYearMonthRouteImport.update({
    id: '/$year/$month',
    path: '/$year/$month',
    getParentRoute: () => AuthModulesCrtCostOfGoodsRouteRoute,
  } as any)
const AuthModulesCreditMyUploadsScopeFileNameRoute =
  AuthModulesCreditMyUploadsScopeFileNameRouteImport.update({
    id: '/$scope/$fileName',
    path: '/$scope/$fileName',
    getParentRoute: () => AuthModulesCreditMyUploadsRouteRoute,
  } as any)
const AuthModulesCreditCustomersErpPrepareClrRoute =
  AuthModulesCreditCustomersErpPrepareClrRouteImport.update({
    id: '/prepare-clr',
    path: '/prepare-clr',
    getParentRoute: () => AuthModulesCreditCustomersErpRouteRoute,
  } as any)
const AuthModulesCreditCreditLimitReviewsMassNewRoute =
  AuthModulesCreditCreditLimitReviewsMassNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthModulesCreditCreditLimitReviewsMassRouteRoute,
  } as any)
const AuthModulesCreditBlockedOrdersGroupsGroupKeyRoute =
  AuthModulesCreditBlockedOrdersGroupsGroupKeyRouteImport.update({
    id: '/groups/$groupKey',
    path: '/groups/$groupKey',
    getParentRoute: () => AuthModulesCreditBlockedOrdersRouteRoute,
  } as any)
const AuthModulesAppReportsSalesforceReportIdRoute =
  AuthModulesAppReportsSalesforceReportIdRouteImport.update({
    id: '/$reportId',
    path: '/$reportId',
    getParentRoute: () => AuthModulesAppReportsSalesforceRouteRoute,
  } as any)
const AuthModulesAppReportsOrderServiceReportIdRoute =
  AuthModulesAppReportsOrderServiceReportIdRouteImport.update({
    id: '/$reportId',
    path: '/$reportId',
    getParentRoute: () => AuthModulesAppReportsOrderServiceRouteRoute,
  } as any)
const AuthModulesAppReportsOperationsReportIdRoute =
  AuthModulesAppReportsOperationsReportIdRouteImport.update({
    id: '/$reportId',
    path: '/$reportId',
    getParentRoute: () => AuthModulesAppReportsOperationsRouteRoute,
  } as any)
const AuthModulesAppReportsMiscReportIdRoute =
  AuthModulesAppReportsMiscReportIdRouteImport.update({
    id: '/$reportId',
    path: '/$reportId',
    getParentRoute: () => AuthModulesAppReportsMiscRouteRoute,
  } as any)
const AuthModulesAppReportsMaterialReportIdRoute =
  AuthModulesAppReportsMaterialReportIdRouteImport.update({
    id: '/$reportId',
    path: '/$reportId',
    getParentRoute: () => AuthModulesAppReportsMaterialRouteRoute,
  } as any)
const AuthModulesAppReportsEccReportIdRoute =
  AuthModulesAppReportsEccReportIdRouteImport.update({
    id: '/$reportId',
    path: '/$reportId',
    getParentRoute: () => AuthModulesAppReportsEccRouteRoute,
  } as any)
const AuthModulesAppMyUploadsScopeFileNameRoute =
  AuthModulesAppMyUploadsScopeFileNameRouteImport.update({
    id: '/$scope/$fileName',
    path: '/$scope/$fileName',
    getParentRoute: () => AuthModulesAppMyUploadsRouteRoute,
  } as any)
const AuthModulesAppCustomersStoresStoreIdRoute =
  AuthModulesAppCustomersStoresStoreIdRouteImport.update({
    id: '/$storeId',
    path: '/$storeId',
    getParentRoute: () => AuthModulesAppCustomersStoresRouteRoute,
  } as any)
const AuthModulesAppCustomersBannersBannerIdRoute =
  AuthModulesAppCustomersBannersBannerIdRouteImport.update({
    id: '/$bannerId',
    path: '/$bannerId',
    getParentRoute: () => AuthModulesAppCustomersBannersRouteRoute,
  } as any)
const AuthModulesAppAssortmentLaunchesLaunchIdRoute =
  AuthModulesAppAssortmentLaunchesLaunchIdRouteImport.update({
    id: '/$launchId',
    path: '/$launchId',
    getParentRoute: () => AuthModulesAppAssortmentLaunchesRouteRoute,
  } as any)
const AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRoute =
  AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRouteImport.update({
    id: '/retailer-rates',
    path: '/retailer-rates',
    getParentRoute: () => AuthModulesCrtPricingExciseInsightsRouteRoute,
  } as any)
const AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRoute =
  AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRouteImport.update({
    id: '/consumer-rates',
    path: '/consumer-rates',
    getParentRoute: () => AuthModulesCrtPricingExciseInsightsRouteRoute,
  } as any)
const AuthModulesCrtPricingExciseInsightsChannelMixRouteRoute =
  AuthModulesCrtPricingExciseInsightsChannelMixRouteRouteImport.update({
    id: '/channel-mix',
    path: '/channel-mix',
    getParentRoute: () => AuthModulesCrtPricingExciseInsightsRouteRoute,
  } as any)
const AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRoute =
  AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRouteImport.update({
    id: '/unreleased-materials',
    path: '/unreleased-materials',
    getParentRoute: () => AuthModulesCrtMaterialsInsightsRouteRoute,
  } as any)
const AuthModulesCrtMaterialsInsightsProductTypesRouteRoute =
  AuthModulesCrtMaterialsInsightsProductTypesRouteRouteImport.update({
    id: '/product-types',
    path: '/product-types',
    getParentRoute: () => AuthModulesCrtMaterialsInsightsRouteRoute,
  } as any)
const AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRoute =
  AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRouteImport.update({
    id: '/product-type-variants',
    path: '/product-type-variants',
    getParentRoute: () => AuthModulesCrtMaterialsInsightsRouteRoute,
  } as any)
const AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRoute =
  AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRouteImport.update(
    {
      id: '/material-groups-overrides',
      path: '/material-groups-overrides',
      getParentRoute: () => AuthModulesCrtMaterialsInsightsRouteRoute,
    } as any,
  )
const AuthModulesCrtMaterialsInsightsFederalExciseRouteRoute =
  AuthModulesCrtMaterialsInsightsFederalExciseRouteRouteImport.update({
    id: '/federal-excise',
    path: '/federal-excise',
    getParentRoute: () => AuthModulesCrtMaterialsInsightsRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRoute =
  AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRouteImport.update({
    id: '/estimates',
    path: '/estimates',
    getParentRoute: () =>
      AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRoute =
  AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRouteImport.update(
    {
      id: '/sales-deal-actuals',
      path: '/sales-deal-actuals',
      getParentRoute: () => AuthModulesCrtCustomerInvestmentsInsightsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRoute =
  AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRouteImport.update({
    id: '/rap-forecasts',
    path: '/rap-forecasts',
    getParentRoute: () => AuthModulesCrtCustomerInvestmentsInsightsRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRoute =
  AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRouteImport.update(
    {
      id: '/master-agreements',
      path: '/master-agreements',
      getParentRoute: () => AuthModulesCrtCustomerInvestmentsInsightsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRoute =
  AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRouteImport.update(
    {
      id: '/manual-investments',
      path: '/manual-investments',
      getParentRoute: () => AuthModulesCrtCustomerInvestmentsInsightsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRoute =
  AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRouteImport.update({
    id: '/ip-accruals',
    path: '/ip-accruals',
    getParentRoute: () => AuthModulesCrtCustomerInvestmentsInsightsRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRoute =
  AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRouteImport.update(
    {
      id: '/distribution-margin-mix',
      path: '/distribution-margin-mix',
      getParentRoute: () => AuthModulesCrtCustomerInvestmentsInsightsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRoute =
  AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRouteImport.update(
    {
      id: '/calculation-run-accruals',
      path: '/calculation-run-accruals',
      getParentRoute: () => AuthModulesCrtCustomerInvestmentsInsightsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRoute =
  AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRouteImport.update(
    {
      id: '/budget-allocations',
      path: '/budget-allocations',
      getParentRoute: () => AuthModulesCrtCustomerInvestmentsInsightsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRoute =
  AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRouteImport.update({
    id: '/agreements',
    path: '/agreements',
    getParentRoute: () => AuthModulesCrtCustomerInvestmentsInsightsRouteRoute,
  } as any)
const AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRoute =
  AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRouteImport.update(
    {
      id: '/pending-confirmations',
      path: '/pending-confirmations',
      getParentRoute: () => AuthModulesCreditCreditLimitReviewsMassRouteRoute,
    } as any,
  )
const AuthModulesCreditCreditLimitReviewsMassRunIdRouteRoute =
  AuthModulesCreditCreditLimitReviewsMassRunIdRouteRouteImport.update({
    id: '/$runId',
    path: '/$runId',
    getParentRoute: () => AuthModulesCreditCreditLimitReviewsMassRouteRoute,
  } as any)
const AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute =
  AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRouteImport.update({
    id: '/delegation-of-authority',
    path: '/delegation-of-authority',
    getParentRoute: () => AuthModulesCreditAdminUsersRouteRoute,
  } as any)
const AuthModulesCrtPricingExciseInsightsRetailerRatesIndexRoute =
  AuthModulesCrtPricingExciseInsightsRetailerRatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRoute,
  } as any)
const AuthModulesCrtPricingExciseInsightsConsumerRatesIndexRoute =
  AuthModulesCrtPricingExciseInsightsConsumerRatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRoute,
  } as any)
const AuthModulesCrtPricingExciseInsightsChannelMixIndexRoute =
  AuthModulesCrtPricingExciseInsightsChannelMixIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtPricingExciseInsightsChannelMixRouteRoute,
  } as any)
const AuthModulesCrtMaterialsInsightsUnreleasedMaterialsIndexRoute =
  AuthModulesCrtMaterialsInsightsUnreleasedMaterialsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRoute,
  } as any)
const AuthModulesCrtMaterialsInsightsProductTypesIndexRoute =
  AuthModulesCrtMaterialsInsightsProductTypesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthModulesCrtMaterialsInsightsProductTypesRouteRoute,
  } as any)
const AuthModulesCrtMaterialsInsightsProductTypeVariantsIndexRoute =
  AuthModulesCrtMaterialsInsightsProductTypeVariantsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRoute,
  } as any)
const AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesIndexRoute =
  AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRoute,
    } as any,
  )
const AuthModulesCrtMaterialsInsightsFederalExciseIndexRoute =
  AuthModulesCrtMaterialsInsightsFederalExciseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtMaterialsInsightsFederalExciseRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesIndexRoute =
  AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsIndexRoute =
  AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsRapForecastsIndexRoute =
  AuthModulesCrtCustomerInvestmentsInsightsRapForecastsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsIndexRoute =
  AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsIndexRoute =
  AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsIndexRoute =
  AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixIndexRoute =
  AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsIndexRoute =
  AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsIndexRoute =
  AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsAgreementsIndexRoute =
  AuthModulesCrtCustomerInvestmentsInsightsAgreementsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRoute,
  } as any)
const AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsIndexRoute =
  AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRoute,
    } as any,
  )
const AuthModulesCreditCreditLimitReviewsMassRunIdIndexRoute =
  AuthModulesCreditCreditLimitReviewsMassRunIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCreditCreditLimitReviewsMassRunIdRouteRoute,
  } as any)
const AuthModulesCreditAdminUsersDelegationOfAuthorityIndexRoute =
  AuthModulesCreditAdminUsersDelegationOfAuthorityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute,
  } as any)
const AuthModulesCrtVolumeForecastsNcProvincialContributionsYearMonthRoute =
  AuthModulesCrtVolumeForecastsNcProvincialContributionsYearMonthRouteImport.update(
    {
      id: '/$year/$month',
      path: '/$year/$month',
      getParentRoute: () =>
        AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRoute,
    } as any,
  )
const AuthModulesCrtVolumeForecastsChannelContributionsYearMonthRoute =
  AuthModulesCrtVolumeForecastsChannelContributionsYearMonthRouteImport.update({
    id: '/$year/$month',
    path: '/$year/$month',
    getParentRoute: () =>
      AuthModulesCrtVolumeForecastsChannelContributionsRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsManualInvestmentIdRoute =
  AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsManualInvestmentIdRouteImport.update(
    {
      id: '/$manualInvestmentId',
      path: '/$manualInvestmentId',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixBannerMixRoute =
  AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixBannerMixRouteImport.update(
    {
      id: '/banner-mix',
      path: '/banner-mix',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRoute,
    } as any,
  )
const AuthModulesCreditCreditLimitReviewsMassRunIdSubmitRoute =
  AuthModulesCreditCreditLimitReviewsMassRunIdSubmitRouteImport.update({
    id: '/submit',
    path: '/submit',
    getParentRoute: () =>
      AuthModulesCreditCreditLimitReviewsMassRunIdRouteRoute,
  } as any)
const AuthModulesCreditCreditLimitReviewsMassRunIdPendingConfirmationsRoute =
  AuthModulesCreditCreditLimitReviewsMassRunIdPendingConfirmationsRouteImport.update(
    {
      id: '/pending-confirmations',
      path: '/pending-confirmations',
      getParentRoute: () =>
        AuthModulesCreditCreditLimitReviewsMassRunIdRouteRoute,
    } as any,
  )
const AuthModulesCreditCreditLimitReviewsMassRunIdLinesRoute =
  AuthModulesCreditCreditLimitReviewsMassRunIdLinesRouteImport.update({
    id: '/lines',
    path: '/lines',
    getParentRoute: () =>
      AuthModulesCreditCreditLimitReviewsMassRunIdRouteRoute,
  } as any)
const AuthModulesAppOrdersAllDynamoIdPoNumberRoute =
  AuthModulesAppOrdersAllDynamoIdPoNumberRouteImport.update({
    id: '/$dynamoId/$poNumber',
    path: '/$dynamoId/$poNumber',
    getParentRoute: () => AuthModulesAppOrdersAllRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRoute =
  AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRouteImport.update(
    {
      id: '/wholesaler-margins/nc',
      path: '/wholesaler-margins/nc',
      getParentRoute: () => AuthModulesCrtCustomerInvestmentsInsightsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRoute =
  AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRouteImport.update(
    {
      id: '/wholesaler-margins/fmc',
      path: '/wholesaler-margins/fmc',
      getParentRoute: () => AuthModulesCrtCustomerInvestmentsInsightsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRoute =
  AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRouteImport.update(
    {
      id: '/retailer-margins/nc',
      path: '/retailer-margins/nc',
      getParentRoute: () => AuthModulesCrtCustomerInvestmentsInsightsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRoute =
  AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRouteImport.update(
    {
      id: '/retailer-margins/fmc',
      path: '/retailer-margins/fmc',
      getParentRoute: () => AuthModulesCrtCustomerInvestmentsInsightsRouteRoute,
    } as any,
  )
const AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRoute =
  AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRouteImport.update(
    {
      id: '/single-with-deviation',
      path: '/single-with-deviation',
      getParentRoute: () =>
        AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute,
    } as any,
  )
const AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRoute =
  AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRouteImport.update(
    {
      id: '/single-no-deviation',
      path: '/single-no-deviation',
      getParentRoute: () =>
        AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute,
    } as any,
  )
const AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRoute =
  AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRouteImport.update({
    id: '/mass',
    path: '/mass',
    getParentRoute: () =>
      AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute,
  } as any)
const AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRoute =
  AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRouteImport.update(
    {
      id: '/initiative',
      path: '/initiative',
      getParentRoute: () =>
        AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute,
    } as any,
  )
const AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRoute =
  AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRouteImport.update(
    {
      id: '/blocked-orders',
      path: '/blocked-orders',
      getParentRoute: () =>
        AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcIndexRoute =
  AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcIndexRoute =
  AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcIndexRoute =
  AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcIndexRoute =
  AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRoute,
    } as any,
  )
const AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationIndexRoute =
  AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRoute,
    } as any,
  )
const AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationIndexRoute =
  AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRoute,
    } as any,
  )
const AuthModulesCreditAdminUsersDelegationOfAuthorityMassIndexRoute =
  AuthModulesCreditAdminUsersDelegationOfAuthorityMassIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRoute,
  } as any)
const AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeIndexRoute =
  AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRoute,
    } as any,
  )
const AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersIndexRoute =
  AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRoute,
    } as any,
  )
const AuthModulesCrtPricingExciseInsightsChannelMixYearMonthRoute =
  AuthModulesCrtPricingExciseInsightsChannelMixYearMonthRouteImport.update({
    id: '/$year/$month',
    path: '/$year/$month',
    getParentRoute: () =>
      AuthModulesCrtPricingExciseInsightsChannelMixRouteRoute,
  } as any)
const AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsYearMonthRoute =
  AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsYearMonthRouteImport.update(
    {
      id: '/$year/$month',
      path: '/$year/$month',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsRapForecastsYearMonthRoute =
  AuthModulesCrtCustomerInvestmentsInsightsRapForecastsYearMonthRouteImport.update(
    {
      id: '/$year/$month',
      path: '/$year/$month',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsYearMonthRoute =
  AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsYearMonthRouteImport.update(
    {
      id: '/$year/$month',
      path: '/$year/$month',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixYearMonthRoute =
  AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixYearMonthRouteImport.update(
    {
      id: '/$year/$month',
      path: '/$year/$month',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRoute,
    } as any,
  )
const AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsYearMonthRoute =
  AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsYearMonthRouteImport.update(
    {
      id: '/$year/$month',
      path: '/$year/$month',
      getParentRoute: () =>
        AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRoute,
    } as any,
  )
const AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRoute =
  AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRouteImport.update(
    {
      id: '/exception-payers',
      path: '/exception-payers',
      getParentRoute: () =>
        AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRoute,
    } as any,
  )
const AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersIndexRoute =
  AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/login': typeof LoginRoute
  '/process-login': typeof ProcessLoginRoute
  '/unverified': typeof AuthUnverifiedRouteRouteWithChildren
  '/credit': typeof AuthModulesCreditRouteRouteWithChildren
  '/crt': typeof AuthModulesCrtRouteRouteWithChildren
  '/track/$erp': typeof AuthTrackErpRoute
  '/': typeof AuthModulesIndexRoute
  '/unverified/': typeof AuthUnverifiedIndexRoute
  '/admin': typeof AuthModulesAppAdminRouteRouteWithChildren
  '/assortment': typeof AuthModulesAppAssortmentRouteRouteWithChildren
  '/core-upload-data': typeof AuthModulesAppCoreUploadDataRouteRouteWithChildren
  '/customers': typeof AuthModulesAppCustomersRouteRouteWithChildren
  '/materials': typeof AuthModulesAppMaterialsRouteRouteWithChildren
  '/my-uploads': typeof AuthModulesAppMyUploadsRouteRouteWithChildren
  '/operations': typeof AuthModulesAppOperationsRouteRouteWithChildren
  '/orders': typeof AuthModulesAppOrdersRouteRouteWithChildren
  '/processes': typeof AuthModulesAppProcessesRouteRouteWithChildren
  '/reports': typeof AuthModulesAppReportsRouteRouteWithChildren
  '/sox-compliance': typeof AuthModulesAppSoxComplianceRouteRouteWithChildren
  '/welcome': typeof AuthModulesAppWelcomeRouteRouteWithChildren
  '/credit/admin': typeof AuthModulesCreditAdminRouteRouteWithChildren
  '/credit/blocked-orders': typeof AuthModulesCreditBlockedOrdersRouteRouteWithChildren
  '/credit/credit-index-scores': typeof AuthModulesCreditCreditIndexScoresRouteRouteWithChildren
  '/credit/credit-limit-reviews': typeof AuthModulesCreditCreditLimitReviewsRouteRouteWithChildren
  '/credit/customers': typeof AuthModulesCreditCustomersRouteRouteWithChildren
  '/credit/google-financial-statements': typeof AuthModulesCreditGoogleFinancialStatementsRouteRouteWithChildren
  '/credit/inbox': typeof AuthModulesCreditInboxRouteRouteWithChildren
  '/credit/initiatives': typeof AuthModulesCreditInitiativesRouteRouteWithChildren
  '/credit/my-exports': typeof AuthModulesCreditMyExportsRouteRouteWithChildren
  '/credit/my-uploads': typeof AuthModulesCreditMyUploadsRouteRouteWithChildren
  '/credit/operations': typeof AuthModulesCreditOperationsRouteRouteWithChildren
  '/credit/welcome': typeof AuthModulesCreditWelcomeRouteRouteWithChildren
  '/crt/admin': typeof AuthModulesCrtAdminRouteRouteWithChildren
  '/crt/azure-imports': typeof AuthModulesCrtAzureImportsRouteRouteWithChildren
  '/crt/bpc-actuals': typeof AuthModulesCrtBpcActualsRouteRouteWithChildren
  '/crt/cost-of-goods': typeof AuthModulesCrtCostOfGoodsRouteRouteWithChildren
  '/crt/customer-investments': typeof AuthModulesCrtCustomerInvestmentsRouteRouteWithChildren
  '/crt/customers': typeof AuthModulesCrtCustomersRouteRouteWithChildren
  '/crt/kpi-reports': typeof AuthModulesCrtKpiReportsRouteRouteWithChildren
  '/crt/materials': typeof AuthModulesCrtMaterialsRouteRouteWithChildren
  '/crt/my-exports': typeof AuthModulesCrtMyExportsRouteRouteWithChildren
  '/crt/my-uploads': typeof AuthModulesCrtMyUploadsRouteRouteWithChildren
  '/crt/pricing-excise': typeof AuthModulesCrtPricingExciseRouteRouteWithChildren
  '/crt/settings': typeof AuthModulesCrtSettingsRouteRouteWithChildren
  '/crt/variance-analysis': typeof AuthModulesCrtVarianceAnalysisRouteRouteWithChildren
  '/crt/volume-forecasts': typeof AuthModulesCrtVolumeForecastsRouteRouteWithChildren
  '/crt/volume-scenarios': typeof AuthModulesCrtVolumeScenariosRouteRouteWithChildren
  '/crt/volumes': typeof AuthModulesCrtVolumesRouteRoute
  '/crt/welcome': typeof AuthModulesCrtWelcomeRouteRouteWithChildren
  '/kitchen-sink': typeof AuthModulesSharedKitchenSinkRoute
  '/admin/audit-trails': typeof AuthModulesAppAdminAuditTrailsRouteRouteWithChildren
  '/admin/invitations': typeof AuthModulesAppAdminInvitationsRouteRouteWithChildren
  '/admin/roles': typeof AuthModulesAppAdminRolesRouteRouteWithChildren
  '/admin/users': typeof AuthModulesAppAdminUsersRouteRouteWithChildren
  '/assortment/active': typeof AuthModulesAppAssortmentActiveRouteRouteWithChildren
  '/assortment/banners': typeof AuthModulesAppAssortmentBannersRouteRouteWithChildren
  '/assortment/launches': typeof AuthModulesAppAssortmentLaunchesRouteRouteWithChildren
  '/core-upload-data/auto-inject': typeof AuthModulesAppCoreUploadDataAutoInjectRouteRouteWithChildren
  '/core-upload-data/business': typeof AuthModulesAppCoreUploadDataBusinessRouteRouteWithChildren
  '/core-upload-data/materials': typeof AuthModulesAppCoreUploadDataMaterialsRouteRouteWithChildren
  '/core-upload-data/on-hand-inventory': typeof AuthModulesAppCoreUploadDataOnHandInventoryRouteRouteWithChildren
  '/core-upload-data/operations': typeof AuthModulesAppCoreUploadDataOperationsRouteRouteWithChildren
  '/core-upload-data/order-service': typeof AuthModulesAppCoreUploadDataOrderServiceRouteRouteWithChildren
  '/customers/banners': typeof AuthModulesAppCustomersBannersRouteRouteWithChildren
  '/customers/stores': typeof AuthModulesAppCustomersStoresRouteRouteWithChildren
  '/materials/bcp-priced': typeof AuthModulesAppMaterialsBcpPricedRouteRouteWithChildren
  '/orders/all': typeof AuthModulesAppOrdersAllRouteRouteWithChildren
  '/orders/flagged': typeof AuthModulesAppOrdersFlaggedRouteRouteWithChildren
  '/orders/missing': typeof AuthModulesAppOrdersMissingRouteRouteWithChildren
  '/orders/payment-review': typeof AuthModulesAppOrdersPaymentReviewRouteRouteWithChildren
  '/orders/returns': typeof AuthModulesAppOrdersReturnsRouteRouteWithChildren
  '/processes/pipelines': typeof AuthModulesAppProcessesPipelinesRouteRouteWithChildren
  '/reports/ecc': typeof AuthModulesAppReportsEccRouteRouteWithChildren
  '/reports/material': typeof AuthModulesAppReportsMaterialRouteRouteWithChildren
  '/reports/misc': typeof AuthModulesAppReportsMiscRouteRouteWithChildren
  '/reports/operations': typeof AuthModulesAppReportsOperationsRouteRouteWithChildren
  '/reports/order-service': typeof AuthModulesAppReportsOrderServiceRouteRouteWithChildren
  '/reports/salesforce': typeof AuthModulesAppReportsSalesforceRouteRouteWithChildren
  '/credit/admin/audit-trails': typeof AuthModulesCreditAdminAuditTrailsRouteRouteWithChildren
  '/credit/admin/invitations': typeof AuthModulesCreditAdminInvitationsRouteRouteWithChildren
  '/credit/admin/roles': typeof AuthModulesCreditAdminRolesRouteRouteWithChildren
  '/credit/admin/users': typeof AuthModulesCreditAdminUsersRouteRouteWithChildren
  '/credit/credit-limit-reviews/mass': typeof AuthModulesCreditCreditLimitReviewsMassRouteRouteWithChildren
  '/credit/credit-limit-reviews/pending-confirmations': typeof AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRouteWithChildren
  '/credit/credit-limit-reviews/review-events': typeof AuthModulesCreditCreditLimitReviewsReviewEventsRouteRouteWithChildren
  '/credit/customers/$erp': typeof AuthModulesCreditCustomersErpRouteRouteWithChildren
  '/credit/operations/multiplier': typeof AuthModulesCreditOperationsMultiplierRouteRouteWithChildren
  '/credit/operations/order-cutoffs': typeof AuthModulesCreditOperationsOrderCutoffsRouteRouteWithChildren
  '/credit/operations/province-aov-per-carton': typeof AuthModulesCreditOperationsProvinceAovPerCartonRouteRouteWithChildren
  '/credit/operations/very-low-risk-customers': typeof AuthModulesCreditOperationsVeryLowRiskCustomersRouteRouteWithChildren
  '/crt/admin/audit-trails': typeof AuthModulesCrtAdminAuditTrailsRouteRouteWithChildren
  '/crt/admin/invitations': typeof AuthModulesCrtAdminInvitationsRouteRouteWithChildren
  '/crt/admin/notifications': typeof AuthModulesCrtAdminNotificationsRouteRouteWithChildren
  '/crt/admin/roles': typeof AuthModulesCrtAdminRolesRouteRouteWithChildren
  '/crt/admin/users': typeof AuthModulesCrtAdminUsersRouteRouteWithChildren
  '/crt/customer-investments/budget-tracker': typeof AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRouteWithChildren
  '/crt/customer-investments/insights': typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRouteWithChildren
  '/crt/customer-investments/investments': typeof AuthModulesCrtCustomerInvestmentsInvestmentsRouteRouteWithChildren
  '/crt/customer-investments/key-accounts': typeof AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRouteWithChildren
  '/crt/customers/commercial-partners': typeof AuthModulesCrtCustomersCommercialPartnersRouteRouteWithChildren
  '/crt/kpi-reports/cash-dashboard': typeof AuthModulesCrtKpiReportsCashDashboardRouteRouteWithChildren
  '/crt/kpi-reports/profits-and-loss-summary': typeof AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRouteWithChildren
  '/crt/materials/brand-variants': typeof AuthModulesCrtMaterialsBrandVariantsRouteRouteWithChildren
  '/crt/materials/insights': typeof AuthModulesCrtMaterialsInsightsRouteRouteWithChildren
  '/crt/materials/materials-list': typeof AuthModulesCrtMaterialsMaterialsListRouteRouteWithChildren
  '/crt/materials/price-list': typeof AuthModulesCrtMaterialsPriceListRouteRouteWithChildren
  '/crt/pricing-excise/insights': typeof AuthModulesCrtPricingExciseInsightsRouteRouteWithChildren
  '/crt/pricing-excise/pricing-assumptions': typeof AuthModulesCrtPricingExcisePricingAssumptionsRouteRouteWithChildren
  '/crt/pricing-excise/pricing-rate-table': typeof AuthModulesCrtPricingExcisePricingRateTableRouteRouteWithChildren
  '/crt/pricing-excise/tax-assumptions': typeof AuthModulesCrtPricingExciseTaxAssumptionsRouteRouteWithChildren
  '/crt/volume-forecasts/channel-contributions': typeof AuthModulesCrtVolumeForecastsChannelContributionsRouteRouteWithChildren
  '/crt/volume-forecasts/nc-provincial-contributions': typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRouteWithChildren
  '/crt/volume-forecasts/sub-channel-allocations': typeof AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRouteWithChildren
  '/error': typeof AuthModulesSharedErrorsErrorRoute
  '/not-found': typeof AuthModulesSharedErrorsNotFoundRoute
  '/unauthorized': typeof AuthModulesSharedErrorsUnauthorizedRoute
  '/credit/credit-limit-reviews/$reviewId': typeof AuthModulesCreditCreditLimitReviewsReviewIdRoute
  '/credit/google-financial-statements/$sapErp': typeof AuthModulesCreditGoogleFinancialStatementsSapErpRoute
  '/credit/initiatives/$id': typeof AuthModulesCreditInitiativesIdRoute
  '/crt/bpc-actuals/$year': typeof AuthModulesCrtBpcActualsYearRoute
  '/crt/kpi-reports/graphs': typeof AuthModulesCrtKpiReportsGraphsRoute
  '/crt/variance-analysis/by-agreement': typeof AuthModulesCrtVarianceAnalysisByAgreementRoute
  '/crt/variance-analysis/by-banner': typeof AuthModulesCrtVarianceAnalysisByBannerRoute
  '/crt/variance-analysis/by-budget': typeof AuthModulesCrtVarianceAnalysisByBudgetRoute
  '/crt/variance-analysis/by-cost-type': typeof AuthModulesCrtVarianceAnalysisByCostTypeRoute
  '/crt/volume-scenarios/$volumeScenarioId': typeof AuthModulesCrtVolumeScenariosVolumeScenarioIdRoute
  '/admin/': typeof AuthModulesAppAdminIndexRoute
  '/assortment/': typeof AuthModulesAppAssortmentIndexRoute
  '/core-upload-data/': typeof AuthModulesAppCoreUploadDataIndexRoute
  '/customers/': typeof AuthModulesAppCustomersIndexRoute
  '/materials/': typeof AuthModulesAppMaterialsIndexRoute
  '/my-uploads/': typeof AuthModulesAppMyUploadsIndexRoute
  '/operations/': typeof AuthModulesAppOperationsIndexRoute
  '/orders/': typeof AuthModulesAppOrdersIndexRoute
  '/processes/': typeof AuthModulesAppProcessesIndexRoute
  '/reports/': typeof AuthModulesAppReportsIndexRoute
  '/sox-compliance/': typeof AuthModulesAppSoxComplianceIndexRoute
  '/welcome/': typeof AuthModulesAppWelcomeIndexRoute
  '/credit/admin/': typeof AuthModulesCreditAdminIndexRoute
  '/credit/blocked-orders/': typeof AuthModulesCreditBlockedOrdersIndexRoute
  '/credit/credit-index-scores/': typeof AuthModulesCreditCreditIndexScoresIndexRoute
  '/credit/credit-limit-reviews/': typeof AuthModulesCreditCreditLimitReviewsIndexRoute
  '/credit/customers/': typeof AuthModulesCreditCustomersIndexRoute
  '/credit/google-financial-statements/': typeof AuthModulesCreditGoogleFinancialStatementsIndexRoute
  '/credit/inbox/': typeof AuthModulesCreditInboxIndexRoute
  '/credit/initiatives/': typeof AuthModulesCreditInitiativesIndexRoute
  '/credit/my-exports/': typeof AuthModulesCreditMyExportsIndexRoute
  '/credit/my-uploads/': typeof AuthModulesCreditMyUploadsIndexRoute
  '/credit/operations/': typeof AuthModulesCreditOperationsIndexRoute
  '/credit/welcome/': typeof AuthModulesCreditWelcomeIndexRoute
  '/crt/admin/': typeof AuthModulesCrtAdminIndexRoute
  '/crt/azure-imports/': typeof AuthModulesCrtAzureImportsIndexRoute
  '/crt/bpc-actuals/': typeof AuthModulesCrtBpcActualsIndexRoute
  '/crt/cost-of-goods/': typeof AuthModulesCrtCostOfGoodsIndexRoute
  '/crt/customer-investments/': typeof AuthModulesCrtCustomerInvestmentsIndexRoute
  '/crt/kpi-reports/': typeof AuthModulesCrtKpiReportsIndexRoute
  '/crt/materials/': typeof AuthModulesCrtMaterialsIndexRoute
  '/crt/my-exports/': typeof AuthModulesCrtMyExportsIndexRoute
  '/crt/my-uploads/': typeof AuthModulesCrtMyUploadsIndexRoute
  '/crt/pricing-excise/': typeof AuthModulesCrtPricingExciseIndexRoute
  '/crt/settings/': typeof AuthModulesCrtSettingsIndexRoute
  '/crt/variance-analysis/': typeof AuthModulesCrtVarianceAnalysisIndexRoute
  '/crt/volume-forecasts/': typeof AuthModulesCrtVolumeForecastsIndexRoute
  '/crt/volume-scenarios/': typeof AuthModulesCrtVolumeScenariosIndexRoute
  '/crt/welcome/': typeof AuthModulesCrtWelcomeIndexRoute
  '/credit/admin/users/delegation-of-authority': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRouteWithChildren
  '/credit/credit-limit-reviews/mass/$runId': typeof AuthModulesCreditCreditLimitReviewsMassRunIdRouteRouteWithChildren
  '/credit/credit-limit-reviews/mass/pending-confirmations': typeof AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRouteWithChildren
  '/crt/customer-investments/insights/agreements': typeof AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRouteWithChildren
  '/crt/customer-investments/insights/budget-allocations': typeof AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRouteWithChildren
  '/crt/customer-investments/insights/calculation-run-accruals': typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRouteWithChildren
  '/crt/customer-investments/insights/distribution-margin-mix': typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRouteWithChildren
  '/crt/customer-investments/insights/ip-accruals': typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRouteWithChildren
  '/crt/customer-investments/insights/manual-investments': typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRouteWithChildren
  '/crt/customer-investments/insights/master-agreements': typeof AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRouteWithChildren
  '/crt/customer-investments/insights/rap-forecasts': typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRouteWithChildren
  '/crt/customer-investments/insights/sales-deal-actuals': typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRouteWithChildren
  '/crt/customer-investments/key-accounts/estimates': typeof AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRouteWithChildren
  '/crt/materials/insights/federal-excise': typeof AuthModulesCrtMaterialsInsightsFederalExciseRouteRouteWithChildren
  '/crt/materials/insights/material-groups-overrides': typeof AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRouteWithChildren
  '/crt/materials/insights/product-type-variants': typeof AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRouteWithChildren
  '/crt/materials/insights/product-types': typeof AuthModulesCrtMaterialsInsightsProductTypesRouteRouteWithChildren
  '/crt/materials/insights/unreleased-materials': typeof AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRouteWithChildren
  '/crt/pricing-excise/insights/channel-mix': typeof AuthModulesCrtPricingExciseInsightsChannelMixRouteRouteWithChildren
  '/crt/pricing-excise/insights/consumer-rates': typeof AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRouteWithChildren
  '/crt/pricing-excise/insights/retailer-rates': typeof AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRouteWithChildren
  '/assortment/launches/$launchId': typeof AuthModulesAppAssortmentLaunchesLaunchIdRoute
  '/customers/banners/$bannerId': typeof AuthModulesAppCustomersBannersBannerIdRoute
  '/customers/stores/$storeId': typeof AuthModulesAppCustomersStoresStoreIdRoute
  '/my-uploads/$scope/$fileName': typeof AuthModulesAppMyUploadsScopeFileNameRoute
  '/reports/ecc/$reportId': typeof AuthModulesAppReportsEccReportIdRoute
  '/reports/material/$reportId': typeof AuthModulesAppReportsMaterialReportIdRoute
  '/reports/misc/$reportId': typeof AuthModulesAppReportsMiscReportIdRoute
  '/reports/operations/$reportId': typeof AuthModulesAppReportsOperationsReportIdRoute
  '/reports/order-service/$reportId': typeof AuthModulesAppReportsOrderServiceReportIdRoute
  '/reports/salesforce/$reportId': typeof AuthModulesAppReportsSalesforceReportIdRoute
  '/credit/blocked-orders/groups/$groupKey': typeof AuthModulesCreditBlockedOrdersGroupsGroupKeyRoute
  '/credit/credit-limit-reviews/mass/new': typeof AuthModulesCreditCreditLimitReviewsMassNewRoute
  '/credit/customers/$erp/prepare-clr': typeof AuthModulesCreditCustomersErpPrepareClrRoute
  '/credit/my-uploads/$scope/$fileName': typeof AuthModulesCreditMyUploadsScopeFileNameRoute
  '/crt/cost-of-goods/$year/$month': typeof AuthModulesCrtCostOfGoodsYearMonthRoute
  '/crt/my-uploads/$scope/$fileName': typeof AuthModulesCrtMyUploadsScopeFileNameRoute
  '/crt/pricing-excise/pricing-assumptions/$pricingAssumptionId': typeof AuthModulesCrtPricingExcisePricingAssumptionsPricingAssumptionIdRoute
  '/crt/pricing-excise/tax-assumptions/$taxAssumptionId': typeof AuthModulesCrtPricingExciseTaxAssumptionsTaxAssumptionIdRoute
  '/admin/audit-trails/': typeof AuthModulesAppAdminAuditTrailsIndexRoute
  '/admin/invitations/': typeof AuthModulesAppAdminInvitationsIndexRoute
  '/admin/roles/': typeof AuthModulesAppAdminRolesIndexRoute
  '/admin/users/': typeof AuthModulesAppAdminUsersIndexRoute
  '/assortment/active/': typeof AuthModulesAppAssortmentActiveIndexRoute
  '/assortment/banners/': typeof AuthModulesAppAssortmentBannersIndexRoute
  '/assortment/launches/': typeof AuthModulesAppAssortmentLaunchesIndexRoute
  '/core-upload-data/auto-inject/': typeof AuthModulesAppCoreUploadDataAutoInjectIndexRoute
  '/core-upload-data/business/': typeof AuthModulesAppCoreUploadDataBusinessIndexRoute
  '/core-upload-data/materials/': typeof AuthModulesAppCoreUploadDataMaterialsIndexRoute
  '/core-upload-data/on-hand-inventory/': typeof AuthModulesAppCoreUploadDataOnHandInventoryIndexRoute
  '/core-upload-data/operations/': typeof AuthModulesAppCoreUploadDataOperationsIndexRoute
  '/core-upload-data/order-service/': typeof AuthModulesAppCoreUploadDataOrderServiceIndexRoute
  '/customers/banners/': typeof AuthModulesAppCustomersBannersIndexRoute
  '/customers/stores/': typeof AuthModulesAppCustomersStoresIndexRoute
  '/materials/bcp-priced/': typeof AuthModulesAppMaterialsBcpPricedIndexRoute
  '/orders/all/': typeof AuthModulesAppOrdersAllIndexRoute
  '/orders/flagged/': typeof AuthModulesAppOrdersFlaggedIndexRoute
  '/orders/missing/': typeof AuthModulesAppOrdersMissingIndexRoute
  '/orders/payment-review/': typeof AuthModulesAppOrdersPaymentReviewIndexRoute
  '/orders/returns/': typeof AuthModulesAppOrdersReturnsIndexRoute
  '/processes/pipelines/': typeof AuthModulesAppProcessesPipelinesIndexRoute
  '/reports/ecc/': typeof AuthModulesAppReportsEccIndexRoute
  '/reports/material/': typeof AuthModulesAppReportsMaterialIndexRoute
  '/reports/misc/': typeof AuthModulesAppReportsMiscIndexRoute
  '/reports/operations/': typeof AuthModulesAppReportsOperationsIndexRoute
  '/reports/order-service/': typeof AuthModulesAppReportsOrderServiceIndexRoute
  '/reports/salesforce/': typeof AuthModulesAppReportsSalesforceIndexRoute
  '/credit/admin/audit-trails/': typeof AuthModulesCreditAdminAuditTrailsIndexRoute
  '/credit/admin/invitations/': typeof AuthModulesCreditAdminInvitationsIndexRoute
  '/credit/admin/roles/': typeof AuthModulesCreditAdminRolesIndexRoute
  '/credit/admin/users/': typeof AuthModulesCreditAdminUsersIndexRoute
  '/credit/credit-limit-reviews/mass/': typeof AuthModulesCreditCreditLimitReviewsMassIndexRoute
  '/credit/credit-limit-reviews/pending-confirmations/': typeof AuthModulesCreditCreditLimitReviewsPendingConfirmationsIndexRoute
  '/credit/credit-limit-reviews/review-events/': typeof AuthModulesCreditCreditLimitReviewsReviewEventsIndexRoute
  '/credit/customers/$erp/': typeof AuthModulesCreditCustomersErpIndexRoute
  '/credit/operations/multiplier/': typeof AuthModulesCreditOperationsMultiplierIndexRoute
  '/credit/operations/order-cutoffs/': typeof AuthModulesCreditOperationsOrderCutoffsIndexRoute
  '/credit/operations/province-aov-per-carton/': typeof AuthModulesCreditOperationsProvinceAovPerCartonIndexRoute
  '/credit/operations/very-low-risk-customers/': typeof AuthModulesCreditOperationsVeryLowRiskCustomersIndexRoute
  '/crt/admin/audit-trails/': typeof AuthModulesCrtAdminAuditTrailsIndexRoute
  '/crt/admin/invitations/': typeof AuthModulesCrtAdminInvitationsIndexRoute
  '/crt/admin/notifications/': typeof AuthModulesCrtAdminNotificationsIndexRoute
  '/crt/admin/roles/': typeof AuthModulesCrtAdminRolesIndexRoute
  '/crt/admin/users/': typeof AuthModulesCrtAdminUsersIndexRoute
  '/crt/customer-investments/budget-tracker/': typeof AuthModulesCrtCustomerInvestmentsBudgetTrackerIndexRoute
  '/crt/customer-investments/insights/': typeof AuthModulesCrtCustomerInvestmentsInsightsIndexRoute
  '/crt/customer-investments/investments/': typeof AuthModulesCrtCustomerInvestmentsInvestmentsIndexRoute
  '/crt/customer-investments/key-accounts/': typeof AuthModulesCrtCustomerInvestmentsKeyAccountsIndexRoute
  '/crt/customers/commercial-partners/': typeof AuthModulesCrtCustomersCommercialPartnersIndexRoute
  '/crt/kpi-reports/cash-dashboard/': typeof AuthModulesCrtKpiReportsCashDashboardIndexRoute
  '/crt/kpi-reports/profits-and-loss-summary/': typeof AuthModulesCrtKpiReportsProfitsAndLossSummaryIndexRoute
  '/crt/materials/brand-variants/': typeof AuthModulesCrtMaterialsBrandVariantsIndexRoute
  '/crt/materials/insights/': typeof AuthModulesCrtMaterialsInsightsIndexRoute
  '/crt/materials/materials-list/': typeof AuthModulesCrtMaterialsMaterialsListIndexRoute
  '/crt/materials/price-list/': typeof AuthModulesCrtMaterialsPriceListIndexRoute
  '/crt/pricing-excise/insights/': typeof AuthModulesCrtPricingExciseInsightsIndexRoute
  '/crt/pricing-excise/pricing-assumptions/': typeof AuthModulesCrtPricingExcisePricingAssumptionsIndexRoute
  '/crt/pricing-excise/pricing-rate-table/': typeof AuthModulesCrtPricingExcisePricingRateTableIndexRoute
  '/crt/pricing-excise/tax-assumptions/': typeof AuthModulesCrtPricingExciseTaxAssumptionsIndexRoute
  '/crt/volume-forecasts/channel-contributions/': typeof AuthModulesCrtVolumeForecastsChannelContributionsIndexRoute
  '/crt/volume-forecasts/nc-provincial-contributions/': typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsIndexRoute
  '/crt/volume-forecasts/sub-channel-allocations/': typeof AuthModulesCrtVolumeForecastsSubChannelAllocationsIndexRoute
  '/credit/admin/users/delegation-of-authority/blocked-orders': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRouteWithChildren
  '/credit/admin/users/delegation-of-authority/initiative': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRouteWithChildren
  '/credit/admin/users/delegation-of-authority/mass': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRouteWithChildren
  '/credit/admin/users/delegation-of-authority/single-no-deviation': typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRouteWithChildren
  '/credit/admin/users/delegation-of-authority/single-with-deviation': typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRouteWithChildren
  '/crt/customer-investments/insights/retailer-margins/fmc': typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRouteWithChildren
  '/crt/customer-investments/insights/retailer-margins/nc': typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRouteWithChildren
  '/crt/customer-investments/insights/wholesaler-margins/fmc': typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRouteWithChildren
  '/crt/customer-investments/insights/wholesaler-margins/nc': typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRouteWithChildren
  '/orders/all/$dynamoId/$poNumber': typeof AuthModulesAppOrdersAllDynamoIdPoNumberRoute
  '/credit/credit-limit-reviews/mass/$runId/lines': typeof AuthModulesCreditCreditLimitReviewsMassRunIdLinesRoute
  '/credit/credit-limit-reviews/mass/$runId/pending-confirmations': typeof AuthModulesCreditCreditLimitReviewsMassRunIdPendingConfirmationsRoute
  '/credit/credit-limit-reviews/mass/$runId/submit': typeof AuthModulesCreditCreditLimitReviewsMassRunIdSubmitRoute
  '/crt/customer-investments/insights/distribution-margin-mix/banner-mix': typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixBannerMixRoute
  '/crt/customer-investments/insights/manual-investments/$manualInvestmentId': typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsManualInvestmentIdRoute
  '/crt/volume-forecasts/channel-contributions/$year/$month': typeof AuthModulesCrtVolumeForecastsChannelContributionsYearMonthRoute
  '/crt/volume-forecasts/nc-provincial-contributions/$year/$month': typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsYearMonthRoute
  '/credit/admin/users/delegation-of-authority/': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityIndexRoute
  '/credit/credit-limit-reviews/mass/$runId/': typeof AuthModulesCreditCreditLimitReviewsMassRunIdIndexRoute
  '/credit/credit-limit-reviews/mass/pending-confirmations/': typeof AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsIndexRoute
  '/crt/customer-investments/insights/agreements/': typeof AuthModulesCrtCustomerInvestmentsInsightsAgreementsIndexRoute
  '/crt/customer-investments/insights/budget-allocations/': typeof AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsIndexRoute
  '/crt/customer-investments/insights/calculation-run-accruals/': typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsIndexRoute
  '/crt/customer-investments/insights/distribution-margin-mix/': typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixIndexRoute
  '/crt/customer-investments/insights/ip-accruals/': typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsIndexRoute
  '/crt/customer-investments/insights/manual-investments/': typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsIndexRoute
  '/crt/customer-investments/insights/master-agreements/': typeof AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsIndexRoute
  '/crt/customer-investments/insights/rap-forecasts/': typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsIndexRoute
  '/crt/customer-investments/insights/sales-deal-actuals/': typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsIndexRoute
  '/crt/customer-investments/key-accounts/estimates/': typeof AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesIndexRoute
  '/crt/materials/insights/federal-excise/': typeof AuthModulesCrtMaterialsInsightsFederalExciseIndexRoute
  '/crt/materials/insights/material-groups-overrides/': typeof AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesIndexRoute
  '/crt/materials/insights/product-type-variants/': typeof AuthModulesCrtMaterialsInsightsProductTypeVariantsIndexRoute
  '/crt/materials/insights/product-types/': typeof AuthModulesCrtMaterialsInsightsProductTypesIndexRoute
  '/crt/materials/insights/unreleased-materials/': typeof AuthModulesCrtMaterialsInsightsUnreleasedMaterialsIndexRoute
  '/crt/pricing-excise/insights/channel-mix/': typeof AuthModulesCrtPricingExciseInsightsChannelMixIndexRoute
  '/crt/pricing-excise/insights/consumer-rates/': typeof AuthModulesCrtPricingExciseInsightsConsumerRatesIndexRoute
  '/crt/pricing-excise/insights/retailer-rates/': typeof AuthModulesCrtPricingExciseInsightsRetailerRatesIndexRoute
  '/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRouteWithChildren
  '/crt/customer-investments/insights/calculation-run-accruals/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsYearMonthRoute
  '/crt/customer-investments/insights/distribution-margin-mix/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixYearMonthRoute
  '/crt/customer-investments/insights/ip-accruals/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsYearMonthRoute
  '/crt/customer-investments/insights/rap-forecasts/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsYearMonthRoute
  '/crt/customer-investments/insights/sales-deal-actuals/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsYearMonthRoute
  '/crt/pricing-excise/insights/channel-mix/$year/$month': typeof AuthModulesCrtPricingExciseInsightsChannelMixYearMonthRoute
  '/credit/admin/users/delegation-of-authority/blocked-orders/': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersIndexRoute
  '/credit/admin/users/delegation-of-authority/initiative/': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeIndexRoute
  '/credit/admin/users/delegation-of-authority/mass/': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityMassIndexRoute
  '/credit/admin/users/delegation-of-authority/single-no-deviation/': typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationIndexRoute
  '/credit/admin/users/delegation-of-authority/single-with-deviation/': typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationIndexRoute
  '/crt/customer-investments/insights/retailer-margins/fmc/': typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcIndexRoute
  '/crt/customer-investments/insights/retailer-margins/nc/': typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcIndexRoute
  '/crt/customer-investments/insights/wholesaler-margins/fmc/': typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcIndexRoute
  '/crt/customer-investments/insights/wholesaler-margins/nc/': typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcIndexRoute
  '/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers/': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/process-login': typeof ProcessLoginRoute
  '/credit': typeof AuthModulesCreditRouteRouteWithChildren
  '/crt': typeof AuthModulesCrtRouteRouteWithChildren
  '/track/$erp': typeof AuthTrackErpRoute
  '/': typeof AuthModulesIndexRoute
  '/unverified': typeof AuthUnverifiedIndexRoute
  '/crt/customers': typeof AuthModulesCrtCustomersRouteRouteWithChildren
  '/crt/volumes': typeof AuthModulesCrtVolumesRouteRoute
  '/kitchen-sink': typeof AuthModulesSharedKitchenSinkRoute
  '/error': typeof AuthModulesSharedErrorsErrorRoute
  '/not-found': typeof AuthModulesSharedErrorsNotFoundRoute
  '/unauthorized': typeof AuthModulesSharedErrorsUnauthorizedRoute
  '/credit/credit-limit-reviews/$reviewId': typeof AuthModulesCreditCreditLimitReviewsReviewIdRoute
  '/credit/google-financial-statements/$sapErp': typeof AuthModulesCreditGoogleFinancialStatementsSapErpRoute
  '/credit/initiatives/$id': typeof AuthModulesCreditInitiativesIdRoute
  '/crt/bpc-actuals/$year': typeof AuthModulesCrtBpcActualsYearRoute
  '/crt/kpi-reports/graphs': typeof AuthModulesCrtKpiReportsGraphsRoute
  '/crt/variance-analysis/by-agreement': typeof AuthModulesCrtVarianceAnalysisByAgreementRoute
  '/crt/variance-analysis/by-banner': typeof AuthModulesCrtVarianceAnalysisByBannerRoute
  '/crt/variance-analysis/by-budget': typeof AuthModulesCrtVarianceAnalysisByBudgetRoute
  '/crt/variance-analysis/by-cost-type': typeof AuthModulesCrtVarianceAnalysisByCostTypeRoute
  '/crt/volume-scenarios/$volumeScenarioId': typeof AuthModulesCrtVolumeScenariosVolumeScenarioIdRoute
  '/admin': typeof AuthModulesAppAdminIndexRoute
  '/assortment': typeof AuthModulesAppAssortmentIndexRoute
  '/core-upload-data': typeof AuthModulesAppCoreUploadDataIndexRoute
  '/customers': typeof AuthModulesAppCustomersIndexRoute
  '/materials': typeof AuthModulesAppMaterialsIndexRoute
  '/my-uploads': typeof AuthModulesAppMyUploadsIndexRoute
  '/operations': typeof AuthModulesAppOperationsIndexRoute
  '/orders': typeof AuthModulesAppOrdersIndexRoute
  '/processes': typeof AuthModulesAppProcessesIndexRoute
  '/reports': typeof AuthModulesAppReportsIndexRoute
  '/sox-compliance': typeof AuthModulesAppSoxComplianceIndexRoute
  '/welcome': typeof AuthModulesAppWelcomeIndexRoute
  '/credit/admin': typeof AuthModulesCreditAdminIndexRoute
  '/credit/blocked-orders': typeof AuthModulesCreditBlockedOrdersIndexRoute
  '/credit/credit-index-scores': typeof AuthModulesCreditCreditIndexScoresIndexRoute
  '/credit/credit-limit-reviews': typeof AuthModulesCreditCreditLimitReviewsIndexRoute
  '/credit/customers': typeof AuthModulesCreditCustomersIndexRoute
  '/credit/google-financial-statements': typeof AuthModulesCreditGoogleFinancialStatementsIndexRoute
  '/credit/inbox': typeof AuthModulesCreditInboxIndexRoute
  '/credit/initiatives': typeof AuthModulesCreditInitiativesIndexRoute
  '/credit/my-exports': typeof AuthModulesCreditMyExportsIndexRoute
  '/credit/my-uploads': typeof AuthModulesCreditMyUploadsIndexRoute
  '/credit/operations': typeof AuthModulesCreditOperationsIndexRoute
  '/credit/welcome': typeof AuthModulesCreditWelcomeIndexRoute
  '/crt/admin': typeof AuthModulesCrtAdminIndexRoute
  '/crt/azure-imports': typeof AuthModulesCrtAzureImportsIndexRoute
  '/crt/bpc-actuals': typeof AuthModulesCrtBpcActualsIndexRoute
  '/crt/cost-of-goods': typeof AuthModulesCrtCostOfGoodsIndexRoute
  '/crt/customer-investments': typeof AuthModulesCrtCustomerInvestmentsIndexRoute
  '/crt/kpi-reports': typeof AuthModulesCrtKpiReportsIndexRoute
  '/crt/materials': typeof AuthModulesCrtMaterialsIndexRoute
  '/crt/my-exports': typeof AuthModulesCrtMyExportsIndexRoute
  '/crt/my-uploads': typeof AuthModulesCrtMyUploadsIndexRoute
  '/crt/pricing-excise': typeof AuthModulesCrtPricingExciseIndexRoute
  '/crt/settings': typeof AuthModulesCrtSettingsIndexRoute
  '/crt/variance-analysis': typeof AuthModulesCrtVarianceAnalysisIndexRoute
  '/crt/volume-forecasts': typeof AuthModulesCrtVolumeForecastsIndexRoute
  '/crt/volume-scenarios': typeof AuthModulesCrtVolumeScenariosIndexRoute
  '/crt/welcome': typeof AuthModulesCrtWelcomeIndexRoute
  '/assortment/launches/$launchId': typeof AuthModulesAppAssortmentLaunchesLaunchIdRoute
  '/customers/banners/$bannerId': typeof AuthModulesAppCustomersBannersBannerIdRoute
  '/customers/stores/$storeId': typeof AuthModulesAppCustomersStoresStoreIdRoute
  '/my-uploads/$scope/$fileName': typeof AuthModulesAppMyUploadsScopeFileNameRoute
  '/reports/ecc/$reportId': typeof AuthModulesAppReportsEccReportIdRoute
  '/reports/material/$reportId': typeof AuthModulesAppReportsMaterialReportIdRoute
  '/reports/misc/$reportId': typeof AuthModulesAppReportsMiscReportIdRoute
  '/reports/operations/$reportId': typeof AuthModulesAppReportsOperationsReportIdRoute
  '/reports/order-service/$reportId': typeof AuthModulesAppReportsOrderServiceReportIdRoute
  '/reports/salesforce/$reportId': typeof AuthModulesAppReportsSalesforceReportIdRoute
  '/credit/blocked-orders/groups/$groupKey': typeof AuthModulesCreditBlockedOrdersGroupsGroupKeyRoute
  '/credit/credit-limit-reviews/mass/new': typeof AuthModulesCreditCreditLimitReviewsMassNewRoute
  '/credit/customers/$erp/prepare-clr': typeof AuthModulesCreditCustomersErpPrepareClrRoute
  '/credit/my-uploads/$scope/$fileName': typeof AuthModulesCreditMyUploadsScopeFileNameRoute
  '/crt/cost-of-goods/$year/$month': typeof AuthModulesCrtCostOfGoodsYearMonthRoute
  '/crt/my-uploads/$scope/$fileName': typeof AuthModulesCrtMyUploadsScopeFileNameRoute
  '/crt/pricing-excise/pricing-assumptions/$pricingAssumptionId': typeof AuthModulesCrtPricingExcisePricingAssumptionsPricingAssumptionIdRoute
  '/crt/pricing-excise/tax-assumptions/$taxAssumptionId': typeof AuthModulesCrtPricingExciseTaxAssumptionsTaxAssumptionIdRoute
  '/admin/audit-trails': typeof AuthModulesAppAdminAuditTrailsIndexRoute
  '/admin/invitations': typeof AuthModulesAppAdminInvitationsIndexRoute
  '/admin/roles': typeof AuthModulesAppAdminRolesIndexRoute
  '/admin/users': typeof AuthModulesAppAdminUsersIndexRoute
  '/assortment/active': typeof AuthModulesAppAssortmentActiveIndexRoute
  '/assortment/banners': typeof AuthModulesAppAssortmentBannersIndexRoute
  '/assortment/launches': typeof AuthModulesAppAssortmentLaunchesIndexRoute
  '/core-upload-data/auto-inject': typeof AuthModulesAppCoreUploadDataAutoInjectIndexRoute
  '/core-upload-data/business': typeof AuthModulesAppCoreUploadDataBusinessIndexRoute
  '/core-upload-data/materials': typeof AuthModulesAppCoreUploadDataMaterialsIndexRoute
  '/core-upload-data/on-hand-inventory': typeof AuthModulesAppCoreUploadDataOnHandInventoryIndexRoute
  '/core-upload-data/operations': typeof AuthModulesAppCoreUploadDataOperationsIndexRoute
  '/core-upload-data/order-service': typeof AuthModulesAppCoreUploadDataOrderServiceIndexRoute
  '/customers/banners': typeof AuthModulesAppCustomersBannersIndexRoute
  '/customers/stores': typeof AuthModulesAppCustomersStoresIndexRoute
  '/materials/bcp-priced': typeof AuthModulesAppMaterialsBcpPricedIndexRoute
  '/orders/all': typeof AuthModulesAppOrdersAllIndexRoute
  '/orders/flagged': typeof AuthModulesAppOrdersFlaggedIndexRoute
  '/orders/missing': typeof AuthModulesAppOrdersMissingIndexRoute
  '/orders/payment-review': typeof AuthModulesAppOrdersPaymentReviewIndexRoute
  '/orders/returns': typeof AuthModulesAppOrdersReturnsIndexRoute
  '/processes/pipelines': typeof AuthModulesAppProcessesPipelinesIndexRoute
  '/reports/ecc': typeof AuthModulesAppReportsEccIndexRoute
  '/reports/material': typeof AuthModulesAppReportsMaterialIndexRoute
  '/reports/misc': typeof AuthModulesAppReportsMiscIndexRoute
  '/reports/operations': typeof AuthModulesAppReportsOperationsIndexRoute
  '/reports/order-service': typeof AuthModulesAppReportsOrderServiceIndexRoute
  '/reports/salesforce': typeof AuthModulesAppReportsSalesforceIndexRoute
  '/credit/admin/audit-trails': typeof AuthModulesCreditAdminAuditTrailsIndexRoute
  '/credit/admin/invitations': typeof AuthModulesCreditAdminInvitationsIndexRoute
  '/credit/admin/roles': typeof AuthModulesCreditAdminRolesIndexRoute
  '/credit/admin/users': typeof AuthModulesCreditAdminUsersIndexRoute
  '/credit/credit-limit-reviews/mass': typeof AuthModulesCreditCreditLimitReviewsMassIndexRoute
  '/credit/credit-limit-reviews/pending-confirmations': typeof AuthModulesCreditCreditLimitReviewsPendingConfirmationsIndexRoute
  '/credit/credit-limit-reviews/review-events': typeof AuthModulesCreditCreditLimitReviewsReviewEventsIndexRoute
  '/credit/customers/$erp': typeof AuthModulesCreditCustomersErpIndexRoute
  '/credit/operations/multiplier': typeof AuthModulesCreditOperationsMultiplierIndexRoute
  '/credit/operations/order-cutoffs': typeof AuthModulesCreditOperationsOrderCutoffsIndexRoute
  '/credit/operations/province-aov-per-carton': typeof AuthModulesCreditOperationsProvinceAovPerCartonIndexRoute
  '/credit/operations/very-low-risk-customers': typeof AuthModulesCreditOperationsVeryLowRiskCustomersIndexRoute
  '/crt/admin/audit-trails': typeof AuthModulesCrtAdminAuditTrailsIndexRoute
  '/crt/admin/invitations': typeof AuthModulesCrtAdminInvitationsIndexRoute
  '/crt/admin/notifications': typeof AuthModulesCrtAdminNotificationsIndexRoute
  '/crt/admin/roles': typeof AuthModulesCrtAdminRolesIndexRoute
  '/crt/admin/users': typeof AuthModulesCrtAdminUsersIndexRoute
  '/crt/customer-investments/budget-tracker': typeof AuthModulesCrtCustomerInvestmentsBudgetTrackerIndexRoute
  '/crt/customer-investments/insights': typeof AuthModulesCrtCustomerInvestmentsInsightsIndexRoute
  '/crt/customer-investments/investments': typeof AuthModulesCrtCustomerInvestmentsInvestmentsIndexRoute
  '/crt/customer-investments/key-accounts': typeof AuthModulesCrtCustomerInvestmentsKeyAccountsIndexRoute
  '/crt/customers/commercial-partners': typeof AuthModulesCrtCustomersCommercialPartnersIndexRoute
  '/crt/kpi-reports/cash-dashboard': typeof AuthModulesCrtKpiReportsCashDashboardIndexRoute
  '/crt/kpi-reports/profits-and-loss-summary': typeof AuthModulesCrtKpiReportsProfitsAndLossSummaryIndexRoute
  '/crt/materials/brand-variants': typeof AuthModulesCrtMaterialsBrandVariantsIndexRoute
  '/crt/materials/insights': typeof AuthModulesCrtMaterialsInsightsIndexRoute
  '/crt/materials/materials-list': typeof AuthModulesCrtMaterialsMaterialsListIndexRoute
  '/crt/materials/price-list': typeof AuthModulesCrtMaterialsPriceListIndexRoute
  '/crt/pricing-excise/insights': typeof AuthModulesCrtPricingExciseInsightsIndexRoute
  '/crt/pricing-excise/pricing-assumptions': typeof AuthModulesCrtPricingExcisePricingAssumptionsIndexRoute
  '/crt/pricing-excise/pricing-rate-table': typeof AuthModulesCrtPricingExcisePricingRateTableIndexRoute
  '/crt/pricing-excise/tax-assumptions': typeof AuthModulesCrtPricingExciseTaxAssumptionsIndexRoute
  '/crt/volume-forecasts/channel-contributions': typeof AuthModulesCrtVolumeForecastsChannelContributionsIndexRoute
  '/crt/volume-forecasts/nc-provincial-contributions': typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsIndexRoute
  '/crt/volume-forecasts/sub-channel-allocations': typeof AuthModulesCrtVolumeForecastsSubChannelAllocationsIndexRoute
  '/orders/all/$dynamoId/$poNumber': typeof AuthModulesAppOrdersAllDynamoIdPoNumberRoute
  '/credit/credit-limit-reviews/mass/$runId/lines': typeof AuthModulesCreditCreditLimitReviewsMassRunIdLinesRoute
  '/credit/credit-limit-reviews/mass/$runId/pending-confirmations': typeof AuthModulesCreditCreditLimitReviewsMassRunIdPendingConfirmationsRoute
  '/credit/credit-limit-reviews/mass/$runId/submit': typeof AuthModulesCreditCreditLimitReviewsMassRunIdSubmitRoute
  '/crt/customer-investments/insights/distribution-margin-mix/banner-mix': typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixBannerMixRoute
  '/crt/customer-investments/insights/manual-investments/$manualInvestmentId': typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsManualInvestmentIdRoute
  '/crt/volume-forecasts/channel-contributions/$year/$month': typeof AuthModulesCrtVolumeForecastsChannelContributionsYearMonthRoute
  '/crt/volume-forecasts/nc-provincial-contributions/$year/$month': typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsYearMonthRoute
  '/credit/admin/users/delegation-of-authority': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityIndexRoute
  '/credit/credit-limit-reviews/mass/$runId': typeof AuthModulesCreditCreditLimitReviewsMassRunIdIndexRoute
  '/credit/credit-limit-reviews/mass/pending-confirmations': typeof AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsIndexRoute
  '/crt/customer-investments/insights/agreements': typeof AuthModulesCrtCustomerInvestmentsInsightsAgreementsIndexRoute
  '/crt/customer-investments/insights/budget-allocations': typeof AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsIndexRoute
  '/crt/customer-investments/insights/calculation-run-accruals': typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsIndexRoute
  '/crt/customer-investments/insights/distribution-margin-mix': typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixIndexRoute
  '/crt/customer-investments/insights/ip-accruals': typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsIndexRoute
  '/crt/customer-investments/insights/manual-investments': typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsIndexRoute
  '/crt/customer-investments/insights/master-agreements': typeof AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsIndexRoute
  '/crt/customer-investments/insights/rap-forecasts': typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsIndexRoute
  '/crt/customer-investments/insights/sales-deal-actuals': typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsIndexRoute
  '/crt/customer-investments/key-accounts/estimates': typeof AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesIndexRoute
  '/crt/materials/insights/federal-excise': typeof AuthModulesCrtMaterialsInsightsFederalExciseIndexRoute
  '/crt/materials/insights/material-groups-overrides': typeof AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesIndexRoute
  '/crt/materials/insights/product-type-variants': typeof AuthModulesCrtMaterialsInsightsProductTypeVariantsIndexRoute
  '/crt/materials/insights/product-types': typeof AuthModulesCrtMaterialsInsightsProductTypesIndexRoute
  '/crt/materials/insights/unreleased-materials': typeof AuthModulesCrtMaterialsInsightsUnreleasedMaterialsIndexRoute
  '/crt/pricing-excise/insights/channel-mix': typeof AuthModulesCrtPricingExciseInsightsChannelMixIndexRoute
  '/crt/pricing-excise/insights/consumer-rates': typeof AuthModulesCrtPricingExciseInsightsConsumerRatesIndexRoute
  '/crt/pricing-excise/insights/retailer-rates': typeof AuthModulesCrtPricingExciseInsightsRetailerRatesIndexRoute
  '/crt/customer-investments/insights/calculation-run-accruals/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsYearMonthRoute
  '/crt/customer-investments/insights/distribution-margin-mix/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixYearMonthRoute
  '/crt/customer-investments/insights/ip-accruals/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsYearMonthRoute
  '/crt/customer-investments/insights/rap-forecasts/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsYearMonthRoute
  '/crt/customer-investments/insights/sales-deal-actuals/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsYearMonthRoute
  '/crt/pricing-excise/insights/channel-mix/$year/$month': typeof AuthModulesCrtPricingExciseInsightsChannelMixYearMonthRoute
  '/credit/admin/users/delegation-of-authority/blocked-orders': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersIndexRoute
  '/credit/admin/users/delegation-of-authority/initiative': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeIndexRoute
  '/credit/admin/users/delegation-of-authority/mass': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityMassIndexRoute
  '/credit/admin/users/delegation-of-authority/single-no-deviation': typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationIndexRoute
  '/credit/admin/users/delegation-of-authority/single-with-deviation': typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationIndexRoute
  '/crt/customer-investments/insights/retailer-margins/fmc': typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcIndexRoute
  '/crt/customer-investments/insights/retailer-margins/nc': typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcIndexRoute
  '/crt/customer-investments/insights/wholesaler-margins/fmc': typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcIndexRoute
  '/crt/customer-investments/insights/wholesaler-margins/nc': typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcIndexRoute
  '/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/process-login': typeof ProcessLoginRoute
  '/_auth/_modules': typeof AuthModulesRouteRouteWithChildren
  '/_auth/unverified': typeof AuthUnverifiedRouteRouteWithChildren
  '/_auth/_modules/_app': typeof AuthModulesAppRouteRouteWithChildren
  '/_auth/_modules/credit': typeof AuthModulesCreditRouteRouteWithChildren
  '/_auth/_modules/crt': typeof AuthModulesCrtRouteRouteWithChildren
  '/_auth/track/$erp': typeof AuthTrackErpRoute
  '/_auth/_modules/': typeof AuthModulesIndexRoute
  '/_auth/unverified/': typeof AuthUnverifiedIndexRoute
  '/_auth/_modules/_app/admin': typeof AuthModulesAppAdminRouteRouteWithChildren
  '/_auth/_modules/_app/assortment': typeof AuthModulesAppAssortmentRouteRouteWithChildren
  '/_auth/_modules/_app/core-upload-data': typeof AuthModulesAppCoreUploadDataRouteRouteWithChildren
  '/_auth/_modules/_app/customers': typeof AuthModulesAppCustomersRouteRouteWithChildren
  '/_auth/_modules/_app/materials': typeof AuthModulesAppMaterialsRouteRouteWithChildren
  '/_auth/_modules/_app/my-uploads': typeof AuthModulesAppMyUploadsRouteRouteWithChildren
  '/_auth/_modules/_app/operations': typeof AuthModulesAppOperationsRouteRouteWithChildren
  '/_auth/_modules/_app/orders': typeof AuthModulesAppOrdersRouteRouteWithChildren
  '/_auth/_modules/_app/processes': typeof AuthModulesAppProcessesRouteRouteWithChildren
  '/_auth/_modules/_app/reports': typeof AuthModulesAppReportsRouteRouteWithChildren
  '/_auth/_modules/_app/sox-compliance': typeof AuthModulesAppSoxComplianceRouteRouteWithChildren
  '/_auth/_modules/_app/welcome': typeof AuthModulesAppWelcomeRouteRouteWithChildren
  '/_auth/_modules/credit/admin': typeof AuthModulesCreditAdminRouteRouteWithChildren
  '/_auth/_modules/credit/blocked-orders': typeof AuthModulesCreditBlockedOrdersRouteRouteWithChildren
  '/_auth/_modules/credit/credit-index-scores': typeof AuthModulesCreditCreditIndexScoresRouteRouteWithChildren
  '/_auth/_modules/credit/credit-limit-reviews': typeof AuthModulesCreditCreditLimitReviewsRouteRouteWithChildren
  '/_auth/_modules/credit/customers': typeof AuthModulesCreditCustomersRouteRouteWithChildren
  '/_auth/_modules/credit/google-financial-statements': typeof AuthModulesCreditGoogleFinancialStatementsRouteRouteWithChildren
  '/_auth/_modules/credit/inbox': typeof AuthModulesCreditInboxRouteRouteWithChildren
  '/_auth/_modules/credit/initiatives': typeof AuthModulesCreditInitiativesRouteRouteWithChildren
  '/_auth/_modules/credit/my-exports': typeof AuthModulesCreditMyExportsRouteRouteWithChildren
  '/_auth/_modules/credit/my-uploads': typeof AuthModulesCreditMyUploadsRouteRouteWithChildren
  '/_auth/_modules/credit/operations': typeof AuthModulesCreditOperationsRouteRouteWithChildren
  '/_auth/_modules/credit/welcome': typeof AuthModulesCreditWelcomeRouteRouteWithChildren
  '/_auth/_modules/crt/admin': typeof AuthModulesCrtAdminRouteRouteWithChildren
  '/_auth/_modules/crt/azure-imports': typeof AuthModulesCrtAzureImportsRouteRouteWithChildren
  '/_auth/_modules/crt/bpc-actuals': typeof AuthModulesCrtBpcActualsRouteRouteWithChildren
  '/_auth/_modules/crt/cost-of-goods': typeof AuthModulesCrtCostOfGoodsRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments': typeof AuthModulesCrtCustomerInvestmentsRouteRouteWithChildren
  '/_auth/_modules/crt/customers': typeof AuthModulesCrtCustomersRouteRouteWithChildren
  '/_auth/_modules/crt/kpi-reports': typeof AuthModulesCrtKpiReportsRouteRouteWithChildren
  '/_auth/_modules/crt/materials': typeof AuthModulesCrtMaterialsRouteRouteWithChildren
  '/_auth/_modules/crt/my-exports': typeof AuthModulesCrtMyExportsRouteRouteWithChildren
  '/_auth/_modules/crt/my-uploads': typeof AuthModulesCrtMyUploadsRouteRouteWithChildren
  '/_auth/_modules/crt/pricing-excise': typeof AuthModulesCrtPricingExciseRouteRouteWithChildren
  '/_auth/_modules/crt/settings': typeof AuthModulesCrtSettingsRouteRouteWithChildren
  '/_auth/_modules/crt/variance-analysis': typeof AuthModulesCrtVarianceAnalysisRouteRouteWithChildren
  '/_auth/_modules/crt/volume-forecasts': typeof AuthModulesCrtVolumeForecastsRouteRouteWithChildren
  '/_auth/_modules/crt/volume-scenarios': typeof AuthModulesCrtVolumeScenariosRouteRouteWithChildren
  '/_auth/_modules/crt/volumes': typeof AuthModulesCrtVolumesRouteRoute
  '/_auth/_modules/crt/welcome': typeof AuthModulesCrtWelcomeRouteRouteWithChildren
  '/_auth/_modules/_shared/kitchen-sink': typeof AuthModulesSharedKitchenSinkRoute
  '/_auth/_modules/_app/admin/audit-trails': typeof AuthModulesAppAdminAuditTrailsRouteRouteWithChildren
  '/_auth/_modules/_app/admin/invitations': typeof AuthModulesAppAdminInvitationsRouteRouteWithChildren
  '/_auth/_modules/_app/admin/roles': typeof AuthModulesAppAdminRolesRouteRouteWithChildren
  '/_auth/_modules/_app/admin/users': typeof AuthModulesAppAdminUsersRouteRouteWithChildren
  '/_auth/_modules/_app/assortment/active': typeof AuthModulesAppAssortmentActiveRouteRouteWithChildren
  '/_auth/_modules/_app/assortment/banners': typeof AuthModulesAppAssortmentBannersRouteRouteWithChildren
  '/_auth/_modules/_app/assortment/launches': typeof AuthModulesAppAssortmentLaunchesRouteRouteWithChildren
  '/_auth/_modules/_app/core-upload-data/auto-inject': typeof AuthModulesAppCoreUploadDataAutoInjectRouteRouteWithChildren
  '/_auth/_modules/_app/core-upload-data/business': typeof AuthModulesAppCoreUploadDataBusinessRouteRouteWithChildren
  '/_auth/_modules/_app/core-upload-data/materials': typeof AuthModulesAppCoreUploadDataMaterialsRouteRouteWithChildren
  '/_auth/_modules/_app/core-upload-data/on-hand-inventory': typeof AuthModulesAppCoreUploadDataOnHandInventoryRouteRouteWithChildren
  '/_auth/_modules/_app/core-upload-data/operations': typeof AuthModulesAppCoreUploadDataOperationsRouteRouteWithChildren
  '/_auth/_modules/_app/core-upload-data/order-service': typeof AuthModulesAppCoreUploadDataOrderServiceRouteRouteWithChildren
  '/_auth/_modules/_app/customers/banners': typeof AuthModulesAppCustomersBannersRouteRouteWithChildren
  '/_auth/_modules/_app/customers/stores': typeof AuthModulesAppCustomersStoresRouteRouteWithChildren
  '/_auth/_modules/_app/materials/bcp-priced': typeof AuthModulesAppMaterialsBcpPricedRouteRouteWithChildren
  '/_auth/_modules/_app/orders/all': typeof AuthModulesAppOrdersAllRouteRouteWithChildren
  '/_auth/_modules/_app/orders/flagged': typeof AuthModulesAppOrdersFlaggedRouteRouteWithChildren
  '/_auth/_modules/_app/orders/missing': typeof AuthModulesAppOrdersMissingRouteRouteWithChildren
  '/_auth/_modules/_app/orders/payment-review': typeof AuthModulesAppOrdersPaymentReviewRouteRouteWithChildren
  '/_auth/_modules/_app/orders/returns': typeof AuthModulesAppOrdersReturnsRouteRouteWithChildren
  '/_auth/_modules/_app/processes/pipelines': typeof AuthModulesAppProcessesPipelinesRouteRouteWithChildren
  '/_auth/_modules/_app/reports/ecc': typeof AuthModulesAppReportsEccRouteRouteWithChildren
  '/_auth/_modules/_app/reports/material': typeof AuthModulesAppReportsMaterialRouteRouteWithChildren
  '/_auth/_modules/_app/reports/misc': typeof AuthModulesAppReportsMiscRouteRouteWithChildren
  '/_auth/_modules/_app/reports/operations': typeof AuthModulesAppReportsOperationsRouteRouteWithChildren
  '/_auth/_modules/_app/reports/order-service': typeof AuthModulesAppReportsOrderServiceRouteRouteWithChildren
  '/_auth/_modules/_app/reports/salesforce': typeof AuthModulesAppReportsSalesforceRouteRouteWithChildren
  '/_auth/_modules/credit/admin/audit-trails': typeof AuthModulesCreditAdminAuditTrailsRouteRouteWithChildren
  '/_auth/_modules/credit/admin/invitations': typeof AuthModulesCreditAdminInvitationsRouteRouteWithChildren
  '/_auth/_modules/credit/admin/roles': typeof AuthModulesCreditAdminRolesRouteRouteWithChildren
  '/_auth/_modules/credit/admin/users': typeof AuthModulesCreditAdminUsersRouteRouteWithChildren
  '/_auth/_modules/credit/credit-limit-reviews/mass': typeof AuthModulesCreditCreditLimitReviewsMassRouteRouteWithChildren
  '/_auth/_modules/credit/credit-limit-reviews/pending-confirmations': typeof AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRouteWithChildren
  '/_auth/_modules/credit/credit-limit-reviews/review-events': typeof AuthModulesCreditCreditLimitReviewsReviewEventsRouteRouteWithChildren
  '/_auth/_modules/credit/customers/$erp': typeof AuthModulesCreditCustomersErpRouteRouteWithChildren
  '/_auth/_modules/credit/operations/multiplier': typeof AuthModulesCreditOperationsMultiplierRouteRouteWithChildren
  '/_auth/_modules/credit/operations/order-cutoffs': typeof AuthModulesCreditOperationsOrderCutoffsRouteRouteWithChildren
  '/_auth/_modules/credit/operations/province-aov-per-carton': typeof AuthModulesCreditOperationsProvinceAovPerCartonRouteRouteWithChildren
  '/_auth/_modules/credit/operations/very-low-risk-customers': typeof AuthModulesCreditOperationsVeryLowRiskCustomersRouteRouteWithChildren
  '/_auth/_modules/crt/admin/audit-trails': typeof AuthModulesCrtAdminAuditTrailsRouteRouteWithChildren
  '/_auth/_modules/crt/admin/invitations': typeof AuthModulesCrtAdminInvitationsRouteRouteWithChildren
  '/_auth/_modules/crt/admin/notifications': typeof AuthModulesCrtAdminNotificationsRouteRouteWithChildren
  '/_auth/_modules/crt/admin/roles': typeof AuthModulesCrtAdminRolesRouteRouteWithChildren
  '/_auth/_modules/crt/admin/users': typeof AuthModulesCrtAdminUsersRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/budget-tracker': typeof AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights': typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/investments': typeof AuthModulesCrtCustomerInvestmentsInvestmentsRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/key-accounts': typeof AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRouteWithChildren
  '/_auth/_modules/crt/customers/commercial-partners': typeof AuthModulesCrtCustomersCommercialPartnersRouteRouteWithChildren
  '/_auth/_modules/crt/kpi-reports/cash-dashboard': typeof AuthModulesCrtKpiReportsCashDashboardRouteRouteWithChildren
  '/_auth/_modules/crt/kpi-reports/profits-and-loss-summary': typeof AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRouteWithChildren
  '/_auth/_modules/crt/materials/brand-variants': typeof AuthModulesCrtMaterialsBrandVariantsRouteRouteWithChildren
  '/_auth/_modules/crt/materials/insights': typeof AuthModulesCrtMaterialsInsightsRouteRouteWithChildren
  '/_auth/_modules/crt/materials/materials-list': typeof AuthModulesCrtMaterialsMaterialsListRouteRouteWithChildren
  '/_auth/_modules/crt/materials/price-list': typeof AuthModulesCrtMaterialsPriceListRouteRouteWithChildren
  '/_auth/_modules/crt/pricing-excise/insights': typeof AuthModulesCrtPricingExciseInsightsRouteRouteWithChildren
  '/_auth/_modules/crt/pricing-excise/pricing-assumptions': typeof AuthModulesCrtPricingExcisePricingAssumptionsRouteRouteWithChildren
  '/_auth/_modules/crt/pricing-excise/pricing-rate-table': typeof AuthModulesCrtPricingExcisePricingRateTableRouteRouteWithChildren
  '/_auth/_modules/crt/pricing-excise/tax-assumptions': typeof AuthModulesCrtPricingExciseTaxAssumptionsRouteRouteWithChildren
  '/_auth/_modules/crt/volume-forecasts/channel-contributions': typeof AuthModulesCrtVolumeForecastsChannelContributionsRouteRouteWithChildren
  '/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions': typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRouteWithChildren
  '/_auth/_modules/crt/volume-forecasts/sub-channel-allocations': typeof AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRouteWithChildren
  '/_auth/_modules/_shared/_errors/error': typeof AuthModulesSharedErrorsErrorRoute
  '/_auth/_modules/_shared/_errors/not-found': typeof AuthModulesSharedErrorsNotFoundRoute
  '/_auth/_modules/_shared/_errors/unauthorized': typeof AuthModulesSharedErrorsUnauthorizedRoute
  '/_auth/_modules/credit/credit-limit-reviews/$reviewId': typeof AuthModulesCreditCreditLimitReviewsReviewIdRoute
  '/_auth/_modules/credit/google-financial-statements/$sapErp': typeof AuthModulesCreditGoogleFinancialStatementsSapErpRoute
  '/_auth/_modules/credit/initiatives/$id': typeof AuthModulesCreditInitiativesIdRoute
  '/_auth/_modules/crt/bpc-actuals/$year': typeof AuthModulesCrtBpcActualsYearRoute
  '/_auth/_modules/crt/kpi-reports/graphs': typeof AuthModulesCrtKpiReportsGraphsRoute
  '/_auth/_modules/crt/variance-analysis/by-agreement': typeof AuthModulesCrtVarianceAnalysisByAgreementRoute
  '/_auth/_modules/crt/variance-analysis/by-banner': typeof AuthModulesCrtVarianceAnalysisByBannerRoute
  '/_auth/_modules/crt/variance-analysis/by-budget': typeof AuthModulesCrtVarianceAnalysisByBudgetRoute
  '/_auth/_modules/crt/variance-analysis/by-cost-type': typeof AuthModulesCrtVarianceAnalysisByCostTypeRoute
  '/_auth/_modules/crt/volume-scenarios/$volumeScenarioId': typeof AuthModulesCrtVolumeScenariosVolumeScenarioIdRoute
  '/_auth/_modules/_app/admin/': typeof AuthModulesAppAdminIndexRoute
  '/_auth/_modules/_app/assortment/': typeof AuthModulesAppAssortmentIndexRoute
  '/_auth/_modules/_app/core-upload-data/': typeof AuthModulesAppCoreUploadDataIndexRoute
  '/_auth/_modules/_app/customers/': typeof AuthModulesAppCustomersIndexRoute
  '/_auth/_modules/_app/materials/': typeof AuthModulesAppMaterialsIndexRoute
  '/_auth/_modules/_app/my-uploads/': typeof AuthModulesAppMyUploadsIndexRoute
  '/_auth/_modules/_app/operations/': typeof AuthModulesAppOperationsIndexRoute
  '/_auth/_modules/_app/orders/': typeof AuthModulesAppOrdersIndexRoute
  '/_auth/_modules/_app/processes/': typeof AuthModulesAppProcessesIndexRoute
  '/_auth/_modules/_app/reports/': typeof AuthModulesAppReportsIndexRoute
  '/_auth/_modules/_app/sox-compliance/': typeof AuthModulesAppSoxComplianceIndexRoute
  '/_auth/_modules/_app/welcome/': typeof AuthModulesAppWelcomeIndexRoute
  '/_auth/_modules/credit/admin/': typeof AuthModulesCreditAdminIndexRoute
  '/_auth/_modules/credit/blocked-orders/': typeof AuthModulesCreditBlockedOrdersIndexRoute
  '/_auth/_modules/credit/credit-index-scores/': typeof AuthModulesCreditCreditIndexScoresIndexRoute
  '/_auth/_modules/credit/credit-limit-reviews/': typeof AuthModulesCreditCreditLimitReviewsIndexRoute
  '/_auth/_modules/credit/customers/': typeof AuthModulesCreditCustomersIndexRoute
  '/_auth/_modules/credit/google-financial-statements/': typeof AuthModulesCreditGoogleFinancialStatementsIndexRoute
  '/_auth/_modules/credit/inbox/': typeof AuthModulesCreditInboxIndexRoute
  '/_auth/_modules/credit/initiatives/': typeof AuthModulesCreditInitiativesIndexRoute
  '/_auth/_modules/credit/my-exports/': typeof AuthModulesCreditMyExportsIndexRoute
  '/_auth/_modules/credit/my-uploads/': typeof AuthModulesCreditMyUploadsIndexRoute
  '/_auth/_modules/credit/operations/': typeof AuthModulesCreditOperationsIndexRoute
  '/_auth/_modules/credit/welcome/': typeof AuthModulesCreditWelcomeIndexRoute
  '/_auth/_modules/crt/admin/': typeof AuthModulesCrtAdminIndexRoute
  '/_auth/_modules/crt/azure-imports/': typeof AuthModulesCrtAzureImportsIndexRoute
  '/_auth/_modules/crt/bpc-actuals/': typeof AuthModulesCrtBpcActualsIndexRoute
  '/_auth/_modules/crt/cost-of-goods/': typeof AuthModulesCrtCostOfGoodsIndexRoute
  '/_auth/_modules/crt/customer-investments/': typeof AuthModulesCrtCustomerInvestmentsIndexRoute
  '/_auth/_modules/crt/kpi-reports/': typeof AuthModulesCrtKpiReportsIndexRoute
  '/_auth/_modules/crt/materials/': typeof AuthModulesCrtMaterialsIndexRoute
  '/_auth/_modules/crt/my-exports/': typeof AuthModulesCrtMyExportsIndexRoute
  '/_auth/_modules/crt/my-uploads/': typeof AuthModulesCrtMyUploadsIndexRoute
  '/_auth/_modules/crt/pricing-excise/': typeof AuthModulesCrtPricingExciseIndexRoute
  '/_auth/_modules/crt/settings/': typeof AuthModulesCrtSettingsIndexRoute
  '/_auth/_modules/crt/variance-analysis/': typeof AuthModulesCrtVarianceAnalysisIndexRoute
  '/_auth/_modules/crt/volume-forecasts/': typeof AuthModulesCrtVolumeForecastsIndexRoute
  '/_auth/_modules/crt/volume-scenarios/': typeof AuthModulesCrtVolumeScenariosIndexRoute
  '/_auth/_modules/crt/welcome/': typeof AuthModulesCrtWelcomeIndexRoute
  '/_auth/_modules/credit/admin/users/delegation-of-authority': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRouteWithChildren
  '/_auth/_modules/credit/credit-limit-reviews/mass/$runId': typeof AuthModulesCreditCreditLimitReviewsMassRunIdRouteRouteWithChildren
  '/_auth/_modules/credit/credit-limit-reviews/mass/pending-confirmations': typeof AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights/agreements': typeof AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights/budget-allocations': typeof AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals': typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix': typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights/ip-accruals': typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights/manual-investments': typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights/master-agreements': typeof AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights/rap-forecasts': typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals': typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/key-accounts/estimates': typeof AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRouteWithChildren
  '/_auth/_modules/crt/materials/insights/federal-excise': typeof AuthModulesCrtMaterialsInsightsFederalExciseRouteRouteWithChildren
  '/_auth/_modules/crt/materials/insights/material-groups-overrides': typeof AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRouteWithChildren
  '/_auth/_modules/crt/materials/insights/product-type-variants': typeof AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRouteWithChildren
  '/_auth/_modules/crt/materials/insights/product-types': typeof AuthModulesCrtMaterialsInsightsProductTypesRouteRouteWithChildren
  '/_auth/_modules/crt/materials/insights/unreleased-materials': typeof AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRouteWithChildren
  '/_auth/_modules/crt/pricing-excise/insights/channel-mix': typeof AuthModulesCrtPricingExciseInsightsChannelMixRouteRouteWithChildren
  '/_auth/_modules/crt/pricing-excise/insights/consumer-rates': typeof AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRouteWithChildren
  '/_auth/_modules/crt/pricing-excise/insights/retailer-rates': typeof AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRouteWithChildren
  '/_auth/_modules/_app/assortment/launches/$launchId': typeof AuthModulesAppAssortmentLaunchesLaunchIdRoute
  '/_auth/_modules/_app/customers/banners/$bannerId': typeof AuthModulesAppCustomersBannersBannerIdRoute
  '/_auth/_modules/_app/customers/stores/$storeId': typeof AuthModulesAppCustomersStoresStoreIdRoute
  '/_auth/_modules/_app/my-uploads/$scope/$fileName': typeof AuthModulesAppMyUploadsScopeFileNameRoute
  '/_auth/_modules/_app/reports/ecc/$reportId': typeof AuthModulesAppReportsEccReportIdRoute
  '/_auth/_modules/_app/reports/material/$reportId': typeof AuthModulesAppReportsMaterialReportIdRoute
  '/_auth/_modules/_app/reports/misc/$reportId': typeof AuthModulesAppReportsMiscReportIdRoute
  '/_auth/_modules/_app/reports/operations/$reportId': typeof AuthModulesAppReportsOperationsReportIdRoute
  '/_auth/_modules/_app/reports/order-service/$reportId': typeof AuthModulesAppReportsOrderServiceReportIdRoute
  '/_auth/_modules/_app/reports/salesforce/$reportId': typeof AuthModulesAppReportsSalesforceReportIdRoute
  '/_auth/_modules/credit/blocked-orders/groups/$groupKey': typeof AuthModulesCreditBlockedOrdersGroupsGroupKeyRoute
  '/_auth/_modules/credit/credit-limit-reviews/mass/new': typeof AuthModulesCreditCreditLimitReviewsMassNewRoute
  '/_auth/_modules/credit/customers/$erp/prepare-clr': typeof AuthModulesCreditCustomersErpPrepareClrRoute
  '/_auth/_modules/credit/my-uploads/$scope/$fileName': typeof AuthModulesCreditMyUploadsScopeFileNameRoute
  '/_auth/_modules/crt/cost-of-goods/$year/$month': typeof AuthModulesCrtCostOfGoodsYearMonthRoute
  '/_auth/_modules/crt/my-uploads/$scope/$fileName': typeof AuthModulesCrtMyUploadsScopeFileNameRoute
  '/_auth/_modules/crt/pricing-excise/pricing-assumptions/$pricingAssumptionId': typeof AuthModulesCrtPricingExcisePricingAssumptionsPricingAssumptionIdRoute
  '/_auth/_modules/crt/pricing-excise/tax-assumptions/$taxAssumptionId': typeof AuthModulesCrtPricingExciseTaxAssumptionsTaxAssumptionIdRoute
  '/_auth/_modules/_app/admin/audit-trails/': typeof AuthModulesAppAdminAuditTrailsIndexRoute
  '/_auth/_modules/_app/admin/invitations/': typeof AuthModulesAppAdminInvitationsIndexRoute
  '/_auth/_modules/_app/admin/roles/': typeof AuthModulesAppAdminRolesIndexRoute
  '/_auth/_modules/_app/admin/users/': typeof AuthModulesAppAdminUsersIndexRoute
  '/_auth/_modules/_app/assortment/active/': typeof AuthModulesAppAssortmentActiveIndexRoute
  '/_auth/_modules/_app/assortment/banners/': typeof AuthModulesAppAssortmentBannersIndexRoute
  '/_auth/_modules/_app/assortment/launches/': typeof AuthModulesAppAssortmentLaunchesIndexRoute
  '/_auth/_modules/_app/core-upload-data/auto-inject/': typeof AuthModulesAppCoreUploadDataAutoInjectIndexRoute
  '/_auth/_modules/_app/core-upload-data/business/': typeof AuthModulesAppCoreUploadDataBusinessIndexRoute
  '/_auth/_modules/_app/core-upload-data/materials/': typeof AuthModulesAppCoreUploadDataMaterialsIndexRoute
  '/_auth/_modules/_app/core-upload-data/on-hand-inventory/': typeof AuthModulesAppCoreUploadDataOnHandInventoryIndexRoute
  '/_auth/_modules/_app/core-upload-data/operations/': typeof AuthModulesAppCoreUploadDataOperationsIndexRoute
  '/_auth/_modules/_app/core-upload-data/order-service/': typeof AuthModulesAppCoreUploadDataOrderServiceIndexRoute
  '/_auth/_modules/_app/customers/banners/': typeof AuthModulesAppCustomersBannersIndexRoute
  '/_auth/_modules/_app/customers/stores/': typeof AuthModulesAppCustomersStoresIndexRoute
  '/_auth/_modules/_app/materials/bcp-priced/': typeof AuthModulesAppMaterialsBcpPricedIndexRoute
  '/_auth/_modules/_app/orders/all/': typeof AuthModulesAppOrdersAllIndexRoute
  '/_auth/_modules/_app/orders/flagged/': typeof AuthModulesAppOrdersFlaggedIndexRoute
  '/_auth/_modules/_app/orders/missing/': typeof AuthModulesAppOrdersMissingIndexRoute
  '/_auth/_modules/_app/orders/payment-review/': typeof AuthModulesAppOrdersPaymentReviewIndexRoute
  '/_auth/_modules/_app/orders/returns/': typeof AuthModulesAppOrdersReturnsIndexRoute
  '/_auth/_modules/_app/processes/pipelines/': typeof AuthModulesAppProcessesPipelinesIndexRoute
  '/_auth/_modules/_app/reports/ecc/': typeof AuthModulesAppReportsEccIndexRoute
  '/_auth/_modules/_app/reports/material/': typeof AuthModulesAppReportsMaterialIndexRoute
  '/_auth/_modules/_app/reports/misc/': typeof AuthModulesAppReportsMiscIndexRoute
  '/_auth/_modules/_app/reports/operations/': typeof AuthModulesAppReportsOperationsIndexRoute
  '/_auth/_modules/_app/reports/order-service/': typeof AuthModulesAppReportsOrderServiceIndexRoute
  '/_auth/_modules/_app/reports/salesforce/': typeof AuthModulesAppReportsSalesforceIndexRoute
  '/_auth/_modules/credit/admin/audit-trails/': typeof AuthModulesCreditAdminAuditTrailsIndexRoute
  '/_auth/_modules/credit/admin/invitations/': typeof AuthModulesCreditAdminInvitationsIndexRoute
  '/_auth/_modules/credit/admin/roles/': typeof AuthModulesCreditAdminRolesIndexRoute
  '/_auth/_modules/credit/admin/users/': typeof AuthModulesCreditAdminUsersIndexRoute
  '/_auth/_modules/credit/credit-limit-reviews/mass/': typeof AuthModulesCreditCreditLimitReviewsMassIndexRoute
  '/_auth/_modules/credit/credit-limit-reviews/pending-confirmations/': typeof AuthModulesCreditCreditLimitReviewsPendingConfirmationsIndexRoute
  '/_auth/_modules/credit/credit-limit-reviews/review-events/': typeof AuthModulesCreditCreditLimitReviewsReviewEventsIndexRoute
  '/_auth/_modules/credit/customers/$erp/': typeof AuthModulesCreditCustomersErpIndexRoute
  '/_auth/_modules/credit/operations/multiplier/': typeof AuthModulesCreditOperationsMultiplierIndexRoute
  '/_auth/_modules/credit/operations/order-cutoffs/': typeof AuthModulesCreditOperationsOrderCutoffsIndexRoute
  '/_auth/_modules/credit/operations/province-aov-per-carton/': typeof AuthModulesCreditOperationsProvinceAovPerCartonIndexRoute
  '/_auth/_modules/credit/operations/very-low-risk-customers/': typeof AuthModulesCreditOperationsVeryLowRiskCustomersIndexRoute
  '/_auth/_modules/crt/admin/audit-trails/': typeof AuthModulesCrtAdminAuditTrailsIndexRoute
  '/_auth/_modules/crt/admin/invitations/': typeof AuthModulesCrtAdminInvitationsIndexRoute
  '/_auth/_modules/crt/admin/notifications/': typeof AuthModulesCrtAdminNotificationsIndexRoute
  '/_auth/_modules/crt/admin/roles/': typeof AuthModulesCrtAdminRolesIndexRoute
  '/_auth/_modules/crt/admin/users/': typeof AuthModulesCrtAdminUsersIndexRoute
  '/_auth/_modules/crt/customer-investments/budget-tracker/': typeof AuthModulesCrtCustomerInvestmentsBudgetTrackerIndexRoute
  '/_auth/_modules/crt/customer-investments/insights/': typeof AuthModulesCrtCustomerInvestmentsInsightsIndexRoute
  '/_auth/_modules/crt/customer-investments/investments/': typeof AuthModulesCrtCustomerInvestmentsInvestmentsIndexRoute
  '/_auth/_modules/crt/customer-investments/key-accounts/': typeof AuthModulesCrtCustomerInvestmentsKeyAccountsIndexRoute
  '/_auth/_modules/crt/customers/commercial-partners/': typeof AuthModulesCrtCustomersCommercialPartnersIndexRoute
  '/_auth/_modules/crt/kpi-reports/cash-dashboard/': typeof AuthModulesCrtKpiReportsCashDashboardIndexRoute
  '/_auth/_modules/crt/kpi-reports/profits-and-loss-summary/': typeof AuthModulesCrtKpiReportsProfitsAndLossSummaryIndexRoute
  '/_auth/_modules/crt/materials/brand-variants/': typeof AuthModulesCrtMaterialsBrandVariantsIndexRoute
  '/_auth/_modules/crt/materials/insights/': typeof AuthModulesCrtMaterialsInsightsIndexRoute
  '/_auth/_modules/crt/materials/materials-list/': typeof AuthModulesCrtMaterialsMaterialsListIndexRoute
  '/_auth/_modules/crt/materials/price-list/': typeof AuthModulesCrtMaterialsPriceListIndexRoute
  '/_auth/_modules/crt/pricing-excise/insights/': typeof AuthModulesCrtPricingExciseInsightsIndexRoute
  '/_auth/_modules/crt/pricing-excise/pricing-assumptions/': typeof AuthModulesCrtPricingExcisePricingAssumptionsIndexRoute
  '/_auth/_modules/crt/pricing-excise/pricing-rate-table/': typeof AuthModulesCrtPricingExcisePricingRateTableIndexRoute
  '/_auth/_modules/crt/pricing-excise/tax-assumptions/': typeof AuthModulesCrtPricingExciseTaxAssumptionsIndexRoute
  '/_auth/_modules/crt/volume-forecasts/channel-contributions/': typeof AuthModulesCrtVolumeForecastsChannelContributionsIndexRoute
  '/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions/': typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsIndexRoute
  '/_auth/_modules/crt/volume-forecasts/sub-channel-allocations/': typeof AuthModulesCrtVolumeForecastsSubChannelAllocationsIndexRoute
  '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRouteWithChildren
  '/_auth/_modules/credit/admin/users/delegation-of-authority/initiative': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRouteWithChildren
  '/_auth/_modules/credit/admin/users/delegation-of-authority/mass': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRouteWithChildren
  '/_auth/_modules/credit/admin/users/delegation-of-authority/single-no-deviation': typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRouteWithChildren
  '/_auth/_modules/credit/admin/users/delegation-of-authority/single-with-deviation': typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights/retailer-margins/fmc': typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights/retailer-margins/nc': typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/fmc': typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/nc': typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRouteWithChildren
  '/_auth/_modules/_app/orders/all/$dynamoId/$poNumber': typeof AuthModulesAppOrdersAllDynamoIdPoNumberRoute
  '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/lines': typeof AuthModulesCreditCreditLimitReviewsMassRunIdLinesRoute
  '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/pending-confirmations': typeof AuthModulesCreditCreditLimitReviewsMassRunIdPendingConfirmationsRoute
  '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/submit': typeof AuthModulesCreditCreditLimitReviewsMassRunIdSubmitRoute
  '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/banner-mix': typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixBannerMixRoute
  '/_auth/_modules/crt/customer-investments/insights/manual-investments/$manualInvestmentId': typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsManualInvestmentIdRoute
  '/_auth/_modules/crt/volume-forecasts/channel-contributions/$year/$month': typeof AuthModulesCrtVolumeForecastsChannelContributionsYearMonthRoute
  '/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions/$year/$month': typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsYearMonthRoute
  '/_auth/_modules/credit/admin/users/delegation-of-authority/': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityIndexRoute
  '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/': typeof AuthModulesCreditCreditLimitReviewsMassRunIdIndexRoute
  '/_auth/_modules/credit/credit-limit-reviews/mass/pending-confirmations/': typeof AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsIndexRoute
  '/_auth/_modules/crt/customer-investments/insights/agreements/': typeof AuthModulesCrtCustomerInvestmentsInsightsAgreementsIndexRoute
  '/_auth/_modules/crt/customer-investments/insights/budget-allocations/': typeof AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsIndexRoute
  '/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals/': typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsIndexRoute
  '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/': typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixIndexRoute
  '/_auth/_modules/crt/customer-investments/insights/ip-accruals/': typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsIndexRoute
  '/_auth/_modules/crt/customer-investments/insights/manual-investments/': typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsIndexRoute
  '/_auth/_modules/crt/customer-investments/insights/master-agreements/': typeof AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsIndexRoute
  '/_auth/_modules/crt/customer-investments/insights/rap-forecasts/': typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsIndexRoute
  '/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals/': typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsIndexRoute
  '/_auth/_modules/crt/customer-investments/key-accounts/estimates/': typeof AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesIndexRoute
  '/_auth/_modules/crt/materials/insights/federal-excise/': typeof AuthModulesCrtMaterialsInsightsFederalExciseIndexRoute
  '/_auth/_modules/crt/materials/insights/material-groups-overrides/': typeof AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesIndexRoute
  '/_auth/_modules/crt/materials/insights/product-type-variants/': typeof AuthModulesCrtMaterialsInsightsProductTypeVariantsIndexRoute
  '/_auth/_modules/crt/materials/insights/product-types/': typeof AuthModulesCrtMaterialsInsightsProductTypesIndexRoute
  '/_auth/_modules/crt/materials/insights/unreleased-materials/': typeof AuthModulesCrtMaterialsInsightsUnreleasedMaterialsIndexRoute
  '/_auth/_modules/crt/pricing-excise/insights/channel-mix/': typeof AuthModulesCrtPricingExciseInsightsChannelMixIndexRoute
  '/_auth/_modules/crt/pricing-excise/insights/consumer-rates/': typeof AuthModulesCrtPricingExciseInsightsConsumerRatesIndexRoute
  '/_auth/_modules/crt/pricing-excise/insights/retailer-rates/': typeof AuthModulesCrtPricingExciseInsightsRetailerRatesIndexRoute
  '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRouteWithChildren
  '/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsYearMonthRoute
  '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixYearMonthRoute
  '/_auth/_modules/crt/customer-investments/insights/ip-accruals/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsYearMonthRoute
  '/_auth/_modules/crt/customer-investments/insights/rap-forecasts/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsYearMonthRoute
  '/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals/$year/$month': typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsYearMonthRoute
  '/_auth/_modules/crt/pricing-excise/insights/channel-mix/$year/$month': typeof AuthModulesCrtPricingExciseInsightsChannelMixYearMonthRoute
  '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersIndexRoute
  '/_auth/_modules/credit/admin/users/delegation-of-authority/initiative/': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeIndexRoute
  '/_auth/_modules/credit/admin/users/delegation-of-authority/mass/': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityMassIndexRoute
  '/_auth/_modules/credit/admin/users/delegation-of-authority/single-no-deviation/': typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationIndexRoute
  '/_auth/_modules/credit/admin/users/delegation-of-authority/single-with-deviation/': typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationIndexRoute
  '/_auth/_modules/crt/customer-investments/insights/retailer-margins/fmc/': typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcIndexRoute
  '/_auth/_modules/crt/customer-investments/insights/retailer-margins/nc/': typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcIndexRoute
  '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/fmc/': typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcIndexRoute
  '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/nc/': typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcIndexRoute
  '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers/': typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/process-login'
    | '/unverified'
    | '/credit'
    | '/crt'
    | '/track/$erp'
    | '/'
    | '/unverified/'
    | '/admin'
    | '/assortment'
    | '/core-upload-data'
    | '/customers'
    | '/materials'
    | '/my-uploads'
    | '/operations'
    | '/orders'
    | '/processes'
    | '/reports'
    | '/sox-compliance'
    | '/welcome'
    | '/credit/admin'
    | '/credit/blocked-orders'
    | '/credit/credit-index-scores'
    | '/credit/credit-limit-reviews'
    | '/credit/customers'
    | '/credit/google-financial-statements'
    | '/credit/inbox'
    | '/credit/initiatives'
    | '/credit/my-exports'
    | '/credit/my-uploads'
    | '/credit/operations'
    | '/credit/welcome'
    | '/crt/admin'
    | '/crt/azure-imports'
    | '/crt/bpc-actuals'
    | '/crt/cost-of-goods'
    | '/crt/customer-investments'
    | '/crt/customers'
    | '/crt/kpi-reports'
    | '/crt/materials'
    | '/crt/my-exports'
    | '/crt/my-uploads'
    | '/crt/pricing-excise'
    | '/crt/settings'
    | '/crt/variance-analysis'
    | '/crt/volume-forecasts'
    | '/crt/volume-scenarios'
    | '/crt/volumes'
    | '/crt/welcome'
    | '/kitchen-sink'
    | '/admin/audit-trails'
    | '/admin/invitations'
    | '/admin/roles'
    | '/admin/users'
    | '/assortment/active'
    | '/assortment/banners'
    | '/assortment/launches'
    | '/core-upload-data/auto-inject'
    | '/core-upload-data/business'
    | '/core-upload-data/materials'
    | '/core-upload-data/on-hand-inventory'
    | '/core-upload-data/operations'
    | '/core-upload-data/order-service'
    | '/customers/banners'
    | '/customers/stores'
    | '/materials/bcp-priced'
    | '/orders/all'
    | '/orders/flagged'
    | '/orders/missing'
    | '/orders/payment-review'
    | '/orders/returns'
    | '/processes/pipelines'
    | '/reports/ecc'
    | '/reports/material'
    | '/reports/misc'
    | '/reports/operations'
    | '/reports/order-service'
    | '/reports/salesforce'
    | '/credit/admin/audit-trails'
    | '/credit/admin/invitations'
    | '/credit/admin/roles'
    | '/credit/admin/users'
    | '/credit/credit-limit-reviews/mass'
    | '/credit/credit-limit-reviews/pending-confirmations'
    | '/credit/credit-limit-reviews/review-events'
    | '/credit/customers/$erp'
    | '/credit/operations/multiplier'
    | '/credit/operations/order-cutoffs'
    | '/credit/operations/province-aov-per-carton'
    | '/credit/operations/very-low-risk-customers'
    | '/crt/admin/audit-trails'
    | '/crt/admin/invitations'
    | '/crt/admin/notifications'
    | '/crt/admin/roles'
    | '/crt/admin/users'
    | '/crt/customer-investments/budget-tracker'
    | '/crt/customer-investments/insights'
    | '/crt/customer-investments/investments'
    | '/crt/customer-investments/key-accounts'
    | '/crt/customers/commercial-partners'
    | '/crt/kpi-reports/cash-dashboard'
    | '/crt/kpi-reports/profits-and-loss-summary'
    | '/crt/materials/brand-variants'
    | '/crt/materials/insights'
    | '/crt/materials/materials-list'
    | '/crt/materials/price-list'
    | '/crt/pricing-excise/insights'
    | '/crt/pricing-excise/pricing-assumptions'
    | '/crt/pricing-excise/pricing-rate-table'
    | '/crt/pricing-excise/tax-assumptions'
    | '/crt/volume-forecasts/channel-contributions'
    | '/crt/volume-forecasts/nc-provincial-contributions'
    | '/crt/volume-forecasts/sub-channel-allocations'
    | '/error'
    | '/not-found'
    | '/unauthorized'
    | '/credit/credit-limit-reviews/$reviewId'
    | '/credit/google-financial-statements/$sapErp'
    | '/credit/initiatives/$id'
    | '/crt/bpc-actuals/$year'
    | '/crt/kpi-reports/graphs'
    | '/crt/variance-analysis/by-agreement'
    | '/crt/variance-analysis/by-banner'
    | '/crt/variance-analysis/by-budget'
    | '/crt/variance-analysis/by-cost-type'
    | '/crt/volume-scenarios/$volumeScenarioId'
    | '/admin/'
    | '/assortment/'
    | '/core-upload-data/'
    | '/customers/'
    | '/materials/'
    | '/my-uploads/'
    | '/operations/'
    | '/orders/'
    | '/processes/'
    | '/reports/'
    | '/sox-compliance/'
    | '/welcome/'
    | '/credit/admin/'
    | '/credit/blocked-orders/'
    | '/credit/credit-index-scores/'
    | '/credit/credit-limit-reviews/'
    | '/credit/customers/'
    | '/credit/google-financial-statements/'
    | '/credit/inbox/'
    | '/credit/initiatives/'
    | '/credit/my-exports/'
    | '/credit/my-uploads/'
    | '/credit/operations/'
    | '/credit/welcome/'
    | '/crt/admin/'
    | '/crt/azure-imports/'
    | '/crt/bpc-actuals/'
    | '/crt/cost-of-goods/'
    | '/crt/customer-investments/'
    | '/crt/kpi-reports/'
    | '/crt/materials/'
    | '/crt/my-exports/'
    | '/crt/my-uploads/'
    | '/crt/pricing-excise/'
    | '/crt/settings/'
    | '/crt/variance-analysis/'
    | '/crt/volume-forecasts/'
    | '/crt/volume-scenarios/'
    | '/crt/welcome/'
    | '/credit/admin/users/delegation-of-authority'
    | '/credit/credit-limit-reviews/mass/$runId'
    | '/credit/credit-limit-reviews/mass/pending-confirmations'
    | '/crt/customer-investments/insights/agreements'
    | '/crt/customer-investments/insights/budget-allocations'
    | '/crt/customer-investments/insights/calculation-run-accruals'
    | '/crt/customer-investments/insights/distribution-margin-mix'
    | '/crt/customer-investments/insights/ip-accruals'
    | '/crt/customer-investments/insights/manual-investments'
    | '/crt/customer-investments/insights/master-agreements'
    | '/crt/customer-investments/insights/rap-forecasts'
    | '/crt/customer-investments/insights/sales-deal-actuals'
    | '/crt/customer-investments/key-accounts/estimates'
    | '/crt/materials/insights/federal-excise'
    | '/crt/materials/insights/material-groups-overrides'
    | '/crt/materials/insights/product-type-variants'
    | '/crt/materials/insights/product-types'
    | '/crt/materials/insights/unreleased-materials'
    | '/crt/pricing-excise/insights/channel-mix'
    | '/crt/pricing-excise/insights/consumer-rates'
    | '/crt/pricing-excise/insights/retailer-rates'
    | '/assortment/launches/$launchId'
    | '/customers/banners/$bannerId'
    | '/customers/stores/$storeId'
    | '/my-uploads/$scope/$fileName'
    | '/reports/ecc/$reportId'
    | '/reports/material/$reportId'
    | '/reports/misc/$reportId'
    | '/reports/operations/$reportId'
    | '/reports/order-service/$reportId'
    | '/reports/salesforce/$reportId'
    | '/credit/blocked-orders/groups/$groupKey'
    | '/credit/credit-limit-reviews/mass/new'
    | '/credit/customers/$erp/prepare-clr'
    | '/credit/my-uploads/$scope/$fileName'
    | '/crt/cost-of-goods/$year/$month'
    | '/crt/my-uploads/$scope/$fileName'
    | '/crt/pricing-excise/pricing-assumptions/$pricingAssumptionId'
    | '/crt/pricing-excise/tax-assumptions/$taxAssumptionId'
    | '/admin/audit-trails/'
    | '/admin/invitations/'
    | '/admin/roles/'
    | '/admin/users/'
    | '/assortment/active/'
    | '/assortment/banners/'
    | '/assortment/launches/'
    | '/core-upload-data/auto-inject/'
    | '/core-upload-data/business/'
    | '/core-upload-data/materials/'
    | '/core-upload-data/on-hand-inventory/'
    | '/core-upload-data/operations/'
    | '/core-upload-data/order-service/'
    | '/customers/banners/'
    | '/customers/stores/'
    | '/materials/bcp-priced/'
    | '/orders/all/'
    | '/orders/flagged/'
    | '/orders/missing/'
    | '/orders/payment-review/'
    | '/orders/returns/'
    | '/processes/pipelines/'
    | '/reports/ecc/'
    | '/reports/material/'
    | '/reports/misc/'
    | '/reports/operations/'
    | '/reports/order-service/'
    | '/reports/salesforce/'
    | '/credit/admin/audit-trails/'
    | '/credit/admin/invitations/'
    | '/credit/admin/roles/'
    | '/credit/admin/users/'
    | '/credit/credit-limit-reviews/mass/'
    | '/credit/credit-limit-reviews/pending-confirmations/'
    | '/credit/credit-limit-reviews/review-events/'
    | '/credit/customers/$erp/'
    | '/credit/operations/multiplier/'
    | '/credit/operations/order-cutoffs/'
    | '/credit/operations/province-aov-per-carton/'
    | '/credit/operations/very-low-risk-customers/'
    | '/crt/admin/audit-trails/'
    | '/crt/admin/invitations/'
    | '/crt/admin/notifications/'
    | '/crt/admin/roles/'
    | '/crt/admin/users/'
    | '/crt/customer-investments/budget-tracker/'
    | '/crt/customer-investments/insights/'
    | '/crt/customer-investments/investments/'
    | '/crt/customer-investments/key-accounts/'
    | '/crt/customers/commercial-partners/'
    | '/crt/kpi-reports/cash-dashboard/'
    | '/crt/kpi-reports/profits-and-loss-summary/'
    | '/crt/materials/brand-variants/'
    | '/crt/materials/insights/'
    | '/crt/materials/materials-list/'
    | '/crt/materials/price-list/'
    | '/crt/pricing-excise/insights/'
    | '/crt/pricing-excise/pricing-assumptions/'
    | '/crt/pricing-excise/pricing-rate-table/'
    | '/crt/pricing-excise/tax-assumptions/'
    | '/crt/volume-forecasts/channel-contributions/'
    | '/crt/volume-forecasts/nc-provincial-contributions/'
    | '/crt/volume-forecasts/sub-channel-allocations/'
    | '/credit/admin/users/delegation-of-authority/blocked-orders'
    | '/credit/admin/users/delegation-of-authority/initiative'
    | '/credit/admin/users/delegation-of-authority/mass'
    | '/credit/admin/users/delegation-of-authority/single-no-deviation'
    | '/credit/admin/users/delegation-of-authority/single-with-deviation'
    | '/crt/customer-investments/insights/retailer-margins/fmc'
    | '/crt/customer-investments/insights/retailer-margins/nc'
    | '/crt/customer-investments/insights/wholesaler-margins/fmc'
    | '/crt/customer-investments/insights/wholesaler-margins/nc'
    | '/orders/all/$dynamoId/$poNumber'
    | '/credit/credit-limit-reviews/mass/$runId/lines'
    | '/credit/credit-limit-reviews/mass/$runId/pending-confirmations'
    | '/credit/credit-limit-reviews/mass/$runId/submit'
    | '/crt/customer-investments/insights/distribution-margin-mix/banner-mix'
    | '/crt/customer-investments/insights/manual-investments/$manualInvestmentId'
    | '/crt/volume-forecasts/channel-contributions/$year/$month'
    | '/crt/volume-forecasts/nc-provincial-contributions/$year/$month'
    | '/credit/admin/users/delegation-of-authority/'
    | '/credit/credit-limit-reviews/mass/$runId/'
    | '/credit/credit-limit-reviews/mass/pending-confirmations/'
    | '/crt/customer-investments/insights/agreements/'
    | '/crt/customer-investments/insights/budget-allocations/'
    | '/crt/customer-investments/insights/calculation-run-accruals/'
    | '/crt/customer-investments/insights/distribution-margin-mix/'
    | '/crt/customer-investments/insights/ip-accruals/'
    | '/crt/customer-investments/insights/manual-investments/'
    | '/crt/customer-investments/insights/master-agreements/'
    | '/crt/customer-investments/insights/rap-forecasts/'
    | '/crt/customer-investments/insights/sales-deal-actuals/'
    | '/crt/customer-investments/key-accounts/estimates/'
    | '/crt/materials/insights/federal-excise/'
    | '/crt/materials/insights/material-groups-overrides/'
    | '/crt/materials/insights/product-type-variants/'
    | '/crt/materials/insights/product-types/'
    | '/crt/materials/insights/unreleased-materials/'
    | '/crt/pricing-excise/insights/channel-mix/'
    | '/crt/pricing-excise/insights/consumer-rates/'
    | '/crt/pricing-excise/insights/retailer-rates/'
    | '/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers'
    | '/crt/customer-investments/insights/calculation-run-accruals/$year/$month'
    | '/crt/customer-investments/insights/distribution-margin-mix/$year/$month'
    | '/crt/customer-investments/insights/ip-accruals/$year/$month'
    | '/crt/customer-investments/insights/rap-forecasts/$year/$month'
    | '/crt/customer-investments/insights/sales-deal-actuals/$year/$month'
    | '/crt/pricing-excise/insights/channel-mix/$year/$month'
    | '/credit/admin/users/delegation-of-authority/blocked-orders/'
    | '/credit/admin/users/delegation-of-authority/initiative/'
    | '/credit/admin/users/delegation-of-authority/mass/'
    | '/credit/admin/users/delegation-of-authority/single-no-deviation/'
    | '/credit/admin/users/delegation-of-authority/single-with-deviation/'
    | '/crt/customer-investments/insights/retailer-margins/fmc/'
    | '/crt/customer-investments/insights/retailer-margins/nc/'
    | '/crt/customer-investments/insights/wholesaler-margins/fmc/'
    | '/crt/customer-investments/insights/wholesaler-margins/nc/'
    | '/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/process-login'
    | '/credit'
    | '/crt'
    | '/track/$erp'
    | '/'
    | '/unverified'
    | '/crt/customers'
    | '/crt/volumes'
    | '/kitchen-sink'
    | '/error'
    | '/not-found'
    | '/unauthorized'
    | '/credit/credit-limit-reviews/$reviewId'
    | '/credit/google-financial-statements/$sapErp'
    | '/credit/initiatives/$id'
    | '/crt/bpc-actuals/$year'
    | '/crt/kpi-reports/graphs'
    | '/crt/variance-analysis/by-agreement'
    | '/crt/variance-analysis/by-banner'
    | '/crt/variance-analysis/by-budget'
    | '/crt/variance-analysis/by-cost-type'
    | '/crt/volume-scenarios/$volumeScenarioId'
    | '/admin'
    | '/assortment'
    | '/core-upload-data'
    | '/customers'
    | '/materials'
    | '/my-uploads'
    | '/operations'
    | '/orders'
    | '/processes'
    | '/reports'
    | '/sox-compliance'
    | '/welcome'
    | '/credit/admin'
    | '/credit/blocked-orders'
    | '/credit/credit-index-scores'
    | '/credit/credit-limit-reviews'
    | '/credit/customers'
    | '/credit/google-financial-statements'
    | '/credit/inbox'
    | '/credit/initiatives'
    | '/credit/my-exports'
    | '/credit/my-uploads'
    | '/credit/operations'
    | '/credit/welcome'
    | '/crt/admin'
    | '/crt/azure-imports'
    | '/crt/bpc-actuals'
    | '/crt/cost-of-goods'
    | '/crt/customer-investments'
    | '/crt/kpi-reports'
    | '/crt/materials'
    | '/crt/my-exports'
    | '/crt/my-uploads'
    | '/crt/pricing-excise'
    | '/crt/settings'
    | '/crt/variance-analysis'
    | '/crt/volume-forecasts'
    | '/crt/volume-scenarios'
    | '/crt/welcome'
    | '/assortment/launches/$launchId'
    | '/customers/banners/$bannerId'
    | '/customers/stores/$storeId'
    | '/my-uploads/$scope/$fileName'
    | '/reports/ecc/$reportId'
    | '/reports/material/$reportId'
    | '/reports/misc/$reportId'
    | '/reports/operations/$reportId'
    | '/reports/order-service/$reportId'
    | '/reports/salesforce/$reportId'
    | '/credit/blocked-orders/groups/$groupKey'
    | '/credit/credit-limit-reviews/mass/new'
    | '/credit/customers/$erp/prepare-clr'
    | '/credit/my-uploads/$scope/$fileName'
    | '/crt/cost-of-goods/$year/$month'
    | '/crt/my-uploads/$scope/$fileName'
    | '/crt/pricing-excise/pricing-assumptions/$pricingAssumptionId'
    | '/crt/pricing-excise/tax-assumptions/$taxAssumptionId'
    | '/admin/audit-trails'
    | '/admin/invitations'
    | '/admin/roles'
    | '/admin/users'
    | '/assortment/active'
    | '/assortment/banners'
    | '/assortment/launches'
    | '/core-upload-data/auto-inject'
    | '/core-upload-data/business'
    | '/core-upload-data/materials'
    | '/core-upload-data/on-hand-inventory'
    | '/core-upload-data/operations'
    | '/core-upload-data/order-service'
    | '/customers/banners'
    | '/customers/stores'
    | '/materials/bcp-priced'
    | '/orders/all'
    | '/orders/flagged'
    | '/orders/missing'
    | '/orders/payment-review'
    | '/orders/returns'
    | '/processes/pipelines'
    | '/reports/ecc'
    | '/reports/material'
    | '/reports/misc'
    | '/reports/operations'
    | '/reports/order-service'
    | '/reports/salesforce'
    | '/credit/admin/audit-trails'
    | '/credit/admin/invitations'
    | '/credit/admin/roles'
    | '/credit/admin/users'
    | '/credit/credit-limit-reviews/mass'
    | '/credit/credit-limit-reviews/pending-confirmations'
    | '/credit/credit-limit-reviews/review-events'
    | '/credit/customers/$erp'
    | '/credit/operations/multiplier'
    | '/credit/operations/order-cutoffs'
    | '/credit/operations/province-aov-per-carton'
    | '/credit/operations/very-low-risk-customers'
    | '/crt/admin/audit-trails'
    | '/crt/admin/invitations'
    | '/crt/admin/notifications'
    | '/crt/admin/roles'
    | '/crt/admin/users'
    | '/crt/customer-investments/budget-tracker'
    | '/crt/customer-investments/insights'
    | '/crt/customer-investments/investments'
    | '/crt/customer-investments/key-accounts'
    | '/crt/customers/commercial-partners'
    | '/crt/kpi-reports/cash-dashboard'
    | '/crt/kpi-reports/profits-and-loss-summary'
    | '/crt/materials/brand-variants'
    | '/crt/materials/insights'
    | '/crt/materials/materials-list'
    | '/crt/materials/price-list'
    | '/crt/pricing-excise/insights'
    | '/crt/pricing-excise/pricing-assumptions'
    | '/crt/pricing-excise/pricing-rate-table'
    | '/crt/pricing-excise/tax-assumptions'
    | '/crt/volume-forecasts/channel-contributions'
    | '/crt/volume-forecasts/nc-provincial-contributions'
    | '/crt/volume-forecasts/sub-channel-allocations'
    | '/orders/all/$dynamoId/$poNumber'
    | '/credit/credit-limit-reviews/mass/$runId/lines'
    | '/credit/credit-limit-reviews/mass/$runId/pending-confirmations'
    | '/credit/credit-limit-reviews/mass/$runId/submit'
    | '/crt/customer-investments/insights/distribution-margin-mix/banner-mix'
    | '/crt/customer-investments/insights/manual-investments/$manualInvestmentId'
    | '/crt/volume-forecasts/channel-contributions/$year/$month'
    | '/crt/volume-forecasts/nc-provincial-contributions/$year/$month'
    | '/credit/admin/users/delegation-of-authority'
    | '/credit/credit-limit-reviews/mass/$runId'
    | '/credit/credit-limit-reviews/mass/pending-confirmations'
    | '/crt/customer-investments/insights/agreements'
    | '/crt/customer-investments/insights/budget-allocations'
    | '/crt/customer-investments/insights/calculation-run-accruals'
    | '/crt/customer-investments/insights/distribution-margin-mix'
    | '/crt/customer-investments/insights/ip-accruals'
    | '/crt/customer-investments/insights/manual-investments'
    | '/crt/customer-investments/insights/master-agreements'
    | '/crt/customer-investments/insights/rap-forecasts'
    | '/crt/customer-investments/insights/sales-deal-actuals'
    | '/crt/customer-investments/key-accounts/estimates'
    | '/crt/materials/insights/federal-excise'
    | '/crt/materials/insights/material-groups-overrides'
    | '/crt/materials/insights/product-type-variants'
    | '/crt/materials/insights/product-types'
    | '/crt/materials/insights/unreleased-materials'
    | '/crt/pricing-excise/insights/channel-mix'
    | '/crt/pricing-excise/insights/consumer-rates'
    | '/crt/pricing-excise/insights/retailer-rates'
    | '/crt/customer-investments/insights/calculation-run-accruals/$year/$month'
    | '/crt/customer-investments/insights/distribution-margin-mix/$year/$month'
    | '/crt/customer-investments/insights/ip-accruals/$year/$month'
    | '/crt/customer-investments/insights/rap-forecasts/$year/$month'
    | '/crt/customer-investments/insights/sales-deal-actuals/$year/$month'
    | '/crt/pricing-excise/insights/channel-mix/$year/$month'
    | '/credit/admin/users/delegation-of-authority/blocked-orders'
    | '/credit/admin/users/delegation-of-authority/initiative'
    | '/credit/admin/users/delegation-of-authority/mass'
    | '/credit/admin/users/delegation-of-authority/single-no-deviation'
    | '/credit/admin/users/delegation-of-authority/single-with-deviation'
    | '/crt/customer-investments/insights/retailer-margins/fmc'
    | '/crt/customer-investments/insights/retailer-margins/nc'
    | '/crt/customer-investments/insights/wholesaler-margins/fmc'
    | '/crt/customer-investments/insights/wholesaler-margins/nc'
    | '/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/process-login'
    | '/_auth/_modules'
    | '/_auth/unverified'
    | '/_auth/_modules/_app'
    | '/_auth/_modules/credit'
    | '/_auth/_modules/crt'
    | '/_auth/track/$erp'
    | '/_auth/_modules/'
    | '/_auth/unverified/'
    | '/_auth/_modules/_app/admin'
    | '/_auth/_modules/_app/assortment'
    | '/_auth/_modules/_app/core-upload-data'
    | '/_auth/_modules/_app/customers'
    | '/_auth/_modules/_app/materials'
    | '/_auth/_modules/_app/my-uploads'
    | '/_auth/_modules/_app/operations'
    | '/_auth/_modules/_app/orders'
    | '/_auth/_modules/_app/processes'
    | '/_auth/_modules/_app/reports'
    | '/_auth/_modules/_app/sox-compliance'
    | '/_auth/_modules/_app/welcome'
    | '/_auth/_modules/credit/admin'
    | '/_auth/_modules/credit/blocked-orders'
    | '/_auth/_modules/credit/credit-index-scores'
    | '/_auth/_modules/credit/credit-limit-reviews'
    | '/_auth/_modules/credit/customers'
    | '/_auth/_modules/credit/google-financial-statements'
    | '/_auth/_modules/credit/inbox'
    | '/_auth/_modules/credit/initiatives'
    | '/_auth/_modules/credit/my-exports'
    | '/_auth/_modules/credit/my-uploads'
    | '/_auth/_modules/credit/operations'
    | '/_auth/_modules/credit/welcome'
    | '/_auth/_modules/crt/admin'
    | '/_auth/_modules/crt/azure-imports'
    | '/_auth/_modules/crt/bpc-actuals'
    | '/_auth/_modules/crt/cost-of-goods'
    | '/_auth/_modules/crt/customer-investments'
    | '/_auth/_modules/crt/customers'
    | '/_auth/_modules/crt/kpi-reports'
    | '/_auth/_modules/crt/materials'
    | '/_auth/_modules/crt/my-exports'
    | '/_auth/_modules/crt/my-uploads'
    | '/_auth/_modules/crt/pricing-excise'
    | '/_auth/_modules/crt/settings'
    | '/_auth/_modules/crt/variance-analysis'
    | '/_auth/_modules/crt/volume-forecasts'
    | '/_auth/_modules/crt/volume-scenarios'
    | '/_auth/_modules/crt/volumes'
    | '/_auth/_modules/crt/welcome'
    | '/_auth/_modules/_shared/kitchen-sink'
    | '/_auth/_modules/_app/admin/audit-trails'
    | '/_auth/_modules/_app/admin/invitations'
    | '/_auth/_modules/_app/admin/roles'
    | '/_auth/_modules/_app/admin/users'
    | '/_auth/_modules/_app/assortment/active'
    | '/_auth/_modules/_app/assortment/banners'
    | '/_auth/_modules/_app/assortment/launches'
    | '/_auth/_modules/_app/core-upload-data/auto-inject'
    | '/_auth/_modules/_app/core-upload-data/business'
    | '/_auth/_modules/_app/core-upload-data/materials'
    | '/_auth/_modules/_app/core-upload-data/on-hand-inventory'
    | '/_auth/_modules/_app/core-upload-data/operations'
    | '/_auth/_modules/_app/core-upload-data/order-service'
    | '/_auth/_modules/_app/customers/banners'
    | '/_auth/_modules/_app/customers/stores'
    | '/_auth/_modules/_app/materials/bcp-priced'
    | '/_auth/_modules/_app/orders/all'
    | '/_auth/_modules/_app/orders/flagged'
    | '/_auth/_modules/_app/orders/missing'
    | '/_auth/_modules/_app/orders/payment-review'
    | '/_auth/_modules/_app/orders/returns'
    | '/_auth/_modules/_app/processes/pipelines'
    | '/_auth/_modules/_app/reports/ecc'
    | '/_auth/_modules/_app/reports/material'
    | '/_auth/_modules/_app/reports/misc'
    | '/_auth/_modules/_app/reports/operations'
    | '/_auth/_modules/_app/reports/order-service'
    | '/_auth/_modules/_app/reports/salesforce'
    | '/_auth/_modules/credit/admin/audit-trails'
    | '/_auth/_modules/credit/admin/invitations'
    | '/_auth/_modules/credit/admin/roles'
    | '/_auth/_modules/credit/admin/users'
    | '/_auth/_modules/credit/credit-limit-reviews/mass'
    | '/_auth/_modules/credit/credit-limit-reviews/pending-confirmations'
    | '/_auth/_modules/credit/credit-limit-reviews/review-events'
    | '/_auth/_modules/credit/customers/$erp'
    | '/_auth/_modules/credit/operations/multiplier'
    | '/_auth/_modules/credit/operations/order-cutoffs'
    | '/_auth/_modules/credit/operations/province-aov-per-carton'
    | '/_auth/_modules/credit/operations/very-low-risk-customers'
    | '/_auth/_modules/crt/admin/audit-trails'
    | '/_auth/_modules/crt/admin/invitations'
    | '/_auth/_modules/crt/admin/notifications'
    | '/_auth/_modules/crt/admin/roles'
    | '/_auth/_modules/crt/admin/users'
    | '/_auth/_modules/crt/customer-investments/budget-tracker'
    | '/_auth/_modules/crt/customer-investments/insights'
    | '/_auth/_modules/crt/customer-investments/investments'
    | '/_auth/_modules/crt/customer-investments/key-accounts'
    | '/_auth/_modules/crt/customers/commercial-partners'
    | '/_auth/_modules/crt/kpi-reports/cash-dashboard'
    | '/_auth/_modules/crt/kpi-reports/profits-and-loss-summary'
    | '/_auth/_modules/crt/materials/brand-variants'
    | '/_auth/_modules/crt/materials/insights'
    | '/_auth/_modules/crt/materials/materials-list'
    | '/_auth/_modules/crt/materials/price-list'
    | '/_auth/_modules/crt/pricing-excise/insights'
    | '/_auth/_modules/crt/pricing-excise/pricing-assumptions'
    | '/_auth/_modules/crt/pricing-excise/pricing-rate-table'
    | '/_auth/_modules/crt/pricing-excise/tax-assumptions'
    | '/_auth/_modules/crt/volume-forecasts/channel-contributions'
    | '/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions'
    | '/_auth/_modules/crt/volume-forecasts/sub-channel-allocations'
    | '/_auth/_modules/_shared/_errors/error'
    | '/_auth/_modules/_shared/_errors/not-found'
    | '/_auth/_modules/_shared/_errors/unauthorized'
    | '/_auth/_modules/credit/credit-limit-reviews/$reviewId'
    | '/_auth/_modules/credit/google-financial-statements/$sapErp'
    | '/_auth/_modules/credit/initiatives/$id'
    | '/_auth/_modules/crt/bpc-actuals/$year'
    | '/_auth/_modules/crt/kpi-reports/graphs'
    | '/_auth/_modules/crt/variance-analysis/by-agreement'
    | '/_auth/_modules/crt/variance-analysis/by-banner'
    | '/_auth/_modules/crt/variance-analysis/by-budget'
    | '/_auth/_modules/crt/variance-analysis/by-cost-type'
    | '/_auth/_modules/crt/volume-scenarios/$volumeScenarioId'
    | '/_auth/_modules/_app/admin/'
    | '/_auth/_modules/_app/assortment/'
    | '/_auth/_modules/_app/core-upload-data/'
    | '/_auth/_modules/_app/customers/'
    | '/_auth/_modules/_app/materials/'
    | '/_auth/_modules/_app/my-uploads/'
    | '/_auth/_modules/_app/operations/'
    | '/_auth/_modules/_app/orders/'
    | '/_auth/_modules/_app/processes/'
    | '/_auth/_modules/_app/reports/'
    | '/_auth/_modules/_app/sox-compliance/'
    | '/_auth/_modules/_app/welcome/'
    | '/_auth/_modules/credit/admin/'
    | '/_auth/_modules/credit/blocked-orders/'
    | '/_auth/_modules/credit/credit-index-scores/'
    | '/_auth/_modules/credit/credit-limit-reviews/'
    | '/_auth/_modules/credit/customers/'
    | '/_auth/_modules/credit/google-financial-statements/'
    | '/_auth/_modules/credit/inbox/'
    | '/_auth/_modules/credit/initiatives/'
    | '/_auth/_modules/credit/my-exports/'
    | '/_auth/_modules/credit/my-uploads/'
    | '/_auth/_modules/credit/operations/'
    | '/_auth/_modules/credit/welcome/'
    | '/_auth/_modules/crt/admin/'
    | '/_auth/_modules/crt/azure-imports/'
    | '/_auth/_modules/crt/bpc-actuals/'
    | '/_auth/_modules/crt/cost-of-goods/'
    | '/_auth/_modules/crt/customer-investments/'
    | '/_auth/_modules/crt/kpi-reports/'
    | '/_auth/_modules/crt/materials/'
    | '/_auth/_modules/crt/my-exports/'
    | '/_auth/_modules/crt/my-uploads/'
    | '/_auth/_modules/crt/pricing-excise/'
    | '/_auth/_modules/crt/settings/'
    | '/_auth/_modules/crt/variance-analysis/'
    | '/_auth/_modules/crt/volume-forecasts/'
    | '/_auth/_modules/crt/volume-scenarios/'
    | '/_auth/_modules/crt/welcome/'
    | '/_auth/_modules/credit/admin/users/delegation-of-authority'
    | '/_auth/_modules/credit/credit-limit-reviews/mass/$runId'
    | '/_auth/_modules/credit/credit-limit-reviews/mass/pending-confirmations'
    | '/_auth/_modules/crt/customer-investments/insights/agreements'
    | '/_auth/_modules/crt/customer-investments/insights/budget-allocations'
    | '/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals'
    | '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix'
    | '/_auth/_modules/crt/customer-investments/insights/ip-accruals'
    | '/_auth/_modules/crt/customer-investments/insights/manual-investments'
    | '/_auth/_modules/crt/customer-investments/insights/master-agreements'
    | '/_auth/_modules/crt/customer-investments/insights/rap-forecasts'
    | '/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals'
    | '/_auth/_modules/crt/customer-investments/key-accounts/estimates'
    | '/_auth/_modules/crt/materials/insights/federal-excise'
    | '/_auth/_modules/crt/materials/insights/material-groups-overrides'
    | '/_auth/_modules/crt/materials/insights/product-type-variants'
    | '/_auth/_modules/crt/materials/insights/product-types'
    | '/_auth/_modules/crt/materials/insights/unreleased-materials'
    | '/_auth/_modules/crt/pricing-excise/insights/channel-mix'
    | '/_auth/_modules/crt/pricing-excise/insights/consumer-rates'
    | '/_auth/_modules/crt/pricing-excise/insights/retailer-rates'
    | '/_auth/_modules/_app/assortment/launches/$launchId'
    | '/_auth/_modules/_app/customers/banners/$bannerId'
    | '/_auth/_modules/_app/customers/stores/$storeId'
    | '/_auth/_modules/_app/my-uploads/$scope/$fileName'
    | '/_auth/_modules/_app/reports/ecc/$reportId'
    | '/_auth/_modules/_app/reports/material/$reportId'
    | '/_auth/_modules/_app/reports/misc/$reportId'
    | '/_auth/_modules/_app/reports/operations/$reportId'
    | '/_auth/_modules/_app/reports/order-service/$reportId'
    | '/_auth/_modules/_app/reports/salesforce/$reportId'
    | '/_auth/_modules/credit/blocked-orders/groups/$groupKey'
    | '/_auth/_modules/credit/credit-limit-reviews/mass/new'
    | '/_auth/_modules/credit/customers/$erp/prepare-clr'
    | '/_auth/_modules/credit/my-uploads/$scope/$fileName'
    | '/_auth/_modules/crt/cost-of-goods/$year/$month'
    | '/_auth/_modules/crt/my-uploads/$scope/$fileName'
    | '/_auth/_modules/crt/pricing-excise/pricing-assumptions/$pricingAssumptionId'
    | '/_auth/_modules/crt/pricing-excise/tax-assumptions/$taxAssumptionId'
    | '/_auth/_modules/_app/admin/audit-trails/'
    | '/_auth/_modules/_app/admin/invitations/'
    | '/_auth/_modules/_app/admin/roles/'
    | '/_auth/_modules/_app/admin/users/'
    | '/_auth/_modules/_app/assortment/active/'
    | '/_auth/_modules/_app/assortment/banners/'
    | '/_auth/_modules/_app/assortment/launches/'
    | '/_auth/_modules/_app/core-upload-data/auto-inject/'
    | '/_auth/_modules/_app/core-upload-data/business/'
    | '/_auth/_modules/_app/core-upload-data/materials/'
    | '/_auth/_modules/_app/core-upload-data/on-hand-inventory/'
    | '/_auth/_modules/_app/core-upload-data/operations/'
    | '/_auth/_modules/_app/core-upload-data/order-service/'
    | '/_auth/_modules/_app/customers/banners/'
    | '/_auth/_modules/_app/customers/stores/'
    | '/_auth/_modules/_app/materials/bcp-priced/'
    | '/_auth/_modules/_app/orders/all/'
    | '/_auth/_modules/_app/orders/flagged/'
    | '/_auth/_modules/_app/orders/missing/'
    | '/_auth/_modules/_app/orders/payment-review/'
    | '/_auth/_modules/_app/orders/returns/'
    | '/_auth/_modules/_app/processes/pipelines/'
    | '/_auth/_modules/_app/reports/ecc/'
    | '/_auth/_modules/_app/reports/material/'
    | '/_auth/_modules/_app/reports/misc/'
    | '/_auth/_modules/_app/reports/operations/'
    | '/_auth/_modules/_app/reports/order-service/'
    | '/_auth/_modules/_app/reports/salesforce/'
    | '/_auth/_modules/credit/admin/audit-trails/'
    | '/_auth/_modules/credit/admin/invitations/'
    | '/_auth/_modules/credit/admin/roles/'
    | '/_auth/_modules/credit/admin/users/'
    | '/_auth/_modules/credit/credit-limit-reviews/mass/'
    | '/_auth/_modules/credit/credit-limit-reviews/pending-confirmations/'
    | '/_auth/_modules/credit/credit-limit-reviews/review-events/'
    | '/_auth/_modules/credit/customers/$erp/'
    | '/_auth/_modules/credit/operations/multiplier/'
    | '/_auth/_modules/credit/operations/order-cutoffs/'
    | '/_auth/_modules/credit/operations/province-aov-per-carton/'
    | '/_auth/_modules/credit/operations/very-low-risk-customers/'
    | '/_auth/_modules/crt/admin/audit-trails/'
    | '/_auth/_modules/crt/admin/invitations/'
    | '/_auth/_modules/crt/admin/notifications/'
    | '/_auth/_modules/crt/admin/roles/'
    | '/_auth/_modules/crt/admin/users/'
    | '/_auth/_modules/crt/customer-investments/budget-tracker/'
    | '/_auth/_modules/crt/customer-investments/insights/'
    | '/_auth/_modules/crt/customer-investments/investments/'
    | '/_auth/_modules/crt/customer-investments/key-accounts/'
    | '/_auth/_modules/crt/customers/commercial-partners/'
    | '/_auth/_modules/crt/kpi-reports/cash-dashboard/'
    | '/_auth/_modules/crt/kpi-reports/profits-and-loss-summary/'
    | '/_auth/_modules/crt/materials/brand-variants/'
    | '/_auth/_modules/crt/materials/insights/'
    | '/_auth/_modules/crt/materials/materials-list/'
    | '/_auth/_modules/crt/materials/price-list/'
    | '/_auth/_modules/crt/pricing-excise/insights/'
    | '/_auth/_modules/crt/pricing-excise/pricing-assumptions/'
    | '/_auth/_modules/crt/pricing-excise/pricing-rate-table/'
    | '/_auth/_modules/crt/pricing-excise/tax-assumptions/'
    | '/_auth/_modules/crt/volume-forecasts/channel-contributions/'
    | '/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions/'
    | '/_auth/_modules/crt/volume-forecasts/sub-channel-allocations/'
    | '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders'
    | '/_auth/_modules/credit/admin/users/delegation-of-authority/initiative'
    | '/_auth/_modules/credit/admin/users/delegation-of-authority/mass'
    | '/_auth/_modules/credit/admin/users/delegation-of-authority/single-no-deviation'
    | '/_auth/_modules/credit/admin/users/delegation-of-authority/single-with-deviation'
    | '/_auth/_modules/crt/customer-investments/insights/retailer-margins/fmc'
    | '/_auth/_modules/crt/customer-investments/insights/retailer-margins/nc'
    | '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/fmc'
    | '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/nc'
    | '/_auth/_modules/_app/orders/all/$dynamoId/$poNumber'
    | '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/lines'
    | '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/pending-confirmations'
    | '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/submit'
    | '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/banner-mix'
    | '/_auth/_modules/crt/customer-investments/insights/manual-investments/$manualInvestmentId'
    | '/_auth/_modules/crt/volume-forecasts/channel-contributions/$year/$month'
    | '/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions/$year/$month'
    | '/_auth/_modules/credit/admin/users/delegation-of-authority/'
    | '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/'
    | '/_auth/_modules/credit/credit-limit-reviews/mass/pending-confirmations/'
    | '/_auth/_modules/crt/customer-investments/insights/agreements/'
    | '/_auth/_modules/crt/customer-investments/insights/budget-allocations/'
    | '/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals/'
    | '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/'
    | '/_auth/_modules/crt/customer-investments/insights/ip-accruals/'
    | '/_auth/_modules/crt/customer-investments/insights/manual-investments/'
    | '/_auth/_modules/crt/customer-investments/insights/master-agreements/'
    | '/_auth/_modules/crt/customer-investments/insights/rap-forecasts/'
    | '/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals/'
    | '/_auth/_modules/crt/customer-investments/key-accounts/estimates/'
    | '/_auth/_modules/crt/materials/insights/federal-excise/'
    | '/_auth/_modules/crt/materials/insights/material-groups-overrides/'
    | '/_auth/_modules/crt/materials/insights/product-type-variants/'
    | '/_auth/_modules/crt/materials/insights/product-types/'
    | '/_auth/_modules/crt/materials/insights/unreleased-materials/'
    | '/_auth/_modules/crt/pricing-excise/insights/channel-mix/'
    | '/_auth/_modules/crt/pricing-excise/insights/consumer-rates/'
    | '/_auth/_modules/crt/pricing-excise/insights/retailer-rates/'
    | '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers'
    | '/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals/$year/$month'
    | '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/$year/$month'
    | '/_auth/_modules/crt/customer-investments/insights/ip-accruals/$year/$month'
    | '/_auth/_modules/crt/customer-investments/insights/rap-forecasts/$year/$month'
    | '/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals/$year/$month'
    | '/_auth/_modules/crt/pricing-excise/insights/channel-mix/$year/$month'
    | '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/'
    | '/_auth/_modules/credit/admin/users/delegation-of-authority/initiative/'
    | '/_auth/_modules/credit/admin/users/delegation-of-authority/mass/'
    | '/_auth/_modules/credit/admin/users/delegation-of-authority/single-no-deviation/'
    | '/_auth/_modules/credit/admin/users/delegation-of-authority/single-with-deviation/'
    | '/_auth/_modules/crt/customer-investments/insights/retailer-margins/fmc/'
    | '/_auth/_modules/crt/customer-investments/insights/retailer-margins/nc/'
    | '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/fmc/'
    | '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/nc/'
    | '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  ProcessLoginRoute: typeof ProcessLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/process-login': {
      id: '/process-login'
      path: '/process-login'
      fullPath: '/process-login'
      preLoaderRoute: typeof ProcessLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/unverified': {
      id: '/_auth/unverified'
      path: '/unverified'
      fullPath: '/unverified'
      preLoaderRoute: typeof AuthUnverifiedRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/_modules': {
      id: '/_auth/_modules'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthModulesRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/unverified/': {
      id: '/_auth/unverified/'
      path: '/'
      fullPath: '/unverified/'
      preLoaderRoute: typeof AuthUnverifiedIndexRouteImport
      parentRoute: typeof AuthUnverifiedRouteRoute
    }
    '/_auth/_modules/': {
      id: '/_auth/_modules/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthModulesIndexRouteImport
      parentRoute: typeof AuthModulesRouteRoute
    }
    '/_auth/track/$erp': {
      id: '/_auth/track/$erp'
      path: '/track/$erp'
      fullPath: '/track/$erp'
      preLoaderRoute: typeof AuthTrackErpRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/_modules/crt': {
      id: '/_auth/_modules/crt'
      path: '/crt'
      fullPath: '/crt'
      preLoaderRoute: typeof AuthModulesCrtRouteRouteImport
      parentRoute: typeof AuthModulesRouteRoute
    }
    '/_auth/_modules/credit': {
      id: '/_auth/_modules/credit'
      path: '/credit'
      fullPath: '/credit'
      preLoaderRoute: typeof AuthModulesCreditRouteRouteImport
      parentRoute: typeof AuthModulesRouteRoute
    }
    '/_auth/_modules/_app': {
      id: '/_auth/_modules/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthModulesAppRouteRouteImport
      parentRoute: typeof AuthModulesRouteRoute
    }
    '/_auth/_modules/_shared/kitchen-sink': {
      id: '/_auth/_modules/_shared/kitchen-sink'
      path: '/kitchen-sink'
      fullPath: '/kitchen-sink'
      preLoaderRoute: typeof AuthModulesSharedKitchenSinkRouteImport
      parentRoute: typeof AuthModulesRouteRoute
    }
    '/_auth/_modules/crt/welcome': {
      id: '/_auth/_modules/crt/welcome'
      path: '/welcome'
      fullPath: '/crt/welcome'
      preLoaderRoute: typeof AuthModulesCrtWelcomeRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/volumes': {
      id: '/_auth/_modules/crt/volumes'
      path: '/volumes'
      fullPath: '/crt/volumes'
      preLoaderRoute: typeof AuthModulesCrtVolumesRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/volume-scenarios': {
      id: '/_auth/_modules/crt/volume-scenarios'
      path: '/volume-scenarios'
      fullPath: '/crt/volume-scenarios'
      preLoaderRoute: typeof AuthModulesCrtVolumeScenariosRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/volume-forecasts': {
      id: '/_auth/_modules/crt/volume-forecasts'
      path: '/volume-forecasts'
      fullPath: '/crt/volume-forecasts'
      preLoaderRoute: typeof AuthModulesCrtVolumeForecastsRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/variance-analysis': {
      id: '/_auth/_modules/crt/variance-analysis'
      path: '/variance-analysis'
      fullPath: '/crt/variance-analysis'
      preLoaderRoute: typeof AuthModulesCrtVarianceAnalysisRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/settings': {
      id: '/_auth/_modules/crt/settings'
      path: '/settings'
      fullPath: '/crt/settings'
      preLoaderRoute: typeof AuthModulesCrtSettingsRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise': {
      id: '/_auth/_modules/crt/pricing-excise'
      path: '/pricing-excise'
      fullPath: '/crt/pricing-excise'
      preLoaderRoute: typeof AuthModulesCrtPricingExciseRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/my-uploads': {
      id: '/_auth/_modules/crt/my-uploads'
      path: '/my-uploads'
      fullPath: '/crt/my-uploads'
      preLoaderRoute: typeof AuthModulesCrtMyUploadsRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/my-exports': {
      id: '/_auth/_modules/crt/my-exports'
      path: '/my-exports'
      fullPath: '/crt/my-exports'
      preLoaderRoute: typeof AuthModulesCrtMyExportsRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/materials': {
      id: '/_auth/_modules/crt/materials'
      path: '/materials'
      fullPath: '/crt/materials'
      preLoaderRoute: typeof AuthModulesCrtMaterialsRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/kpi-reports': {
      id: '/_auth/_modules/crt/kpi-reports'
      path: '/kpi-reports'
      fullPath: '/crt/kpi-reports'
      preLoaderRoute: typeof AuthModulesCrtKpiReportsRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/customers': {
      id: '/_auth/_modules/crt/customers'
      path: '/customers'
      fullPath: '/crt/customers'
      preLoaderRoute: typeof AuthModulesCrtCustomersRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/customer-investments': {
      id: '/_auth/_modules/crt/customer-investments'
      path: '/customer-investments'
      fullPath: '/crt/customer-investments'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/cost-of-goods': {
      id: '/_auth/_modules/crt/cost-of-goods'
      path: '/cost-of-goods'
      fullPath: '/crt/cost-of-goods'
      preLoaderRoute: typeof AuthModulesCrtCostOfGoodsRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/bpc-actuals': {
      id: '/_auth/_modules/crt/bpc-actuals'
      path: '/bpc-actuals'
      fullPath: '/crt/bpc-actuals'
      preLoaderRoute: typeof AuthModulesCrtBpcActualsRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/azure-imports': {
      id: '/_auth/_modules/crt/azure-imports'
      path: '/azure-imports'
      fullPath: '/crt/azure-imports'
      preLoaderRoute: typeof AuthModulesCrtAzureImportsRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/crt/admin': {
      id: '/_auth/_modules/crt/admin'
      path: '/admin'
      fullPath: '/crt/admin'
      preLoaderRoute: typeof AuthModulesCrtAdminRouteRouteImport
      parentRoute: typeof AuthModulesCrtRouteRoute
    }
    '/_auth/_modules/credit/welcome': {
      id: '/_auth/_modules/credit/welcome'
      path: '/welcome'
      fullPath: '/credit/welcome'
      preLoaderRoute: typeof AuthModulesCreditWelcomeRouteRouteImport
      parentRoute: typeof AuthModulesCreditRouteRoute
    }
    '/_auth/_modules/credit/operations': {
      id: '/_auth/_modules/credit/operations'
      path: '/operations'
      fullPath: '/credit/operations'
      preLoaderRoute: typeof AuthModulesCreditOperationsRouteRouteImport
      parentRoute: typeof AuthModulesCreditRouteRoute
    }
    '/_auth/_modules/credit/my-uploads': {
      id: '/_auth/_modules/credit/my-uploads'
      path: '/my-uploads'
      fullPath: '/credit/my-uploads'
      preLoaderRoute: typeof AuthModulesCreditMyUploadsRouteRouteImport
      parentRoute: typeof AuthModulesCreditRouteRoute
    }
    '/_auth/_modules/credit/my-exports': {
      id: '/_auth/_modules/credit/my-exports'
      path: '/my-exports'
      fullPath: '/credit/my-exports'
      preLoaderRoute: typeof AuthModulesCreditMyExportsRouteRouteImport
      parentRoute: typeof AuthModulesCreditRouteRoute
    }
    '/_auth/_modules/credit/initiatives': {
      id: '/_auth/_modules/credit/initiatives'
      path: '/initiatives'
      fullPath: '/credit/initiatives'
      preLoaderRoute: typeof AuthModulesCreditInitiativesRouteRouteImport
      parentRoute: typeof AuthModulesCreditRouteRoute
    }
    '/_auth/_modules/credit/inbox': {
      id: '/_auth/_modules/credit/inbox'
      path: '/inbox'
      fullPath: '/credit/inbox'
      preLoaderRoute: typeof AuthModulesCreditInboxRouteRouteImport
      parentRoute: typeof AuthModulesCreditRouteRoute
    }
    '/_auth/_modules/credit/google-financial-statements': {
      id: '/_auth/_modules/credit/google-financial-statements'
      path: '/google-financial-statements'
      fullPath: '/credit/google-financial-statements'
      preLoaderRoute: typeof AuthModulesCreditGoogleFinancialStatementsRouteRouteImport
      parentRoute: typeof AuthModulesCreditRouteRoute
    }
    '/_auth/_modules/credit/customers': {
      id: '/_auth/_modules/credit/customers'
      path: '/customers'
      fullPath: '/credit/customers'
      preLoaderRoute: typeof AuthModulesCreditCustomersRouteRouteImport
      parentRoute: typeof AuthModulesCreditRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews': {
      id: '/_auth/_modules/credit/credit-limit-reviews'
      path: '/credit-limit-reviews'
      fullPath: '/credit/credit-limit-reviews'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsRouteRouteImport
      parentRoute: typeof AuthModulesCreditRouteRoute
    }
    '/_auth/_modules/credit/credit-index-scores': {
      id: '/_auth/_modules/credit/credit-index-scores'
      path: '/credit-index-scores'
      fullPath: '/credit/credit-index-scores'
      preLoaderRoute: typeof AuthModulesCreditCreditIndexScoresRouteRouteImport
      parentRoute: typeof AuthModulesCreditRouteRoute
    }
    '/_auth/_modules/credit/blocked-orders': {
      id: '/_auth/_modules/credit/blocked-orders'
      path: '/blocked-orders'
      fullPath: '/credit/blocked-orders'
      preLoaderRoute: typeof AuthModulesCreditBlockedOrdersRouteRouteImport
      parentRoute: typeof AuthModulesCreditRouteRoute
    }
    '/_auth/_modules/credit/admin': {
      id: '/_auth/_modules/credit/admin'
      path: '/admin'
      fullPath: '/credit/admin'
      preLoaderRoute: typeof AuthModulesCreditAdminRouteRouteImport
      parentRoute: typeof AuthModulesCreditRouteRoute
    }
    '/_auth/_modules/_app/welcome': {
      id: '/_auth/_modules/_app/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof AuthModulesAppWelcomeRouteRouteImport
      parentRoute: typeof AuthModulesAppRouteRoute
    }
    '/_auth/_modules/_app/sox-compliance': {
      id: '/_auth/_modules/_app/sox-compliance'
      path: '/sox-compliance'
      fullPath: '/sox-compliance'
      preLoaderRoute: typeof AuthModulesAppSoxComplianceRouteRouteImport
      parentRoute: typeof AuthModulesAppRouteRoute
    }
    '/_auth/_modules/_app/reports': {
      id: '/_auth/_modules/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthModulesAppReportsRouteRouteImport
      parentRoute: typeof AuthModulesAppRouteRoute
    }
    '/_auth/_modules/_app/processes': {
      id: '/_auth/_modules/_app/processes'
      path: '/processes'
      fullPath: '/processes'
      preLoaderRoute: typeof AuthModulesAppProcessesRouteRouteImport
      parentRoute: typeof AuthModulesAppRouteRoute
    }
    '/_auth/_modules/_app/orders': {
      id: '/_auth/_modules/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AuthModulesAppOrdersRouteRouteImport
      parentRoute: typeof AuthModulesAppRouteRoute
    }
    '/_auth/_modules/_app/operations': {
      id: '/_auth/_modules/_app/operations'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof AuthModulesAppOperationsRouteRouteImport
      parentRoute: typeof AuthModulesAppRouteRoute
    }
    '/_auth/_modules/_app/my-uploads': {
      id: '/_auth/_modules/_app/my-uploads'
      path: '/my-uploads'
      fullPath: '/my-uploads'
      preLoaderRoute: typeof AuthModulesAppMyUploadsRouteRouteImport
      parentRoute: typeof AuthModulesAppRouteRoute
    }
    '/_auth/_modules/_app/materials': {
      id: '/_auth/_modules/_app/materials'
      path: '/materials'
      fullPath: '/materials'
      preLoaderRoute: typeof AuthModulesAppMaterialsRouteRouteImport
      parentRoute: typeof AuthModulesAppRouteRoute
    }
    '/_auth/_modules/_app/customers': {
      id: '/_auth/_modules/_app/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthModulesAppCustomersRouteRouteImport
      parentRoute: typeof AuthModulesAppRouteRoute
    }
    '/_auth/_modules/_app/core-upload-data': {
      id: '/_auth/_modules/_app/core-upload-data'
      path: '/core-upload-data'
      fullPath: '/core-upload-data'
      preLoaderRoute: typeof AuthModulesAppCoreUploadDataRouteRouteImport
      parentRoute: typeof AuthModulesAppRouteRoute
    }
    '/_auth/_modules/_app/assortment': {
      id: '/_auth/_modules/_app/assortment'
      path: '/assortment'
      fullPath: '/assortment'
      preLoaderRoute: typeof AuthModulesAppAssortmentRouteRouteImport
      parentRoute: typeof AuthModulesAppRouteRoute
    }
    '/_auth/_modules/_app/admin': {
      id: '/_auth/_modules/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthModulesAppAdminRouteRouteImport
      parentRoute: typeof AuthModulesAppRouteRoute
    }
    '/_auth/_modules/crt/welcome/': {
      id: '/_auth/_modules/crt/welcome/'
      path: '/'
      fullPath: '/crt/welcome/'
      preLoaderRoute: typeof AuthModulesCrtWelcomeIndexRouteImport
      parentRoute: typeof AuthModulesCrtWelcomeRouteRoute
    }
    '/_auth/_modules/crt/volume-scenarios/': {
      id: '/_auth/_modules/crt/volume-scenarios/'
      path: '/'
      fullPath: '/crt/volume-scenarios/'
      preLoaderRoute: typeof AuthModulesCrtVolumeScenariosIndexRouteImport
      parentRoute: typeof AuthModulesCrtVolumeScenariosRouteRoute
    }
    '/_auth/_modules/crt/volume-forecasts/': {
      id: '/_auth/_modules/crt/volume-forecasts/'
      path: '/'
      fullPath: '/crt/volume-forecasts/'
      preLoaderRoute: typeof AuthModulesCrtVolumeForecastsIndexRouteImport
      parentRoute: typeof AuthModulesCrtVolumeForecastsRouteRoute
    }
    '/_auth/_modules/crt/variance-analysis/': {
      id: '/_auth/_modules/crt/variance-analysis/'
      path: '/'
      fullPath: '/crt/variance-analysis/'
      preLoaderRoute: typeof AuthModulesCrtVarianceAnalysisIndexRouteImport
      parentRoute: typeof AuthModulesCrtVarianceAnalysisRouteRoute
    }
    '/_auth/_modules/crt/settings/': {
      id: '/_auth/_modules/crt/settings/'
      path: '/'
      fullPath: '/crt/settings/'
      preLoaderRoute: typeof AuthModulesCrtSettingsIndexRouteImport
      parentRoute: typeof AuthModulesCrtSettingsRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/': {
      id: '/_auth/_modules/crt/pricing-excise/'
      path: '/'
      fullPath: '/crt/pricing-excise/'
      preLoaderRoute: typeof AuthModulesCrtPricingExciseIndexRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseRouteRoute
    }
    '/_auth/_modules/crt/my-uploads/': {
      id: '/_auth/_modules/crt/my-uploads/'
      path: '/'
      fullPath: '/crt/my-uploads/'
      preLoaderRoute: typeof AuthModulesCrtMyUploadsIndexRouteImport
      parentRoute: typeof AuthModulesCrtMyUploadsRouteRoute
    }
    '/_auth/_modules/crt/my-exports/': {
      id: '/_auth/_modules/crt/my-exports/'
      path: '/'
      fullPath: '/crt/my-exports/'
      preLoaderRoute: typeof AuthModulesCrtMyExportsIndexRouteImport
      parentRoute: typeof AuthModulesCrtMyExportsRouteRoute
    }
    '/_auth/_modules/crt/materials/': {
      id: '/_auth/_modules/crt/materials/'
      path: '/'
      fullPath: '/crt/materials/'
      preLoaderRoute: typeof AuthModulesCrtMaterialsIndexRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsRouteRoute
    }
    '/_auth/_modules/crt/kpi-reports/': {
      id: '/_auth/_modules/crt/kpi-reports/'
      path: '/'
      fullPath: '/crt/kpi-reports/'
      preLoaderRoute: typeof AuthModulesCrtKpiReportsIndexRouteImport
      parentRoute: typeof AuthModulesCrtKpiReportsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/': {
      id: '/_auth/_modules/crt/customer-investments/'
      path: '/'
      fullPath: '/crt/customer-investments/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsRouteRoute
    }
    '/_auth/_modules/crt/cost-of-goods/': {
      id: '/_auth/_modules/crt/cost-of-goods/'
      path: '/'
      fullPath: '/crt/cost-of-goods/'
      preLoaderRoute: typeof AuthModulesCrtCostOfGoodsIndexRouteImport
      parentRoute: typeof AuthModulesCrtCostOfGoodsRouteRoute
    }
    '/_auth/_modules/crt/bpc-actuals/': {
      id: '/_auth/_modules/crt/bpc-actuals/'
      path: '/'
      fullPath: '/crt/bpc-actuals/'
      preLoaderRoute: typeof AuthModulesCrtBpcActualsIndexRouteImport
      parentRoute: typeof AuthModulesCrtBpcActualsRouteRoute
    }
    '/_auth/_modules/crt/azure-imports/': {
      id: '/_auth/_modules/crt/azure-imports/'
      path: '/'
      fullPath: '/crt/azure-imports/'
      preLoaderRoute: typeof AuthModulesCrtAzureImportsIndexRouteImport
      parentRoute: typeof AuthModulesCrtAzureImportsRouteRoute
    }
    '/_auth/_modules/crt/admin/': {
      id: '/_auth/_modules/crt/admin/'
      path: '/'
      fullPath: '/crt/admin/'
      preLoaderRoute: typeof AuthModulesCrtAdminIndexRouteImport
      parentRoute: typeof AuthModulesCrtAdminRouteRoute
    }
    '/_auth/_modules/credit/welcome/': {
      id: '/_auth/_modules/credit/welcome/'
      path: '/'
      fullPath: '/credit/welcome/'
      preLoaderRoute: typeof AuthModulesCreditWelcomeIndexRouteImport
      parentRoute: typeof AuthModulesCreditWelcomeRouteRoute
    }
    '/_auth/_modules/credit/operations/': {
      id: '/_auth/_modules/credit/operations/'
      path: '/'
      fullPath: '/credit/operations/'
      preLoaderRoute: typeof AuthModulesCreditOperationsIndexRouteImport
      parentRoute: typeof AuthModulesCreditOperationsRouteRoute
    }
    '/_auth/_modules/credit/my-uploads/': {
      id: '/_auth/_modules/credit/my-uploads/'
      path: '/'
      fullPath: '/credit/my-uploads/'
      preLoaderRoute: typeof AuthModulesCreditMyUploadsIndexRouteImport
      parentRoute: typeof AuthModulesCreditMyUploadsRouteRoute
    }
    '/_auth/_modules/credit/my-exports/': {
      id: '/_auth/_modules/credit/my-exports/'
      path: '/'
      fullPath: '/credit/my-exports/'
      preLoaderRoute: typeof AuthModulesCreditMyExportsIndexRouteImport
      parentRoute: typeof AuthModulesCreditMyExportsRouteRoute
    }
    '/_auth/_modules/credit/initiatives/': {
      id: '/_auth/_modules/credit/initiatives/'
      path: '/'
      fullPath: '/credit/initiatives/'
      preLoaderRoute: typeof AuthModulesCreditInitiativesIndexRouteImport
      parentRoute: typeof AuthModulesCreditInitiativesRouteRoute
    }
    '/_auth/_modules/credit/inbox/': {
      id: '/_auth/_modules/credit/inbox/'
      path: '/'
      fullPath: '/credit/inbox/'
      preLoaderRoute: typeof AuthModulesCreditInboxIndexRouteImport
      parentRoute: typeof AuthModulesCreditInboxRouteRoute
    }
    '/_auth/_modules/credit/google-financial-statements/': {
      id: '/_auth/_modules/credit/google-financial-statements/'
      path: '/'
      fullPath: '/credit/google-financial-statements/'
      preLoaderRoute: typeof AuthModulesCreditGoogleFinancialStatementsIndexRouteImport
      parentRoute: typeof AuthModulesCreditGoogleFinancialStatementsRouteRoute
    }
    '/_auth/_modules/credit/customers/': {
      id: '/_auth/_modules/credit/customers/'
      path: '/'
      fullPath: '/credit/customers/'
      preLoaderRoute: typeof AuthModulesCreditCustomersIndexRouteImport
      parentRoute: typeof AuthModulesCreditCustomersRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/': {
      id: '/_auth/_modules/credit/credit-limit-reviews/'
      path: '/'
      fullPath: '/credit/credit-limit-reviews/'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsIndexRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsRouteRoute
    }
    '/_auth/_modules/credit/credit-index-scores/': {
      id: '/_auth/_modules/credit/credit-index-scores/'
      path: '/'
      fullPath: '/credit/credit-index-scores/'
      preLoaderRoute: typeof AuthModulesCreditCreditIndexScoresIndexRouteImport
      parentRoute: typeof AuthModulesCreditCreditIndexScoresRouteRoute
    }
    '/_auth/_modules/credit/blocked-orders/': {
      id: '/_auth/_modules/credit/blocked-orders/'
      path: '/'
      fullPath: '/credit/blocked-orders/'
      preLoaderRoute: typeof AuthModulesCreditBlockedOrdersIndexRouteImport
      parentRoute: typeof AuthModulesCreditBlockedOrdersRouteRoute
    }
    '/_auth/_modules/credit/admin/': {
      id: '/_auth/_modules/credit/admin/'
      path: '/'
      fullPath: '/credit/admin/'
      preLoaderRoute: typeof AuthModulesCreditAdminIndexRouteImport
      parentRoute: typeof AuthModulesCreditAdminRouteRoute
    }
    '/_auth/_modules/_app/welcome/': {
      id: '/_auth/_modules/_app/welcome/'
      path: '/'
      fullPath: '/welcome/'
      preLoaderRoute: typeof AuthModulesAppWelcomeIndexRouteImport
      parentRoute: typeof AuthModulesAppWelcomeRouteRoute
    }
    '/_auth/_modules/_app/sox-compliance/': {
      id: '/_auth/_modules/_app/sox-compliance/'
      path: '/'
      fullPath: '/sox-compliance/'
      preLoaderRoute: typeof AuthModulesAppSoxComplianceIndexRouteImport
      parentRoute: typeof AuthModulesAppSoxComplianceRouteRoute
    }
    '/_auth/_modules/_app/reports/': {
      id: '/_auth/_modules/_app/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthModulesAppReportsIndexRouteImport
      parentRoute: typeof AuthModulesAppReportsRouteRoute
    }
    '/_auth/_modules/_app/processes/': {
      id: '/_auth/_modules/_app/processes/'
      path: '/'
      fullPath: '/processes/'
      preLoaderRoute: typeof AuthModulesAppProcessesIndexRouteImport
      parentRoute: typeof AuthModulesAppProcessesRouteRoute
    }
    '/_auth/_modules/_app/orders/': {
      id: '/_auth/_modules/_app/orders/'
      path: '/'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthModulesAppOrdersIndexRouteImport
      parentRoute: typeof AuthModulesAppOrdersRouteRoute
    }
    '/_auth/_modules/_app/operations/': {
      id: '/_auth/_modules/_app/operations/'
      path: '/'
      fullPath: '/operations/'
      preLoaderRoute: typeof AuthModulesAppOperationsIndexRouteImport
      parentRoute: typeof AuthModulesAppOperationsRouteRoute
    }
    '/_auth/_modules/_app/my-uploads/': {
      id: '/_auth/_modules/_app/my-uploads/'
      path: '/'
      fullPath: '/my-uploads/'
      preLoaderRoute: typeof AuthModulesAppMyUploadsIndexRouteImport
      parentRoute: typeof AuthModulesAppMyUploadsRouteRoute
    }
    '/_auth/_modules/_app/materials/': {
      id: '/_auth/_modules/_app/materials/'
      path: '/'
      fullPath: '/materials/'
      preLoaderRoute: typeof AuthModulesAppMaterialsIndexRouteImport
      parentRoute: typeof AuthModulesAppMaterialsRouteRoute
    }
    '/_auth/_modules/_app/customers/': {
      id: '/_auth/_modules/_app/customers/'
      path: '/'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthModulesAppCustomersIndexRouteImport
      parentRoute: typeof AuthModulesAppCustomersRouteRoute
    }
    '/_auth/_modules/_app/core-upload-data/': {
      id: '/_auth/_modules/_app/core-upload-data/'
      path: '/'
      fullPath: '/core-upload-data/'
      preLoaderRoute: typeof AuthModulesAppCoreUploadDataIndexRouteImport
      parentRoute: typeof AuthModulesAppCoreUploadDataRouteRoute
    }
    '/_auth/_modules/_app/assortment/': {
      id: '/_auth/_modules/_app/assortment/'
      path: '/'
      fullPath: '/assortment/'
      preLoaderRoute: typeof AuthModulesAppAssortmentIndexRouteImport
      parentRoute: typeof AuthModulesAppAssortmentRouteRoute
    }
    '/_auth/_modules/_app/admin/': {
      id: '/_auth/_modules/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthModulesAppAdminIndexRouteImport
      parentRoute: typeof AuthModulesAppAdminRouteRoute
    }
    '/_auth/_modules/crt/volume-scenarios/$volumeScenarioId': {
      id: '/_auth/_modules/crt/volume-scenarios/$volumeScenarioId'
      path: '/$volumeScenarioId'
      fullPath: '/crt/volume-scenarios/$volumeScenarioId'
      preLoaderRoute: typeof AuthModulesCrtVolumeScenariosVolumeScenarioIdRouteImport
      parentRoute: typeof AuthModulesCrtVolumeScenariosRouteRoute
    }
    '/_auth/_modules/crt/variance-analysis/by-cost-type': {
      id: '/_auth/_modules/crt/variance-analysis/by-cost-type'
      path: '/by-cost-type'
      fullPath: '/crt/variance-analysis/by-cost-type'
      preLoaderRoute: typeof AuthModulesCrtVarianceAnalysisByCostTypeRouteImport
      parentRoute: typeof AuthModulesCrtVarianceAnalysisRouteRoute
    }
    '/_auth/_modules/crt/variance-analysis/by-budget': {
      id: '/_auth/_modules/crt/variance-analysis/by-budget'
      path: '/by-budget'
      fullPath: '/crt/variance-analysis/by-budget'
      preLoaderRoute: typeof AuthModulesCrtVarianceAnalysisByBudgetRouteImport
      parentRoute: typeof AuthModulesCrtVarianceAnalysisRouteRoute
    }
    '/_auth/_modules/crt/variance-analysis/by-banner': {
      id: '/_auth/_modules/crt/variance-analysis/by-banner'
      path: '/by-banner'
      fullPath: '/crt/variance-analysis/by-banner'
      preLoaderRoute: typeof AuthModulesCrtVarianceAnalysisByBannerRouteImport
      parentRoute: typeof AuthModulesCrtVarianceAnalysisRouteRoute
    }
    '/_auth/_modules/crt/variance-analysis/by-agreement': {
      id: '/_auth/_modules/crt/variance-analysis/by-agreement'
      path: '/by-agreement'
      fullPath: '/crt/variance-analysis/by-agreement'
      preLoaderRoute: typeof AuthModulesCrtVarianceAnalysisByAgreementRouteImport
      parentRoute: typeof AuthModulesCrtVarianceAnalysisRouteRoute
    }
    '/_auth/_modules/crt/kpi-reports/graphs': {
      id: '/_auth/_modules/crt/kpi-reports/graphs'
      path: '/graphs'
      fullPath: '/crt/kpi-reports/graphs'
      preLoaderRoute: typeof AuthModulesCrtKpiReportsGraphsRouteImport
      parentRoute: typeof AuthModulesCrtKpiReportsRouteRoute
    }
    '/_auth/_modules/crt/bpc-actuals/$year': {
      id: '/_auth/_modules/crt/bpc-actuals/$year'
      path: '/$year'
      fullPath: '/crt/bpc-actuals/$year'
      preLoaderRoute: typeof AuthModulesCrtBpcActualsYearRouteImport
      parentRoute: typeof AuthModulesCrtBpcActualsRouteRoute
    }
    '/_auth/_modules/credit/initiatives/$id': {
      id: '/_auth/_modules/credit/initiatives/$id'
      path: '/$id'
      fullPath: '/credit/initiatives/$id'
      preLoaderRoute: typeof AuthModulesCreditInitiativesIdRouteImport
      parentRoute: typeof AuthModulesCreditInitiativesRouteRoute
    }
    '/_auth/_modules/credit/google-financial-statements/$sapErp': {
      id: '/_auth/_modules/credit/google-financial-statements/$sapErp'
      path: '/$sapErp'
      fullPath: '/credit/google-financial-statements/$sapErp'
      preLoaderRoute: typeof AuthModulesCreditGoogleFinancialStatementsSapErpRouteImport
      parentRoute: typeof AuthModulesCreditGoogleFinancialStatementsRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/$reviewId': {
      id: '/_auth/_modules/credit/credit-limit-reviews/$reviewId'
      path: '/$reviewId'
      fullPath: '/credit/credit-limit-reviews/$reviewId'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsReviewIdRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsRouteRoute
    }
    '/_auth/_modules/_shared/_errors/unauthorized': {
      id: '/_auth/_modules/_shared/_errors/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof AuthModulesSharedErrorsUnauthorizedRouteImport
      parentRoute: typeof AuthModulesRouteRoute
    }
    '/_auth/_modules/_shared/_errors/not-found': {
      id: '/_auth/_modules/_shared/_errors/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof AuthModulesSharedErrorsNotFoundRouteImport
      parentRoute: typeof AuthModulesRouteRoute
    }
    '/_auth/_modules/_shared/_errors/error': {
      id: '/_auth/_modules/_shared/_errors/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof AuthModulesSharedErrorsErrorRouteImport
      parentRoute: typeof AuthModulesRouteRoute
    }
    '/_auth/_modules/crt/volume-forecasts/sub-channel-allocations': {
      id: '/_auth/_modules/crt/volume-forecasts/sub-channel-allocations'
      path: '/sub-channel-allocations'
      fullPath: '/crt/volume-forecasts/sub-channel-allocations'
      preLoaderRoute: typeof AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRouteImport
      parentRoute: typeof AuthModulesCrtVolumeForecastsRouteRoute
    }
    '/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions': {
      id: '/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions'
      path: '/nc-provincial-contributions'
      fullPath: '/crt/volume-forecasts/nc-provincial-contributions'
      preLoaderRoute: typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRouteImport
      parentRoute: typeof AuthModulesCrtVolumeForecastsRouteRoute
    }
    '/_auth/_modules/crt/volume-forecasts/channel-contributions': {
      id: '/_auth/_modules/crt/volume-forecasts/channel-contributions'
      path: '/channel-contributions'
      fullPath: '/crt/volume-forecasts/channel-contributions'
      preLoaderRoute: typeof AuthModulesCrtVolumeForecastsChannelContributionsRouteRouteImport
      parentRoute: typeof AuthModulesCrtVolumeForecastsRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/tax-assumptions': {
      id: '/_auth/_modules/crt/pricing-excise/tax-assumptions'
      path: '/tax-assumptions'
      fullPath: '/crt/pricing-excise/tax-assumptions'
      preLoaderRoute: typeof AuthModulesCrtPricingExciseTaxAssumptionsRouteRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/pricing-rate-table': {
      id: '/_auth/_modules/crt/pricing-excise/pricing-rate-table'
      path: '/pricing-rate-table'
      fullPath: '/crt/pricing-excise/pricing-rate-table'
      preLoaderRoute: typeof AuthModulesCrtPricingExcisePricingRateTableRouteRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/pricing-assumptions': {
      id: '/_auth/_modules/crt/pricing-excise/pricing-assumptions'
      path: '/pricing-assumptions'
      fullPath: '/crt/pricing-excise/pricing-assumptions'
      preLoaderRoute: typeof AuthModulesCrtPricingExcisePricingAssumptionsRouteRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/insights': {
      id: '/_auth/_modules/crt/pricing-excise/insights'
      path: '/insights'
      fullPath: '/crt/pricing-excise/insights'
      preLoaderRoute: typeof AuthModulesCrtPricingExciseInsightsRouteRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseRouteRoute
    }
    '/_auth/_modules/crt/materials/price-list': {
      id: '/_auth/_modules/crt/materials/price-list'
      path: '/price-list'
      fullPath: '/crt/materials/price-list'
      preLoaderRoute: typeof AuthModulesCrtMaterialsPriceListRouteRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsRouteRoute
    }
    '/_auth/_modules/crt/materials/materials-list': {
      id: '/_auth/_modules/crt/materials/materials-list'
      path: '/materials-list'
      fullPath: '/crt/materials/materials-list'
      preLoaderRoute: typeof AuthModulesCrtMaterialsMaterialsListRouteRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsRouteRoute
    }
    '/_auth/_modules/crt/materials/insights': {
      id: '/_auth/_modules/crt/materials/insights'
      path: '/insights'
      fullPath: '/crt/materials/insights'
      preLoaderRoute: typeof AuthModulesCrtMaterialsInsightsRouteRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsRouteRoute
    }
    '/_auth/_modules/crt/materials/brand-variants': {
      id: '/_auth/_modules/crt/materials/brand-variants'
      path: '/brand-variants'
      fullPath: '/crt/materials/brand-variants'
      preLoaderRoute: typeof AuthModulesCrtMaterialsBrandVariantsRouteRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsRouteRoute
    }
    '/_auth/_modules/crt/kpi-reports/profits-and-loss-summary': {
      id: '/_auth/_modules/crt/kpi-reports/profits-and-loss-summary'
      path: '/profits-and-loss-summary'
      fullPath: '/crt/kpi-reports/profits-and-loss-summary'
      preLoaderRoute: typeof AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRouteImport
      parentRoute: typeof AuthModulesCrtKpiReportsRouteRoute
    }
    '/_auth/_modules/crt/kpi-reports/cash-dashboard': {
      id: '/_auth/_modules/crt/kpi-reports/cash-dashboard'
      path: '/cash-dashboard'
      fullPath: '/crt/kpi-reports/cash-dashboard'
      preLoaderRoute: typeof AuthModulesCrtKpiReportsCashDashboardRouteRouteImport
      parentRoute: typeof AuthModulesCrtKpiReportsRouteRoute
    }
    '/_auth/_modules/crt/customers/commercial-partners': {
      id: '/_auth/_modules/crt/customers/commercial-partners'
      path: '/commercial-partners'
      fullPath: '/crt/customers/commercial-partners'
      preLoaderRoute: typeof AuthModulesCrtCustomersCommercialPartnersRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomersRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/key-accounts': {
      id: '/_auth/_modules/crt/customer-investments/key-accounts'
      path: '/key-accounts'
      fullPath: '/crt/customer-investments/key-accounts'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/investments': {
      id: '/_auth/_modules/crt/customer-investments/investments'
      path: '/investments'
      fullPath: '/crt/customer-investments/investments'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInvestmentsRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights': {
      id: '/_auth/_modules/crt/customer-investments/insights'
      path: '/insights'
      fullPath: '/crt/customer-investments/insights'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/budget-tracker': {
      id: '/_auth/_modules/crt/customer-investments/budget-tracker'
      path: '/budget-tracker'
      fullPath: '/crt/customer-investments/budget-tracker'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsRouteRoute
    }
    '/_auth/_modules/crt/admin/users': {
      id: '/_auth/_modules/crt/admin/users'
      path: '/users'
      fullPath: '/crt/admin/users'
      preLoaderRoute: typeof AuthModulesCrtAdminUsersRouteRouteImport
      parentRoute: typeof AuthModulesCrtAdminRouteRoute
    }
    '/_auth/_modules/crt/admin/roles': {
      id: '/_auth/_modules/crt/admin/roles'
      path: '/roles'
      fullPath: '/crt/admin/roles'
      preLoaderRoute: typeof AuthModulesCrtAdminRolesRouteRouteImport
      parentRoute: typeof AuthModulesCrtAdminRouteRoute
    }
    '/_auth/_modules/crt/admin/notifications': {
      id: '/_auth/_modules/crt/admin/notifications'
      path: '/notifications'
      fullPath: '/crt/admin/notifications'
      preLoaderRoute: typeof AuthModulesCrtAdminNotificationsRouteRouteImport
      parentRoute: typeof AuthModulesCrtAdminRouteRoute
    }
    '/_auth/_modules/crt/admin/invitations': {
      id: '/_auth/_modules/crt/admin/invitations'
      path: '/invitations'
      fullPath: '/crt/admin/invitations'
      preLoaderRoute: typeof AuthModulesCrtAdminInvitationsRouteRouteImport
      parentRoute: typeof AuthModulesCrtAdminRouteRoute
    }
    '/_auth/_modules/crt/admin/audit-trails': {
      id: '/_auth/_modules/crt/admin/audit-trails'
      path: '/audit-trails'
      fullPath: '/crt/admin/audit-trails'
      preLoaderRoute: typeof AuthModulesCrtAdminAuditTrailsRouteRouteImport
      parentRoute: typeof AuthModulesCrtAdminRouteRoute
    }
    '/_auth/_modules/credit/operations/very-low-risk-customers': {
      id: '/_auth/_modules/credit/operations/very-low-risk-customers'
      path: '/very-low-risk-customers'
      fullPath: '/credit/operations/very-low-risk-customers'
      preLoaderRoute: typeof AuthModulesCreditOperationsVeryLowRiskCustomersRouteRouteImport
      parentRoute: typeof AuthModulesCreditOperationsRouteRoute
    }
    '/_auth/_modules/credit/operations/province-aov-per-carton': {
      id: '/_auth/_modules/credit/operations/province-aov-per-carton'
      path: '/province-aov-per-carton'
      fullPath: '/credit/operations/province-aov-per-carton'
      preLoaderRoute: typeof AuthModulesCreditOperationsProvinceAovPerCartonRouteRouteImport
      parentRoute: typeof AuthModulesCreditOperationsRouteRoute
    }
    '/_auth/_modules/credit/operations/order-cutoffs': {
      id: '/_auth/_modules/credit/operations/order-cutoffs'
      path: '/order-cutoffs'
      fullPath: '/credit/operations/order-cutoffs'
      preLoaderRoute: typeof AuthModulesCreditOperationsOrderCutoffsRouteRouteImport
      parentRoute: typeof AuthModulesCreditOperationsRouteRoute
    }
    '/_auth/_modules/credit/operations/multiplier': {
      id: '/_auth/_modules/credit/operations/multiplier'
      path: '/multiplier'
      fullPath: '/credit/operations/multiplier'
      preLoaderRoute: typeof AuthModulesCreditOperationsMultiplierRouteRouteImport
      parentRoute: typeof AuthModulesCreditOperationsRouteRoute
    }
    '/_auth/_modules/credit/customers/$erp': {
      id: '/_auth/_modules/credit/customers/$erp'
      path: '/$erp'
      fullPath: '/credit/customers/$erp'
      preLoaderRoute: typeof AuthModulesCreditCustomersErpRouteRouteImport
      parentRoute: typeof AuthModulesCreditCustomersRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/review-events': {
      id: '/_auth/_modules/credit/credit-limit-reviews/review-events'
      path: '/review-events'
      fullPath: '/credit/credit-limit-reviews/review-events'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsReviewEventsRouteRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/pending-confirmations': {
      id: '/_auth/_modules/credit/credit-limit-reviews/pending-confirmations'
      path: '/pending-confirmations'
      fullPath: '/credit/credit-limit-reviews/pending-confirmations'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/mass': {
      id: '/_auth/_modules/credit/credit-limit-reviews/mass'
      path: '/mass'
      fullPath: '/credit/credit-limit-reviews/mass'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsMassRouteRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsRouteRoute
    }
    '/_auth/_modules/credit/admin/users': {
      id: '/_auth/_modules/credit/admin/users'
      path: '/users'
      fullPath: '/credit/admin/users'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersRouteRouteImport
      parentRoute: typeof AuthModulesCreditAdminRouteRoute
    }
    '/_auth/_modules/credit/admin/roles': {
      id: '/_auth/_modules/credit/admin/roles'
      path: '/roles'
      fullPath: '/credit/admin/roles'
      preLoaderRoute: typeof AuthModulesCreditAdminRolesRouteRouteImport
      parentRoute: typeof AuthModulesCreditAdminRouteRoute
    }
    '/_auth/_modules/credit/admin/invitations': {
      id: '/_auth/_modules/credit/admin/invitations'
      path: '/invitations'
      fullPath: '/credit/admin/invitations'
      preLoaderRoute: typeof AuthModulesCreditAdminInvitationsRouteRouteImport
      parentRoute: typeof AuthModulesCreditAdminRouteRoute
    }
    '/_auth/_modules/credit/admin/audit-trails': {
      id: '/_auth/_modules/credit/admin/audit-trails'
      path: '/audit-trails'
      fullPath: '/credit/admin/audit-trails'
      preLoaderRoute: typeof AuthModulesCreditAdminAuditTrailsRouteRouteImport
      parentRoute: typeof AuthModulesCreditAdminRouteRoute
    }
    '/_auth/_modules/_app/reports/salesforce': {
      id: '/_auth/_modules/_app/reports/salesforce'
      path: '/salesforce'
      fullPath: '/reports/salesforce'
      preLoaderRoute: typeof AuthModulesAppReportsSalesforceRouteRouteImport
      parentRoute: typeof AuthModulesAppReportsRouteRoute
    }
    '/_auth/_modules/_app/reports/order-service': {
      id: '/_auth/_modules/_app/reports/order-service'
      path: '/order-service'
      fullPath: '/reports/order-service'
      preLoaderRoute: typeof AuthModulesAppReportsOrderServiceRouteRouteImport
      parentRoute: typeof AuthModulesAppReportsRouteRoute
    }
    '/_auth/_modules/_app/reports/operations': {
      id: '/_auth/_modules/_app/reports/operations'
      path: '/operations'
      fullPath: '/reports/operations'
      preLoaderRoute: typeof AuthModulesAppReportsOperationsRouteRouteImport
      parentRoute: typeof AuthModulesAppReportsRouteRoute
    }
    '/_auth/_modules/_app/reports/misc': {
      id: '/_auth/_modules/_app/reports/misc'
      path: '/misc'
      fullPath: '/reports/misc'
      preLoaderRoute: typeof AuthModulesAppReportsMiscRouteRouteImport
      parentRoute: typeof AuthModulesAppReportsRouteRoute
    }
    '/_auth/_modules/_app/reports/material': {
      id: '/_auth/_modules/_app/reports/material'
      path: '/material'
      fullPath: '/reports/material'
      preLoaderRoute: typeof AuthModulesAppReportsMaterialRouteRouteImport
      parentRoute: typeof AuthModulesAppReportsRouteRoute
    }
    '/_auth/_modules/_app/reports/ecc': {
      id: '/_auth/_modules/_app/reports/ecc'
      path: '/ecc'
      fullPath: '/reports/ecc'
      preLoaderRoute: typeof AuthModulesAppReportsEccRouteRouteImport
      parentRoute: typeof AuthModulesAppReportsRouteRoute
    }
    '/_auth/_modules/_app/processes/pipelines': {
      id: '/_auth/_modules/_app/processes/pipelines'
      path: '/pipelines'
      fullPath: '/processes/pipelines'
      preLoaderRoute: typeof AuthModulesAppProcessesPipelinesRouteRouteImport
      parentRoute: typeof AuthModulesAppProcessesRouteRoute
    }
    '/_auth/_modules/_app/orders/returns': {
      id: '/_auth/_modules/_app/orders/returns'
      path: '/returns'
      fullPath: '/orders/returns'
      preLoaderRoute: typeof AuthModulesAppOrdersReturnsRouteRouteImport
      parentRoute: typeof AuthModulesAppOrdersRouteRoute
    }
    '/_auth/_modules/_app/orders/payment-review': {
      id: '/_auth/_modules/_app/orders/payment-review'
      path: '/payment-review'
      fullPath: '/orders/payment-review'
      preLoaderRoute: typeof AuthModulesAppOrdersPaymentReviewRouteRouteImport
      parentRoute: typeof AuthModulesAppOrdersRouteRoute
    }
    '/_auth/_modules/_app/orders/missing': {
      id: '/_auth/_modules/_app/orders/missing'
      path: '/missing'
      fullPath: '/orders/missing'
      preLoaderRoute: typeof AuthModulesAppOrdersMissingRouteRouteImport
      parentRoute: typeof AuthModulesAppOrdersRouteRoute
    }
    '/_auth/_modules/_app/orders/flagged': {
      id: '/_auth/_modules/_app/orders/flagged'
      path: '/flagged'
      fullPath: '/orders/flagged'
      preLoaderRoute: typeof AuthModulesAppOrdersFlaggedRouteRouteImport
      parentRoute: typeof AuthModulesAppOrdersRouteRoute
    }
    '/_auth/_modules/_app/orders/all': {
      id: '/_auth/_modules/_app/orders/all'
      path: '/all'
      fullPath: '/orders/all'
      preLoaderRoute: typeof AuthModulesAppOrdersAllRouteRouteImport
      parentRoute: typeof AuthModulesAppOrdersRouteRoute
    }
    '/_auth/_modules/_app/materials/bcp-priced': {
      id: '/_auth/_modules/_app/materials/bcp-priced'
      path: '/bcp-priced'
      fullPath: '/materials/bcp-priced'
      preLoaderRoute: typeof AuthModulesAppMaterialsBcpPricedRouteRouteImport
      parentRoute: typeof AuthModulesAppMaterialsRouteRoute
    }
    '/_auth/_modules/_app/customers/stores': {
      id: '/_auth/_modules/_app/customers/stores'
      path: '/stores'
      fullPath: '/customers/stores'
      preLoaderRoute: typeof AuthModulesAppCustomersStoresRouteRouteImport
      parentRoute: typeof AuthModulesAppCustomersRouteRoute
    }
    '/_auth/_modules/_app/customers/banners': {
      id: '/_auth/_modules/_app/customers/banners'
      path: '/banners'
      fullPath: '/customers/banners'
      preLoaderRoute: typeof AuthModulesAppCustomersBannersRouteRouteImport
      parentRoute: typeof AuthModulesAppCustomersRouteRoute
    }
    '/_auth/_modules/_app/core-upload-data/order-service': {
      id: '/_auth/_modules/_app/core-upload-data/order-service'
      path: '/order-service'
      fullPath: '/core-upload-data/order-service'
      preLoaderRoute: typeof AuthModulesAppCoreUploadDataOrderServiceRouteRouteImport
      parentRoute: typeof AuthModulesAppCoreUploadDataRouteRoute
    }
    '/_auth/_modules/_app/core-upload-data/operations': {
      id: '/_auth/_modules/_app/core-upload-data/operations'
      path: '/operations'
      fullPath: '/core-upload-data/operations'
      preLoaderRoute: typeof AuthModulesAppCoreUploadDataOperationsRouteRouteImport
      parentRoute: typeof AuthModulesAppCoreUploadDataRouteRoute
    }
    '/_auth/_modules/_app/core-upload-data/on-hand-inventory': {
      id: '/_auth/_modules/_app/core-upload-data/on-hand-inventory'
      path: '/on-hand-inventory'
      fullPath: '/core-upload-data/on-hand-inventory'
      preLoaderRoute: typeof AuthModulesAppCoreUploadDataOnHandInventoryRouteRouteImport
      parentRoute: typeof AuthModulesAppCoreUploadDataRouteRoute
    }
    '/_auth/_modules/_app/core-upload-data/materials': {
      id: '/_auth/_modules/_app/core-upload-data/materials'
      path: '/materials'
      fullPath: '/core-upload-data/materials'
      preLoaderRoute: typeof AuthModulesAppCoreUploadDataMaterialsRouteRouteImport
      parentRoute: typeof AuthModulesAppCoreUploadDataRouteRoute
    }
    '/_auth/_modules/_app/core-upload-data/business': {
      id: '/_auth/_modules/_app/core-upload-data/business'
      path: '/business'
      fullPath: '/core-upload-data/business'
      preLoaderRoute: typeof AuthModulesAppCoreUploadDataBusinessRouteRouteImport
      parentRoute: typeof AuthModulesAppCoreUploadDataRouteRoute
    }
    '/_auth/_modules/_app/core-upload-data/auto-inject': {
      id: '/_auth/_modules/_app/core-upload-data/auto-inject'
      path: '/auto-inject'
      fullPath: '/core-upload-data/auto-inject'
      preLoaderRoute: typeof AuthModulesAppCoreUploadDataAutoInjectRouteRouteImport
      parentRoute: typeof AuthModulesAppCoreUploadDataRouteRoute
    }
    '/_auth/_modules/_app/assortment/launches': {
      id: '/_auth/_modules/_app/assortment/launches'
      path: '/launches'
      fullPath: '/assortment/launches'
      preLoaderRoute: typeof AuthModulesAppAssortmentLaunchesRouteRouteImport
      parentRoute: typeof AuthModulesAppAssortmentRouteRoute
    }
    '/_auth/_modules/_app/assortment/banners': {
      id: '/_auth/_modules/_app/assortment/banners'
      path: '/banners'
      fullPath: '/assortment/banners'
      preLoaderRoute: typeof AuthModulesAppAssortmentBannersRouteRouteImport
      parentRoute: typeof AuthModulesAppAssortmentRouteRoute
    }
    '/_auth/_modules/_app/assortment/active': {
      id: '/_auth/_modules/_app/assortment/active'
      path: '/active'
      fullPath: '/assortment/active'
      preLoaderRoute: typeof AuthModulesAppAssortmentActiveRouteRouteImport
      parentRoute: typeof AuthModulesAppAssortmentRouteRoute
    }
    '/_auth/_modules/_app/admin/users': {
      id: '/_auth/_modules/_app/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthModulesAppAdminUsersRouteRouteImport
      parentRoute: typeof AuthModulesAppAdminRouteRoute
    }
    '/_auth/_modules/_app/admin/roles': {
      id: '/_auth/_modules/_app/admin/roles'
      path: '/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AuthModulesAppAdminRolesRouteRouteImport
      parentRoute: typeof AuthModulesAppAdminRouteRoute
    }
    '/_auth/_modules/_app/admin/invitations': {
      id: '/_auth/_modules/_app/admin/invitations'
      path: '/invitations'
      fullPath: '/admin/invitations'
      preLoaderRoute: typeof AuthModulesAppAdminInvitationsRouteRouteImport
      parentRoute: typeof AuthModulesAppAdminRouteRoute
    }
    '/_auth/_modules/_app/admin/audit-trails': {
      id: '/_auth/_modules/_app/admin/audit-trails'
      path: '/audit-trails'
      fullPath: '/admin/audit-trails'
      preLoaderRoute: typeof AuthModulesAppAdminAuditTrailsRouteRouteImport
      parentRoute: typeof AuthModulesAppAdminRouteRoute
    }
    '/_auth/_modules/crt/volume-forecasts/sub-channel-allocations/': {
      id: '/_auth/_modules/crt/volume-forecasts/sub-channel-allocations/'
      path: '/'
      fullPath: '/crt/volume-forecasts/sub-channel-allocations/'
      preLoaderRoute: typeof AuthModulesCrtVolumeForecastsSubChannelAllocationsIndexRouteImport
      parentRoute: typeof AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRoute
    }
    '/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions/': {
      id: '/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions/'
      path: '/'
      fullPath: '/crt/volume-forecasts/nc-provincial-contributions/'
      preLoaderRoute: typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsIndexRouteImport
      parentRoute: typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRoute
    }
    '/_auth/_modules/crt/volume-forecasts/channel-contributions/': {
      id: '/_auth/_modules/crt/volume-forecasts/channel-contributions/'
      path: '/'
      fullPath: '/crt/volume-forecasts/channel-contributions/'
      preLoaderRoute: typeof AuthModulesCrtVolumeForecastsChannelContributionsIndexRouteImport
      parentRoute: typeof AuthModulesCrtVolumeForecastsChannelContributionsRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/tax-assumptions/': {
      id: '/_auth/_modules/crt/pricing-excise/tax-assumptions/'
      path: '/'
      fullPath: '/crt/pricing-excise/tax-assumptions/'
      preLoaderRoute: typeof AuthModulesCrtPricingExciseTaxAssumptionsIndexRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseTaxAssumptionsRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/pricing-rate-table/': {
      id: '/_auth/_modules/crt/pricing-excise/pricing-rate-table/'
      path: '/'
      fullPath: '/crt/pricing-excise/pricing-rate-table/'
      preLoaderRoute: typeof AuthModulesCrtPricingExcisePricingRateTableIndexRouteImport
      parentRoute: typeof AuthModulesCrtPricingExcisePricingRateTableRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/pricing-assumptions/': {
      id: '/_auth/_modules/crt/pricing-excise/pricing-assumptions/'
      path: '/'
      fullPath: '/crt/pricing-excise/pricing-assumptions/'
      preLoaderRoute: typeof AuthModulesCrtPricingExcisePricingAssumptionsIndexRouteImport
      parentRoute: typeof AuthModulesCrtPricingExcisePricingAssumptionsRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/insights/': {
      id: '/_auth/_modules/crt/pricing-excise/insights/'
      path: '/'
      fullPath: '/crt/pricing-excise/insights/'
      preLoaderRoute: typeof AuthModulesCrtPricingExciseInsightsIndexRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseInsightsRouteRoute
    }
    '/_auth/_modules/crt/materials/price-list/': {
      id: '/_auth/_modules/crt/materials/price-list/'
      path: '/'
      fullPath: '/crt/materials/price-list/'
      preLoaderRoute: typeof AuthModulesCrtMaterialsPriceListIndexRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsPriceListRouteRoute
    }
    '/_auth/_modules/crt/materials/materials-list/': {
      id: '/_auth/_modules/crt/materials/materials-list/'
      path: '/'
      fullPath: '/crt/materials/materials-list/'
      preLoaderRoute: typeof AuthModulesCrtMaterialsMaterialsListIndexRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsMaterialsListRouteRoute
    }
    '/_auth/_modules/crt/materials/insights/': {
      id: '/_auth/_modules/crt/materials/insights/'
      path: '/'
      fullPath: '/crt/materials/insights/'
      preLoaderRoute: typeof AuthModulesCrtMaterialsInsightsIndexRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsInsightsRouteRoute
    }
    '/_auth/_modules/crt/materials/brand-variants/': {
      id: '/_auth/_modules/crt/materials/brand-variants/'
      path: '/'
      fullPath: '/crt/materials/brand-variants/'
      preLoaderRoute: typeof AuthModulesCrtMaterialsBrandVariantsIndexRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsBrandVariantsRouteRoute
    }
    '/_auth/_modules/crt/kpi-reports/profits-and-loss-summary/': {
      id: '/_auth/_modules/crt/kpi-reports/profits-and-loss-summary/'
      path: '/'
      fullPath: '/crt/kpi-reports/profits-and-loss-summary/'
      preLoaderRoute: typeof AuthModulesCrtKpiReportsProfitsAndLossSummaryIndexRouteImport
      parentRoute: typeof AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRoute
    }
    '/_auth/_modules/crt/kpi-reports/cash-dashboard/': {
      id: '/_auth/_modules/crt/kpi-reports/cash-dashboard/'
      path: '/'
      fullPath: '/crt/kpi-reports/cash-dashboard/'
      preLoaderRoute: typeof AuthModulesCrtKpiReportsCashDashboardIndexRouteImport
      parentRoute: typeof AuthModulesCrtKpiReportsCashDashboardRouteRoute
    }
    '/_auth/_modules/crt/customers/commercial-partners/': {
      id: '/_auth/_modules/crt/customers/commercial-partners/'
      path: '/'
      fullPath: '/crt/customers/commercial-partners/'
      preLoaderRoute: typeof AuthModulesCrtCustomersCommercialPartnersIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomersCommercialPartnersRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/key-accounts/': {
      id: '/_auth/_modules/crt/customer-investments/key-accounts/'
      path: '/'
      fullPath: '/crt/customer-investments/key-accounts/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsKeyAccountsIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/investments/': {
      id: '/_auth/_modules/crt/customer-investments/investments/'
      path: '/'
      fullPath: '/crt/customer-investments/investments/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInvestmentsIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInvestmentsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/': {
      id: '/_auth/_modules/crt/customer-investments/insights/'
      path: '/'
      fullPath: '/crt/customer-investments/insights/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/budget-tracker/': {
      id: '/_auth/_modules/crt/customer-investments/budget-tracker/'
      path: '/'
      fullPath: '/crt/customer-investments/budget-tracker/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsBudgetTrackerIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRoute
    }
    '/_auth/_modules/crt/admin/users/': {
      id: '/_auth/_modules/crt/admin/users/'
      path: '/'
      fullPath: '/crt/admin/users/'
      preLoaderRoute: typeof AuthModulesCrtAdminUsersIndexRouteImport
      parentRoute: typeof AuthModulesCrtAdminUsersRouteRoute
    }
    '/_auth/_modules/crt/admin/roles/': {
      id: '/_auth/_modules/crt/admin/roles/'
      path: '/'
      fullPath: '/crt/admin/roles/'
      preLoaderRoute: typeof AuthModulesCrtAdminRolesIndexRouteImport
      parentRoute: typeof AuthModulesCrtAdminRolesRouteRoute
    }
    '/_auth/_modules/crt/admin/notifications/': {
      id: '/_auth/_modules/crt/admin/notifications/'
      path: '/'
      fullPath: '/crt/admin/notifications/'
      preLoaderRoute: typeof AuthModulesCrtAdminNotificationsIndexRouteImport
      parentRoute: typeof AuthModulesCrtAdminNotificationsRouteRoute
    }
    '/_auth/_modules/crt/admin/invitations/': {
      id: '/_auth/_modules/crt/admin/invitations/'
      path: '/'
      fullPath: '/crt/admin/invitations/'
      preLoaderRoute: typeof AuthModulesCrtAdminInvitationsIndexRouteImport
      parentRoute: typeof AuthModulesCrtAdminInvitationsRouteRoute
    }
    '/_auth/_modules/crt/admin/audit-trails/': {
      id: '/_auth/_modules/crt/admin/audit-trails/'
      path: '/'
      fullPath: '/crt/admin/audit-trails/'
      preLoaderRoute: typeof AuthModulesCrtAdminAuditTrailsIndexRouteImport
      parentRoute: typeof AuthModulesCrtAdminAuditTrailsRouteRoute
    }
    '/_auth/_modules/credit/operations/very-low-risk-customers/': {
      id: '/_auth/_modules/credit/operations/very-low-risk-customers/'
      path: '/'
      fullPath: '/credit/operations/very-low-risk-customers/'
      preLoaderRoute: typeof AuthModulesCreditOperationsVeryLowRiskCustomersIndexRouteImport
      parentRoute: typeof AuthModulesCreditOperationsVeryLowRiskCustomersRouteRoute
    }
    '/_auth/_modules/credit/operations/province-aov-per-carton/': {
      id: '/_auth/_modules/credit/operations/province-aov-per-carton/'
      path: '/'
      fullPath: '/credit/operations/province-aov-per-carton/'
      preLoaderRoute: typeof AuthModulesCreditOperationsProvinceAovPerCartonIndexRouteImport
      parentRoute: typeof AuthModulesCreditOperationsProvinceAovPerCartonRouteRoute
    }
    '/_auth/_modules/credit/operations/order-cutoffs/': {
      id: '/_auth/_modules/credit/operations/order-cutoffs/'
      path: '/'
      fullPath: '/credit/operations/order-cutoffs/'
      preLoaderRoute: typeof AuthModulesCreditOperationsOrderCutoffsIndexRouteImport
      parentRoute: typeof AuthModulesCreditOperationsOrderCutoffsRouteRoute
    }
    '/_auth/_modules/credit/operations/multiplier/': {
      id: '/_auth/_modules/credit/operations/multiplier/'
      path: '/'
      fullPath: '/credit/operations/multiplier/'
      preLoaderRoute: typeof AuthModulesCreditOperationsMultiplierIndexRouteImport
      parentRoute: typeof AuthModulesCreditOperationsMultiplierRouteRoute
    }
    '/_auth/_modules/credit/customers/$erp/': {
      id: '/_auth/_modules/credit/customers/$erp/'
      path: '/'
      fullPath: '/credit/customers/$erp/'
      preLoaderRoute: typeof AuthModulesCreditCustomersErpIndexRouteImport
      parentRoute: typeof AuthModulesCreditCustomersErpRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/review-events/': {
      id: '/_auth/_modules/credit/credit-limit-reviews/review-events/'
      path: '/'
      fullPath: '/credit/credit-limit-reviews/review-events/'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsReviewEventsIndexRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsReviewEventsRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/pending-confirmations/': {
      id: '/_auth/_modules/credit/credit-limit-reviews/pending-confirmations/'
      path: '/'
      fullPath: '/credit/credit-limit-reviews/pending-confirmations/'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsPendingConfirmationsIndexRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/mass/': {
      id: '/_auth/_modules/credit/credit-limit-reviews/mass/'
      path: '/'
      fullPath: '/credit/credit-limit-reviews/mass/'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsMassIndexRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsMassRouteRoute
    }
    '/_auth/_modules/credit/admin/users/': {
      id: '/_auth/_modules/credit/admin/users/'
      path: '/'
      fullPath: '/credit/admin/users/'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersIndexRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersRouteRoute
    }
    '/_auth/_modules/credit/admin/roles/': {
      id: '/_auth/_modules/credit/admin/roles/'
      path: '/'
      fullPath: '/credit/admin/roles/'
      preLoaderRoute: typeof AuthModulesCreditAdminRolesIndexRouteImport
      parentRoute: typeof AuthModulesCreditAdminRolesRouteRoute
    }
    '/_auth/_modules/credit/admin/invitations/': {
      id: '/_auth/_modules/credit/admin/invitations/'
      path: '/'
      fullPath: '/credit/admin/invitations/'
      preLoaderRoute: typeof AuthModulesCreditAdminInvitationsIndexRouteImport
      parentRoute: typeof AuthModulesCreditAdminInvitationsRouteRoute
    }
    '/_auth/_modules/credit/admin/audit-trails/': {
      id: '/_auth/_modules/credit/admin/audit-trails/'
      path: '/'
      fullPath: '/credit/admin/audit-trails/'
      preLoaderRoute: typeof AuthModulesCreditAdminAuditTrailsIndexRouteImport
      parentRoute: typeof AuthModulesCreditAdminAuditTrailsRouteRoute
    }
    '/_auth/_modules/_app/reports/salesforce/': {
      id: '/_auth/_modules/_app/reports/salesforce/'
      path: '/'
      fullPath: '/reports/salesforce/'
      preLoaderRoute: typeof AuthModulesAppReportsSalesforceIndexRouteImport
      parentRoute: typeof AuthModulesAppReportsSalesforceRouteRoute
    }
    '/_auth/_modules/_app/reports/order-service/': {
      id: '/_auth/_modules/_app/reports/order-service/'
      path: '/'
      fullPath: '/reports/order-service/'
      preLoaderRoute: typeof AuthModulesAppReportsOrderServiceIndexRouteImport
      parentRoute: typeof AuthModulesAppReportsOrderServiceRouteRoute
    }
    '/_auth/_modules/_app/reports/operations/': {
      id: '/_auth/_modules/_app/reports/operations/'
      path: '/'
      fullPath: '/reports/operations/'
      preLoaderRoute: typeof AuthModulesAppReportsOperationsIndexRouteImport
      parentRoute: typeof AuthModulesAppReportsOperationsRouteRoute
    }
    '/_auth/_modules/_app/reports/misc/': {
      id: '/_auth/_modules/_app/reports/misc/'
      path: '/'
      fullPath: '/reports/misc/'
      preLoaderRoute: typeof AuthModulesAppReportsMiscIndexRouteImport
      parentRoute: typeof AuthModulesAppReportsMiscRouteRoute
    }
    '/_auth/_modules/_app/reports/material/': {
      id: '/_auth/_modules/_app/reports/material/'
      path: '/'
      fullPath: '/reports/material/'
      preLoaderRoute: typeof AuthModulesAppReportsMaterialIndexRouteImport
      parentRoute: typeof AuthModulesAppReportsMaterialRouteRoute
    }
    '/_auth/_modules/_app/reports/ecc/': {
      id: '/_auth/_modules/_app/reports/ecc/'
      path: '/'
      fullPath: '/reports/ecc/'
      preLoaderRoute: typeof AuthModulesAppReportsEccIndexRouteImport
      parentRoute: typeof AuthModulesAppReportsEccRouteRoute
    }
    '/_auth/_modules/_app/processes/pipelines/': {
      id: '/_auth/_modules/_app/processes/pipelines/'
      path: '/'
      fullPath: '/processes/pipelines/'
      preLoaderRoute: typeof AuthModulesAppProcessesPipelinesIndexRouteImport
      parentRoute: typeof AuthModulesAppProcessesPipelinesRouteRoute
    }
    '/_auth/_modules/_app/orders/returns/': {
      id: '/_auth/_modules/_app/orders/returns/'
      path: '/'
      fullPath: '/orders/returns/'
      preLoaderRoute: typeof AuthModulesAppOrdersReturnsIndexRouteImport
      parentRoute: typeof AuthModulesAppOrdersReturnsRouteRoute
    }
    '/_auth/_modules/_app/orders/payment-review/': {
      id: '/_auth/_modules/_app/orders/payment-review/'
      path: '/'
      fullPath: '/orders/payment-review/'
      preLoaderRoute: typeof AuthModulesAppOrdersPaymentReviewIndexRouteImport
      parentRoute: typeof AuthModulesAppOrdersPaymentReviewRouteRoute
    }
    '/_auth/_modules/_app/orders/missing/': {
      id: '/_auth/_modules/_app/orders/missing/'
      path: '/'
      fullPath: '/orders/missing/'
      preLoaderRoute: typeof AuthModulesAppOrdersMissingIndexRouteImport
      parentRoute: typeof AuthModulesAppOrdersMissingRouteRoute
    }
    '/_auth/_modules/_app/orders/flagged/': {
      id: '/_auth/_modules/_app/orders/flagged/'
      path: '/'
      fullPath: '/orders/flagged/'
      preLoaderRoute: typeof AuthModulesAppOrdersFlaggedIndexRouteImport
      parentRoute: typeof AuthModulesAppOrdersFlaggedRouteRoute
    }
    '/_auth/_modules/_app/orders/all/': {
      id: '/_auth/_modules/_app/orders/all/'
      path: '/'
      fullPath: '/orders/all/'
      preLoaderRoute: typeof AuthModulesAppOrdersAllIndexRouteImport
      parentRoute: typeof AuthModulesAppOrdersAllRouteRoute
    }
    '/_auth/_modules/_app/materials/bcp-priced/': {
      id: '/_auth/_modules/_app/materials/bcp-priced/'
      path: '/'
      fullPath: '/materials/bcp-priced/'
      preLoaderRoute: typeof AuthModulesAppMaterialsBcpPricedIndexRouteImport
      parentRoute: typeof AuthModulesAppMaterialsBcpPricedRouteRoute
    }
    '/_auth/_modules/_app/customers/stores/': {
      id: '/_auth/_modules/_app/customers/stores/'
      path: '/'
      fullPath: '/customers/stores/'
      preLoaderRoute: typeof AuthModulesAppCustomersStoresIndexRouteImport
      parentRoute: typeof AuthModulesAppCustomersStoresRouteRoute
    }
    '/_auth/_modules/_app/customers/banners/': {
      id: '/_auth/_modules/_app/customers/banners/'
      path: '/'
      fullPath: '/customers/banners/'
      preLoaderRoute: typeof AuthModulesAppCustomersBannersIndexRouteImport
      parentRoute: typeof AuthModulesAppCustomersBannersRouteRoute
    }
    '/_auth/_modules/_app/core-upload-data/order-service/': {
      id: '/_auth/_modules/_app/core-upload-data/order-service/'
      path: '/'
      fullPath: '/core-upload-data/order-service/'
      preLoaderRoute: typeof AuthModulesAppCoreUploadDataOrderServiceIndexRouteImport
      parentRoute: typeof AuthModulesAppCoreUploadDataOrderServiceRouteRoute
    }
    '/_auth/_modules/_app/core-upload-data/operations/': {
      id: '/_auth/_modules/_app/core-upload-data/operations/'
      path: '/'
      fullPath: '/core-upload-data/operations/'
      preLoaderRoute: typeof AuthModulesAppCoreUploadDataOperationsIndexRouteImport
      parentRoute: typeof AuthModulesAppCoreUploadDataOperationsRouteRoute
    }
    '/_auth/_modules/_app/core-upload-data/on-hand-inventory/': {
      id: '/_auth/_modules/_app/core-upload-data/on-hand-inventory/'
      path: '/'
      fullPath: '/core-upload-data/on-hand-inventory/'
      preLoaderRoute: typeof AuthModulesAppCoreUploadDataOnHandInventoryIndexRouteImport
      parentRoute: typeof AuthModulesAppCoreUploadDataOnHandInventoryRouteRoute
    }
    '/_auth/_modules/_app/core-upload-data/materials/': {
      id: '/_auth/_modules/_app/core-upload-data/materials/'
      path: '/'
      fullPath: '/core-upload-data/materials/'
      preLoaderRoute: typeof AuthModulesAppCoreUploadDataMaterialsIndexRouteImport
      parentRoute: typeof AuthModulesAppCoreUploadDataMaterialsRouteRoute
    }
    '/_auth/_modules/_app/core-upload-data/business/': {
      id: '/_auth/_modules/_app/core-upload-data/business/'
      path: '/'
      fullPath: '/core-upload-data/business/'
      preLoaderRoute: typeof AuthModulesAppCoreUploadDataBusinessIndexRouteImport
      parentRoute: typeof AuthModulesAppCoreUploadDataBusinessRouteRoute
    }
    '/_auth/_modules/_app/core-upload-data/auto-inject/': {
      id: '/_auth/_modules/_app/core-upload-data/auto-inject/'
      path: '/'
      fullPath: '/core-upload-data/auto-inject/'
      preLoaderRoute: typeof AuthModulesAppCoreUploadDataAutoInjectIndexRouteImport
      parentRoute: typeof AuthModulesAppCoreUploadDataAutoInjectRouteRoute
    }
    '/_auth/_modules/_app/assortment/launches/': {
      id: '/_auth/_modules/_app/assortment/launches/'
      path: '/'
      fullPath: '/assortment/launches/'
      preLoaderRoute: typeof AuthModulesAppAssortmentLaunchesIndexRouteImport
      parentRoute: typeof AuthModulesAppAssortmentLaunchesRouteRoute
    }
    '/_auth/_modules/_app/assortment/banners/': {
      id: '/_auth/_modules/_app/assortment/banners/'
      path: '/'
      fullPath: '/assortment/banners/'
      preLoaderRoute: typeof AuthModulesAppAssortmentBannersIndexRouteImport
      parentRoute: typeof AuthModulesAppAssortmentBannersRouteRoute
    }
    '/_auth/_modules/_app/assortment/active/': {
      id: '/_auth/_modules/_app/assortment/active/'
      path: '/'
      fullPath: '/assortment/active/'
      preLoaderRoute: typeof AuthModulesAppAssortmentActiveIndexRouteImport
      parentRoute: typeof AuthModulesAppAssortmentActiveRouteRoute
    }
    '/_auth/_modules/_app/admin/users/': {
      id: '/_auth/_modules/_app/admin/users/'
      path: '/'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AuthModulesAppAdminUsersIndexRouteImport
      parentRoute: typeof AuthModulesAppAdminUsersRouteRoute
    }
    '/_auth/_modules/_app/admin/roles/': {
      id: '/_auth/_modules/_app/admin/roles/'
      path: '/'
      fullPath: '/admin/roles/'
      preLoaderRoute: typeof AuthModulesAppAdminRolesIndexRouteImport
      parentRoute: typeof AuthModulesAppAdminRolesRouteRoute
    }
    '/_auth/_modules/_app/admin/invitations/': {
      id: '/_auth/_modules/_app/admin/invitations/'
      path: '/'
      fullPath: '/admin/invitations/'
      preLoaderRoute: typeof AuthModulesAppAdminInvitationsIndexRouteImport
      parentRoute: typeof AuthModulesAppAdminInvitationsRouteRoute
    }
    '/_auth/_modules/_app/admin/audit-trails/': {
      id: '/_auth/_modules/_app/admin/audit-trails/'
      path: '/'
      fullPath: '/admin/audit-trails/'
      preLoaderRoute: typeof AuthModulesAppAdminAuditTrailsIndexRouteImport
      parentRoute: typeof AuthModulesAppAdminAuditTrailsRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/tax-assumptions/$taxAssumptionId': {
      id: '/_auth/_modules/crt/pricing-excise/tax-assumptions/$taxAssumptionId'
      path: '/$taxAssumptionId'
      fullPath: '/crt/pricing-excise/tax-assumptions/$taxAssumptionId'
      preLoaderRoute: typeof AuthModulesCrtPricingExciseTaxAssumptionsTaxAssumptionIdRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseTaxAssumptionsRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/pricing-assumptions/$pricingAssumptionId': {
      id: '/_auth/_modules/crt/pricing-excise/pricing-assumptions/$pricingAssumptionId'
      path: '/$pricingAssumptionId'
      fullPath: '/crt/pricing-excise/pricing-assumptions/$pricingAssumptionId'
      preLoaderRoute: typeof AuthModulesCrtPricingExcisePricingAssumptionsPricingAssumptionIdRouteImport
      parentRoute: typeof AuthModulesCrtPricingExcisePricingAssumptionsRouteRoute
    }
    '/_auth/_modules/crt/my-uploads/$scope/$fileName': {
      id: '/_auth/_modules/crt/my-uploads/$scope/$fileName'
      path: '/$scope/$fileName'
      fullPath: '/crt/my-uploads/$scope/$fileName'
      preLoaderRoute: typeof AuthModulesCrtMyUploadsScopeFileNameRouteImport
      parentRoute: typeof AuthModulesCrtMyUploadsRouteRoute
    }
    '/_auth/_modules/crt/cost-of-goods/$year/$month': {
      id: '/_auth/_modules/crt/cost-of-goods/$year/$month'
      path: '/$year/$month'
      fullPath: '/crt/cost-of-goods/$year/$month'
      preLoaderRoute: typeof AuthModulesCrtCostOfGoodsYearMonthRouteImport
      parentRoute: typeof AuthModulesCrtCostOfGoodsRouteRoute
    }
    '/_auth/_modules/credit/my-uploads/$scope/$fileName': {
      id: '/_auth/_modules/credit/my-uploads/$scope/$fileName'
      path: '/$scope/$fileName'
      fullPath: '/credit/my-uploads/$scope/$fileName'
      preLoaderRoute: typeof AuthModulesCreditMyUploadsScopeFileNameRouteImport
      parentRoute: typeof AuthModulesCreditMyUploadsRouteRoute
    }
    '/_auth/_modules/credit/customers/$erp/prepare-clr': {
      id: '/_auth/_modules/credit/customers/$erp/prepare-clr'
      path: '/prepare-clr'
      fullPath: '/credit/customers/$erp/prepare-clr'
      preLoaderRoute: typeof AuthModulesCreditCustomersErpPrepareClrRouteImport
      parentRoute: typeof AuthModulesCreditCustomersErpRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/mass/new': {
      id: '/_auth/_modules/credit/credit-limit-reviews/mass/new'
      path: '/new'
      fullPath: '/credit/credit-limit-reviews/mass/new'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsMassNewRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsMassRouteRoute
    }
    '/_auth/_modules/credit/blocked-orders/groups/$groupKey': {
      id: '/_auth/_modules/credit/blocked-orders/groups/$groupKey'
      path: '/groups/$groupKey'
      fullPath: '/credit/blocked-orders/groups/$groupKey'
      preLoaderRoute: typeof AuthModulesCreditBlockedOrdersGroupsGroupKeyRouteImport
      parentRoute: typeof AuthModulesCreditBlockedOrdersRouteRoute
    }
    '/_auth/_modules/_app/reports/salesforce/$reportId': {
      id: '/_auth/_modules/_app/reports/salesforce/$reportId'
      path: '/$reportId'
      fullPath: '/reports/salesforce/$reportId'
      preLoaderRoute: typeof AuthModulesAppReportsSalesforceReportIdRouteImport
      parentRoute: typeof AuthModulesAppReportsSalesforceRouteRoute
    }
    '/_auth/_modules/_app/reports/order-service/$reportId': {
      id: '/_auth/_modules/_app/reports/order-service/$reportId'
      path: '/$reportId'
      fullPath: '/reports/order-service/$reportId'
      preLoaderRoute: typeof AuthModulesAppReportsOrderServiceReportIdRouteImport
      parentRoute: typeof AuthModulesAppReportsOrderServiceRouteRoute
    }
    '/_auth/_modules/_app/reports/operations/$reportId': {
      id: '/_auth/_modules/_app/reports/operations/$reportId'
      path: '/$reportId'
      fullPath: '/reports/operations/$reportId'
      preLoaderRoute: typeof AuthModulesAppReportsOperationsReportIdRouteImport
      parentRoute: typeof AuthModulesAppReportsOperationsRouteRoute
    }
    '/_auth/_modules/_app/reports/misc/$reportId': {
      id: '/_auth/_modules/_app/reports/misc/$reportId'
      path: '/$reportId'
      fullPath: '/reports/misc/$reportId'
      preLoaderRoute: typeof AuthModulesAppReportsMiscReportIdRouteImport
      parentRoute: typeof AuthModulesAppReportsMiscRouteRoute
    }
    '/_auth/_modules/_app/reports/material/$reportId': {
      id: '/_auth/_modules/_app/reports/material/$reportId'
      path: '/$reportId'
      fullPath: '/reports/material/$reportId'
      preLoaderRoute: typeof AuthModulesAppReportsMaterialReportIdRouteImport
      parentRoute: typeof AuthModulesAppReportsMaterialRouteRoute
    }
    '/_auth/_modules/_app/reports/ecc/$reportId': {
      id: '/_auth/_modules/_app/reports/ecc/$reportId'
      path: '/$reportId'
      fullPath: '/reports/ecc/$reportId'
      preLoaderRoute: typeof AuthModulesAppReportsEccReportIdRouteImport
      parentRoute: typeof AuthModulesAppReportsEccRouteRoute
    }
    '/_auth/_modules/_app/my-uploads/$scope/$fileName': {
      id: '/_auth/_modules/_app/my-uploads/$scope/$fileName'
      path: '/$scope/$fileName'
      fullPath: '/my-uploads/$scope/$fileName'
      preLoaderRoute: typeof AuthModulesAppMyUploadsScopeFileNameRouteImport
      parentRoute: typeof AuthModulesAppMyUploadsRouteRoute
    }
    '/_auth/_modules/_app/customers/stores/$storeId': {
      id: '/_auth/_modules/_app/customers/stores/$storeId'
      path: '/$storeId'
      fullPath: '/customers/stores/$storeId'
      preLoaderRoute: typeof AuthModulesAppCustomersStoresStoreIdRouteImport
      parentRoute: typeof AuthModulesAppCustomersStoresRouteRoute
    }
    '/_auth/_modules/_app/customers/banners/$bannerId': {
      id: '/_auth/_modules/_app/customers/banners/$bannerId'
      path: '/$bannerId'
      fullPath: '/customers/banners/$bannerId'
      preLoaderRoute: typeof AuthModulesAppCustomersBannersBannerIdRouteImport
      parentRoute: typeof AuthModulesAppCustomersBannersRouteRoute
    }
    '/_auth/_modules/_app/assortment/launches/$launchId': {
      id: '/_auth/_modules/_app/assortment/launches/$launchId'
      path: '/$launchId'
      fullPath: '/assortment/launches/$launchId'
      preLoaderRoute: typeof AuthModulesAppAssortmentLaunchesLaunchIdRouteImport
      parentRoute: typeof AuthModulesAppAssortmentLaunchesRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/insights/retailer-rates': {
      id: '/_auth/_modules/crt/pricing-excise/insights/retailer-rates'
      path: '/retailer-rates'
      fullPath: '/crt/pricing-excise/insights/retailer-rates'
      preLoaderRoute: typeof AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseInsightsRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/insights/consumer-rates': {
      id: '/_auth/_modules/crt/pricing-excise/insights/consumer-rates'
      path: '/consumer-rates'
      fullPath: '/crt/pricing-excise/insights/consumer-rates'
      preLoaderRoute: typeof AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseInsightsRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/insights/channel-mix': {
      id: '/_auth/_modules/crt/pricing-excise/insights/channel-mix'
      path: '/channel-mix'
      fullPath: '/crt/pricing-excise/insights/channel-mix'
      preLoaderRoute: typeof AuthModulesCrtPricingExciseInsightsChannelMixRouteRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseInsightsRouteRoute
    }
    '/_auth/_modules/crt/materials/insights/unreleased-materials': {
      id: '/_auth/_modules/crt/materials/insights/unreleased-materials'
      path: '/unreleased-materials'
      fullPath: '/crt/materials/insights/unreleased-materials'
      preLoaderRoute: typeof AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsInsightsRouteRoute
    }
    '/_auth/_modules/crt/materials/insights/product-types': {
      id: '/_auth/_modules/crt/materials/insights/product-types'
      path: '/product-types'
      fullPath: '/crt/materials/insights/product-types'
      preLoaderRoute: typeof AuthModulesCrtMaterialsInsightsProductTypesRouteRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsInsightsRouteRoute
    }
    '/_auth/_modules/crt/materials/insights/product-type-variants': {
      id: '/_auth/_modules/crt/materials/insights/product-type-variants'
      path: '/product-type-variants'
      fullPath: '/crt/materials/insights/product-type-variants'
      preLoaderRoute: typeof AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsInsightsRouteRoute
    }
    '/_auth/_modules/crt/materials/insights/material-groups-overrides': {
      id: '/_auth/_modules/crt/materials/insights/material-groups-overrides'
      path: '/material-groups-overrides'
      fullPath: '/crt/materials/insights/material-groups-overrides'
      preLoaderRoute: typeof AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsInsightsRouteRoute
    }
    '/_auth/_modules/crt/materials/insights/federal-excise': {
      id: '/_auth/_modules/crt/materials/insights/federal-excise'
      path: '/federal-excise'
      fullPath: '/crt/materials/insights/federal-excise'
      preLoaderRoute: typeof AuthModulesCrtMaterialsInsightsFederalExciseRouteRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsInsightsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/key-accounts/estimates': {
      id: '/_auth/_modules/crt/customer-investments/key-accounts/estimates'
      path: '/estimates'
      fullPath: '/crt/customer-investments/key-accounts/estimates'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals': {
      id: '/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals'
      path: '/sales-deal-actuals'
      fullPath: '/crt/customer-investments/insights/sales-deal-actuals'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/rap-forecasts': {
      id: '/_auth/_modules/crt/customer-investments/insights/rap-forecasts'
      path: '/rap-forecasts'
      fullPath: '/crt/customer-investments/insights/rap-forecasts'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/master-agreements': {
      id: '/_auth/_modules/crt/customer-investments/insights/master-agreements'
      path: '/master-agreements'
      fullPath: '/crt/customer-investments/insights/master-agreements'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/manual-investments': {
      id: '/_auth/_modules/crt/customer-investments/insights/manual-investments'
      path: '/manual-investments'
      fullPath: '/crt/customer-investments/insights/manual-investments'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/ip-accruals': {
      id: '/_auth/_modules/crt/customer-investments/insights/ip-accruals'
      path: '/ip-accruals'
      fullPath: '/crt/customer-investments/insights/ip-accruals'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix': {
      id: '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix'
      path: '/distribution-margin-mix'
      fullPath: '/crt/customer-investments/insights/distribution-margin-mix'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals': {
      id: '/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals'
      path: '/calculation-run-accruals'
      fullPath: '/crt/customer-investments/insights/calculation-run-accruals'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/budget-allocations': {
      id: '/_auth/_modules/crt/customer-investments/insights/budget-allocations'
      path: '/budget-allocations'
      fullPath: '/crt/customer-investments/insights/budget-allocations'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/agreements': {
      id: '/_auth/_modules/crt/customer-investments/insights/agreements'
      path: '/agreements'
      fullPath: '/crt/customer-investments/insights/agreements'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/mass/pending-confirmations': {
      id: '/_auth/_modules/credit/credit-limit-reviews/mass/pending-confirmations'
      path: '/pending-confirmations'
      fullPath: '/credit/credit-limit-reviews/mass/pending-confirmations'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsMassRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/mass/$runId': {
      id: '/_auth/_modules/credit/credit-limit-reviews/mass/$runId'
      path: '/$runId'
      fullPath: '/credit/credit-limit-reviews/mass/$runId'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsMassRunIdRouteRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsMassRouteRoute
    }
    '/_auth/_modules/credit/admin/users/delegation-of-authority': {
      id: '/_auth/_modules/credit/admin/users/delegation-of-authority'
      path: '/delegation-of-authority'
      fullPath: '/credit/admin/users/delegation-of-authority'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/insights/retailer-rates/': {
      id: '/_auth/_modules/crt/pricing-excise/insights/retailer-rates/'
      path: '/'
      fullPath: '/crt/pricing-excise/insights/retailer-rates/'
      preLoaderRoute: typeof AuthModulesCrtPricingExciseInsightsRetailerRatesIndexRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/insights/consumer-rates/': {
      id: '/_auth/_modules/crt/pricing-excise/insights/consumer-rates/'
      path: '/'
      fullPath: '/crt/pricing-excise/insights/consumer-rates/'
      preLoaderRoute: typeof AuthModulesCrtPricingExciseInsightsConsumerRatesIndexRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/insights/channel-mix/': {
      id: '/_auth/_modules/crt/pricing-excise/insights/channel-mix/'
      path: '/'
      fullPath: '/crt/pricing-excise/insights/channel-mix/'
      preLoaderRoute: typeof AuthModulesCrtPricingExciseInsightsChannelMixIndexRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseInsightsChannelMixRouteRoute
    }
    '/_auth/_modules/crt/materials/insights/unreleased-materials/': {
      id: '/_auth/_modules/crt/materials/insights/unreleased-materials/'
      path: '/'
      fullPath: '/crt/materials/insights/unreleased-materials/'
      preLoaderRoute: typeof AuthModulesCrtMaterialsInsightsUnreleasedMaterialsIndexRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRoute
    }
    '/_auth/_modules/crt/materials/insights/product-types/': {
      id: '/_auth/_modules/crt/materials/insights/product-types/'
      path: '/'
      fullPath: '/crt/materials/insights/product-types/'
      preLoaderRoute: typeof AuthModulesCrtMaterialsInsightsProductTypesIndexRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsInsightsProductTypesRouteRoute
    }
    '/_auth/_modules/crt/materials/insights/product-type-variants/': {
      id: '/_auth/_modules/crt/materials/insights/product-type-variants/'
      path: '/'
      fullPath: '/crt/materials/insights/product-type-variants/'
      preLoaderRoute: typeof AuthModulesCrtMaterialsInsightsProductTypeVariantsIndexRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRoute
    }
    '/_auth/_modules/crt/materials/insights/material-groups-overrides/': {
      id: '/_auth/_modules/crt/materials/insights/material-groups-overrides/'
      path: '/'
      fullPath: '/crt/materials/insights/material-groups-overrides/'
      preLoaderRoute: typeof AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesIndexRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRoute
    }
    '/_auth/_modules/crt/materials/insights/federal-excise/': {
      id: '/_auth/_modules/crt/materials/insights/federal-excise/'
      path: '/'
      fullPath: '/crt/materials/insights/federal-excise/'
      preLoaderRoute: typeof AuthModulesCrtMaterialsInsightsFederalExciseIndexRouteImport
      parentRoute: typeof AuthModulesCrtMaterialsInsightsFederalExciseRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/key-accounts/estimates/': {
      id: '/_auth/_modules/crt/customer-investments/key-accounts/estimates/'
      path: '/'
      fullPath: '/crt/customer-investments/key-accounts/estimates/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals/': {
      id: '/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals/'
      path: '/'
      fullPath: '/crt/customer-investments/insights/sales-deal-actuals/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/rap-forecasts/': {
      id: '/_auth/_modules/crt/customer-investments/insights/rap-forecasts/'
      path: '/'
      fullPath: '/crt/customer-investments/insights/rap-forecasts/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/master-agreements/': {
      id: '/_auth/_modules/crt/customer-investments/insights/master-agreements/'
      path: '/'
      fullPath: '/crt/customer-investments/insights/master-agreements/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/manual-investments/': {
      id: '/_auth/_modules/crt/customer-investments/insights/manual-investments/'
      path: '/'
      fullPath: '/crt/customer-investments/insights/manual-investments/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/ip-accruals/': {
      id: '/_auth/_modules/crt/customer-investments/insights/ip-accruals/'
      path: '/'
      fullPath: '/crt/customer-investments/insights/ip-accruals/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/': {
      id: '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/'
      path: '/'
      fullPath: '/crt/customer-investments/insights/distribution-margin-mix/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals/': {
      id: '/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals/'
      path: '/'
      fullPath: '/crt/customer-investments/insights/calculation-run-accruals/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/budget-allocations/': {
      id: '/_auth/_modules/crt/customer-investments/insights/budget-allocations/'
      path: '/'
      fullPath: '/crt/customer-investments/insights/budget-allocations/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/agreements/': {
      id: '/_auth/_modules/crt/customer-investments/insights/agreements/'
      path: '/'
      fullPath: '/crt/customer-investments/insights/agreements/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsAgreementsIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/mass/pending-confirmations/': {
      id: '/_auth/_modules/credit/credit-limit-reviews/mass/pending-confirmations/'
      path: '/'
      fullPath: '/credit/credit-limit-reviews/mass/pending-confirmations/'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsIndexRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/': {
      id: '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/'
      path: '/'
      fullPath: '/credit/credit-limit-reviews/mass/$runId/'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsMassRunIdIndexRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsMassRunIdRouteRoute
    }
    '/_auth/_modules/credit/admin/users/delegation-of-authority/': {
      id: '/_auth/_modules/credit/admin/users/delegation-of-authority/'
      path: '/'
      fullPath: '/credit/admin/users/delegation-of-authority/'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityIndexRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute
    }
    '/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions/$year/$month': {
      id: '/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions/$year/$month'
      path: '/$year/$month'
      fullPath: '/crt/volume-forecasts/nc-provincial-contributions/$year/$month'
      preLoaderRoute: typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsYearMonthRouteImport
      parentRoute: typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRoute
    }
    '/_auth/_modules/crt/volume-forecasts/channel-contributions/$year/$month': {
      id: '/_auth/_modules/crt/volume-forecasts/channel-contributions/$year/$month'
      path: '/$year/$month'
      fullPath: '/crt/volume-forecasts/channel-contributions/$year/$month'
      preLoaderRoute: typeof AuthModulesCrtVolumeForecastsChannelContributionsYearMonthRouteImport
      parentRoute: typeof AuthModulesCrtVolumeForecastsChannelContributionsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/manual-investments/$manualInvestmentId': {
      id: '/_auth/_modules/crt/customer-investments/insights/manual-investments/$manualInvestmentId'
      path: '/$manualInvestmentId'
      fullPath: '/crt/customer-investments/insights/manual-investments/$manualInvestmentId'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsManualInvestmentIdRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/banner-mix': {
      id: '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/banner-mix'
      path: '/banner-mix'
      fullPath: '/crt/customer-investments/insights/distribution-margin-mix/banner-mix'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixBannerMixRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/submit': {
      id: '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/submit'
      path: '/submit'
      fullPath: '/credit/credit-limit-reviews/mass/$runId/submit'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsMassRunIdSubmitRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsMassRunIdRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/pending-confirmations': {
      id: '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/pending-confirmations'
      path: '/pending-confirmations'
      fullPath: '/credit/credit-limit-reviews/mass/$runId/pending-confirmations'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsMassRunIdPendingConfirmationsRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsMassRunIdRouteRoute
    }
    '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/lines': {
      id: '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/lines'
      path: '/lines'
      fullPath: '/credit/credit-limit-reviews/mass/$runId/lines'
      preLoaderRoute: typeof AuthModulesCreditCreditLimitReviewsMassRunIdLinesRouteImport
      parentRoute: typeof AuthModulesCreditCreditLimitReviewsMassRunIdRouteRoute
    }
    '/_auth/_modules/_app/orders/all/$dynamoId/$poNumber': {
      id: '/_auth/_modules/_app/orders/all/$dynamoId/$poNumber'
      path: '/$dynamoId/$poNumber'
      fullPath: '/orders/all/$dynamoId/$poNumber'
      preLoaderRoute: typeof AuthModulesAppOrdersAllDynamoIdPoNumberRouteImport
      parentRoute: typeof AuthModulesAppOrdersAllRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/nc': {
      id: '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/nc'
      path: '/wholesaler-margins/nc'
      fullPath: '/crt/customer-investments/insights/wholesaler-margins/nc'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/fmc': {
      id: '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/fmc'
      path: '/wholesaler-margins/fmc'
      fullPath: '/crt/customer-investments/insights/wholesaler-margins/fmc'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/retailer-margins/nc': {
      id: '/_auth/_modules/crt/customer-investments/insights/retailer-margins/nc'
      path: '/retailer-margins/nc'
      fullPath: '/crt/customer-investments/insights/retailer-margins/nc'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/retailer-margins/fmc': {
      id: '/_auth/_modules/crt/customer-investments/insights/retailer-margins/fmc'
      path: '/retailer-margins/fmc'
      fullPath: '/crt/customer-investments/insights/retailer-margins/fmc'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRoute
    }
    '/_auth/_modules/credit/admin/users/delegation-of-authority/single-with-deviation': {
      id: '/_auth/_modules/credit/admin/users/delegation-of-authority/single-with-deviation'
      path: '/single-with-deviation'
      fullPath: '/credit/admin/users/delegation-of-authority/single-with-deviation'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute
    }
    '/_auth/_modules/credit/admin/users/delegation-of-authority/single-no-deviation': {
      id: '/_auth/_modules/credit/admin/users/delegation-of-authority/single-no-deviation'
      path: '/single-no-deviation'
      fullPath: '/credit/admin/users/delegation-of-authority/single-no-deviation'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute
    }
    '/_auth/_modules/credit/admin/users/delegation-of-authority/mass': {
      id: '/_auth/_modules/credit/admin/users/delegation-of-authority/mass'
      path: '/mass'
      fullPath: '/credit/admin/users/delegation-of-authority/mass'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute
    }
    '/_auth/_modules/credit/admin/users/delegation-of-authority/initiative': {
      id: '/_auth/_modules/credit/admin/users/delegation-of-authority/initiative'
      path: '/initiative'
      fullPath: '/credit/admin/users/delegation-of-authority/initiative'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute
    }
    '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders': {
      id: '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders'
      path: '/blocked-orders'
      fullPath: '/credit/admin/users/delegation-of-authority/blocked-orders'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/nc/': {
      id: '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/nc/'
      path: '/'
      fullPath: '/crt/customer-investments/insights/wholesaler-margins/nc/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/fmc/': {
      id: '/_auth/_modules/crt/customer-investments/insights/wholesaler-margins/fmc/'
      path: '/'
      fullPath: '/crt/customer-investments/insights/wholesaler-margins/fmc/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/retailer-margins/nc/': {
      id: '/_auth/_modules/crt/customer-investments/insights/retailer-margins/nc/'
      path: '/'
      fullPath: '/crt/customer-investments/insights/retailer-margins/nc/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/retailer-margins/fmc/': {
      id: '/_auth/_modules/crt/customer-investments/insights/retailer-margins/fmc/'
      path: '/'
      fullPath: '/crt/customer-investments/insights/retailer-margins/fmc/'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcIndexRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRoute
    }
    '/_auth/_modules/credit/admin/users/delegation-of-authority/single-with-deviation/': {
      id: '/_auth/_modules/credit/admin/users/delegation-of-authority/single-with-deviation/'
      path: '/'
      fullPath: '/credit/admin/users/delegation-of-authority/single-with-deviation/'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationIndexRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRoute
    }
    '/_auth/_modules/credit/admin/users/delegation-of-authority/single-no-deviation/': {
      id: '/_auth/_modules/credit/admin/users/delegation-of-authority/single-no-deviation/'
      path: '/'
      fullPath: '/credit/admin/users/delegation-of-authority/single-no-deviation/'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationIndexRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRoute
    }
    '/_auth/_modules/credit/admin/users/delegation-of-authority/mass/': {
      id: '/_auth/_modules/credit/admin/users/delegation-of-authority/mass/'
      path: '/'
      fullPath: '/credit/admin/users/delegation-of-authority/mass/'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityMassIndexRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRoute
    }
    '/_auth/_modules/credit/admin/users/delegation-of-authority/initiative/': {
      id: '/_auth/_modules/credit/admin/users/delegation-of-authority/initiative/'
      path: '/'
      fullPath: '/credit/admin/users/delegation-of-authority/initiative/'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeIndexRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRoute
    }
    '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/': {
      id: '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/'
      path: '/'
      fullPath: '/credit/admin/users/delegation-of-authority/blocked-orders/'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersIndexRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRoute
    }
    '/_auth/_modules/crt/pricing-excise/insights/channel-mix/$year/$month': {
      id: '/_auth/_modules/crt/pricing-excise/insights/channel-mix/$year/$month'
      path: '/$year/$month'
      fullPath: '/crt/pricing-excise/insights/channel-mix/$year/$month'
      preLoaderRoute: typeof AuthModulesCrtPricingExciseInsightsChannelMixYearMonthRouteImport
      parentRoute: typeof AuthModulesCrtPricingExciseInsightsChannelMixRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals/$year/$month': {
      id: '/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals/$year/$month'
      path: '/$year/$month'
      fullPath: '/crt/customer-investments/insights/sales-deal-actuals/$year/$month'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsYearMonthRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/rap-forecasts/$year/$month': {
      id: '/_auth/_modules/crt/customer-investments/insights/rap-forecasts/$year/$month'
      path: '/$year/$month'
      fullPath: '/crt/customer-investments/insights/rap-forecasts/$year/$month'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsYearMonthRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/ip-accruals/$year/$month': {
      id: '/_auth/_modules/crt/customer-investments/insights/ip-accruals/$year/$month'
      path: '/$year/$month'
      fullPath: '/crt/customer-investments/insights/ip-accruals/$year/$month'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsYearMonthRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/$year/$month': {
      id: '/_auth/_modules/crt/customer-investments/insights/distribution-margin-mix/$year/$month'
      path: '/$year/$month'
      fullPath: '/crt/customer-investments/insights/distribution-margin-mix/$year/$month'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixYearMonthRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRoute
    }
    '/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals/$year/$month': {
      id: '/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals/$year/$month'
      path: '/$year/$month'
      fullPath: '/crt/customer-investments/insights/calculation-run-accruals/$year/$month'
      preLoaderRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsYearMonthRouteImport
      parentRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRoute
    }
    '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers': {
      id: '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers'
      path: '/exception-payers'
      fullPath: '/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRoute
    }
    '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers/': {
      id: '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers/'
      path: '/'
      fullPath: '/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers/'
      preLoaderRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersIndexRouteImport
      parentRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRoute
    }
  }
}

interface AuthModulesAppAdminAuditTrailsRouteRouteChildren {
  AuthModulesAppAdminAuditTrailsIndexRoute: typeof AuthModulesAppAdminAuditTrailsIndexRoute
}

const AuthModulesAppAdminAuditTrailsRouteRouteChildren: AuthModulesAppAdminAuditTrailsRouteRouteChildren =
  {
    AuthModulesAppAdminAuditTrailsIndexRoute:
      AuthModulesAppAdminAuditTrailsIndexRoute,
  }

const AuthModulesAppAdminAuditTrailsRouteRouteWithChildren =
  AuthModulesAppAdminAuditTrailsRouteRoute._addFileChildren(
    AuthModulesAppAdminAuditTrailsRouteRouteChildren,
  )

interface AuthModulesAppAdminInvitationsRouteRouteChildren {
  AuthModulesAppAdminInvitationsIndexRoute: typeof AuthModulesAppAdminInvitationsIndexRoute
}

const AuthModulesAppAdminInvitationsRouteRouteChildren: AuthModulesAppAdminInvitationsRouteRouteChildren =
  {
    AuthModulesAppAdminInvitationsIndexRoute:
      AuthModulesAppAdminInvitationsIndexRoute,
  }

const AuthModulesAppAdminInvitationsRouteRouteWithChildren =
  AuthModulesAppAdminInvitationsRouteRoute._addFileChildren(
    AuthModulesAppAdminInvitationsRouteRouteChildren,
  )

interface AuthModulesAppAdminRolesRouteRouteChildren {
  AuthModulesAppAdminRolesIndexRoute: typeof AuthModulesAppAdminRolesIndexRoute
}

const AuthModulesAppAdminRolesRouteRouteChildren: AuthModulesAppAdminRolesRouteRouteChildren =
  {
    AuthModulesAppAdminRolesIndexRoute: AuthModulesAppAdminRolesIndexRoute,
  }

const AuthModulesAppAdminRolesRouteRouteWithChildren =
  AuthModulesAppAdminRolesRouteRoute._addFileChildren(
    AuthModulesAppAdminRolesRouteRouteChildren,
  )

interface AuthModulesAppAdminUsersRouteRouteChildren {
  AuthModulesAppAdminUsersIndexRoute: typeof AuthModulesAppAdminUsersIndexRoute
}

const AuthModulesAppAdminUsersRouteRouteChildren: AuthModulesAppAdminUsersRouteRouteChildren =
  {
    AuthModulesAppAdminUsersIndexRoute: AuthModulesAppAdminUsersIndexRoute,
  }

const AuthModulesAppAdminUsersRouteRouteWithChildren =
  AuthModulesAppAdminUsersRouteRoute._addFileChildren(
    AuthModulesAppAdminUsersRouteRouteChildren,
  )

interface AuthModulesAppAdminRouteRouteChildren {
  AuthModulesAppAdminAuditTrailsRouteRoute: typeof AuthModulesAppAdminAuditTrailsRouteRouteWithChildren
  AuthModulesAppAdminInvitationsRouteRoute: typeof AuthModulesAppAdminInvitationsRouteRouteWithChildren
  AuthModulesAppAdminRolesRouteRoute: typeof AuthModulesAppAdminRolesRouteRouteWithChildren
  AuthModulesAppAdminUsersRouteRoute: typeof AuthModulesAppAdminUsersRouteRouteWithChildren
  AuthModulesAppAdminIndexRoute: typeof AuthModulesAppAdminIndexRoute
}

const AuthModulesAppAdminRouteRouteChildren: AuthModulesAppAdminRouteRouteChildren =
  {
    AuthModulesAppAdminAuditTrailsRouteRoute:
      AuthModulesAppAdminAuditTrailsRouteRouteWithChildren,
    AuthModulesAppAdminInvitationsRouteRoute:
      AuthModulesAppAdminInvitationsRouteRouteWithChildren,
    AuthModulesAppAdminRolesRouteRoute:
      AuthModulesAppAdminRolesRouteRouteWithChildren,
    AuthModulesAppAdminUsersRouteRoute:
      AuthModulesAppAdminUsersRouteRouteWithChildren,
    AuthModulesAppAdminIndexRoute: AuthModulesAppAdminIndexRoute,
  }

const AuthModulesAppAdminRouteRouteWithChildren =
  AuthModulesAppAdminRouteRoute._addFileChildren(
    AuthModulesAppAdminRouteRouteChildren,
  )

interface AuthModulesAppAssortmentActiveRouteRouteChildren {
  AuthModulesAppAssortmentActiveIndexRoute: typeof AuthModulesAppAssortmentActiveIndexRoute
}

const AuthModulesAppAssortmentActiveRouteRouteChildren: AuthModulesAppAssortmentActiveRouteRouteChildren =
  {
    AuthModulesAppAssortmentActiveIndexRoute:
      AuthModulesAppAssortmentActiveIndexRoute,
  }

const AuthModulesAppAssortmentActiveRouteRouteWithChildren =
  AuthModulesAppAssortmentActiveRouteRoute._addFileChildren(
    AuthModulesAppAssortmentActiveRouteRouteChildren,
  )

interface AuthModulesAppAssortmentBannersRouteRouteChildren {
  AuthModulesAppAssortmentBannersIndexRoute: typeof AuthModulesAppAssortmentBannersIndexRoute
}

const AuthModulesAppAssortmentBannersRouteRouteChildren: AuthModulesAppAssortmentBannersRouteRouteChildren =
  {
    AuthModulesAppAssortmentBannersIndexRoute:
      AuthModulesAppAssortmentBannersIndexRoute,
  }

const AuthModulesAppAssortmentBannersRouteRouteWithChildren =
  AuthModulesAppAssortmentBannersRouteRoute._addFileChildren(
    AuthModulesAppAssortmentBannersRouteRouteChildren,
  )

interface AuthModulesAppAssortmentLaunchesRouteRouteChildren {
  AuthModulesAppAssortmentLaunchesLaunchIdRoute: typeof AuthModulesAppAssortmentLaunchesLaunchIdRoute
  AuthModulesAppAssortmentLaunchesIndexRoute: typeof AuthModulesAppAssortmentLaunchesIndexRoute
}

const AuthModulesAppAssortmentLaunchesRouteRouteChildren: AuthModulesAppAssortmentLaunchesRouteRouteChildren =
  {
    AuthModulesAppAssortmentLaunchesLaunchIdRoute:
      AuthModulesAppAssortmentLaunchesLaunchIdRoute,
    AuthModulesAppAssortmentLaunchesIndexRoute:
      AuthModulesAppAssortmentLaunchesIndexRoute,
  }

const AuthModulesAppAssortmentLaunchesRouteRouteWithChildren =
  AuthModulesAppAssortmentLaunchesRouteRoute._addFileChildren(
    AuthModulesAppAssortmentLaunchesRouteRouteChildren,
  )

interface AuthModulesAppAssortmentRouteRouteChildren {
  AuthModulesAppAssortmentActiveRouteRoute: typeof AuthModulesAppAssortmentActiveRouteRouteWithChildren
  AuthModulesAppAssortmentBannersRouteRoute: typeof AuthModulesAppAssortmentBannersRouteRouteWithChildren
  AuthModulesAppAssortmentLaunchesRouteRoute: typeof AuthModulesAppAssortmentLaunchesRouteRouteWithChildren
  AuthModulesAppAssortmentIndexRoute: typeof AuthModulesAppAssortmentIndexRoute
}

const AuthModulesAppAssortmentRouteRouteChildren: AuthModulesAppAssortmentRouteRouteChildren =
  {
    AuthModulesAppAssortmentActiveRouteRoute:
      AuthModulesAppAssortmentActiveRouteRouteWithChildren,
    AuthModulesAppAssortmentBannersRouteRoute:
      AuthModulesAppAssortmentBannersRouteRouteWithChildren,
    AuthModulesAppAssortmentLaunchesRouteRoute:
      AuthModulesAppAssortmentLaunchesRouteRouteWithChildren,
    AuthModulesAppAssortmentIndexRoute: AuthModulesAppAssortmentIndexRoute,
  }

const AuthModulesAppAssortmentRouteRouteWithChildren =
  AuthModulesAppAssortmentRouteRoute._addFileChildren(
    AuthModulesAppAssortmentRouteRouteChildren,
  )

interface AuthModulesAppCoreUploadDataAutoInjectRouteRouteChildren {
  AuthModulesAppCoreUploadDataAutoInjectIndexRoute: typeof AuthModulesAppCoreUploadDataAutoInjectIndexRoute
}

const AuthModulesAppCoreUploadDataAutoInjectRouteRouteChildren: AuthModulesAppCoreUploadDataAutoInjectRouteRouteChildren =
  {
    AuthModulesAppCoreUploadDataAutoInjectIndexRoute:
      AuthModulesAppCoreUploadDataAutoInjectIndexRoute,
  }

const AuthModulesAppCoreUploadDataAutoInjectRouteRouteWithChildren =
  AuthModulesAppCoreUploadDataAutoInjectRouteRoute._addFileChildren(
    AuthModulesAppCoreUploadDataAutoInjectRouteRouteChildren,
  )

interface AuthModulesAppCoreUploadDataBusinessRouteRouteChildren {
  AuthModulesAppCoreUploadDataBusinessIndexRoute: typeof AuthModulesAppCoreUploadDataBusinessIndexRoute
}

const AuthModulesAppCoreUploadDataBusinessRouteRouteChildren: AuthModulesAppCoreUploadDataBusinessRouteRouteChildren =
  {
    AuthModulesAppCoreUploadDataBusinessIndexRoute:
      AuthModulesAppCoreUploadDataBusinessIndexRoute,
  }

const AuthModulesAppCoreUploadDataBusinessRouteRouteWithChildren =
  AuthModulesAppCoreUploadDataBusinessRouteRoute._addFileChildren(
    AuthModulesAppCoreUploadDataBusinessRouteRouteChildren,
  )

interface AuthModulesAppCoreUploadDataMaterialsRouteRouteChildren {
  AuthModulesAppCoreUploadDataMaterialsIndexRoute: typeof AuthModulesAppCoreUploadDataMaterialsIndexRoute
}

const AuthModulesAppCoreUploadDataMaterialsRouteRouteChildren: AuthModulesAppCoreUploadDataMaterialsRouteRouteChildren =
  {
    AuthModulesAppCoreUploadDataMaterialsIndexRoute:
      AuthModulesAppCoreUploadDataMaterialsIndexRoute,
  }

const AuthModulesAppCoreUploadDataMaterialsRouteRouteWithChildren =
  AuthModulesAppCoreUploadDataMaterialsRouteRoute._addFileChildren(
    AuthModulesAppCoreUploadDataMaterialsRouteRouteChildren,
  )

interface AuthModulesAppCoreUploadDataOnHandInventoryRouteRouteChildren {
  AuthModulesAppCoreUploadDataOnHandInventoryIndexRoute: typeof AuthModulesAppCoreUploadDataOnHandInventoryIndexRoute
}

const AuthModulesAppCoreUploadDataOnHandInventoryRouteRouteChildren: AuthModulesAppCoreUploadDataOnHandInventoryRouteRouteChildren =
  {
    AuthModulesAppCoreUploadDataOnHandInventoryIndexRoute:
      AuthModulesAppCoreUploadDataOnHandInventoryIndexRoute,
  }

const AuthModulesAppCoreUploadDataOnHandInventoryRouteRouteWithChildren =
  AuthModulesAppCoreUploadDataOnHandInventoryRouteRoute._addFileChildren(
    AuthModulesAppCoreUploadDataOnHandInventoryRouteRouteChildren,
  )

interface AuthModulesAppCoreUploadDataOperationsRouteRouteChildren {
  AuthModulesAppCoreUploadDataOperationsIndexRoute: typeof AuthModulesAppCoreUploadDataOperationsIndexRoute
}

const AuthModulesAppCoreUploadDataOperationsRouteRouteChildren: AuthModulesAppCoreUploadDataOperationsRouteRouteChildren =
  {
    AuthModulesAppCoreUploadDataOperationsIndexRoute:
      AuthModulesAppCoreUploadDataOperationsIndexRoute,
  }

const AuthModulesAppCoreUploadDataOperationsRouteRouteWithChildren =
  AuthModulesAppCoreUploadDataOperationsRouteRoute._addFileChildren(
    AuthModulesAppCoreUploadDataOperationsRouteRouteChildren,
  )

interface AuthModulesAppCoreUploadDataOrderServiceRouteRouteChildren {
  AuthModulesAppCoreUploadDataOrderServiceIndexRoute: typeof AuthModulesAppCoreUploadDataOrderServiceIndexRoute
}

const AuthModulesAppCoreUploadDataOrderServiceRouteRouteChildren: AuthModulesAppCoreUploadDataOrderServiceRouteRouteChildren =
  {
    AuthModulesAppCoreUploadDataOrderServiceIndexRoute:
      AuthModulesAppCoreUploadDataOrderServiceIndexRoute,
  }

const AuthModulesAppCoreUploadDataOrderServiceRouteRouteWithChildren =
  AuthModulesAppCoreUploadDataOrderServiceRouteRoute._addFileChildren(
    AuthModulesAppCoreUploadDataOrderServiceRouteRouteChildren,
  )

interface AuthModulesAppCoreUploadDataRouteRouteChildren {
  AuthModulesAppCoreUploadDataAutoInjectRouteRoute: typeof AuthModulesAppCoreUploadDataAutoInjectRouteRouteWithChildren
  AuthModulesAppCoreUploadDataBusinessRouteRoute: typeof AuthModulesAppCoreUploadDataBusinessRouteRouteWithChildren
  AuthModulesAppCoreUploadDataMaterialsRouteRoute: typeof AuthModulesAppCoreUploadDataMaterialsRouteRouteWithChildren
  AuthModulesAppCoreUploadDataOnHandInventoryRouteRoute: typeof AuthModulesAppCoreUploadDataOnHandInventoryRouteRouteWithChildren
  AuthModulesAppCoreUploadDataOperationsRouteRoute: typeof AuthModulesAppCoreUploadDataOperationsRouteRouteWithChildren
  AuthModulesAppCoreUploadDataOrderServiceRouteRoute: typeof AuthModulesAppCoreUploadDataOrderServiceRouteRouteWithChildren
  AuthModulesAppCoreUploadDataIndexRoute: typeof AuthModulesAppCoreUploadDataIndexRoute
}

const AuthModulesAppCoreUploadDataRouteRouteChildren: AuthModulesAppCoreUploadDataRouteRouteChildren =
  {
    AuthModulesAppCoreUploadDataAutoInjectRouteRoute:
      AuthModulesAppCoreUploadDataAutoInjectRouteRouteWithChildren,
    AuthModulesAppCoreUploadDataBusinessRouteRoute:
      AuthModulesAppCoreUploadDataBusinessRouteRouteWithChildren,
    AuthModulesAppCoreUploadDataMaterialsRouteRoute:
      AuthModulesAppCoreUploadDataMaterialsRouteRouteWithChildren,
    AuthModulesAppCoreUploadDataOnHandInventoryRouteRoute:
      AuthModulesAppCoreUploadDataOnHandInventoryRouteRouteWithChildren,
    AuthModulesAppCoreUploadDataOperationsRouteRoute:
      AuthModulesAppCoreUploadDataOperationsRouteRouteWithChildren,
    AuthModulesAppCoreUploadDataOrderServiceRouteRoute:
      AuthModulesAppCoreUploadDataOrderServiceRouteRouteWithChildren,
    AuthModulesAppCoreUploadDataIndexRoute:
      AuthModulesAppCoreUploadDataIndexRoute,
  }

const AuthModulesAppCoreUploadDataRouteRouteWithChildren =
  AuthModulesAppCoreUploadDataRouteRoute._addFileChildren(
    AuthModulesAppCoreUploadDataRouteRouteChildren,
  )

interface AuthModulesAppCustomersBannersRouteRouteChildren {
  AuthModulesAppCustomersBannersBannerIdRoute: typeof AuthModulesAppCustomersBannersBannerIdRoute
  AuthModulesAppCustomersBannersIndexRoute: typeof AuthModulesAppCustomersBannersIndexRoute
}

const AuthModulesAppCustomersBannersRouteRouteChildren: AuthModulesAppCustomersBannersRouteRouteChildren =
  {
    AuthModulesAppCustomersBannersBannerIdRoute:
      AuthModulesAppCustomersBannersBannerIdRoute,
    AuthModulesAppCustomersBannersIndexRoute:
      AuthModulesAppCustomersBannersIndexRoute,
  }

const AuthModulesAppCustomersBannersRouteRouteWithChildren =
  AuthModulesAppCustomersBannersRouteRoute._addFileChildren(
    AuthModulesAppCustomersBannersRouteRouteChildren,
  )

interface AuthModulesAppCustomersStoresRouteRouteChildren {
  AuthModulesAppCustomersStoresStoreIdRoute: typeof AuthModulesAppCustomersStoresStoreIdRoute
  AuthModulesAppCustomersStoresIndexRoute: typeof AuthModulesAppCustomersStoresIndexRoute
}

const AuthModulesAppCustomersStoresRouteRouteChildren: AuthModulesAppCustomersStoresRouteRouteChildren =
  {
    AuthModulesAppCustomersStoresStoreIdRoute:
      AuthModulesAppCustomersStoresStoreIdRoute,
    AuthModulesAppCustomersStoresIndexRoute:
      AuthModulesAppCustomersStoresIndexRoute,
  }

const AuthModulesAppCustomersStoresRouteRouteWithChildren =
  AuthModulesAppCustomersStoresRouteRoute._addFileChildren(
    AuthModulesAppCustomersStoresRouteRouteChildren,
  )

interface AuthModulesAppCustomersRouteRouteChildren {
  AuthModulesAppCustomersBannersRouteRoute: typeof AuthModulesAppCustomersBannersRouteRouteWithChildren
  AuthModulesAppCustomersStoresRouteRoute: typeof AuthModulesAppCustomersStoresRouteRouteWithChildren
  AuthModulesAppCustomersIndexRoute: typeof AuthModulesAppCustomersIndexRoute
}

const AuthModulesAppCustomersRouteRouteChildren: AuthModulesAppCustomersRouteRouteChildren =
  {
    AuthModulesAppCustomersBannersRouteRoute:
      AuthModulesAppCustomersBannersRouteRouteWithChildren,
    AuthModulesAppCustomersStoresRouteRoute:
      AuthModulesAppCustomersStoresRouteRouteWithChildren,
    AuthModulesAppCustomersIndexRoute: AuthModulesAppCustomersIndexRoute,
  }

const AuthModulesAppCustomersRouteRouteWithChildren =
  AuthModulesAppCustomersRouteRoute._addFileChildren(
    AuthModulesAppCustomersRouteRouteChildren,
  )

interface AuthModulesAppMaterialsBcpPricedRouteRouteChildren {
  AuthModulesAppMaterialsBcpPricedIndexRoute: typeof AuthModulesAppMaterialsBcpPricedIndexRoute
}

const AuthModulesAppMaterialsBcpPricedRouteRouteChildren: AuthModulesAppMaterialsBcpPricedRouteRouteChildren =
  {
    AuthModulesAppMaterialsBcpPricedIndexRoute:
      AuthModulesAppMaterialsBcpPricedIndexRoute,
  }

const AuthModulesAppMaterialsBcpPricedRouteRouteWithChildren =
  AuthModulesAppMaterialsBcpPricedRouteRoute._addFileChildren(
    AuthModulesAppMaterialsBcpPricedRouteRouteChildren,
  )

interface AuthModulesAppMaterialsRouteRouteChildren {
  AuthModulesAppMaterialsBcpPricedRouteRoute: typeof AuthModulesAppMaterialsBcpPricedRouteRouteWithChildren
  AuthModulesAppMaterialsIndexRoute: typeof AuthModulesAppMaterialsIndexRoute
}

const AuthModulesAppMaterialsRouteRouteChildren: AuthModulesAppMaterialsRouteRouteChildren =
  {
    AuthModulesAppMaterialsBcpPricedRouteRoute:
      AuthModulesAppMaterialsBcpPricedRouteRouteWithChildren,
    AuthModulesAppMaterialsIndexRoute: AuthModulesAppMaterialsIndexRoute,
  }

const AuthModulesAppMaterialsRouteRouteWithChildren =
  AuthModulesAppMaterialsRouteRoute._addFileChildren(
    AuthModulesAppMaterialsRouteRouteChildren,
  )

interface AuthModulesAppMyUploadsRouteRouteChildren {
  AuthModulesAppMyUploadsIndexRoute: typeof AuthModulesAppMyUploadsIndexRoute
  AuthModulesAppMyUploadsScopeFileNameRoute: typeof AuthModulesAppMyUploadsScopeFileNameRoute
}

const AuthModulesAppMyUploadsRouteRouteChildren: AuthModulesAppMyUploadsRouteRouteChildren =
  {
    AuthModulesAppMyUploadsIndexRoute: AuthModulesAppMyUploadsIndexRoute,
    AuthModulesAppMyUploadsScopeFileNameRoute:
      AuthModulesAppMyUploadsScopeFileNameRoute,
  }

const AuthModulesAppMyUploadsRouteRouteWithChildren =
  AuthModulesAppMyUploadsRouteRoute._addFileChildren(
    AuthModulesAppMyUploadsRouteRouteChildren,
  )

interface AuthModulesAppOperationsRouteRouteChildren {
  AuthModulesAppOperationsIndexRoute: typeof AuthModulesAppOperationsIndexRoute
}

const AuthModulesAppOperationsRouteRouteChildren: AuthModulesAppOperationsRouteRouteChildren =
  {
    AuthModulesAppOperationsIndexRoute: AuthModulesAppOperationsIndexRoute,
  }

const AuthModulesAppOperationsRouteRouteWithChildren =
  AuthModulesAppOperationsRouteRoute._addFileChildren(
    AuthModulesAppOperationsRouteRouteChildren,
  )

interface AuthModulesAppOrdersAllRouteRouteChildren {
  AuthModulesAppOrdersAllIndexRoute: typeof AuthModulesAppOrdersAllIndexRoute
  AuthModulesAppOrdersAllDynamoIdPoNumberRoute: typeof AuthModulesAppOrdersAllDynamoIdPoNumberRoute
}

const AuthModulesAppOrdersAllRouteRouteChildren: AuthModulesAppOrdersAllRouteRouteChildren =
  {
    AuthModulesAppOrdersAllIndexRoute: AuthModulesAppOrdersAllIndexRoute,
    AuthModulesAppOrdersAllDynamoIdPoNumberRoute:
      AuthModulesAppOrdersAllDynamoIdPoNumberRoute,
  }

const AuthModulesAppOrdersAllRouteRouteWithChildren =
  AuthModulesAppOrdersAllRouteRoute._addFileChildren(
    AuthModulesAppOrdersAllRouteRouteChildren,
  )

interface AuthModulesAppOrdersFlaggedRouteRouteChildren {
  AuthModulesAppOrdersFlaggedIndexRoute: typeof AuthModulesAppOrdersFlaggedIndexRoute
}

const AuthModulesAppOrdersFlaggedRouteRouteChildren: AuthModulesAppOrdersFlaggedRouteRouteChildren =
  {
    AuthModulesAppOrdersFlaggedIndexRoute:
      AuthModulesAppOrdersFlaggedIndexRoute,
  }

const AuthModulesAppOrdersFlaggedRouteRouteWithChildren =
  AuthModulesAppOrdersFlaggedRouteRoute._addFileChildren(
    AuthModulesAppOrdersFlaggedRouteRouteChildren,
  )

interface AuthModulesAppOrdersMissingRouteRouteChildren {
  AuthModulesAppOrdersMissingIndexRoute: typeof AuthModulesAppOrdersMissingIndexRoute
}

const AuthModulesAppOrdersMissingRouteRouteChildren: AuthModulesAppOrdersMissingRouteRouteChildren =
  {
    AuthModulesAppOrdersMissingIndexRoute:
      AuthModulesAppOrdersMissingIndexRoute,
  }

const AuthModulesAppOrdersMissingRouteRouteWithChildren =
  AuthModulesAppOrdersMissingRouteRoute._addFileChildren(
    AuthModulesAppOrdersMissingRouteRouteChildren,
  )

interface AuthModulesAppOrdersPaymentReviewRouteRouteChildren {
  AuthModulesAppOrdersPaymentReviewIndexRoute: typeof AuthModulesAppOrdersPaymentReviewIndexRoute
}

const AuthModulesAppOrdersPaymentReviewRouteRouteChildren: AuthModulesAppOrdersPaymentReviewRouteRouteChildren =
  {
    AuthModulesAppOrdersPaymentReviewIndexRoute:
      AuthModulesAppOrdersPaymentReviewIndexRoute,
  }

const AuthModulesAppOrdersPaymentReviewRouteRouteWithChildren =
  AuthModulesAppOrdersPaymentReviewRouteRoute._addFileChildren(
    AuthModulesAppOrdersPaymentReviewRouteRouteChildren,
  )

interface AuthModulesAppOrdersReturnsRouteRouteChildren {
  AuthModulesAppOrdersReturnsIndexRoute: typeof AuthModulesAppOrdersReturnsIndexRoute
}

const AuthModulesAppOrdersReturnsRouteRouteChildren: AuthModulesAppOrdersReturnsRouteRouteChildren =
  {
    AuthModulesAppOrdersReturnsIndexRoute:
      AuthModulesAppOrdersReturnsIndexRoute,
  }

const AuthModulesAppOrdersReturnsRouteRouteWithChildren =
  AuthModulesAppOrdersReturnsRouteRoute._addFileChildren(
    AuthModulesAppOrdersReturnsRouteRouteChildren,
  )

interface AuthModulesAppOrdersRouteRouteChildren {
  AuthModulesAppOrdersAllRouteRoute: typeof AuthModulesAppOrdersAllRouteRouteWithChildren
  AuthModulesAppOrdersFlaggedRouteRoute: typeof AuthModulesAppOrdersFlaggedRouteRouteWithChildren
  AuthModulesAppOrdersMissingRouteRoute: typeof AuthModulesAppOrdersMissingRouteRouteWithChildren
  AuthModulesAppOrdersPaymentReviewRouteRoute: typeof AuthModulesAppOrdersPaymentReviewRouteRouteWithChildren
  AuthModulesAppOrdersReturnsRouteRoute: typeof AuthModulesAppOrdersReturnsRouteRouteWithChildren
  AuthModulesAppOrdersIndexRoute: typeof AuthModulesAppOrdersIndexRoute
}

const AuthModulesAppOrdersRouteRouteChildren: AuthModulesAppOrdersRouteRouteChildren =
  {
    AuthModulesAppOrdersAllRouteRoute:
      AuthModulesAppOrdersAllRouteRouteWithChildren,
    AuthModulesAppOrdersFlaggedRouteRoute:
      AuthModulesAppOrdersFlaggedRouteRouteWithChildren,
    AuthModulesAppOrdersMissingRouteRoute:
      AuthModulesAppOrdersMissingRouteRouteWithChildren,
    AuthModulesAppOrdersPaymentReviewRouteRoute:
      AuthModulesAppOrdersPaymentReviewRouteRouteWithChildren,
    AuthModulesAppOrdersReturnsRouteRoute:
      AuthModulesAppOrdersReturnsRouteRouteWithChildren,
    AuthModulesAppOrdersIndexRoute: AuthModulesAppOrdersIndexRoute,
  }

const AuthModulesAppOrdersRouteRouteWithChildren =
  AuthModulesAppOrdersRouteRoute._addFileChildren(
    AuthModulesAppOrdersRouteRouteChildren,
  )

interface AuthModulesAppProcessesPipelinesRouteRouteChildren {
  AuthModulesAppProcessesPipelinesIndexRoute: typeof AuthModulesAppProcessesPipelinesIndexRoute
}

const AuthModulesAppProcessesPipelinesRouteRouteChildren: AuthModulesAppProcessesPipelinesRouteRouteChildren =
  {
    AuthModulesAppProcessesPipelinesIndexRoute:
      AuthModulesAppProcessesPipelinesIndexRoute,
  }

const AuthModulesAppProcessesPipelinesRouteRouteWithChildren =
  AuthModulesAppProcessesPipelinesRouteRoute._addFileChildren(
    AuthModulesAppProcessesPipelinesRouteRouteChildren,
  )

interface AuthModulesAppProcessesRouteRouteChildren {
  AuthModulesAppProcessesPipelinesRouteRoute: typeof AuthModulesAppProcessesPipelinesRouteRouteWithChildren
  AuthModulesAppProcessesIndexRoute: typeof AuthModulesAppProcessesIndexRoute
}

const AuthModulesAppProcessesRouteRouteChildren: AuthModulesAppProcessesRouteRouteChildren =
  {
    AuthModulesAppProcessesPipelinesRouteRoute:
      AuthModulesAppProcessesPipelinesRouteRouteWithChildren,
    AuthModulesAppProcessesIndexRoute: AuthModulesAppProcessesIndexRoute,
  }

const AuthModulesAppProcessesRouteRouteWithChildren =
  AuthModulesAppProcessesRouteRoute._addFileChildren(
    AuthModulesAppProcessesRouteRouteChildren,
  )

interface AuthModulesAppReportsEccRouteRouteChildren {
  AuthModulesAppReportsEccReportIdRoute: typeof AuthModulesAppReportsEccReportIdRoute
  AuthModulesAppReportsEccIndexRoute: typeof AuthModulesAppReportsEccIndexRoute
}

const AuthModulesAppReportsEccRouteRouteChildren: AuthModulesAppReportsEccRouteRouteChildren =
  {
    AuthModulesAppReportsEccReportIdRoute:
      AuthModulesAppReportsEccReportIdRoute,
    AuthModulesAppReportsEccIndexRoute: AuthModulesAppReportsEccIndexRoute,
  }

const AuthModulesAppReportsEccRouteRouteWithChildren =
  AuthModulesAppReportsEccRouteRoute._addFileChildren(
    AuthModulesAppReportsEccRouteRouteChildren,
  )

interface AuthModulesAppReportsMaterialRouteRouteChildren {
  AuthModulesAppReportsMaterialReportIdRoute: typeof AuthModulesAppReportsMaterialReportIdRoute
  AuthModulesAppReportsMaterialIndexRoute: typeof AuthModulesAppReportsMaterialIndexRoute
}

const AuthModulesAppReportsMaterialRouteRouteChildren: AuthModulesAppReportsMaterialRouteRouteChildren =
  {
    AuthModulesAppReportsMaterialReportIdRoute:
      AuthModulesAppReportsMaterialReportIdRoute,
    AuthModulesAppReportsMaterialIndexRoute:
      AuthModulesAppReportsMaterialIndexRoute,
  }

const AuthModulesAppReportsMaterialRouteRouteWithChildren =
  AuthModulesAppReportsMaterialRouteRoute._addFileChildren(
    AuthModulesAppReportsMaterialRouteRouteChildren,
  )

interface AuthModulesAppReportsMiscRouteRouteChildren {
  AuthModulesAppReportsMiscReportIdRoute: typeof AuthModulesAppReportsMiscReportIdRoute
  AuthModulesAppReportsMiscIndexRoute: typeof AuthModulesAppReportsMiscIndexRoute
}

const AuthModulesAppReportsMiscRouteRouteChildren: AuthModulesAppReportsMiscRouteRouteChildren =
  {
    AuthModulesAppReportsMiscReportIdRoute:
      AuthModulesAppReportsMiscReportIdRoute,
    AuthModulesAppReportsMiscIndexRoute: AuthModulesAppReportsMiscIndexRoute,
  }

const AuthModulesAppReportsMiscRouteRouteWithChildren =
  AuthModulesAppReportsMiscRouteRoute._addFileChildren(
    AuthModulesAppReportsMiscRouteRouteChildren,
  )

interface AuthModulesAppReportsOperationsRouteRouteChildren {
  AuthModulesAppReportsOperationsReportIdRoute: typeof AuthModulesAppReportsOperationsReportIdRoute
  AuthModulesAppReportsOperationsIndexRoute: typeof AuthModulesAppReportsOperationsIndexRoute
}

const AuthModulesAppReportsOperationsRouteRouteChildren: AuthModulesAppReportsOperationsRouteRouteChildren =
  {
    AuthModulesAppReportsOperationsReportIdRoute:
      AuthModulesAppReportsOperationsReportIdRoute,
    AuthModulesAppReportsOperationsIndexRoute:
      AuthModulesAppReportsOperationsIndexRoute,
  }

const AuthModulesAppReportsOperationsRouteRouteWithChildren =
  AuthModulesAppReportsOperationsRouteRoute._addFileChildren(
    AuthModulesAppReportsOperationsRouteRouteChildren,
  )

interface AuthModulesAppReportsOrderServiceRouteRouteChildren {
  AuthModulesAppReportsOrderServiceReportIdRoute: typeof AuthModulesAppReportsOrderServiceReportIdRoute
  AuthModulesAppReportsOrderServiceIndexRoute: typeof AuthModulesAppReportsOrderServiceIndexRoute
}

const AuthModulesAppReportsOrderServiceRouteRouteChildren: AuthModulesAppReportsOrderServiceRouteRouteChildren =
  {
    AuthModulesAppReportsOrderServiceReportIdRoute:
      AuthModulesAppReportsOrderServiceReportIdRoute,
    AuthModulesAppReportsOrderServiceIndexRoute:
      AuthModulesAppReportsOrderServiceIndexRoute,
  }

const AuthModulesAppReportsOrderServiceRouteRouteWithChildren =
  AuthModulesAppReportsOrderServiceRouteRoute._addFileChildren(
    AuthModulesAppReportsOrderServiceRouteRouteChildren,
  )

interface AuthModulesAppReportsSalesforceRouteRouteChildren {
  AuthModulesAppReportsSalesforceReportIdRoute: typeof AuthModulesAppReportsSalesforceReportIdRoute
  AuthModulesAppReportsSalesforceIndexRoute: typeof AuthModulesAppReportsSalesforceIndexRoute
}

const AuthModulesAppReportsSalesforceRouteRouteChildren: AuthModulesAppReportsSalesforceRouteRouteChildren =
  {
    AuthModulesAppReportsSalesforceReportIdRoute:
      AuthModulesAppReportsSalesforceReportIdRoute,
    AuthModulesAppReportsSalesforceIndexRoute:
      AuthModulesAppReportsSalesforceIndexRoute,
  }

const AuthModulesAppReportsSalesforceRouteRouteWithChildren =
  AuthModulesAppReportsSalesforceRouteRoute._addFileChildren(
    AuthModulesAppReportsSalesforceRouteRouteChildren,
  )

interface AuthModulesAppReportsRouteRouteChildren {
  AuthModulesAppReportsEccRouteRoute: typeof AuthModulesAppReportsEccRouteRouteWithChildren
  AuthModulesAppReportsMaterialRouteRoute: typeof AuthModulesAppReportsMaterialRouteRouteWithChildren
  AuthModulesAppReportsMiscRouteRoute: typeof AuthModulesAppReportsMiscRouteRouteWithChildren
  AuthModulesAppReportsOperationsRouteRoute: typeof AuthModulesAppReportsOperationsRouteRouteWithChildren
  AuthModulesAppReportsOrderServiceRouteRoute: typeof AuthModulesAppReportsOrderServiceRouteRouteWithChildren
  AuthModulesAppReportsSalesforceRouteRoute: typeof AuthModulesAppReportsSalesforceRouteRouteWithChildren
  AuthModulesAppReportsIndexRoute: typeof AuthModulesAppReportsIndexRoute
}

const AuthModulesAppReportsRouteRouteChildren: AuthModulesAppReportsRouteRouteChildren =
  {
    AuthModulesAppReportsEccRouteRoute:
      AuthModulesAppReportsEccRouteRouteWithChildren,
    AuthModulesAppReportsMaterialRouteRoute:
      AuthModulesAppReportsMaterialRouteRouteWithChildren,
    AuthModulesAppReportsMiscRouteRoute:
      AuthModulesAppReportsMiscRouteRouteWithChildren,
    AuthModulesAppReportsOperationsRouteRoute:
      AuthModulesAppReportsOperationsRouteRouteWithChildren,
    AuthModulesAppReportsOrderServiceRouteRoute:
      AuthModulesAppReportsOrderServiceRouteRouteWithChildren,
    AuthModulesAppReportsSalesforceRouteRoute:
      AuthModulesAppReportsSalesforceRouteRouteWithChildren,
    AuthModulesAppReportsIndexRoute: AuthModulesAppReportsIndexRoute,
  }

const AuthModulesAppReportsRouteRouteWithChildren =
  AuthModulesAppReportsRouteRoute._addFileChildren(
    AuthModulesAppReportsRouteRouteChildren,
  )

interface AuthModulesAppSoxComplianceRouteRouteChildren {
  AuthModulesAppSoxComplianceIndexRoute: typeof AuthModulesAppSoxComplianceIndexRoute
}

const AuthModulesAppSoxComplianceRouteRouteChildren: AuthModulesAppSoxComplianceRouteRouteChildren =
  {
    AuthModulesAppSoxComplianceIndexRoute:
      AuthModulesAppSoxComplianceIndexRoute,
  }

const AuthModulesAppSoxComplianceRouteRouteWithChildren =
  AuthModulesAppSoxComplianceRouteRoute._addFileChildren(
    AuthModulesAppSoxComplianceRouteRouteChildren,
  )

interface AuthModulesAppWelcomeRouteRouteChildren {
  AuthModulesAppWelcomeIndexRoute: typeof AuthModulesAppWelcomeIndexRoute
}

const AuthModulesAppWelcomeRouteRouteChildren: AuthModulesAppWelcomeRouteRouteChildren =
  {
    AuthModulesAppWelcomeIndexRoute: AuthModulesAppWelcomeIndexRoute,
  }

const AuthModulesAppWelcomeRouteRouteWithChildren =
  AuthModulesAppWelcomeRouteRoute._addFileChildren(
    AuthModulesAppWelcomeRouteRouteChildren,
  )

interface AuthModulesAppRouteRouteChildren {
  AuthModulesAppAdminRouteRoute: typeof AuthModulesAppAdminRouteRouteWithChildren
  AuthModulesAppAssortmentRouteRoute: typeof AuthModulesAppAssortmentRouteRouteWithChildren
  AuthModulesAppCoreUploadDataRouteRoute: typeof AuthModulesAppCoreUploadDataRouteRouteWithChildren
  AuthModulesAppCustomersRouteRoute: typeof AuthModulesAppCustomersRouteRouteWithChildren
  AuthModulesAppMaterialsRouteRoute: typeof AuthModulesAppMaterialsRouteRouteWithChildren
  AuthModulesAppMyUploadsRouteRoute: typeof AuthModulesAppMyUploadsRouteRouteWithChildren
  AuthModulesAppOperationsRouteRoute: typeof AuthModulesAppOperationsRouteRouteWithChildren
  AuthModulesAppOrdersRouteRoute: typeof AuthModulesAppOrdersRouteRouteWithChildren
  AuthModulesAppProcessesRouteRoute: typeof AuthModulesAppProcessesRouteRouteWithChildren
  AuthModulesAppReportsRouteRoute: typeof AuthModulesAppReportsRouteRouteWithChildren
  AuthModulesAppSoxComplianceRouteRoute: typeof AuthModulesAppSoxComplianceRouteRouteWithChildren
  AuthModulesAppWelcomeRouteRoute: typeof AuthModulesAppWelcomeRouteRouteWithChildren
}

const AuthModulesAppRouteRouteChildren: AuthModulesAppRouteRouteChildren = {
  AuthModulesAppAdminRouteRoute: AuthModulesAppAdminRouteRouteWithChildren,
  AuthModulesAppAssortmentRouteRoute:
    AuthModulesAppAssortmentRouteRouteWithChildren,
  AuthModulesAppCoreUploadDataRouteRoute:
    AuthModulesAppCoreUploadDataRouteRouteWithChildren,
  AuthModulesAppCustomersRouteRoute:
    AuthModulesAppCustomersRouteRouteWithChildren,
  AuthModulesAppMaterialsRouteRoute:
    AuthModulesAppMaterialsRouteRouteWithChildren,
  AuthModulesAppMyUploadsRouteRoute:
    AuthModulesAppMyUploadsRouteRouteWithChildren,
  AuthModulesAppOperationsRouteRoute:
    AuthModulesAppOperationsRouteRouteWithChildren,
  AuthModulesAppOrdersRouteRoute: AuthModulesAppOrdersRouteRouteWithChildren,
  AuthModulesAppProcessesRouteRoute:
    AuthModulesAppProcessesRouteRouteWithChildren,
  AuthModulesAppReportsRouteRoute: AuthModulesAppReportsRouteRouteWithChildren,
  AuthModulesAppSoxComplianceRouteRoute:
    AuthModulesAppSoxComplianceRouteRouteWithChildren,
  AuthModulesAppWelcomeRouteRoute: AuthModulesAppWelcomeRouteRouteWithChildren,
}

const AuthModulesAppRouteRouteWithChildren =
  AuthModulesAppRouteRoute._addFileChildren(AuthModulesAppRouteRouteChildren)

interface AuthModulesCreditAdminAuditTrailsRouteRouteChildren {
  AuthModulesCreditAdminAuditTrailsIndexRoute: typeof AuthModulesCreditAdminAuditTrailsIndexRoute
}

const AuthModulesCreditAdminAuditTrailsRouteRouteChildren: AuthModulesCreditAdminAuditTrailsRouteRouteChildren =
  {
    AuthModulesCreditAdminAuditTrailsIndexRoute:
      AuthModulesCreditAdminAuditTrailsIndexRoute,
  }

const AuthModulesCreditAdminAuditTrailsRouteRouteWithChildren =
  AuthModulesCreditAdminAuditTrailsRouteRoute._addFileChildren(
    AuthModulesCreditAdminAuditTrailsRouteRouteChildren,
  )

interface AuthModulesCreditAdminInvitationsRouteRouteChildren {
  AuthModulesCreditAdminInvitationsIndexRoute: typeof AuthModulesCreditAdminInvitationsIndexRoute
}

const AuthModulesCreditAdminInvitationsRouteRouteChildren: AuthModulesCreditAdminInvitationsRouteRouteChildren =
  {
    AuthModulesCreditAdminInvitationsIndexRoute:
      AuthModulesCreditAdminInvitationsIndexRoute,
  }

const AuthModulesCreditAdminInvitationsRouteRouteWithChildren =
  AuthModulesCreditAdminInvitationsRouteRoute._addFileChildren(
    AuthModulesCreditAdminInvitationsRouteRouteChildren,
  )

interface AuthModulesCreditAdminRolesRouteRouteChildren {
  AuthModulesCreditAdminRolesIndexRoute: typeof AuthModulesCreditAdminRolesIndexRoute
}

const AuthModulesCreditAdminRolesRouteRouteChildren: AuthModulesCreditAdminRolesRouteRouteChildren =
  {
    AuthModulesCreditAdminRolesIndexRoute:
      AuthModulesCreditAdminRolesIndexRoute,
  }

const AuthModulesCreditAdminRolesRouteRouteWithChildren =
  AuthModulesCreditAdminRolesRouteRoute._addFileChildren(
    AuthModulesCreditAdminRolesRouteRouteChildren,
  )

interface AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRouteChildren {
  AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersIndexRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersIndexRoute
}

const AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRouteChildren: AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRouteChildren =
  {
    AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersIndexRoute:
      AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersIndexRoute,
  }

const AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRouteWithChildren =
  AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRoute._addFileChildren(
    AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRouteChildren,
  )

interface AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRouteChildren {
  AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRouteWithChildren
  AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersIndexRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersIndexRoute
}

const AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRouteChildren: AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRouteChildren =
  {
    AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRoute:
      AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersExceptionPayersRouteRouteWithChildren,
    AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersIndexRoute:
      AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersIndexRoute,
  }

const AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRouteWithChildren =
  AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRoute._addFileChildren(
    AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRouteChildren,
  )

interface AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRouteChildren {
  AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeIndexRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeIndexRoute
}

const AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRouteChildren: AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRouteChildren =
  {
    AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeIndexRoute:
      AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeIndexRoute,
  }

const AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRouteWithChildren =
  AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRoute._addFileChildren(
    AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRouteChildren,
  )

interface AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRouteChildren {
  AuthModulesCreditAdminUsersDelegationOfAuthorityMassIndexRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityMassIndexRoute
}

const AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRouteChildren: AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRouteChildren =
  {
    AuthModulesCreditAdminUsersDelegationOfAuthorityMassIndexRoute:
      AuthModulesCreditAdminUsersDelegationOfAuthorityMassIndexRoute,
  }

const AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRouteWithChildren =
  AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRoute._addFileChildren(
    AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRouteChildren,
  )

interface AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRouteChildren {
  AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationIndexRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationIndexRoute
}

const AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRouteChildren: AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRouteChildren =
  {
    AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationIndexRoute:
      AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationIndexRoute,
  }

const AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRouteWithChildren =
  AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRoute._addFileChildren(
    AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRouteChildren,
  )

interface AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRouteChildren {
  AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationIndexRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationIndexRoute
}

const AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRouteChildren: AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRouteChildren =
  {
    AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationIndexRoute:
      AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationIndexRoute,
  }

const AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRouteWithChildren =
  AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRoute._addFileChildren(
    AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRouteChildren,
  )

interface AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRouteChildren {
  AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRouteWithChildren
  AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRouteWithChildren
  AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRouteWithChildren
  AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRouteWithChildren
  AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRouteWithChildren
  AuthModulesCreditAdminUsersDelegationOfAuthorityIndexRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityIndexRoute
}

const AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRouteChildren: AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRouteChildren =
  {
    AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRoute:
      AuthModulesCreditAdminUsersDelegationOfAuthorityBlockedOrdersRouteRouteWithChildren,
    AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRoute:
      AuthModulesCreditAdminUsersDelegationOfAuthorityInitiativeRouteRouteWithChildren,
    AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRoute:
      AuthModulesCreditAdminUsersDelegationOfAuthorityMassRouteRouteWithChildren,
    AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRoute:
      AuthModulesCreditAdminUsersDelegationOfAuthoritySingleNoDeviationRouteRouteWithChildren,
    AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRoute:
      AuthModulesCreditAdminUsersDelegationOfAuthoritySingleWithDeviationRouteRouteWithChildren,
    AuthModulesCreditAdminUsersDelegationOfAuthorityIndexRoute:
      AuthModulesCreditAdminUsersDelegationOfAuthorityIndexRoute,
  }

const AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRouteWithChildren =
  AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute._addFileChildren(
    AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRouteChildren,
  )

interface AuthModulesCreditAdminUsersRouteRouteChildren {
  AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute: typeof AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRouteWithChildren
  AuthModulesCreditAdminUsersIndexRoute: typeof AuthModulesCreditAdminUsersIndexRoute
}

const AuthModulesCreditAdminUsersRouteRouteChildren: AuthModulesCreditAdminUsersRouteRouteChildren =
  {
    AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRoute:
      AuthModulesCreditAdminUsersDelegationOfAuthorityRouteRouteWithChildren,
    AuthModulesCreditAdminUsersIndexRoute:
      AuthModulesCreditAdminUsersIndexRoute,
  }

const AuthModulesCreditAdminUsersRouteRouteWithChildren =
  AuthModulesCreditAdminUsersRouteRoute._addFileChildren(
    AuthModulesCreditAdminUsersRouteRouteChildren,
  )

interface AuthModulesCreditAdminRouteRouteChildren {
  AuthModulesCreditAdminAuditTrailsRouteRoute: typeof AuthModulesCreditAdminAuditTrailsRouteRouteWithChildren
  AuthModulesCreditAdminInvitationsRouteRoute: typeof AuthModulesCreditAdminInvitationsRouteRouteWithChildren
  AuthModulesCreditAdminRolesRouteRoute: typeof AuthModulesCreditAdminRolesRouteRouteWithChildren
  AuthModulesCreditAdminUsersRouteRoute: typeof AuthModulesCreditAdminUsersRouteRouteWithChildren
  AuthModulesCreditAdminIndexRoute: typeof AuthModulesCreditAdminIndexRoute
}

const AuthModulesCreditAdminRouteRouteChildren: AuthModulesCreditAdminRouteRouteChildren =
  {
    AuthModulesCreditAdminAuditTrailsRouteRoute:
      AuthModulesCreditAdminAuditTrailsRouteRouteWithChildren,
    AuthModulesCreditAdminInvitationsRouteRoute:
      AuthModulesCreditAdminInvitationsRouteRouteWithChildren,
    AuthModulesCreditAdminRolesRouteRoute:
      AuthModulesCreditAdminRolesRouteRouteWithChildren,
    AuthModulesCreditAdminUsersRouteRoute:
      AuthModulesCreditAdminUsersRouteRouteWithChildren,
    AuthModulesCreditAdminIndexRoute: AuthModulesCreditAdminIndexRoute,
  }

const AuthModulesCreditAdminRouteRouteWithChildren =
  AuthModulesCreditAdminRouteRoute._addFileChildren(
    AuthModulesCreditAdminRouteRouteChildren,
  )

interface AuthModulesCreditBlockedOrdersRouteRouteChildren {
  AuthModulesCreditBlockedOrdersIndexRoute: typeof AuthModulesCreditBlockedOrdersIndexRoute
  AuthModulesCreditBlockedOrdersGroupsGroupKeyRoute: typeof AuthModulesCreditBlockedOrdersGroupsGroupKeyRoute
}

const AuthModulesCreditBlockedOrdersRouteRouteChildren: AuthModulesCreditBlockedOrdersRouteRouteChildren =
  {
    AuthModulesCreditBlockedOrdersIndexRoute:
      AuthModulesCreditBlockedOrdersIndexRoute,
    AuthModulesCreditBlockedOrdersGroupsGroupKeyRoute:
      AuthModulesCreditBlockedOrdersGroupsGroupKeyRoute,
  }

const AuthModulesCreditBlockedOrdersRouteRouteWithChildren =
  AuthModulesCreditBlockedOrdersRouteRoute._addFileChildren(
    AuthModulesCreditBlockedOrdersRouteRouteChildren,
  )

interface AuthModulesCreditCreditIndexScoresRouteRouteChildren {
  AuthModulesCreditCreditIndexScoresIndexRoute: typeof AuthModulesCreditCreditIndexScoresIndexRoute
}

const AuthModulesCreditCreditIndexScoresRouteRouteChildren: AuthModulesCreditCreditIndexScoresRouteRouteChildren =
  {
    AuthModulesCreditCreditIndexScoresIndexRoute:
      AuthModulesCreditCreditIndexScoresIndexRoute,
  }

const AuthModulesCreditCreditIndexScoresRouteRouteWithChildren =
  AuthModulesCreditCreditIndexScoresRouteRoute._addFileChildren(
    AuthModulesCreditCreditIndexScoresRouteRouteChildren,
  )

interface AuthModulesCreditCreditLimitReviewsMassRunIdRouteRouteChildren {
  AuthModulesCreditCreditLimitReviewsMassRunIdLinesRoute: typeof AuthModulesCreditCreditLimitReviewsMassRunIdLinesRoute
  AuthModulesCreditCreditLimitReviewsMassRunIdPendingConfirmationsRoute: typeof AuthModulesCreditCreditLimitReviewsMassRunIdPendingConfirmationsRoute
  AuthModulesCreditCreditLimitReviewsMassRunIdSubmitRoute: typeof AuthModulesCreditCreditLimitReviewsMassRunIdSubmitRoute
  AuthModulesCreditCreditLimitReviewsMassRunIdIndexRoute: typeof AuthModulesCreditCreditLimitReviewsMassRunIdIndexRoute
}

const AuthModulesCreditCreditLimitReviewsMassRunIdRouteRouteChildren: AuthModulesCreditCreditLimitReviewsMassRunIdRouteRouteChildren =
  {
    AuthModulesCreditCreditLimitReviewsMassRunIdLinesRoute:
      AuthModulesCreditCreditLimitReviewsMassRunIdLinesRoute,
    AuthModulesCreditCreditLimitReviewsMassRunIdPendingConfirmationsRoute:
      AuthModulesCreditCreditLimitReviewsMassRunIdPendingConfirmationsRoute,
    AuthModulesCreditCreditLimitReviewsMassRunIdSubmitRoute:
      AuthModulesCreditCreditLimitReviewsMassRunIdSubmitRoute,
    AuthModulesCreditCreditLimitReviewsMassRunIdIndexRoute:
      AuthModulesCreditCreditLimitReviewsMassRunIdIndexRoute,
  }

const AuthModulesCreditCreditLimitReviewsMassRunIdRouteRouteWithChildren =
  AuthModulesCreditCreditLimitReviewsMassRunIdRouteRoute._addFileChildren(
    AuthModulesCreditCreditLimitReviewsMassRunIdRouteRouteChildren,
  )

interface AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRouteChildren {
  AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsIndexRoute: typeof AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsIndexRoute
}

const AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRouteChildren: AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRouteChildren =
  {
    AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsIndexRoute:
      AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsIndexRoute,
  }

const AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRouteWithChildren =
  AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRoute._addFileChildren(
    AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRouteChildren,
  )

interface AuthModulesCreditCreditLimitReviewsMassRouteRouteChildren {
  AuthModulesCreditCreditLimitReviewsMassRunIdRouteRoute: typeof AuthModulesCreditCreditLimitReviewsMassRunIdRouteRouteWithChildren
  AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRoute: typeof AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRouteWithChildren
  AuthModulesCreditCreditLimitReviewsMassNewRoute: typeof AuthModulesCreditCreditLimitReviewsMassNewRoute
  AuthModulesCreditCreditLimitReviewsMassIndexRoute: typeof AuthModulesCreditCreditLimitReviewsMassIndexRoute
}

const AuthModulesCreditCreditLimitReviewsMassRouteRouteChildren: AuthModulesCreditCreditLimitReviewsMassRouteRouteChildren =
  {
    AuthModulesCreditCreditLimitReviewsMassRunIdRouteRoute:
      AuthModulesCreditCreditLimitReviewsMassRunIdRouteRouteWithChildren,
    AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRoute:
      AuthModulesCreditCreditLimitReviewsMassPendingConfirmationsRouteRouteWithChildren,
    AuthModulesCreditCreditLimitReviewsMassNewRoute:
      AuthModulesCreditCreditLimitReviewsMassNewRoute,
    AuthModulesCreditCreditLimitReviewsMassIndexRoute:
      AuthModulesCreditCreditLimitReviewsMassIndexRoute,
  }

const AuthModulesCreditCreditLimitReviewsMassRouteRouteWithChildren =
  AuthModulesCreditCreditLimitReviewsMassRouteRoute._addFileChildren(
    AuthModulesCreditCreditLimitReviewsMassRouteRouteChildren,
  )

interface AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRouteChildren {
  AuthModulesCreditCreditLimitReviewsPendingConfirmationsIndexRoute: typeof AuthModulesCreditCreditLimitReviewsPendingConfirmationsIndexRoute
}

const AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRouteChildren: AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRouteChildren =
  {
    AuthModulesCreditCreditLimitReviewsPendingConfirmationsIndexRoute:
      AuthModulesCreditCreditLimitReviewsPendingConfirmationsIndexRoute,
  }

const AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRouteWithChildren =
  AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRoute._addFileChildren(
    AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRouteChildren,
  )

interface AuthModulesCreditCreditLimitReviewsReviewEventsRouteRouteChildren {
  AuthModulesCreditCreditLimitReviewsReviewEventsIndexRoute: typeof AuthModulesCreditCreditLimitReviewsReviewEventsIndexRoute
}

const AuthModulesCreditCreditLimitReviewsReviewEventsRouteRouteChildren: AuthModulesCreditCreditLimitReviewsReviewEventsRouteRouteChildren =
  {
    AuthModulesCreditCreditLimitReviewsReviewEventsIndexRoute:
      AuthModulesCreditCreditLimitReviewsReviewEventsIndexRoute,
  }

const AuthModulesCreditCreditLimitReviewsReviewEventsRouteRouteWithChildren =
  AuthModulesCreditCreditLimitReviewsReviewEventsRouteRoute._addFileChildren(
    AuthModulesCreditCreditLimitReviewsReviewEventsRouteRouteChildren,
  )

interface AuthModulesCreditCreditLimitReviewsRouteRouteChildren {
  AuthModulesCreditCreditLimitReviewsMassRouteRoute: typeof AuthModulesCreditCreditLimitReviewsMassRouteRouteWithChildren
  AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRoute: typeof AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRouteWithChildren
  AuthModulesCreditCreditLimitReviewsReviewEventsRouteRoute: typeof AuthModulesCreditCreditLimitReviewsReviewEventsRouteRouteWithChildren
  AuthModulesCreditCreditLimitReviewsReviewIdRoute: typeof AuthModulesCreditCreditLimitReviewsReviewIdRoute
  AuthModulesCreditCreditLimitReviewsIndexRoute: typeof AuthModulesCreditCreditLimitReviewsIndexRoute
}

const AuthModulesCreditCreditLimitReviewsRouteRouteChildren: AuthModulesCreditCreditLimitReviewsRouteRouteChildren =
  {
    AuthModulesCreditCreditLimitReviewsMassRouteRoute:
      AuthModulesCreditCreditLimitReviewsMassRouteRouteWithChildren,
    AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRoute:
      AuthModulesCreditCreditLimitReviewsPendingConfirmationsRouteRouteWithChildren,
    AuthModulesCreditCreditLimitReviewsReviewEventsRouteRoute:
      AuthModulesCreditCreditLimitReviewsReviewEventsRouteRouteWithChildren,
    AuthModulesCreditCreditLimitReviewsReviewIdRoute:
      AuthModulesCreditCreditLimitReviewsReviewIdRoute,
    AuthModulesCreditCreditLimitReviewsIndexRoute:
      AuthModulesCreditCreditLimitReviewsIndexRoute,
  }

const AuthModulesCreditCreditLimitReviewsRouteRouteWithChildren =
  AuthModulesCreditCreditLimitReviewsRouteRoute._addFileChildren(
    AuthModulesCreditCreditLimitReviewsRouteRouteChildren,
  )

interface AuthModulesCreditCustomersErpRouteRouteChildren {
  AuthModulesCreditCustomersErpPrepareClrRoute: typeof AuthModulesCreditCustomersErpPrepareClrRoute
  AuthModulesCreditCustomersErpIndexRoute: typeof AuthModulesCreditCustomersErpIndexRoute
}

const AuthModulesCreditCustomersErpRouteRouteChildren: AuthModulesCreditCustomersErpRouteRouteChildren =
  {
    AuthModulesCreditCustomersErpPrepareClrRoute:
      AuthModulesCreditCustomersErpPrepareClrRoute,
    AuthModulesCreditCustomersErpIndexRoute:
      AuthModulesCreditCustomersErpIndexRoute,
  }

const AuthModulesCreditCustomersErpRouteRouteWithChildren =
  AuthModulesCreditCustomersErpRouteRoute._addFileChildren(
    AuthModulesCreditCustomersErpRouteRouteChildren,
  )

interface AuthModulesCreditCustomersRouteRouteChildren {
  AuthModulesCreditCustomersErpRouteRoute: typeof AuthModulesCreditCustomersErpRouteRouteWithChildren
  AuthModulesCreditCustomersIndexRoute: typeof AuthModulesCreditCustomersIndexRoute
}

const AuthModulesCreditCustomersRouteRouteChildren: AuthModulesCreditCustomersRouteRouteChildren =
  {
    AuthModulesCreditCustomersErpRouteRoute:
      AuthModulesCreditCustomersErpRouteRouteWithChildren,
    AuthModulesCreditCustomersIndexRoute: AuthModulesCreditCustomersIndexRoute,
  }

const AuthModulesCreditCustomersRouteRouteWithChildren =
  AuthModulesCreditCustomersRouteRoute._addFileChildren(
    AuthModulesCreditCustomersRouteRouteChildren,
  )

interface AuthModulesCreditGoogleFinancialStatementsRouteRouteChildren {
  AuthModulesCreditGoogleFinancialStatementsSapErpRoute: typeof AuthModulesCreditGoogleFinancialStatementsSapErpRoute
  AuthModulesCreditGoogleFinancialStatementsIndexRoute: typeof AuthModulesCreditGoogleFinancialStatementsIndexRoute
}

const AuthModulesCreditGoogleFinancialStatementsRouteRouteChildren: AuthModulesCreditGoogleFinancialStatementsRouteRouteChildren =
  {
    AuthModulesCreditGoogleFinancialStatementsSapErpRoute:
      AuthModulesCreditGoogleFinancialStatementsSapErpRoute,
    AuthModulesCreditGoogleFinancialStatementsIndexRoute:
      AuthModulesCreditGoogleFinancialStatementsIndexRoute,
  }

const AuthModulesCreditGoogleFinancialStatementsRouteRouteWithChildren =
  AuthModulesCreditGoogleFinancialStatementsRouteRoute._addFileChildren(
    AuthModulesCreditGoogleFinancialStatementsRouteRouteChildren,
  )

interface AuthModulesCreditInboxRouteRouteChildren {
  AuthModulesCreditInboxIndexRoute: typeof AuthModulesCreditInboxIndexRoute
}

const AuthModulesCreditInboxRouteRouteChildren: AuthModulesCreditInboxRouteRouteChildren =
  {
    AuthModulesCreditInboxIndexRoute: AuthModulesCreditInboxIndexRoute,
  }

const AuthModulesCreditInboxRouteRouteWithChildren =
  AuthModulesCreditInboxRouteRoute._addFileChildren(
    AuthModulesCreditInboxRouteRouteChildren,
  )

interface AuthModulesCreditInitiativesRouteRouteChildren {
  AuthModulesCreditInitiativesIdRoute: typeof AuthModulesCreditInitiativesIdRoute
  AuthModulesCreditInitiativesIndexRoute: typeof AuthModulesCreditInitiativesIndexRoute
}

const AuthModulesCreditInitiativesRouteRouteChildren: AuthModulesCreditInitiativesRouteRouteChildren =
  {
    AuthModulesCreditInitiativesIdRoute: AuthModulesCreditInitiativesIdRoute,
    AuthModulesCreditInitiativesIndexRoute:
      AuthModulesCreditInitiativesIndexRoute,
  }

const AuthModulesCreditInitiativesRouteRouteWithChildren =
  AuthModulesCreditInitiativesRouteRoute._addFileChildren(
    AuthModulesCreditInitiativesRouteRouteChildren,
  )

interface AuthModulesCreditMyExportsRouteRouteChildren {
  AuthModulesCreditMyExportsIndexRoute: typeof AuthModulesCreditMyExportsIndexRoute
}

const AuthModulesCreditMyExportsRouteRouteChildren: AuthModulesCreditMyExportsRouteRouteChildren =
  {
    AuthModulesCreditMyExportsIndexRoute: AuthModulesCreditMyExportsIndexRoute,
  }

const AuthModulesCreditMyExportsRouteRouteWithChildren =
  AuthModulesCreditMyExportsRouteRoute._addFileChildren(
    AuthModulesCreditMyExportsRouteRouteChildren,
  )

interface AuthModulesCreditMyUploadsRouteRouteChildren {
  AuthModulesCreditMyUploadsIndexRoute: typeof AuthModulesCreditMyUploadsIndexRoute
  AuthModulesCreditMyUploadsScopeFileNameRoute: typeof AuthModulesCreditMyUploadsScopeFileNameRoute
}

const AuthModulesCreditMyUploadsRouteRouteChildren: AuthModulesCreditMyUploadsRouteRouteChildren =
  {
    AuthModulesCreditMyUploadsIndexRoute: AuthModulesCreditMyUploadsIndexRoute,
    AuthModulesCreditMyUploadsScopeFileNameRoute:
      AuthModulesCreditMyUploadsScopeFileNameRoute,
  }

const AuthModulesCreditMyUploadsRouteRouteWithChildren =
  AuthModulesCreditMyUploadsRouteRoute._addFileChildren(
    AuthModulesCreditMyUploadsRouteRouteChildren,
  )

interface AuthModulesCreditOperationsMultiplierRouteRouteChildren {
  AuthModulesCreditOperationsMultiplierIndexRoute: typeof AuthModulesCreditOperationsMultiplierIndexRoute
}

const AuthModulesCreditOperationsMultiplierRouteRouteChildren: AuthModulesCreditOperationsMultiplierRouteRouteChildren =
  {
    AuthModulesCreditOperationsMultiplierIndexRoute:
      AuthModulesCreditOperationsMultiplierIndexRoute,
  }

const AuthModulesCreditOperationsMultiplierRouteRouteWithChildren =
  AuthModulesCreditOperationsMultiplierRouteRoute._addFileChildren(
    AuthModulesCreditOperationsMultiplierRouteRouteChildren,
  )

interface AuthModulesCreditOperationsOrderCutoffsRouteRouteChildren {
  AuthModulesCreditOperationsOrderCutoffsIndexRoute: typeof AuthModulesCreditOperationsOrderCutoffsIndexRoute
}

const AuthModulesCreditOperationsOrderCutoffsRouteRouteChildren: AuthModulesCreditOperationsOrderCutoffsRouteRouteChildren =
  {
    AuthModulesCreditOperationsOrderCutoffsIndexRoute:
      AuthModulesCreditOperationsOrderCutoffsIndexRoute,
  }

const AuthModulesCreditOperationsOrderCutoffsRouteRouteWithChildren =
  AuthModulesCreditOperationsOrderCutoffsRouteRoute._addFileChildren(
    AuthModulesCreditOperationsOrderCutoffsRouteRouteChildren,
  )

interface AuthModulesCreditOperationsProvinceAovPerCartonRouteRouteChildren {
  AuthModulesCreditOperationsProvinceAovPerCartonIndexRoute: typeof AuthModulesCreditOperationsProvinceAovPerCartonIndexRoute
}

const AuthModulesCreditOperationsProvinceAovPerCartonRouteRouteChildren: AuthModulesCreditOperationsProvinceAovPerCartonRouteRouteChildren =
  {
    AuthModulesCreditOperationsProvinceAovPerCartonIndexRoute:
      AuthModulesCreditOperationsProvinceAovPerCartonIndexRoute,
  }

const AuthModulesCreditOperationsProvinceAovPerCartonRouteRouteWithChildren =
  AuthModulesCreditOperationsProvinceAovPerCartonRouteRoute._addFileChildren(
    AuthModulesCreditOperationsProvinceAovPerCartonRouteRouteChildren,
  )

interface AuthModulesCreditOperationsVeryLowRiskCustomersRouteRouteChildren {
  AuthModulesCreditOperationsVeryLowRiskCustomersIndexRoute: typeof AuthModulesCreditOperationsVeryLowRiskCustomersIndexRoute
}

const AuthModulesCreditOperationsVeryLowRiskCustomersRouteRouteChildren: AuthModulesCreditOperationsVeryLowRiskCustomersRouteRouteChildren =
  {
    AuthModulesCreditOperationsVeryLowRiskCustomersIndexRoute:
      AuthModulesCreditOperationsVeryLowRiskCustomersIndexRoute,
  }

const AuthModulesCreditOperationsVeryLowRiskCustomersRouteRouteWithChildren =
  AuthModulesCreditOperationsVeryLowRiskCustomersRouteRoute._addFileChildren(
    AuthModulesCreditOperationsVeryLowRiskCustomersRouteRouteChildren,
  )

interface AuthModulesCreditOperationsRouteRouteChildren {
  AuthModulesCreditOperationsMultiplierRouteRoute: typeof AuthModulesCreditOperationsMultiplierRouteRouteWithChildren
  AuthModulesCreditOperationsOrderCutoffsRouteRoute: typeof AuthModulesCreditOperationsOrderCutoffsRouteRouteWithChildren
  AuthModulesCreditOperationsProvinceAovPerCartonRouteRoute: typeof AuthModulesCreditOperationsProvinceAovPerCartonRouteRouteWithChildren
  AuthModulesCreditOperationsVeryLowRiskCustomersRouteRoute: typeof AuthModulesCreditOperationsVeryLowRiskCustomersRouteRouteWithChildren
  AuthModulesCreditOperationsIndexRoute: typeof AuthModulesCreditOperationsIndexRoute
}

const AuthModulesCreditOperationsRouteRouteChildren: AuthModulesCreditOperationsRouteRouteChildren =
  {
    AuthModulesCreditOperationsMultiplierRouteRoute:
      AuthModulesCreditOperationsMultiplierRouteRouteWithChildren,
    AuthModulesCreditOperationsOrderCutoffsRouteRoute:
      AuthModulesCreditOperationsOrderCutoffsRouteRouteWithChildren,
    AuthModulesCreditOperationsProvinceAovPerCartonRouteRoute:
      AuthModulesCreditOperationsProvinceAovPerCartonRouteRouteWithChildren,
    AuthModulesCreditOperationsVeryLowRiskCustomersRouteRoute:
      AuthModulesCreditOperationsVeryLowRiskCustomersRouteRouteWithChildren,
    AuthModulesCreditOperationsIndexRoute:
      AuthModulesCreditOperationsIndexRoute,
  }

const AuthModulesCreditOperationsRouteRouteWithChildren =
  AuthModulesCreditOperationsRouteRoute._addFileChildren(
    AuthModulesCreditOperationsRouteRouteChildren,
  )

interface AuthModulesCreditWelcomeRouteRouteChildren {
  AuthModulesCreditWelcomeIndexRoute: typeof AuthModulesCreditWelcomeIndexRoute
}

const AuthModulesCreditWelcomeRouteRouteChildren: AuthModulesCreditWelcomeRouteRouteChildren =
  {
    AuthModulesCreditWelcomeIndexRoute: AuthModulesCreditWelcomeIndexRoute,
  }

const AuthModulesCreditWelcomeRouteRouteWithChildren =
  AuthModulesCreditWelcomeRouteRoute._addFileChildren(
    AuthModulesCreditWelcomeRouteRouteChildren,
  )

interface AuthModulesCreditRouteRouteChildren {
  AuthModulesCreditAdminRouteRoute: typeof AuthModulesCreditAdminRouteRouteWithChildren
  AuthModulesCreditBlockedOrdersRouteRoute: typeof AuthModulesCreditBlockedOrdersRouteRouteWithChildren
  AuthModulesCreditCreditIndexScoresRouteRoute: typeof AuthModulesCreditCreditIndexScoresRouteRouteWithChildren
  AuthModulesCreditCreditLimitReviewsRouteRoute: typeof AuthModulesCreditCreditLimitReviewsRouteRouteWithChildren
  AuthModulesCreditCustomersRouteRoute: typeof AuthModulesCreditCustomersRouteRouteWithChildren
  AuthModulesCreditGoogleFinancialStatementsRouteRoute: typeof AuthModulesCreditGoogleFinancialStatementsRouteRouteWithChildren
  AuthModulesCreditInboxRouteRoute: typeof AuthModulesCreditInboxRouteRouteWithChildren
  AuthModulesCreditInitiativesRouteRoute: typeof AuthModulesCreditInitiativesRouteRouteWithChildren
  AuthModulesCreditMyExportsRouteRoute: typeof AuthModulesCreditMyExportsRouteRouteWithChildren
  AuthModulesCreditMyUploadsRouteRoute: typeof AuthModulesCreditMyUploadsRouteRouteWithChildren
  AuthModulesCreditOperationsRouteRoute: typeof AuthModulesCreditOperationsRouteRouteWithChildren
  AuthModulesCreditWelcomeRouteRoute: typeof AuthModulesCreditWelcomeRouteRouteWithChildren
}

const AuthModulesCreditRouteRouteChildren: AuthModulesCreditRouteRouteChildren =
  {
    AuthModulesCreditAdminRouteRoute:
      AuthModulesCreditAdminRouteRouteWithChildren,
    AuthModulesCreditBlockedOrdersRouteRoute:
      AuthModulesCreditBlockedOrdersRouteRouteWithChildren,
    AuthModulesCreditCreditIndexScoresRouteRoute:
      AuthModulesCreditCreditIndexScoresRouteRouteWithChildren,
    AuthModulesCreditCreditLimitReviewsRouteRoute:
      AuthModulesCreditCreditLimitReviewsRouteRouteWithChildren,
    AuthModulesCreditCustomersRouteRoute:
      AuthModulesCreditCustomersRouteRouteWithChildren,
    AuthModulesCreditGoogleFinancialStatementsRouteRoute:
      AuthModulesCreditGoogleFinancialStatementsRouteRouteWithChildren,
    AuthModulesCreditInboxRouteRoute:
      AuthModulesCreditInboxRouteRouteWithChildren,
    AuthModulesCreditInitiativesRouteRoute:
      AuthModulesCreditInitiativesRouteRouteWithChildren,
    AuthModulesCreditMyExportsRouteRoute:
      AuthModulesCreditMyExportsRouteRouteWithChildren,
    AuthModulesCreditMyUploadsRouteRoute:
      AuthModulesCreditMyUploadsRouteRouteWithChildren,
    AuthModulesCreditOperationsRouteRoute:
      AuthModulesCreditOperationsRouteRouteWithChildren,
    AuthModulesCreditWelcomeRouteRoute:
      AuthModulesCreditWelcomeRouteRouteWithChildren,
  }

const AuthModulesCreditRouteRouteWithChildren =
  AuthModulesCreditRouteRoute._addFileChildren(
    AuthModulesCreditRouteRouteChildren,
  )

interface AuthModulesCrtAdminAuditTrailsRouteRouteChildren {
  AuthModulesCrtAdminAuditTrailsIndexRoute: typeof AuthModulesCrtAdminAuditTrailsIndexRoute
}

const AuthModulesCrtAdminAuditTrailsRouteRouteChildren: AuthModulesCrtAdminAuditTrailsRouteRouteChildren =
  {
    AuthModulesCrtAdminAuditTrailsIndexRoute:
      AuthModulesCrtAdminAuditTrailsIndexRoute,
  }

const AuthModulesCrtAdminAuditTrailsRouteRouteWithChildren =
  AuthModulesCrtAdminAuditTrailsRouteRoute._addFileChildren(
    AuthModulesCrtAdminAuditTrailsRouteRouteChildren,
  )

interface AuthModulesCrtAdminInvitationsRouteRouteChildren {
  AuthModulesCrtAdminInvitationsIndexRoute: typeof AuthModulesCrtAdminInvitationsIndexRoute
}

const AuthModulesCrtAdminInvitationsRouteRouteChildren: AuthModulesCrtAdminInvitationsRouteRouteChildren =
  {
    AuthModulesCrtAdminInvitationsIndexRoute:
      AuthModulesCrtAdminInvitationsIndexRoute,
  }

const AuthModulesCrtAdminInvitationsRouteRouteWithChildren =
  AuthModulesCrtAdminInvitationsRouteRoute._addFileChildren(
    AuthModulesCrtAdminInvitationsRouteRouteChildren,
  )

interface AuthModulesCrtAdminNotificationsRouteRouteChildren {
  AuthModulesCrtAdminNotificationsIndexRoute: typeof AuthModulesCrtAdminNotificationsIndexRoute
}

const AuthModulesCrtAdminNotificationsRouteRouteChildren: AuthModulesCrtAdminNotificationsRouteRouteChildren =
  {
    AuthModulesCrtAdminNotificationsIndexRoute:
      AuthModulesCrtAdminNotificationsIndexRoute,
  }

const AuthModulesCrtAdminNotificationsRouteRouteWithChildren =
  AuthModulesCrtAdminNotificationsRouteRoute._addFileChildren(
    AuthModulesCrtAdminNotificationsRouteRouteChildren,
  )

interface AuthModulesCrtAdminRolesRouteRouteChildren {
  AuthModulesCrtAdminRolesIndexRoute: typeof AuthModulesCrtAdminRolesIndexRoute
}

const AuthModulesCrtAdminRolesRouteRouteChildren: AuthModulesCrtAdminRolesRouteRouteChildren =
  {
    AuthModulesCrtAdminRolesIndexRoute: AuthModulesCrtAdminRolesIndexRoute,
  }

const AuthModulesCrtAdminRolesRouteRouteWithChildren =
  AuthModulesCrtAdminRolesRouteRoute._addFileChildren(
    AuthModulesCrtAdminRolesRouteRouteChildren,
  )

interface AuthModulesCrtAdminUsersRouteRouteChildren {
  AuthModulesCrtAdminUsersIndexRoute: typeof AuthModulesCrtAdminUsersIndexRoute
}

const AuthModulesCrtAdminUsersRouteRouteChildren: AuthModulesCrtAdminUsersRouteRouteChildren =
  {
    AuthModulesCrtAdminUsersIndexRoute: AuthModulesCrtAdminUsersIndexRoute,
  }

const AuthModulesCrtAdminUsersRouteRouteWithChildren =
  AuthModulesCrtAdminUsersRouteRoute._addFileChildren(
    AuthModulesCrtAdminUsersRouteRouteChildren,
  )

interface AuthModulesCrtAdminRouteRouteChildren {
  AuthModulesCrtAdminAuditTrailsRouteRoute: typeof AuthModulesCrtAdminAuditTrailsRouteRouteWithChildren
  AuthModulesCrtAdminInvitationsRouteRoute: typeof AuthModulesCrtAdminInvitationsRouteRouteWithChildren
  AuthModulesCrtAdminNotificationsRouteRoute: typeof AuthModulesCrtAdminNotificationsRouteRouteWithChildren
  AuthModulesCrtAdminRolesRouteRoute: typeof AuthModulesCrtAdminRolesRouteRouteWithChildren
  AuthModulesCrtAdminUsersRouteRoute: typeof AuthModulesCrtAdminUsersRouteRouteWithChildren
  AuthModulesCrtAdminIndexRoute: typeof AuthModulesCrtAdminIndexRoute
}

const AuthModulesCrtAdminRouteRouteChildren: AuthModulesCrtAdminRouteRouteChildren =
  {
    AuthModulesCrtAdminAuditTrailsRouteRoute:
      AuthModulesCrtAdminAuditTrailsRouteRouteWithChildren,
    AuthModulesCrtAdminInvitationsRouteRoute:
      AuthModulesCrtAdminInvitationsRouteRouteWithChildren,
    AuthModulesCrtAdminNotificationsRouteRoute:
      AuthModulesCrtAdminNotificationsRouteRouteWithChildren,
    AuthModulesCrtAdminRolesRouteRoute:
      AuthModulesCrtAdminRolesRouteRouteWithChildren,
    AuthModulesCrtAdminUsersRouteRoute:
      AuthModulesCrtAdminUsersRouteRouteWithChildren,
    AuthModulesCrtAdminIndexRoute: AuthModulesCrtAdminIndexRoute,
  }

const AuthModulesCrtAdminRouteRouteWithChildren =
  AuthModulesCrtAdminRouteRoute._addFileChildren(
    AuthModulesCrtAdminRouteRouteChildren,
  )

interface AuthModulesCrtAzureImportsRouteRouteChildren {
  AuthModulesCrtAzureImportsIndexRoute: typeof AuthModulesCrtAzureImportsIndexRoute
}

const AuthModulesCrtAzureImportsRouteRouteChildren: AuthModulesCrtAzureImportsRouteRouteChildren =
  {
    AuthModulesCrtAzureImportsIndexRoute: AuthModulesCrtAzureImportsIndexRoute,
  }

const AuthModulesCrtAzureImportsRouteRouteWithChildren =
  AuthModulesCrtAzureImportsRouteRoute._addFileChildren(
    AuthModulesCrtAzureImportsRouteRouteChildren,
  )

interface AuthModulesCrtBpcActualsRouteRouteChildren {
  AuthModulesCrtBpcActualsYearRoute: typeof AuthModulesCrtBpcActualsYearRoute
  AuthModulesCrtBpcActualsIndexRoute: typeof AuthModulesCrtBpcActualsIndexRoute
}

const AuthModulesCrtBpcActualsRouteRouteChildren: AuthModulesCrtBpcActualsRouteRouteChildren =
  {
    AuthModulesCrtBpcActualsYearRoute: AuthModulesCrtBpcActualsYearRoute,
    AuthModulesCrtBpcActualsIndexRoute: AuthModulesCrtBpcActualsIndexRoute,
  }

const AuthModulesCrtBpcActualsRouteRouteWithChildren =
  AuthModulesCrtBpcActualsRouteRoute._addFileChildren(
    AuthModulesCrtBpcActualsRouteRouteChildren,
  )

interface AuthModulesCrtCostOfGoodsRouteRouteChildren {
  AuthModulesCrtCostOfGoodsIndexRoute: typeof AuthModulesCrtCostOfGoodsIndexRoute
  AuthModulesCrtCostOfGoodsYearMonthRoute: typeof AuthModulesCrtCostOfGoodsYearMonthRoute
}

const AuthModulesCrtCostOfGoodsRouteRouteChildren: AuthModulesCrtCostOfGoodsRouteRouteChildren =
  {
    AuthModulesCrtCostOfGoodsIndexRoute: AuthModulesCrtCostOfGoodsIndexRoute,
    AuthModulesCrtCostOfGoodsYearMonthRoute:
      AuthModulesCrtCostOfGoodsYearMonthRoute,
  }

const AuthModulesCrtCostOfGoodsRouteRouteWithChildren =
  AuthModulesCrtCostOfGoodsRouteRoute._addFileChildren(
    AuthModulesCrtCostOfGoodsRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsBudgetTrackerIndexRoute: typeof AuthModulesCrtCustomerInvestmentsBudgetTrackerIndexRoute
}

const AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRouteChildren: AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsBudgetTrackerIndexRoute:
      AuthModulesCrtCustomerInvestmentsBudgetTrackerIndexRoute,
  }

const AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInsightsAgreementsIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsAgreementsIndexRoute
}

const AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInsightsAgreementsIndexRoute:
      AuthModulesCrtCustomerInvestmentsInsightsAgreementsIndexRoute,
  }

const AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsIndexRoute
}

const AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsIndexRoute:
      AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsIndexRoute,
  }

const AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsIndexRoute
  AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsYearMonthRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsYearMonthRoute
}

const AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsIndexRoute:
      AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsIndexRoute,
    AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsYearMonthRoute:
      AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsYearMonthRoute,
  }

const AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixBannerMixRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixBannerMixRoute
  AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixIndexRoute
  AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixYearMonthRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixYearMonthRoute
}

const AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixBannerMixRoute:
      AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixBannerMixRoute,
    AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixIndexRoute:
      AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixIndexRoute,
    AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixYearMonthRoute:
      AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixYearMonthRoute,
  }

const AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsIndexRoute
  AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsYearMonthRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsYearMonthRoute
}

const AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsIndexRoute:
      AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsIndexRoute,
    AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsYearMonthRoute:
      AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsYearMonthRoute,
  }

const AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsManualInvestmentIdRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsManualInvestmentIdRoute
  AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsIndexRoute
}

const AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsManualInvestmentIdRoute:
      AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsManualInvestmentIdRoute,
    AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsIndexRoute:
      AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsIndexRoute,
  }

const AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsIndexRoute
}

const AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsIndexRoute:
      AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsIndexRoute,
  }

const AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInsightsRapForecastsIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsIndexRoute
  AuthModulesCrtCustomerInvestmentsInsightsRapForecastsYearMonthRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsYearMonthRoute
}

const AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInsightsRapForecastsIndexRoute:
      AuthModulesCrtCustomerInvestmentsInsightsRapForecastsIndexRoute,
    AuthModulesCrtCustomerInvestmentsInsightsRapForecastsYearMonthRoute:
      AuthModulesCrtCustomerInvestmentsInsightsRapForecastsYearMonthRoute,
  }

const AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsIndexRoute
  AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsYearMonthRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsYearMonthRoute
}

const AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsIndexRoute:
      AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsIndexRoute,
    AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsYearMonthRoute:
      AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsYearMonthRoute,
  }

const AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcIndexRoute
}

const AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcIndexRoute:
      AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcIndexRoute,
  }

const AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcIndexRoute
}

const AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcIndexRoute:
      AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcIndexRoute,
  }

const AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcIndexRoute
}

const AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcIndexRoute:
      AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcIndexRoute,
  }

const AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcIndexRoute
}

const AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcIndexRoute:
      AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcIndexRoute,
  }

const AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInsightsRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsInsightsIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsIndexRoute
  AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRouteWithChildren
}

const AuthModulesCrtCustomerInvestmentsInsightsRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInsightsRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRoute:
      AuthModulesCrtCustomerInvestmentsInsightsAgreementsRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRoute:
      AuthModulesCrtCustomerInvestmentsInsightsBudgetAllocationsRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRoute:
      AuthModulesCrtCustomerInvestmentsInsightsCalculationRunAccrualsRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRoute:
      AuthModulesCrtCustomerInvestmentsInsightsDistributionMarginMixRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRoute:
      AuthModulesCrtCustomerInvestmentsInsightsIpAccrualsRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRoute:
      AuthModulesCrtCustomerInvestmentsInsightsManualInvestmentsRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRoute:
      AuthModulesCrtCustomerInvestmentsInsightsMasterAgreementsRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRoute:
      AuthModulesCrtCustomerInvestmentsInsightsRapForecastsRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRoute:
      AuthModulesCrtCustomerInvestmentsInsightsSalesDealActualsRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsInsightsIndexRoute:
      AuthModulesCrtCustomerInvestmentsInsightsIndexRoute,
    AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRoute:
      AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsFmcRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRoute:
      AuthModulesCrtCustomerInvestmentsInsightsRetailerMarginsNcRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRoute:
      AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsFmcRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRoute:
      AuthModulesCrtCustomerInvestmentsInsightsWholesalerMarginsNcRouteRouteWithChildren,
  }

const AuthModulesCrtCustomerInvestmentsInsightsRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInsightsRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInsightsRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsInvestmentsRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsInvestmentsIndexRoute: typeof AuthModulesCrtCustomerInvestmentsInvestmentsIndexRoute
}

const AuthModulesCrtCustomerInvestmentsInvestmentsRouteRouteChildren: AuthModulesCrtCustomerInvestmentsInvestmentsRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsInvestmentsIndexRoute:
      AuthModulesCrtCustomerInvestmentsInvestmentsIndexRoute,
  }

const AuthModulesCrtCustomerInvestmentsInvestmentsRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsInvestmentsRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsInvestmentsRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesIndexRoute: typeof AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesIndexRoute
}

const AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRouteChildren: AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesIndexRoute:
      AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesIndexRoute,
  }

const AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRoute: typeof AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsKeyAccountsIndexRoute: typeof AuthModulesCrtCustomerInvestmentsKeyAccountsIndexRoute
}

const AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRouteChildren: AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRoute:
      AuthModulesCrtCustomerInvestmentsKeyAccountsEstimatesRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsKeyAccountsIndexRoute:
      AuthModulesCrtCustomerInvestmentsKeyAccountsIndexRoute,
  }

const AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRouteChildren,
  )

interface AuthModulesCrtCustomerInvestmentsRouteRouteChildren {
  AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRoute: typeof AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsInsightsRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInsightsRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsInvestmentsRouteRoute: typeof AuthModulesCrtCustomerInvestmentsInvestmentsRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRoute: typeof AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsIndexRoute: typeof AuthModulesCrtCustomerInvestmentsIndexRoute
}

const AuthModulesCrtCustomerInvestmentsRouteRouteChildren: AuthModulesCrtCustomerInvestmentsRouteRouteChildren =
  {
    AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRoute:
      AuthModulesCrtCustomerInvestmentsBudgetTrackerRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsInsightsRouteRoute:
      AuthModulesCrtCustomerInvestmentsInsightsRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsInvestmentsRouteRoute:
      AuthModulesCrtCustomerInvestmentsInvestmentsRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRoute:
      AuthModulesCrtCustomerInvestmentsKeyAccountsRouteRouteWithChildren,
    AuthModulesCrtCustomerInvestmentsIndexRoute:
      AuthModulesCrtCustomerInvestmentsIndexRoute,
  }

const AuthModulesCrtCustomerInvestmentsRouteRouteWithChildren =
  AuthModulesCrtCustomerInvestmentsRouteRoute._addFileChildren(
    AuthModulesCrtCustomerInvestmentsRouteRouteChildren,
  )

interface AuthModulesCrtCustomersCommercialPartnersRouteRouteChildren {
  AuthModulesCrtCustomersCommercialPartnersIndexRoute: typeof AuthModulesCrtCustomersCommercialPartnersIndexRoute
}

const AuthModulesCrtCustomersCommercialPartnersRouteRouteChildren: AuthModulesCrtCustomersCommercialPartnersRouteRouteChildren =
  {
    AuthModulesCrtCustomersCommercialPartnersIndexRoute:
      AuthModulesCrtCustomersCommercialPartnersIndexRoute,
  }

const AuthModulesCrtCustomersCommercialPartnersRouteRouteWithChildren =
  AuthModulesCrtCustomersCommercialPartnersRouteRoute._addFileChildren(
    AuthModulesCrtCustomersCommercialPartnersRouteRouteChildren,
  )

interface AuthModulesCrtCustomersRouteRouteChildren {
  AuthModulesCrtCustomersCommercialPartnersRouteRoute: typeof AuthModulesCrtCustomersCommercialPartnersRouteRouteWithChildren
}

const AuthModulesCrtCustomersRouteRouteChildren: AuthModulesCrtCustomersRouteRouteChildren =
  {
    AuthModulesCrtCustomersCommercialPartnersRouteRoute:
      AuthModulesCrtCustomersCommercialPartnersRouteRouteWithChildren,
  }

const AuthModulesCrtCustomersRouteRouteWithChildren =
  AuthModulesCrtCustomersRouteRoute._addFileChildren(
    AuthModulesCrtCustomersRouteRouteChildren,
  )

interface AuthModulesCrtKpiReportsCashDashboardRouteRouteChildren {
  AuthModulesCrtKpiReportsCashDashboardIndexRoute: typeof AuthModulesCrtKpiReportsCashDashboardIndexRoute
}

const AuthModulesCrtKpiReportsCashDashboardRouteRouteChildren: AuthModulesCrtKpiReportsCashDashboardRouteRouteChildren =
  {
    AuthModulesCrtKpiReportsCashDashboardIndexRoute:
      AuthModulesCrtKpiReportsCashDashboardIndexRoute,
  }

const AuthModulesCrtKpiReportsCashDashboardRouteRouteWithChildren =
  AuthModulesCrtKpiReportsCashDashboardRouteRoute._addFileChildren(
    AuthModulesCrtKpiReportsCashDashboardRouteRouteChildren,
  )

interface AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRouteChildren {
  AuthModulesCrtKpiReportsProfitsAndLossSummaryIndexRoute: typeof AuthModulesCrtKpiReportsProfitsAndLossSummaryIndexRoute
}

const AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRouteChildren: AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRouteChildren =
  {
    AuthModulesCrtKpiReportsProfitsAndLossSummaryIndexRoute:
      AuthModulesCrtKpiReportsProfitsAndLossSummaryIndexRoute,
  }

const AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRouteWithChildren =
  AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRoute._addFileChildren(
    AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRouteChildren,
  )

interface AuthModulesCrtKpiReportsRouteRouteChildren {
  AuthModulesCrtKpiReportsCashDashboardRouteRoute: typeof AuthModulesCrtKpiReportsCashDashboardRouteRouteWithChildren
  AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRoute: typeof AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRouteWithChildren
  AuthModulesCrtKpiReportsGraphsRoute: typeof AuthModulesCrtKpiReportsGraphsRoute
  AuthModulesCrtKpiReportsIndexRoute: typeof AuthModulesCrtKpiReportsIndexRoute
}

const AuthModulesCrtKpiReportsRouteRouteChildren: AuthModulesCrtKpiReportsRouteRouteChildren =
  {
    AuthModulesCrtKpiReportsCashDashboardRouteRoute:
      AuthModulesCrtKpiReportsCashDashboardRouteRouteWithChildren,
    AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRoute:
      AuthModulesCrtKpiReportsProfitsAndLossSummaryRouteRouteWithChildren,
    AuthModulesCrtKpiReportsGraphsRoute: AuthModulesCrtKpiReportsGraphsRoute,
    AuthModulesCrtKpiReportsIndexRoute: AuthModulesCrtKpiReportsIndexRoute,
  }

const AuthModulesCrtKpiReportsRouteRouteWithChildren =
  AuthModulesCrtKpiReportsRouteRoute._addFileChildren(
    AuthModulesCrtKpiReportsRouteRouteChildren,
  )

interface AuthModulesCrtMaterialsBrandVariantsRouteRouteChildren {
  AuthModulesCrtMaterialsBrandVariantsIndexRoute: typeof AuthModulesCrtMaterialsBrandVariantsIndexRoute
}

const AuthModulesCrtMaterialsBrandVariantsRouteRouteChildren: AuthModulesCrtMaterialsBrandVariantsRouteRouteChildren =
  {
    AuthModulesCrtMaterialsBrandVariantsIndexRoute:
      AuthModulesCrtMaterialsBrandVariantsIndexRoute,
  }

const AuthModulesCrtMaterialsBrandVariantsRouteRouteWithChildren =
  AuthModulesCrtMaterialsBrandVariantsRouteRoute._addFileChildren(
    AuthModulesCrtMaterialsBrandVariantsRouteRouteChildren,
  )

interface AuthModulesCrtMaterialsInsightsFederalExciseRouteRouteChildren {
  AuthModulesCrtMaterialsInsightsFederalExciseIndexRoute: typeof AuthModulesCrtMaterialsInsightsFederalExciseIndexRoute
}

const AuthModulesCrtMaterialsInsightsFederalExciseRouteRouteChildren: AuthModulesCrtMaterialsInsightsFederalExciseRouteRouteChildren =
  {
    AuthModulesCrtMaterialsInsightsFederalExciseIndexRoute:
      AuthModulesCrtMaterialsInsightsFederalExciseIndexRoute,
  }

const AuthModulesCrtMaterialsInsightsFederalExciseRouteRouteWithChildren =
  AuthModulesCrtMaterialsInsightsFederalExciseRouteRoute._addFileChildren(
    AuthModulesCrtMaterialsInsightsFederalExciseRouteRouteChildren,
  )

interface AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRouteChildren {
  AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesIndexRoute: typeof AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesIndexRoute
}

const AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRouteChildren: AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRouteChildren =
  {
    AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesIndexRoute:
      AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesIndexRoute,
  }

const AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRouteWithChildren =
  AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRoute._addFileChildren(
    AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRouteChildren,
  )

interface AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRouteChildren {
  AuthModulesCrtMaterialsInsightsProductTypeVariantsIndexRoute: typeof AuthModulesCrtMaterialsInsightsProductTypeVariantsIndexRoute
}

const AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRouteChildren: AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRouteChildren =
  {
    AuthModulesCrtMaterialsInsightsProductTypeVariantsIndexRoute:
      AuthModulesCrtMaterialsInsightsProductTypeVariantsIndexRoute,
  }

const AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRouteWithChildren =
  AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRoute._addFileChildren(
    AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRouteChildren,
  )

interface AuthModulesCrtMaterialsInsightsProductTypesRouteRouteChildren {
  AuthModulesCrtMaterialsInsightsProductTypesIndexRoute: typeof AuthModulesCrtMaterialsInsightsProductTypesIndexRoute
}

const AuthModulesCrtMaterialsInsightsProductTypesRouteRouteChildren: AuthModulesCrtMaterialsInsightsProductTypesRouteRouteChildren =
  {
    AuthModulesCrtMaterialsInsightsProductTypesIndexRoute:
      AuthModulesCrtMaterialsInsightsProductTypesIndexRoute,
  }

const AuthModulesCrtMaterialsInsightsProductTypesRouteRouteWithChildren =
  AuthModulesCrtMaterialsInsightsProductTypesRouteRoute._addFileChildren(
    AuthModulesCrtMaterialsInsightsProductTypesRouteRouteChildren,
  )

interface AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRouteChildren {
  AuthModulesCrtMaterialsInsightsUnreleasedMaterialsIndexRoute: typeof AuthModulesCrtMaterialsInsightsUnreleasedMaterialsIndexRoute
}

const AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRouteChildren: AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRouteChildren =
  {
    AuthModulesCrtMaterialsInsightsUnreleasedMaterialsIndexRoute:
      AuthModulesCrtMaterialsInsightsUnreleasedMaterialsIndexRoute,
  }

const AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRouteWithChildren =
  AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRoute._addFileChildren(
    AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRouteChildren,
  )

interface AuthModulesCrtMaterialsInsightsRouteRouteChildren {
  AuthModulesCrtMaterialsInsightsFederalExciseRouteRoute: typeof AuthModulesCrtMaterialsInsightsFederalExciseRouteRouteWithChildren
  AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRoute: typeof AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRouteWithChildren
  AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRoute: typeof AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRouteWithChildren
  AuthModulesCrtMaterialsInsightsProductTypesRouteRoute: typeof AuthModulesCrtMaterialsInsightsProductTypesRouteRouteWithChildren
  AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRoute: typeof AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRouteWithChildren
  AuthModulesCrtMaterialsInsightsIndexRoute: typeof AuthModulesCrtMaterialsInsightsIndexRoute
}

const AuthModulesCrtMaterialsInsightsRouteRouteChildren: AuthModulesCrtMaterialsInsightsRouteRouteChildren =
  {
    AuthModulesCrtMaterialsInsightsFederalExciseRouteRoute:
      AuthModulesCrtMaterialsInsightsFederalExciseRouteRouteWithChildren,
    AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRoute:
      AuthModulesCrtMaterialsInsightsMaterialGroupsOverridesRouteRouteWithChildren,
    AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRoute:
      AuthModulesCrtMaterialsInsightsProductTypeVariantsRouteRouteWithChildren,
    AuthModulesCrtMaterialsInsightsProductTypesRouteRoute:
      AuthModulesCrtMaterialsInsightsProductTypesRouteRouteWithChildren,
    AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRoute:
      AuthModulesCrtMaterialsInsightsUnreleasedMaterialsRouteRouteWithChildren,
    AuthModulesCrtMaterialsInsightsIndexRoute:
      AuthModulesCrtMaterialsInsightsIndexRoute,
  }

const AuthModulesCrtMaterialsInsightsRouteRouteWithChildren =
  AuthModulesCrtMaterialsInsightsRouteRoute._addFileChildren(
    AuthModulesCrtMaterialsInsightsRouteRouteChildren,
  )

interface AuthModulesCrtMaterialsMaterialsListRouteRouteChildren {
  AuthModulesCrtMaterialsMaterialsListIndexRoute: typeof AuthModulesCrtMaterialsMaterialsListIndexRoute
}

const AuthModulesCrtMaterialsMaterialsListRouteRouteChildren: AuthModulesCrtMaterialsMaterialsListRouteRouteChildren =
  {
    AuthModulesCrtMaterialsMaterialsListIndexRoute:
      AuthModulesCrtMaterialsMaterialsListIndexRoute,
  }

const AuthModulesCrtMaterialsMaterialsListRouteRouteWithChildren =
  AuthModulesCrtMaterialsMaterialsListRouteRoute._addFileChildren(
    AuthModulesCrtMaterialsMaterialsListRouteRouteChildren,
  )

interface AuthModulesCrtMaterialsPriceListRouteRouteChildren {
  AuthModulesCrtMaterialsPriceListIndexRoute: typeof AuthModulesCrtMaterialsPriceListIndexRoute
}

const AuthModulesCrtMaterialsPriceListRouteRouteChildren: AuthModulesCrtMaterialsPriceListRouteRouteChildren =
  {
    AuthModulesCrtMaterialsPriceListIndexRoute:
      AuthModulesCrtMaterialsPriceListIndexRoute,
  }

const AuthModulesCrtMaterialsPriceListRouteRouteWithChildren =
  AuthModulesCrtMaterialsPriceListRouteRoute._addFileChildren(
    AuthModulesCrtMaterialsPriceListRouteRouteChildren,
  )

interface AuthModulesCrtMaterialsRouteRouteChildren {
  AuthModulesCrtMaterialsBrandVariantsRouteRoute: typeof AuthModulesCrtMaterialsBrandVariantsRouteRouteWithChildren
  AuthModulesCrtMaterialsInsightsRouteRoute: typeof AuthModulesCrtMaterialsInsightsRouteRouteWithChildren
  AuthModulesCrtMaterialsMaterialsListRouteRoute: typeof AuthModulesCrtMaterialsMaterialsListRouteRouteWithChildren
  AuthModulesCrtMaterialsPriceListRouteRoute: typeof AuthModulesCrtMaterialsPriceListRouteRouteWithChildren
  AuthModulesCrtMaterialsIndexRoute: typeof AuthModulesCrtMaterialsIndexRoute
}

const AuthModulesCrtMaterialsRouteRouteChildren: AuthModulesCrtMaterialsRouteRouteChildren =
  {
    AuthModulesCrtMaterialsBrandVariantsRouteRoute:
      AuthModulesCrtMaterialsBrandVariantsRouteRouteWithChildren,
    AuthModulesCrtMaterialsInsightsRouteRoute:
      AuthModulesCrtMaterialsInsightsRouteRouteWithChildren,
    AuthModulesCrtMaterialsMaterialsListRouteRoute:
      AuthModulesCrtMaterialsMaterialsListRouteRouteWithChildren,
    AuthModulesCrtMaterialsPriceListRouteRoute:
      AuthModulesCrtMaterialsPriceListRouteRouteWithChildren,
    AuthModulesCrtMaterialsIndexRoute: AuthModulesCrtMaterialsIndexRoute,
  }

const AuthModulesCrtMaterialsRouteRouteWithChildren =
  AuthModulesCrtMaterialsRouteRoute._addFileChildren(
    AuthModulesCrtMaterialsRouteRouteChildren,
  )

interface AuthModulesCrtMyExportsRouteRouteChildren {
  AuthModulesCrtMyExportsIndexRoute: typeof AuthModulesCrtMyExportsIndexRoute
}

const AuthModulesCrtMyExportsRouteRouteChildren: AuthModulesCrtMyExportsRouteRouteChildren =
  {
    AuthModulesCrtMyExportsIndexRoute: AuthModulesCrtMyExportsIndexRoute,
  }

const AuthModulesCrtMyExportsRouteRouteWithChildren =
  AuthModulesCrtMyExportsRouteRoute._addFileChildren(
    AuthModulesCrtMyExportsRouteRouteChildren,
  )

interface AuthModulesCrtMyUploadsRouteRouteChildren {
  AuthModulesCrtMyUploadsIndexRoute: typeof AuthModulesCrtMyUploadsIndexRoute
  AuthModulesCrtMyUploadsScopeFileNameRoute: typeof AuthModulesCrtMyUploadsScopeFileNameRoute
}

const AuthModulesCrtMyUploadsRouteRouteChildren: AuthModulesCrtMyUploadsRouteRouteChildren =
  {
    AuthModulesCrtMyUploadsIndexRoute: AuthModulesCrtMyUploadsIndexRoute,
    AuthModulesCrtMyUploadsScopeFileNameRoute:
      AuthModulesCrtMyUploadsScopeFileNameRoute,
  }

const AuthModulesCrtMyUploadsRouteRouteWithChildren =
  AuthModulesCrtMyUploadsRouteRoute._addFileChildren(
    AuthModulesCrtMyUploadsRouteRouteChildren,
  )

interface AuthModulesCrtPricingExciseInsightsChannelMixRouteRouteChildren {
  AuthModulesCrtPricingExciseInsightsChannelMixIndexRoute: typeof AuthModulesCrtPricingExciseInsightsChannelMixIndexRoute
  AuthModulesCrtPricingExciseInsightsChannelMixYearMonthRoute: typeof AuthModulesCrtPricingExciseInsightsChannelMixYearMonthRoute
}

const AuthModulesCrtPricingExciseInsightsChannelMixRouteRouteChildren: AuthModulesCrtPricingExciseInsightsChannelMixRouteRouteChildren =
  {
    AuthModulesCrtPricingExciseInsightsChannelMixIndexRoute:
      AuthModulesCrtPricingExciseInsightsChannelMixIndexRoute,
    AuthModulesCrtPricingExciseInsightsChannelMixYearMonthRoute:
      AuthModulesCrtPricingExciseInsightsChannelMixYearMonthRoute,
  }

const AuthModulesCrtPricingExciseInsightsChannelMixRouteRouteWithChildren =
  AuthModulesCrtPricingExciseInsightsChannelMixRouteRoute._addFileChildren(
    AuthModulesCrtPricingExciseInsightsChannelMixRouteRouteChildren,
  )

interface AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRouteChildren {
  AuthModulesCrtPricingExciseInsightsConsumerRatesIndexRoute: typeof AuthModulesCrtPricingExciseInsightsConsumerRatesIndexRoute
}

const AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRouteChildren: AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRouteChildren =
  {
    AuthModulesCrtPricingExciseInsightsConsumerRatesIndexRoute:
      AuthModulesCrtPricingExciseInsightsConsumerRatesIndexRoute,
  }

const AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRouteWithChildren =
  AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRoute._addFileChildren(
    AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRouteChildren,
  )

interface AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRouteChildren {
  AuthModulesCrtPricingExciseInsightsRetailerRatesIndexRoute: typeof AuthModulesCrtPricingExciseInsightsRetailerRatesIndexRoute
}

const AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRouteChildren: AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRouteChildren =
  {
    AuthModulesCrtPricingExciseInsightsRetailerRatesIndexRoute:
      AuthModulesCrtPricingExciseInsightsRetailerRatesIndexRoute,
  }

const AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRouteWithChildren =
  AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRoute._addFileChildren(
    AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRouteChildren,
  )

interface AuthModulesCrtPricingExciseInsightsRouteRouteChildren {
  AuthModulesCrtPricingExciseInsightsChannelMixRouteRoute: typeof AuthModulesCrtPricingExciseInsightsChannelMixRouteRouteWithChildren
  AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRoute: typeof AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRouteWithChildren
  AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRoute: typeof AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRouteWithChildren
  AuthModulesCrtPricingExciseInsightsIndexRoute: typeof AuthModulesCrtPricingExciseInsightsIndexRoute
}

const AuthModulesCrtPricingExciseInsightsRouteRouteChildren: AuthModulesCrtPricingExciseInsightsRouteRouteChildren =
  {
    AuthModulesCrtPricingExciseInsightsChannelMixRouteRoute:
      AuthModulesCrtPricingExciseInsightsChannelMixRouteRouteWithChildren,
    AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRoute:
      AuthModulesCrtPricingExciseInsightsConsumerRatesRouteRouteWithChildren,
    AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRoute:
      AuthModulesCrtPricingExciseInsightsRetailerRatesRouteRouteWithChildren,
    AuthModulesCrtPricingExciseInsightsIndexRoute:
      AuthModulesCrtPricingExciseInsightsIndexRoute,
  }

const AuthModulesCrtPricingExciseInsightsRouteRouteWithChildren =
  AuthModulesCrtPricingExciseInsightsRouteRoute._addFileChildren(
    AuthModulesCrtPricingExciseInsightsRouteRouteChildren,
  )

interface AuthModulesCrtPricingExcisePricingAssumptionsRouteRouteChildren {
  AuthModulesCrtPricingExcisePricingAssumptionsPricingAssumptionIdRoute: typeof AuthModulesCrtPricingExcisePricingAssumptionsPricingAssumptionIdRoute
  AuthModulesCrtPricingExcisePricingAssumptionsIndexRoute: typeof AuthModulesCrtPricingExcisePricingAssumptionsIndexRoute
}

const AuthModulesCrtPricingExcisePricingAssumptionsRouteRouteChildren: AuthModulesCrtPricingExcisePricingAssumptionsRouteRouteChildren =
  {
    AuthModulesCrtPricingExcisePricingAssumptionsPricingAssumptionIdRoute:
      AuthModulesCrtPricingExcisePricingAssumptionsPricingAssumptionIdRoute,
    AuthModulesCrtPricingExcisePricingAssumptionsIndexRoute:
      AuthModulesCrtPricingExcisePricingAssumptionsIndexRoute,
  }

const AuthModulesCrtPricingExcisePricingAssumptionsRouteRouteWithChildren =
  AuthModulesCrtPricingExcisePricingAssumptionsRouteRoute._addFileChildren(
    AuthModulesCrtPricingExcisePricingAssumptionsRouteRouteChildren,
  )

interface AuthModulesCrtPricingExcisePricingRateTableRouteRouteChildren {
  AuthModulesCrtPricingExcisePricingRateTableIndexRoute: typeof AuthModulesCrtPricingExcisePricingRateTableIndexRoute
}

const AuthModulesCrtPricingExcisePricingRateTableRouteRouteChildren: AuthModulesCrtPricingExcisePricingRateTableRouteRouteChildren =
  {
    AuthModulesCrtPricingExcisePricingRateTableIndexRoute:
      AuthModulesCrtPricingExcisePricingRateTableIndexRoute,
  }

const AuthModulesCrtPricingExcisePricingRateTableRouteRouteWithChildren =
  AuthModulesCrtPricingExcisePricingRateTableRouteRoute._addFileChildren(
    AuthModulesCrtPricingExcisePricingRateTableRouteRouteChildren,
  )

interface AuthModulesCrtPricingExciseTaxAssumptionsRouteRouteChildren {
  AuthModulesCrtPricingExciseTaxAssumptionsTaxAssumptionIdRoute: typeof AuthModulesCrtPricingExciseTaxAssumptionsTaxAssumptionIdRoute
  AuthModulesCrtPricingExciseTaxAssumptionsIndexRoute: typeof AuthModulesCrtPricingExciseTaxAssumptionsIndexRoute
}

const AuthModulesCrtPricingExciseTaxAssumptionsRouteRouteChildren: AuthModulesCrtPricingExciseTaxAssumptionsRouteRouteChildren =
  {
    AuthModulesCrtPricingExciseTaxAssumptionsTaxAssumptionIdRoute:
      AuthModulesCrtPricingExciseTaxAssumptionsTaxAssumptionIdRoute,
    AuthModulesCrtPricingExciseTaxAssumptionsIndexRoute:
      AuthModulesCrtPricingExciseTaxAssumptionsIndexRoute,
  }

const AuthModulesCrtPricingExciseTaxAssumptionsRouteRouteWithChildren =
  AuthModulesCrtPricingExciseTaxAssumptionsRouteRoute._addFileChildren(
    AuthModulesCrtPricingExciseTaxAssumptionsRouteRouteChildren,
  )

interface AuthModulesCrtPricingExciseRouteRouteChildren {
  AuthModulesCrtPricingExciseInsightsRouteRoute: typeof AuthModulesCrtPricingExciseInsightsRouteRouteWithChildren
  AuthModulesCrtPricingExcisePricingAssumptionsRouteRoute: typeof AuthModulesCrtPricingExcisePricingAssumptionsRouteRouteWithChildren
  AuthModulesCrtPricingExcisePricingRateTableRouteRoute: typeof AuthModulesCrtPricingExcisePricingRateTableRouteRouteWithChildren
  AuthModulesCrtPricingExciseTaxAssumptionsRouteRoute: typeof AuthModulesCrtPricingExciseTaxAssumptionsRouteRouteWithChildren
  AuthModulesCrtPricingExciseIndexRoute: typeof AuthModulesCrtPricingExciseIndexRoute
}

const AuthModulesCrtPricingExciseRouteRouteChildren: AuthModulesCrtPricingExciseRouteRouteChildren =
  {
    AuthModulesCrtPricingExciseInsightsRouteRoute:
      AuthModulesCrtPricingExciseInsightsRouteRouteWithChildren,
    AuthModulesCrtPricingExcisePricingAssumptionsRouteRoute:
      AuthModulesCrtPricingExcisePricingAssumptionsRouteRouteWithChildren,
    AuthModulesCrtPricingExcisePricingRateTableRouteRoute:
      AuthModulesCrtPricingExcisePricingRateTableRouteRouteWithChildren,
    AuthModulesCrtPricingExciseTaxAssumptionsRouteRoute:
      AuthModulesCrtPricingExciseTaxAssumptionsRouteRouteWithChildren,
    AuthModulesCrtPricingExciseIndexRoute:
      AuthModulesCrtPricingExciseIndexRoute,
  }

const AuthModulesCrtPricingExciseRouteRouteWithChildren =
  AuthModulesCrtPricingExciseRouteRoute._addFileChildren(
    AuthModulesCrtPricingExciseRouteRouteChildren,
  )

interface AuthModulesCrtSettingsRouteRouteChildren {
  AuthModulesCrtSettingsIndexRoute: typeof AuthModulesCrtSettingsIndexRoute
}

const AuthModulesCrtSettingsRouteRouteChildren: AuthModulesCrtSettingsRouteRouteChildren =
  {
    AuthModulesCrtSettingsIndexRoute: AuthModulesCrtSettingsIndexRoute,
  }

const AuthModulesCrtSettingsRouteRouteWithChildren =
  AuthModulesCrtSettingsRouteRoute._addFileChildren(
    AuthModulesCrtSettingsRouteRouteChildren,
  )

interface AuthModulesCrtVarianceAnalysisRouteRouteChildren {
  AuthModulesCrtVarianceAnalysisByAgreementRoute: typeof AuthModulesCrtVarianceAnalysisByAgreementRoute
  AuthModulesCrtVarianceAnalysisByBannerRoute: typeof AuthModulesCrtVarianceAnalysisByBannerRoute
  AuthModulesCrtVarianceAnalysisByBudgetRoute: typeof AuthModulesCrtVarianceAnalysisByBudgetRoute
  AuthModulesCrtVarianceAnalysisByCostTypeRoute: typeof AuthModulesCrtVarianceAnalysisByCostTypeRoute
  AuthModulesCrtVarianceAnalysisIndexRoute: typeof AuthModulesCrtVarianceAnalysisIndexRoute
}

const AuthModulesCrtVarianceAnalysisRouteRouteChildren: AuthModulesCrtVarianceAnalysisRouteRouteChildren =
  {
    AuthModulesCrtVarianceAnalysisByAgreementRoute:
      AuthModulesCrtVarianceAnalysisByAgreementRoute,
    AuthModulesCrtVarianceAnalysisByBannerRoute:
      AuthModulesCrtVarianceAnalysisByBannerRoute,
    AuthModulesCrtVarianceAnalysisByBudgetRoute:
      AuthModulesCrtVarianceAnalysisByBudgetRoute,
    AuthModulesCrtVarianceAnalysisByCostTypeRoute:
      AuthModulesCrtVarianceAnalysisByCostTypeRoute,
    AuthModulesCrtVarianceAnalysisIndexRoute:
      AuthModulesCrtVarianceAnalysisIndexRoute,
  }

const AuthModulesCrtVarianceAnalysisRouteRouteWithChildren =
  AuthModulesCrtVarianceAnalysisRouteRoute._addFileChildren(
    AuthModulesCrtVarianceAnalysisRouteRouteChildren,
  )

interface AuthModulesCrtVolumeForecastsChannelContributionsRouteRouteChildren {
  AuthModulesCrtVolumeForecastsChannelContributionsIndexRoute: typeof AuthModulesCrtVolumeForecastsChannelContributionsIndexRoute
  AuthModulesCrtVolumeForecastsChannelContributionsYearMonthRoute: typeof AuthModulesCrtVolumeForecastsChannelContributionsYearMonthRoute
}

const AuthModulesCrtVolumeForecastsChannelContributionsRouteRouteChildren: AuthModulesCrtVolumeForecastsChannelContributionsRouteRouteChildren =
  {
    AuthModulesCrtVolumeForecastsChannelContributionsIndexRoute:
      AuthModulesCrtVolumeForecastsChannelContributionsIndexRoute,
    AuthModulesCrtVolumeForecastsChannelContributionsYearMonthRoute:
      AuthModulesCrtVolumeForecastsChannelContributionsYearMonthRoute,
  }

const AuthModulesCrtVolumeForecastsChannelContributionsRouteRouteWithChildren =
  AuthModulesCrtVolumeForecastsChannelContributionsRouteRoute._addFileChildren(
    AuthModulesCrtVolumeForecastsChannelContributionsRouteRouteChildren,
  )

interface AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRouteChildren {
  AuthModulesCrtVolumeForecastsNcProvincialContributionsIndexRoute: typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsIndexRoute
  AuthModulesCrtVolumeForecastsNcProvincialContributionsYearMonthRoute: typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsYearMonthRoute
}

const AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRouteChildren: AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRouteChildren =
  {
    AuthModulesCrtVolumeForecastsNcProvincialContributionsIndexRoute:
      AuthModulesCrtVolumeForecastsNcProvincialContributionsIndexRoute,
    AuthModulesCrtVolumeForecastsNcProvincialContributionsYearMonthRoute:
      AuthModulesCrtVolumeForecastsNcProvincialContributionsYearMonthRoute,
  }

const AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRouteWithChildren =
  AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRoute._addFileChildren(
    AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRouteChildren,
  )

interface AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRouteChildren {
  AuthModulesCrtVolumeForecastsSubChannelAllocationsIndexRoute: typeof AuthModulesCrtVolumeForecastsSubChannelAllocationsIndexRoute
}

const AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRouteChildren: AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRouteChildren =
  {
    AuthModulesCrtVolumeForecastsSubChannelAllocationsIndexRoute:
      AuthModulesCrtVolumeForecastsSubChannelAllocationsIndexRoute,
  }

const AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRouteWithChildren =
  AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRoute._addFileChildren(
    AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRouteChildren,
  )

interface AuthModulesCrtVolumeForecastsRouteRouteChildren {
  AuthModulesCrtVolumeForecastsChannelContributionsRouteRoute: typeof AuthModulesCrtVolumeForecastsChannelContributionsRouteRouteWithChildren
  AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRoute: typeof AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRouteWithChildren
  AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRoute: typeof AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRouteWithChildren
  AuthModulesCrtVolumeForecastsIndexRoute: typeof AuthModulesCrtVolumeForecastsIndexRoute
}

const AuthModulesCrtVolumeForecastsRouteRouteChildren: AuthModulesCrtVolumeForecastsRouteRouteChildren =
  {
    AuthModulesCrtVolumeForecastsChannelContributionsRouteRoute:
      AuthModulesCrtVolumeForecastsChannelContributionsRouteRouteWithChildren,
    AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRoute:
      AuthModulesCrtVolumeForecastsNcProvincialContributionsRouteRouteWithChildren,
    AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRoute:
      AuthModulesCrtVolumeForecastsSubChannelAllocationsRouteRouteWithChildren,
    AuthModulesCrtVolumeForecastsIndexRoute:
      AuthModulesCrtVolumeForecastsIndexRoute,
  }

const AuthModulesCrtVolumeForecastsRouteRouteWithChildren =
  AuthModulesCrtVolumeForecastsRouteRoute._addFileChildren(
    AuthModulesCrtVolumeForecastsRouteRouteChildren,
  )

interface AuthModulesCrtVolumeScenariosRouteRouteChildren {
  AuthModulesCrtVolumeScenariosVolumeScenarioIdRoute: typeof AuthModulesCrtVolumeScenariosVolumeScenarioIdRoute
  AuthModulesCrtVolumeScenariosIndexRoute: typeof AuthModulesCrtVolumeScenariosIndexRoute
}

const AuthModulesCrtVolumeScenariosRouteRouteChildren: AuthModulesCrtVolumeScenariosRouteRouteChildren =
  {
    AuthModulesCrtVolumeScenariosVolumeScenarioIdRoute:
      AuthModulesCrtVolumeScenariosVolumeScenarioIdRoute,
    AuthModulesCrtVolumeScenariosIndexRoute:
      AuthModulesCrtVolumeScenariosIndexRoute,
  }

const AuthModulesCrtVolumeScenariosRouteRouteWithChildren =
  AuthModulesCrtVolumeScenariosRouteRoute._addFileChildren(
    AuthModulesCrtVolumeScenariosRouteRouteChildren,
  )

interface AuthModulesCrtWelcomeRouteRouteChildren {
  AuthModulesCrtWelcomeIndexRoute: typeof AuthModulesCrtWelcomeIndexRoute
}

const AuthModulesCrtWelcomeRouteRouteChildren: AuthModulesCrtWelcomeRouteRouteChildren =
  {
    AuthModulesCrtWelcomeIndexRoute: AuthModulesCrtWelcomeIndexRoute,
  }

const AuthModulesCrtWelcomeRouteRouteWithChildren =
  AuthModulesCrtWelcomeRouteRoute._addFileChildren(
    AuthModulesCrtWelcomeRouteRouteChildren,
  )

interface AuthModulesCrtRouteRouteChildren {
  AuthModulesCrtAdminRouteRoute: typeof AuthModulesCrtAdminRouteRouteWithChildren
  AuthModulesCrtAzureImportsRouteRoute: typeof AuthModulesCrtAzureImportsRouteRouteWithChildren
  AuthModulesCrtBpcActualsRouteRoute: typeof AuthModulesCrtBpcActualsRouteRouteWithChildren
  AuthModulesCrtCostOfGoodsRouteRoute: typeof AuthModulesCrtCostOfGoodsRouteRouteWithChildren
  AuthModulesCrtCustomerInvestmentsRouteRoute: typeof AuthModulesCrtCustomerInvestmentsRouteRouteWithChildren
  AuthModulesCrtCustomersRouteRoute: typeof AuthModulesCrtCustomersRouteRouteWithChildren
  AuthModulesCrtKpiReportsRouteRoute: typeof AuthModulesCrtKpiReportsRouteRouteWithChildren
  AuthModulesCrtMaterialsRouteRoute: typeof AuthModulesCrtMaterialsRouteRouteWithChildren
  AuthModulesCrtMyExportsRouteRoute: typeof AuthModulesCrtMyExportsRouteRouteWithChildren
  AuthModulesCrtMyUploadsRouteRoute: typeof AuthModulesCrtMyUploadsRouteRouteWithChildren
  AuthModulesCrtPricingExciseRouteRoute: typeof AuthModulesCrtPricingExciseRouteRouteWithChildren
  AuthModulesCrtSettingsRouteRoute: typeof AuthModulesCrtSettingsRouteRouteWithChildren
  AuthModulesCrtVarianceAnalysisRouteRoute: typeof AuthModulesCrtVarianceAnalysisRouteRouteWithChildren
  AuthModulesCrtVolumeForecastsRouteRoute: typeof AuthModulesCrtVolumeForecastsRouteRouteWithChildren
  AuthModulesCrtVolumeScenariosRouteRoute: typeof AuthModulesCrtVolumeScenariosRouteRouteWithChildren
  AuthModulesCrtVolumesRouteRoute: typeof AuthModulesCrtVolumesRouteRoute
  AuthModulesCrtWelcomeRouteRoute: typeof AuthModulesCrtWelcomeRouteRouteWithChildren
}

const AuthModulesCrtRouteRouteChildren: AuthModulesCrtRouteRouteChildren = {
  AuthModulesCrtAdminRouteRoute: AuthModulesCrtAdminRouteRouteWithChildren,
  AuthModulesCrtAzureImportsRouteRoute:
    AuthModulesCrtAzureImportsRouteRouteWithChildren,
  AuthModulesCrtBpcActualsRouteRoute:
    AuthModulesCrtBpcActualsRouteRouteWithChildren,
  AuthModulesCrtCostOfGoodsRouteRoute:
    AuthModulesCrtCostOfGoodsRouteRouteWithChildren,
  AuthModulesCrtCustomerInvestmentsRouteRoute:
    AuthModulesCrtCustomerInvestmentsRouteRouteWithChildren,
  AuthModulesCrtCustomersRouteRoute:
    AuthModulesCrtCustomersRouteRouteWithChildren,
  AuthModulesCrtKpiReportsRouteRoute:
    AuthModulesCrtKpiReportsRouteRouteWithChildren,
  AuthModulesCrtMaterialsRouteRoute:
    AuthModulesCrtMaterialsRouteRouteWithChildren,
  AuthModulesCrtMyExportsRouteRoute:
    AuthModulesCrtMyExportsRouteRouteWithChildren,
  AuthModulesCrtMyUploadsRouteRoute:
    AuthModulesCrtMyUploadsRouteRouteWithChildren,
  AuthModulesCrtPricingExciseRouteRoute:
    AuthModulesCrtPricingExciseRouteRouteWithChildren,
  AuthModulesCrtSettingsRouteRoute:
    AuthModulesCrtSettingsRouteRouteWithChildren,
  AuthModulesCrtVarianceAnalysisRouteRoute:
    AuthModulesCrtVarianceAnalysisRouteRouteWithChildren,
  AuthModulesCrtVolumeForecastsRouteRoute:
    AuthModulesCrtVolumeForecastsRouteRouteWithChildren,
  AuthModulesCrtVolumeScenariosRouteRoute:
    AuthModulesCrtVolumeScenariosRouteRouteWithChildren,
  AuthModulesCrtVolumesRouteRoute: AuthModulesCrtVolumesRouteRoute,
  AuthModulesCrtWelcomeRouteRoute: AuthModulesCrtWelcomeRouteRouteWithChildren,
}

const AuthModulesCrtRouteRouteWithChildren =
  AuthModulesCrtRouteRoute._addFileChildren(AuthModulesCrtRouteRouteChildren)

interface AuthModulesRouteRouteChildren {
  AuthModulesAppRouteRoute: typeof AuthModulesAppRouteRouteWithChildren
  AuthModulesCreditRouteRoute: typeof AuthModulesCreditRouteRouteWithChildren
  AuthModulesCrtRouteRoute: typeof AuthModulesCrtRouteRouteWithChildren
  AuthModulesIndexRoute: typeof AuthModulesIndexRoute
  AuthModulesSharedKitchenSinkRoute: typeof AuthModulesSharedKitchenSinkRoute
  AuthModulesSharedErrorsErrorRoute: typeof AuthModulesSharedErrorsErrorRoute
  AuthModulesSharedErrorsNotFoundRoute: typeof AuthModulesSharedErrorsNotFoundRoute
  AuthModulesSharedErrorsUnauthorizedRoute: typeof AuthModulesSharedErrorsUnauthorizedRoute
}

const AuthModulesRouteRouteChildren: AuthModulesRouteRouteChildren = {
  AuthModulesAppRouteRoute: AuthModulesAppRouteRouteWithChildren,
  AuthModulesCreditRouteRoute: AuthModulesCreditRouteRouteWithChildren,
  AuthModulesCrtRouteRoute: AuthModulesCrtRouteRouteWithChildren,
  AuthModulesIndexRoute: AuthModulesIndexRoute,
  AuthModulesSharedKitchenSinkRoute: AuthModulesSharedKitchenSinkRoute,
  AuthModulesSharedErrorsErrorRoute: AuthModulesSharedErrorsErrorRoute,
  AuthModulesSharedErrorsNotFoundRoute: AuthModulesSharedErrorsNotFoundRoute,
  AuthModulesSharedErrorsUnauthorizedRoute:
    AuthModulesSharedErrorsUnauthorizedRoute,
}

const AuthModulesRouteRouteWithChildren =
  AuthModulesRouteRoute._addFileChildren(AuthModulesRouteRouteChildren)

interface AuthUnverifiedRouteRouteChildren {
  AuthUnverifiedIndexRoute: typeof AuthUnverifiedIndexRoute
}

const AuthUnverifiedRouteRouteChildren: AuthUnverifiedRouteRouteChildren = {
  AuthUnverifiedIndexRoute: AuthUnverifiedIndexRoute,
}

const AuthUnverifiedRouteRouteWithChildren =
  AuthUnverifiedRouteRoute._addFileChildren(AuthUnverifiedRouteRouteChildren)

interface AuthRouteRouteChildren {
  AuthModulesRouteRoute: typeof AuthModulesRouteRouteWithChildren
  AuthUnverifiedRouteRoute: typeof AuthUnverifiedRouteRouteWithChildren
  AuthTrackErpRoute: typeof AuthTrackErpRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthModulesRouteRoute: AuthModulesRouteRouteWithChildren,
  AuthUnverifiedRouteRoute: AuthUnverifiedRouteRouteWithChildren,
  AuthTrackErpRoute: AuthTrackErpRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  ProcessLoginRoute: ProcessLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
